// Observational only: telemetry must never change an editor operation.
function nhFunnelCall(method, ...args) {
  try {
    const funnel = window.NH_EditorFunnel;
    if (funnel && typeof funnel[method] === 'function') funnel[method](...args);
  } catch (_) { /* Measurement is optional. */ }
}
function nhFunnelMarkError(error, code) {
  try {
    if (error && (typeof error === 'object' || typeof error === 'function')) {
      Object.defineProperty(error, '__nhFunnelErrorCode', { value: code, configurable: true });
    }
  } catch (_) { /* Keep the original error, including frozen errors. */ }
  return error;
}

// Prevent iOS double-tap zoom so the editor stays at a stable scale
(function preventDoubleTapZoom() {
  let lastTouchEnd = 0;
  document.addEventListener('touchend', (event) => {
    const isEditableTarget = event.target.closest('input, textarea, select');
    if (isEditableTarget) return;

    const now = performance.now ? performance.now() : Date.now();
    if (now - lastTouchEnd <= 300) {
      event.preventDefault();
    }
    lastTouchEnd = now;
  }, { passive: false });
})();

// ===== Fix: Auswahlrahmen entspricht exakt der sichtbaren Textbreite (inkl. … & Kerning) =====
(function () {
  if (!(window.fabric && fabric.Text)) return;

  // Hilfs-Context zum Messen
  const _probeCanvas = document.createElement('canvas');
  const _ctx = _probeCanvas.getContext('2d');

  // charSpacing-Breite wie in Fabric
  function charSpacingDelta(obj, line) {
    if (!obj.charSpacing) return 0;
    // Fabric rechnet charSpacing in 1/1000 em -> px über fontSize
    const perChar = (obj.charSpacing / 1000) * obj.fontSize;
    return Math.max(0, (line.length - 1) * perChar);
  }

  function measureLineExact(obj, i) {
    const lines = obj._textLines || obj.text.split('\n');
    const line = lines[i] || '';

    if (!_ctx || typeof _ctx.measureText !== 'function') {
      return orig_getLineWidth.call(obj, i);
    }

    _ctx.font = obj._getFontDeclaration();
    _ctx.textBaseline = obj.textBaseline || 'alphabetic';
    _ctx.direction = obj.direction || 'ltr';

    const metrics = _ctx.measureText(line);
    const leftBox = metrics?.actualBoundingBoxLeft || 0;
    const rightBox = metrics?.actualBoundingBoxRight || 0;
    let width = Number.isFinite(metrics?.width) ? metrics.width : 0;

    if (leftBox || rightBox) {
      width = Math.max(width, leftBox + rightBox);
    }

    return width + charSpacingDelta(obj, line);
  }

  // Patch: echte Zeilenbreite an Fabric zurückgeben
  const T = fabric.Text.prototype;
  const orig_getLineWidth = T._getLineWidth;
  T._getLineWidth = function (i) {
    try {
      return measureLineExact(this, i);
    } catch (e) {
      // Fallback auf Original falls irgendwas schiefgeht
      return orig_getLineWidth.call(this, i);
    }
  };

  // Wenn Text/Eigenschaften geändert werden, Dimensionen neu berechnen
  const orig_set = T.set;
  T.set = function () {
    const ret = orig_set.apply(this, arguments);
    this.initDimensions(); // Rahmen sofort aktualisieren
    return ret;
  };
})();
/// ===== Ende Fix =====

(function configureScalingDefaults() {
  if (!(window.fabric && fabric.Object && fabric.Object.prototype)) return;
  const proto = fabric.Object.prototype;
  proto.lockUniScaling = true;
  proto.lockScalingFlip = true;
  const controls = proto.controls;
  if (controls) {
    ['ml', 'mr', 'mt', 'mb'].forEach((key) => {
      if (controls[key]) {
        controls[key].visible = false;
      }
    });
  }
})();

// ===== Fonts warten & Text-Rahmen nachziehen (einfügen: ganz oben in app.js) =====
async function waitForFontsReady() {
  if (document.fonts && document.fonts.ready) {
    try { await document.fonts.ready; } catch (_) {}
  } else {
    await new Promise(r => setTimeout(r, 300));
  }
}
function refreshTextMetrics() {
  if (!window.canvas || typeof canvas.getObjects !== 'function') return;
  const texts = canvas.getObjects().filter(o =>
    o && (o.type === 'text' || o.type === 'textbox' || o.type === 'i-text')
  );
  if (!texts.length) return;
  texts.forEach(t => {
    if (typeof t._clearCache === 'function') t._clearCache();
    t.dirty = true;
    if (typeof t.initDimensions === 'function') t.initDimensions();
    if (typeof t.setCoords === 'function') t.setCoords();
  });
  canvas.requestRenderAll();
}

function scheduleTextMetricRefresh(delays = [0]) {
  const queue = Array.isArray(delays) ? delays : [delays];
  queue
    .map(delay => Number(delay) || 0)
    .filter(delay => delay >= 0)
    .forEach(delay => {
      window.setTimeout(() => {
        if (typeof requestAnimationFrame === 'function') {
          requestAnimationFrame(refreshTextMetrics);
        } else {
          refreshTextMetrics();
        }
      }, delay);
    });
}

async function ensureFontLoaded(fontFamily, weights = ['400'], styles = ['normal'], px = 32) {
  const family = (fontFamily || '').trim();
  if (!family) return;

  if (typeof weights === 'number') {
    px = weights;
    weights = ['400'];
    styles = ['normal'];
  }

  if (!Array.isArray(weights) || !weights.length) weights = ['400'];
  if (!Array.isArray(styles) || !styles.length) styles = ['normal'];

  if (document.fonts && typeof document.fonts.load === 'function') {
    try {
      const jobs = [];
      weights.forEach(weight => {
        const w = String(weight).trim() || '400';
        styles.forEach(style => {
          const s = String(style).trim() || 'normal';
          jobs.push(document.fonts.load(`${s} ${w} ${px}px "${family}"`));
        });
      });
      await Promise.all(jobs);
    } catch (err) {
      console.warn('Schrift konnte nicht geladen werden', family, err);
    }
  }
}

// automatisch nachziehen, wenn Fonts fertig sind
if (document.fonts) {
  document.fonts.ready.then(() => scheduleTextMetricRefresh([0, 120, 480]));
  if (typeof document.fonts.addEventListener === 'function') {
    document.fonts.addEventListener('loadingdone', () => scheduleTextMetricRefresh([0, 180]));
    document.fonts.addEventListener('loadingerror', () => scheduleTextMetricRefresh([0]));
  }
}

window.addEventListener('load', () => scheduleTextMetricRefresh([0, 220]));
// ===== Ende Block =====


window.canvas = new fabric.Canvas('oval-canvas'); // ← global verfügbar
const canvas = window.canvas;
canvas.uniformScaling = true;
let socialSizeSlider = null;
let socialSizeValue = null;
scheduleTextMetricRefresh([0, 320]);
(async () => {
  await waitForFontsReady();
  scheduleTextMetricRefresh([0, 160]);
})();
    fabric.Object.prototype.objectCaching = false;
    canvas.renderOnAddRemove = true;
    canvas.preserveObjectStacking = true; // Auswahl verändert Z-Order nicht

  const coarsePointerQuery = (window.matchMedia && window.matchMedia('(pointer: coarse)')) || null;
  function isCoarsePointerDevice() {
    if (coarsePointerQuery) return coarsePointerQuery.matches;
    const ua = (navigator && navigator.userAgent) || '';
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(ua);
  }

  function applySelectionModeForPointer() {
    const isCoarse = isCoarsePointerDevice();
    canvas.selection = !isCoarse;
    canvas.allowTouchScrolling = true;
    const touchAction = 'pan-y';
    ['upperCanvasEl', 'lowerCanvasEl', 'wrapperEl'].forEach((key) => {
      const el = canvas[key];
      if (el && el.style) {
        el.style.touchAction = touchAction;
      }
    });
  }

  (function enableCanvasTouchScrollBridge(){
    const upperCanvas = canvas?.upperCanvasEl;
    if (!upperCanvas) return;
    let scrollSession = null;

    function shouldHijack(evt) {
      if (!isCoarsePointerDevice()) return false;
      if (!evt.touches || evt.touches.length !== 1) return false;
      if (canvas?._currentTransform || canvas?.isDrawingMode || canvas?.getActiveObject?.()?.isEditing) return false;
      if (!canvas || typeof canvas.findTarget !== 'function') return true;
      const target = canvas.findTarget(evt, true);
      return !target;
    }

    upperCanvas.addEventListener('touchstart', (evt) => {
      if (!shouldHijack(evt)) {
        scrollSession = null;
        return;
      }
      // The capture scroll bridge bypasses Fabric's normal background deselection.
      if (canvas.getActiveObject?.()) {
        canvas.discardActiveObject(evt);
        canvas.requestRenderAll();
      }
      const touch = evt.touches[0];
      scrollSession = {
        lastY: touch.clientY
      };
      evt.preventDefault();
      if (typeof evt.stopImmediatePropagation === 'function') {
        evt.stopImmediatePropagation();
      }
    }, { passive: false, capture: true });

    upperCanvas.addEventListener('touchmove', (evt) => {
      if (!scrollSession) return;
      const touch = evt.touches && evt.touches[0];
      if (!touch) return;
      const deltaY = scrollSession.lastY - touch.clientY;
      scrollSession.lastY = touch.clientY;
      if (Math.abs(deltaY) > 0) {
        window.scrollBy(0, deltaY);
      }
      evt.preventDefault();
      if (typeof evt.stopImmediatePropagation === 'function') {
        evt.stopImmediatePropagation();
      }
    }, { passive: false, capture: true });

    const endScroll = () => {
      scrollSession = null;
    };

    ['touchend', 'touchcancel'].forEach(type => {
      upperCanvas.addEventListener(type, endScroll, { passive: true, capture: true });
    });
  })();

  applySelectionModeForPointer();
  if (coarsePointerQuery) {
    const cb = () => applySelectionModeForPointer();
    if (typeof coarsePointerQuery.addEventListener === 'function') {
      coarsePointerQuery.addEventListener('change', cb);
    } else if (typeof coarsePointerQuery.addListener === 'function') {
      coarsePointerQuery.addListener(cb);
    }
  }

  // 🔒 Harter Z-Order-Guard: nichts (außer die Form selbst) kommt jemals hinter das Oval/Rechteck
  (function hardenZOrderGuard(){
    const C = canvas;
    const orig = {
      moveTo        : C.moveTo.bind(C),
      sendToBack    : C.sendToBack.bind(C),
      sendBackwards : C.sendBackwards.bind(C),
      insertAt      : C.insertAt ? C.insertAt.bind(C) : null
    };

    function bgIndex(){
      const i = C.getObjects().findIndex(o => o._isBackground);
     return i < 0 ? null : i;
    }
    function minAllowedIndex(){                 // direkt über dem Hintergrund
      const bgi = bgIndex();
      return bgi === null ? 0 : bgi + 1;
    }
    function clampAboveBackground(obj){
        if (!obj || obj._isBackground || obj._helperUI) return;
      const bgi = bgIndex(); if (bgi === null) return;
      const idx = C.getObjects().indexOf(obj);
      if (idx <= bgi) orig.moveTo(obj, bgi + 1);
    }
    window.clampAllAboveBackground = function(){
      const bgi = bgIndex(); if (bgi === null) return;
      C.getObjects().forEach(o => {
        if (o === window.oval || o?._helperUI) return;
        clampAboveBackground(o);
      });
    };

    // ▶️ zentraler Move-Guard
    C.moveTo = function(obj, index){
      const bgi = bgIndex();
      if (bgi !== null && !obj._isBackground && index <= bgi) index = bgi + 1;
      return orig.moveTo(obj, index);
    };

    // ▶️ „ganz nach hinten“ immer nur bis knapp über die Form
    C.sendToBack = function(obj){
        if (obj._isBackground) return orig.sendToBack(obj);  // Form darf wirklich ganz nach hinten
      return orig.moveTo(obj, minAllowedIndex());
    };

    // ▶️ „eine Ebene nach hinten“ – nie unter die Form
    C.sendBackwards = function(obj){
        if (obj._isBackground) return obj;
      const bgi = bgIndex();
      if (bgi === null) return orig.sendBackwards(obj);
      const idx = C.getObjects().indexOf(obj);
      if (idx <= bgi + 1) return obj;      // bereits direkt über der Form
      orig.sendBackwards(obj);
      clampAboveBackground(obj);
      return obj;
    };

    // ▶️ selten genutzt, aber sicherheitshalber abklemmen
    if (orig.insertAt) {
      C.insertAt = function(obj, index, nonSplicing){
        const bgi = bgIndex();
        if (bgi !== null && obj !== window.oval && index <= bgi) index = bgi + 1;
        return orig.insertAt(obj, index, nonSplicing);
      };
    }

    // ▶️ automatische Klammer bei Änderungen/Hinzufügen
    C.on('object:added',    e => { if (!e?.target?._helperUI) clampAboveBackground(e.target); });
    C.on('object:modified', e => { if (!e?.target?._helperUI) clampAboveBackground(e.target); });
  })();

  // === History & Undo/Redo =====================================================
  const HISTORY_PROPS = [
    '_historyId',
    '_isBackground',
    '_bgGradientState',
    '_helperUI',
    'excludeFromExport',
    '_locked',
    '_linkedInputId',
    '_inputLabel',
    '_emojiChar',
    '_originalBase64',
    '_originalWidth',
    '_originalHeight',
    '_sourceWidth',
    '_sourceHeight',
    '_optimizedWidth',
    '_optimizedHeight',
    '_imageEditSource',
    '_imageCropMode',
    '_isSocial',
    '_socialBrand',
    '_socialLabel',
    '_socialSpacing',
    '_socialFont',
    '_socialColor',
    '_socialScale',
    '_qrLogoRatio',
    '_qrLogoDataURL',
    '_qrId',
    '_qrOwnerId',
    '_qrPart',
    '_isQr',
    '_qrState',
    'isEmoji',
    'visible',
    'selectable',
    'evented',
    'lockMovementX',
    'lockMovementY',
    'lockScalingX',
    'lockScalingY',
    'lockRotation',
    '__wasCenteredOnce'
  ];
  const HISTORY_MAX_ENTRIES = 80;
  const HISTORY_DEFAULT_DELAY = 320;
  const HIDDEN_DRAFT_STORAGE_KEY = 'NH_HIDDEN_DRAFT_V1';
  const HIDDEN_DRAFTS_DISABLED = true;
  const designShareRequestedAtBoot = (() => {
    try { return new URLSearchParams(window.location.search || '').has('nh_design'); }
    catch (_) { return false; }
  })();
  let resolveDesignShareInitialized;
  const designShareInitialized = new Promise(resolve => { resolveDesignShareInitialized = resolve; });
  let hiddenDraftAutoSaveEnabled = false;
  let hiddenDraftSaveTimer = null;
  const draftModalEl = document.getElementById('draft-modal');
  const draftModalResumeBtn = document.getElementById('draft-resume-btn');
  const draftModalDiscardBtn = document.getElementById('draft-discard-btn');
  const draftModalCloseBtn = draftModalEl ? draftModalEl.querySelector('.draft-close') : null;
  const draftModalBackdrop = draftModalEl ? draftModalEl.querySelector('.draft-backdrop') : null;
  const draftModalMessageEl = document.getElementById('draft-modal-message');
  const welcomeModalEl = document.getElementById('welcome-modal');
  const welcomeStartBtn = document.getElementById('welcome-start-btn');
  const welcomeLoadBtn = document.getElementById('welcome-load-btn');
  const welcomeCloseBtn = welcomeModalEl ? welcomeModalEl.querySelector('.welcome-close') : null;
  const welcomeBackdrop = welcomeModalEl ? welcomeModalEl.querySelector('.welcome-backdrop') : null;
  let welcomeModalShown = false;

  let hiddenDraftBaselineFingerprint = null;
  const savedDesignFingerprints = new Set();

  function markDesignSaved(fingerprint) {
    if (fingerprint) savedDesignFingerprints.add(fingerprint);
  }

  function hasUnsavedDesignChanges() {
    if (!hiddenDraftBaselineFingerprint) return false;
    const fingerprint = currentDesignFingerprint();
    return fingerprint !== hiddenDraftBaselineFingerprint && !savedDesignFingerprints.has(fingerprint);
  }

  let historyIdCounter = 0;

  function ensureHistoryId(obj, prefix = 'obj') {
    if (!obj) return null;
    if (!obj._historyId) {
      historyIdCounter += 1;
      obj._historyId = `${prefix}-${historyIdCounter}`;
    }
    return obj._historyId;
  }

  function updateHistoryCounterFromCanvas() {
    const max = canvas.getObjects().reduce((acc, obj) => {
      const id = obj?._historyId;
      if (!id) return acc;
      const number = parseInt(String(id).replace(/[^0-9]/g, ''), 10);
      return Number.isFinite(number) ? Math.max(acc, number) : acc;
    }, historyIdCounter);
    historyIdCounter = Math.max(historyIdCounter, max);
  }

  function isTrackableObject(obj) {
    return !!(obj && !obj._helperUI && !obj.excludeFromHistory);
  }

  function describeHistoryAction(kind, obj) {
    const noun = obj?._isBackground
      ? 'Hintergrund'
      : obj?._isQr
        ? 'QR-Code'
        : obj?.isEmoji
          ? 'Emoji'
          : obj?.type === 'i-text'
            ? 'Text'
            : obj?.type === 'image'
              ? 'Bild'
              : obj?.type === 'group'
                ? 'Gruppe'
                : 'Element';

    const verb = (() => {
      switch (kind) {
        case 'added': return 'hinzugefügt';
        case 'removed': return 'entfernt';
        case 'color': return 'Farbe geändert';
        case 'alignment': return 'Ausrichtung geändert';
        case 'font': return 'Schrift geändert';
        case 'toggle': return 'umgeschaltet';
        case 'reorder': return 'Reihenfolge geändert';
        default: return 'geändert';
      }
    })();

    return `${noun} ${verb}`;
  }

  const historyDom = {
    undo: document.getElementById('history-undo'),
    redo: document.getElementById('history-redo'),
    remove: document.getElementById('history-remove')
  };

  const removeBtn = historyDom.remove || null;
  if (removeBtn) removeBtn.disabled = true;

  function canRemoveObject(obj) {
    if (!obj) return false;
    if (obj._helperUI) return false;
    if (obj._isBackground) return false;
    return true;
  }

  function syncRemoveButtonState() {
    if (!removeBtn) return;
    removeBtn.disabled = !getActiveTargets().some(canRemoveObject);
  }

  function removeActiveCanvasObject() {
    // A Fabric activeSelection is a temporary wrapper, not a canvas object.
    // Keep a single deletion path for individual objects and multiple selections.
    return removeActiveSelection();
  }

  if (removeBtn) {
    removeBtn.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      removeActiveCanvasObject();
    });

    ['selection:created', 'selection:updated', 'selection:cleared'].forEach(evt => {
      canvas.on(evt, syncRemoveButtonState);
    });
    canvas.on('object:added', syncRemoveButtonState);
    canvas.on('object:removed', syncRemoveButtonState);
    syncRemoveButtonState();
  }

  const historyService = createHistoryService(canvas, {
    maxEntries: HISTORY_MAX_ENTRIES,
    defaultDelay: HISTORY_DEFAULT_DELAY,
    toJSONProps: HISTORY_PROPS,
    onAfterRestore: () => {
      updateHistoryCounterFromCanvas();
      rebindCoreReferences();
      rebuildDynamicTextInputs();
      refreshLayerList?.();
      updateColorPickersUI?.();
      clampAllAboveBackground?.();
      resyncQrStateFromCanvas?.();
      resetGuideHelpers();
      ensureCenterGuides?.();
      hideCenterGuides?.();
      ensureBleedGuide?.();
      applyBleedClipToAllObjects?.();
      hideBleedGuide?.();
      syncOpacityControl?.();
      syncRemoveButtonState();
      syncRestoredImageUploadStatus();
      window.__nhSyncFontPanel?.();
      try { reapplySocialConstraints(); } catch (err) { console.warn('Social constraints restore failed', err); }
      setTimeout(() => {
        if (typeof syncSocialColorInput === 'function') {
          try { syncSocialColorInput(); } catch (err) { console.warn('Social color sync after restore failed', err); }
        }
        if (typeof syncSocialSizeControl === 'function') {
          try { syncSocialSizeControl(); } catch (err) { console.warn('Social size sync after restore failed', err); }
        }
      }, 0);
    }
  });
  window.historyService = historyService;

  let historyBaselineSynced = false;
  let nhFunnelEditorInitialized = false;

  function syncHistoryBaseline(label = 'Startzustand') {
    if (historyBaselineSynced) return;
    const currentState = historyService.state?.();
    if (currentState && currentState.size > 1) {
      historyBaselineSynced = true;
      return;
    }
    historyBaselineSynced = true;
    historyService.reset(label);
  }

  function pushHistory(label, options = {}) {
    historyService.record(label || 'Änderung', options);
    try {
      if (nhFunnelEditorInitialized && historyService.isRecording() && !historyService.isRestoring()) {
        nhFunnelCall('emit', 'design_started');
      }
    } catch (_) { /* Do not interfere with history. */ }
  }

  function ensureCenteredTextOrigin(obj) {
    if (!obj || obj.type !== 'i-text') return;
    // Changing the origin must not move the design or change its text alignment.
    const center = typeof obj.getCenterPoint === 'function' ? obj.getCenterPoint() : null;
    if (center && typeof obj.setPositionByOrigin === 'function') {
      obj.set({ originX: 'center' });
      obj.setPositionByOrigin(center, 'center', 'center');
      obj.setCoords?.();
    }
    if (obj.canvas && typeof obj.canvas.requestRenderAll === 'function') {
      obj.canvas.requestRenderAll();
    }
    scheduleTextMetricRefresh([0, 80]);
  }

  historyService.onChange(state => renderHistoryUI(state, historyDom));
  historyService.onChange(() => scheduleHiddenDraftSave());

  if (historyDom.undo) historyDom.undo.addEventListener('click', () => historyService.undo());
  if (historyDom.redo) historyDom.redo.addEventListener('click', () => historyService.redo());

  document.addEventListener('keydown', (e) => {
    const tag = (e.target && e.target.tagName || '').toLowerCase();
    if (tag === 'input' || tag === 'textarea' || canvas.getActiveObject()?.isEditing) return;
    const meta = e.metaKey || e.ctrlKey;
    if (!meta) return;
    const key = String(e.key || '').toLowerCase();

    if (key === 'z' && !e.shiftKey) {
      e.preventDefault();
      historyService.undo();
    } else if (key === 'z' && e.shiftKey) {
      e.preventDefault();
      historyService.redo();
    } else if (key === 'y') {
      e.preventDefault();
      historyService.redo();
    }
  });

  // === Responsive Canvas-Scaling ===============================================
  const BASE_W = 450;  // entspricht deinem initialen <canvas width="450">
  const BASE_H = 290;  // entspricht deinem initialen <canvas height="290">
  let __nhEditorBaseZoom = 1;

  function getLogicalSize() {
    const zoom = getZoomSafe() || 1;
    return {
      w: canvas.getWidth() / zoom,
      h: canvas.getHeight() / zoom
    };
  }
  function getZoomSafe() {
    return (typeof canvas.getZoom === 'function' && canvas.getZoom()) || 1;
  }
  function getLogicalCenter() {
    const s = getLogicalSize();
    return { x: s.w / 2, y: s.h / 2 };
  }

  const MIN_LAYOUT_WIDTH = 32;
  let fitCanvasRetryHandle = null;
  let fitCanvasRetryCount = 0;

  function fitCanvasToPreview(options = {}) {
    const wrap = document.querySelector('.preview');
    if (!wrap) return;

    const cs = getComputedStyle(wrap);
    const padX =
      (parseFloat(cs.paddingLeft) || 0) + (parseFloat(cs.paddingRight) || 0);
    const padY =
      (parseFloat(cs.paddingTop) || 0) + (parseFloat(cs.paddingBottom) || 0);

    let innerWidth = wrap.clientWidth;
    if (!innerWidth) innerWidth = wrap.getBoundingClientRect().width;
    let availW = Number.isFinite(innerWidth) ? Math.max(0, innerWidth - padX) : 0;
    let innerHeight = wrap.clientHeight;
    if (!innerHeight) innerHeight = wrap.getBoundingClientRect().height;
    const availH = Number.isFinite(innerHeight) ? Math.max(0, innerHeight - padY) : 0;

    const widthInvalid = !Number.isFinite(availW) || availW < MIN_LAYOUT_WIDTH;
    if (widthInvalid) {
      if (
        typeof requestAnimationFrame === 'function' &&
        fitCanvasRetryHandle == null &&
        fitCanvasRetryCount < 6
      ) {
        // Layout ist noch nicht final – beim nächsten Frame erneut versuchen.
        fitCanvasRetryHandle = requestAnimationFrame(() => {
          fitCanvasRetryHandle = null;
          fitCanvasToPreview({ force: true });
        });
        fitCanvasRetryCount += 1;
      }
      if (!options.force) {
        return;
      }
    } else if (fitCanvasRetryHandle != null && typeof cancelAnimationFrame === 'function') {
      cancelAnimationFrame(fitCanvasRetryHandle);
      fitCanvasRetryHandle = null;
    }

    if (!widthInvalid) {
      fitCanvasRetryCount = 0;
    }

    if (widthInvalid) {
      availW = BASE_W; // Fallback auf Originalgröße, bis echte Maße vorliegen.
    }

    // Auf schmalen Layouts muss auch die verfuegbare Hoehe beruecksichtigt
    // werden, damit das Motiv bei breiteren Smartphones komplett sichtbar bleibt.
    const widthScale = availW / BASE_W;
    const isMobileLayout = window.matchMedia('(max-width: 760px)').matches;
    const mobileTrimSafety = 1.08;
    const heightScale = availH > MIN_LAYOUT_WIDTH
      ? availH / (BASE_H * mobileTrimSafety)
      : widthScale;
    const scale = isMobileLayout
      ? Math.min(widthScale, heightScale)
      : widthScale;
    __nhEditorBaseZoom = scale;

    // physische Canvas-Pixel (für knackige Darstellung)
    const pixelW = Math.round(BASE_W * scale);
    const pixelH = Math.round(BASE_H * scale);

    // 1) Canvas-Pixel anpassen
    canvas.setDimensions({ width: pixelW, height: pixelH });

    // 2) Viewport-Transform setzen (ohne Offsets)
    canvas.setViewportTransform([scale, 0, 0, scale, 0, 0]);

      if (typeof ensureCenterGuides === 'function') ensureCenterGuides();
      if (typeof ensureBleedGuide === 'function') ensureBleedGuide();
    canvas.requestRenderAll();

    // Falls der Delete-Button sichtbar ist, korrekt repositionieren
    if (typeof updateDeleteBtnPosition === 'function') {
      try { updateDeleteBtnPosition(); } catch {}
    }
  }

  // on load/resize & bei Layout-Änderungen neu rechnen
  window.addEventListener('load', () => {
    fitCanvasToPreview();
    // kleiner Tick, falls Layout erst nach Render final ist (Sidebar/Fonts)
    setTimeout(fitCanvasToPreview, 0);
  });
window.addEventListener('resize', fitCanvasToPreview);

  // reagiert auch auf Sidebar-Embedding, Panel-Wechsel usw.
  const __previewEl = document.querySelector('.preview');
  if (window.ResizeObserver && __previewEl) {
    new ResizeObserver(() => fitCanvasToPreview()).observe(__previewEl);
  }

    // ===== EBENEN-MANAGER =========================================================

    // Hilfs-Referenzen
    const $btnTop     = document.getElementById('layer-top');
    const $btnUp      = document.getElementById('layer-up');
    const $btnDown    = document.getElementById('layer-down');
    const $btnBottom  = document.getElementById('layer-bottom');
    const $layerList  = document.getElementById('nh-layer-list');

    // Welche Objekte sollen in der Ebenenliste erscheinen?
    function layerableObjects(){
      return canvas.getObjects().filter(o => {
        // Hintergrundform & Helper aussortieren
        if (o === window.oval) return false;
        if (o._helperUI || o.excludeFromExport) return false;
        return true;
      });
    }

    // Aktives, „layerbares“ Objekt
    function activeLayerObject(){
      const a = canvas.getActiveObject();
      return (a && layerableObjects().includes(a)) ? a : null;
    }

    let layerDragState = null;

    function layerLabel(object) {
      const rawText = typeof object?.text === 'string'
        ? object.text.trim().replace(/\s+/g, ' ')
        : '';
      const fallbackLabel = object?._isQr
        ? 'QR-Code'
        : object?.type === 'image'
          ? 'Bild'
          : object?.type === 'group'
            ? 'Elementgruppe'
            : 'Element';
      const label = object?._inputLabel || rawText || fallbackLabel;
      return label.length > 42 ? `${label.slice(0, 39)}…` : label;
    }

    function applyLayerDisplayOrder(displayObjects) {
      const desiredBottomToTop = displayObjects.slice().reverse();
      const { minIdx } = zBounds();
      desiredBottomToTop.forEach((object, index) => {
        canvas.moveTo(object, minIdx + index);
      });
      canvas.requestRenderAll();
    }

    function finishLayerDrag() {
      if (!layerDragState) return;
      const { object, moved } = layerDragState;
      layerDragState = null;
      document.body?.classList.remove('is-layer-dragging');
      if (object && canvas.getObjects().includes(object)) {
        canvas.setActiveObject(object);
      }
      refreshLayerList();
      if (moved && !historyService.isRestoring()) {
        pushHistory('Ebenenreihenfolge geändert', { immediate: true });
      }
    }

    function handleLayerDragMove(event) {
      if (!layerDragState) return;
      event.preventDefault();

      const rows = Array.from($layerList?.querySelectorAll('.layer-list__item[data-layer-id]') || []);
      if (!rows.length) return;
      const targetRow = rows.reduce((nearest, row) => {
        const rect = row.getBoundingClientRect();
        const distance = Math.abs(event.clientY - (rect.top + rect.height / 2));
        return !nearest || distance < nearest.distance ? { row, distance } : nearest;
      }, null)?.row;
      if (!targetRow) return;

      const displayObjects = layerableObjects().slice().reverse();
      const dragged = layerDragState.object;
      const target = displayObjects.find(object => ensureHistoryId(object) === targetRow.dataset.layerId);
      if (!target || target === dragged) return;

      const withoutDragged = displayObjects.filter(object => object !== dragged);
      let insertionIndex = withoutDragged.indexOf(target);
      if (insertionIndex < 0) return;
      const rect = targetRow.getBoundingClientRect();
      if (event.clientY > rect.top + rect.height / 2) insertionIndex += 1;

      withoutDragged.splice(insertionIndex, 0, dragged);
      const currentDisplay = layerableObjects().slice().reverse();
      const changed = withoutDragged.some((object, index) => object !== currentDisplay[index]);
      if (!changed) return;

      applyLayerDisplayOrder(withoutDragged);
      layerDragState.moved = true;
      layerDragState.displayIndex = insertionIndex;
      canvas.setActiveObject(dragged);
      refreshLayerList();
    }

    document.addEventListener('pointermove', handleLayerDragMove, { passive: false });
    document.addEventListener('pointerup', finishLayerDrag);
    document.addEventListener('pointercancel', finishLayerDrag);

    function refreshLayerList(){
      updateLayerButtons();
      if ($layerList) {
        const objects = layerableObjects().slice().reverse();
        const active = activeLayerObject();
        $layerList.replaceChildren();

        if (!objects.length) {
          const empty = document.createElement('p');
          empty.className = 'layer-list__empty';
          empty.textContent = 'Noch keine bearbeitbaren Elemente vorhanden.';
          $layerList.appendChild(empty);
        } else {
          objects.forEach((object, index) => {
            const item = document.createElement('div');
            item.className = 'layer-list__item';
            item.classList.toggle('is-active', object === active);
            item.classList.toggle('is-dragging', object === layerDragState?.object);
            item.dataset.layerId = ensureHistoryId(object);

            const number = document.createElement('span');
            number.className = 'layer-list__index';
            number.setAttribute('aria-hidden', 'true');
            number.textContent = String(index + 1);

            const copy = document.createElement('span');
            copy.className = 'layer-list__copy';
            copy.textContent = layerLabel(object);

            const selectButton = document.createElement('button');
            selectButton.type = 'button';
            selectButton.className = 'layer-list__select';
            selectButton.setAttribute('aria-label', `${copy.textContent} auswählen`);
            selectButton.append(number, copy);
            selectButton.addEventListener('click', () => {
              canvas.setActiveObject(object);
              object.setCoords();
              canvas.requestRenderAll();
              refreshLayerList();
            });

            const dragHandle = document.createElement('button');
            dragHandle.type = 'button';
            dragHandle.className = 'layer-list__drag';
            dragHandle.textContent = '⠿';
            dragHandle.title = 'Ebene ziehen';
            dragHandle.setAttribute('aria-label', `${copy.textContent} verschieben`);
            dragHandle.addEventListener('pointerdown', event => {
              if (event.button !== undefined && event.button !== 0) return;
              event.preventDefault();
              event.stopPropagation();
              canvas.setActiveObject(object);
              layerDragState = {
                object,
                displayIndex: index,
                moved: false,
                pointerId: event.pointerId
              };
              document.body?.classList.add('is-layer-dragging');
              item.classList.add('is-dragging');
            });

            item.append(selectButton, dragHandle);
            $layerList.appendChild(item);
          });
        }
      }
      canvas.requestRenderAll();
    }
    window.__nhRefreshLayerList = refreshLayerList;

    // Buttons aktivieren/deaktivieren
    function updateLayerButtons(){
      const o = activeLayerObject();
      const dis = (el, flag) => el && (el.disabled = !!flag);

      const objs = layerableObjects();
      const idx  = o ? canvas.getObjects().indexOf(o) : -1;
      const bgIdx = canvas.getObjects().findIndex(o => o._isBackground);

      // Bewegungsgrenzen
      // unten = direkt über der Hintergrundform (bgIdx + 1)
      const minIdx = (bgIdx >= 0) ? bgIdx + 1 : 0;
      const maxIdx = canvas.getObjects().length - 1;

      dis($btnTop,    !o || idx >= maxIdx);
      dis($btnBottom, !o || idx <= minIdx);
      dis($btnUp,     !o || idx >= maxIdx);
      dis($btnDown,   !o || idx <= minIdx);
    }

    // 👉 HINTERGRUND-Index & Grenzen ermitteln (ignoriert Helper-Objekte)
    function zBounds() {
      const objs = canvas.getObjects();
      const bgIdx = objs.findIndex(o => o._isBackground);

      // oberster erlaubter Index = letzter nicht-Helper
      let topIdx = objs.length - 1;
      for (let i = objs.length - 1; i >= 0; i--) {
        const o = objs[i];
        if (o?._helperUI || o?.excludeFromExport) continue;
        topIdx = i; break;
      }

      const minIdx = bgIdx >= 0 ? bgIdx + 1 : 0;          // nie unter den Hintergrund
      const maxIdx = Math.max(minIdx, topIdx);
      return { objs, bgIdx, minIdx, maxIdx };
    }

    function moveToClamped(o, target) {
      const { minIdx, maxIdx } = zBounds();
      const clamped = Math.min(maxIdx, Math.max(minIdx, target));
      const current = canvas.getObjects().indexOf(o);
      if (clamped === current) return;                    // nichts zu tun
      canvas.moveTo(o, clamped);                          // direkt setzen (ohne Back/Forward)
      canvas.setActiveObject(o);
      canvas.requestRenderAll();
      refreshLayerList();
      if (!historyService.isRestoring()) {
        pushHistory('Ebenenreihenfolge geändert', { immediate: true });
      }
    }

    function moveTop() {
      const o = activeLayerObject(); if (!o) return;
      const { maxIdx } = zBounds();
      moveToClamped(o, maxIdx);
    }
    function moveUp() {
      const o = activeLayerObject(); if (!o) return;
      const idx = canvas.getObjects().indexOf(o);
      moveToClamped(o, idx + 1);
    }
    function moveDown() {
      const o = activeLayerObject(); if (!o) return;
      const idx = canvas.getObjects().indexOf(o);
      moveToClamped(o, idx - 1);
    }
    function moveBottom() {
      const o = activeLayerObject(); if (!o) return;
      const { minIdx } = zBounds();
      moveToClamped(o, minIdx);
    }

    // Buttons verdrahten
    function bindImmediate(btn, fn){
      if(!btn) return;
      const h = (e)=>{ e.preventDefault(); e.stopPropagation(); fn(e); };
      btn.addEventListener('click', h, {passive:false});
    }
    bindImmediate($btnTop,    moveTop);
    bindImmediate($btnUp,     moveUp);
    bindImmediate($btnDown,   moveDown);
    bindImmediate($btnBottom, moveBottom);

    // Refresh an Canvas-Events koppeln
    ['object:added','object:removed','object:modified',
     'selection:created','selection:updated','selection:cleared']
      .forEach(ev => canvas.on(ev, refreshLayerList));

    // Beim Formwechsel (Oval/Rechteck) sicherstellen, dass Grenzen stimmen
    const _origToggleShape = window.toggleShape;
    window.toggleShape = function(){
      if (typeof _origToggleShape === 'function') _origToggleShape();
      refreshLayerList();
    };

    // Keyboard-Shortcuts: Ctrl+[ / Ctrl+] / Shift-Kombi
    document.addEventListener('keydown', (e) => {
      const tag = (e.target && e.target.tagName || '').toLowerCase();
      const editing = canvas.getActiveObject()?.isEditing;
      if (tag === 'input' || tag === 'textarea' || editing) return;

      if (e.ctrlKey && e.shiftKey && e.key === ']'){ e.preventDefault(); moveTop(); }
      else if (e.ctrlKey && e.shiftKey && e.key === '['){ e.preventDefault(); moveBottom(); }
      else if (e.ctrlKey && e.key === ']'){ e.preventDefault(); moveUp(); }
      else if (e.ctrlKey && e.key === '['){ e.preventDefault(); moveDown(); }
    });

    // Erstaufbau
    window.addEventListener('load', refreshLayerList);

  function applyInitialTexts() {
    const titleInput = document.getElementById('title-input');
    const sloganInput = document.getElementById('slogan-input');
    const title = (titleInput?.value ?? DEFAULT_TITLE_TEXT).trimEnd();
    const slogan = (sloganInput?.value ?? DEFAULT_SLOGAN_TEXT).trimEnd();

    const centerX = (window.oval && window.oval.left) || (canvas.getWidth() / 2);

    if (textTop) {
      const text = title || DEFAULT_TITLE_TEXT;
      textTop.set({
        text,
        visible: !!text.trim().length,
        padding: 8,
        originX: 'center',
        left: centerX
      });
      if (typeof textTop._clearCache === 'function') textTop._clearCache();
      if (typeof textTop.initDimensions === 'function') textTop.initDimensions();
      if (typeof textTop.setCoords === 'function') textTop.setCoords();
    }

    if (textBottom) {
      const text = slogan || DEFAULT_SLOGAN_TEXT;
      textBottom.set({
        text,
        visible: !!text.trim().length,
        padding: 8,
        originX: 'center',
        left: centerX
      });
      if (typeof textBottom._clearCache === 'function') textBottom._clearCache();
      if (typeof textBottom.initDimensions === 'function') textBottom.initDimensions();
      if (typeof textBottom.setCoords === 'function') textBottom.setCoords();
    }

    canvas.requestRenderAll();
    scheduleTextMetricRefresh([0, 120, 360]);
  }

  let initialTextsReady;
  if (document?.fonts?.load) {
    // Nur die Standard-Canvas-Schrift (Playfair) vorwärmen, damit der erste Render stimmt
    initialTextsReady = ensureFontLoaded('Playfair Display', ['400', '700'], ['normal', 'italic'], 64)
      .then(applyInitialTexts)
      .catch(err => {
        console.warn('Fonts konnten nicht rechtzeitig geladen werden', err);
        applyInitialTexts();
      });
  } else {
    applyInitialTexts();
    initialTextsReady = Promise.resolve();
  }

  // ——— Maßeinheiten ———
  const MM_PER_INCH = 25.4;
  const CSS_DPI = 96; // Browser-CSS px pro Zoll

  function mmToPx(mm, dpi = CSS_DPI) { return Math.round(mm * dpi / MM_PER_INCH); }
  function pxToMm(px, dpi = CSS_DPI) { return px * MM_PER_INCH / dpi; }
  function mmToPt(mm) { return mm * 72 / MM_PER_INCH; }

let isExporting = false;
let backgroundExportJob = null;
window.__pendingDesignExports = null;
let previewContext = null;
let releaseIdModalFocusTrap = null;
let previousActiveElement = null;
let copyFeedbackTimer = null;
const MODAL_FOCUSABLE_SELECTOR = [
  'button:not([disabled])',
  'a[href]',
  'input:not([type="hidden"]):not([disabled])',
  'select:not([disabled])',
  'textarea:not([disabled])',
  '[tabindex]:not([tabindex="-1"])'
].join(', ');
let qrObject = null;               // ✅
let qrLogoImage = null;            // ✅ QR-Overlay-Bild separat tracken
let qrIdCounter = 0;
let qrRenderCounter = 0;
window.qrObject = null;
window.qrLogoImage = null;

const EXPORT_PROGRESS_EVENT = 'nh:export-progress';
function emitExportProgress(rawValue) {
  const value = Math.max(0, Math.min(1, Number(rawValue) || 0));
  try {
    window.dispatchEvent(new CustomEvent(EXPORT_PROGRESS_EVENT, { detail: { value } }));
  } catch (err) {
    try {
      document.dispatchEvent(new CustomEvent(EXPORT_PROGRESS_EVENT, { detail: { value } }));
    } catch (_) { /* noop */ }
  }
  try {
    if (window.parent && window.parent !== window && typeof window.parent.postMessage === 'function') {
      window.parent.postMessage({ type: 'NH_EXPORT_PROGRESS', value }, '*');
    }
  } catch (err) {
    /* noop */
  }
}

  let currentTextColor = '#000';
  let currentTextFont = 'Playfair Display';
  let opacityControl = null;
  let opacityValueDisplay = null;

  let isOval = true;
  window.isOval = true;
  let oval = new fabric.Ellipse({
    rx: 221.31,
    ry: 127.73,
    left: 225,
    top: 157.5,
    fill: '#ffff00',
    originX: 'center',
    originY: 'center',
    selectable: false,
    evented: false,
    hasControls: false,
    strokeUniform: true
  });
  oval._isBackground = true;         // 👈 eindeutig als Hintergrund markieren

  const DEFAULT_TITLE_TEXT = 'Nett hier.';
  const DEFAULT_SLOGAN_TEXT = 'Aber waren Sie schon mal in...';

  let textTop = new fabric.IText('', {
    fontSize: 45,
    top: 88,
    left: 135,
    fill: '#000',
    fontFamily: 'Playfair Display',
    textAlign: 'center',
    padding: 8,
    visible: false

  });

  let textBottom = new fabric.IText('', {
    fontSize: 16,
    top: 152,
    left: 120,
    fill: '#000',
    fontFamily: 'Playfair Display',
    textAlign: 'center',
    padding: 8,
    visible: false
  });

  canvas.add(oval, textTop, textBottom);
  oval.sendToBack();
  if (typeof refreshTextMetrics === 'function') {
    refreshTextMetrics(); // sofort nach dem ersten Aufbau nachziehen
  }


  oval._historyId = 'background';
  textTop._historyId = 'text-top';
  textBottom._historyId = 'text-bottom';
  textTop._inputLabel = 'Titel';
  textBottom._inputLabel = 'Slogan';
  textTop._linkedInputId = 'title-input';
  textBottom._linkedInputId = 'slogan-input';
  textTop.__wasCenteredOnce = true;
  textBottom.__wasCenteredOnce = true;
  ensureHistoryId(oval, 'background');
  ensureHistoryId(textTop, 'text');
  ensureHistoryId(textBottom, 'text');
  window.oval = oval;
  window.textTop = textTop;
  window.textBottom = textBottom;


  function getRx() {
    return isOval ? oval.rx : oval.width / 2;
  }
  function getRy() {
    return isOval ? oval.ry : oval.height / 2;
  }
  function centerOnShape(obj, yOffset = 0) {
    if (!obj) return;
    const shapeCenter = (oval && typeof oval.getCenterPoint === 'function')
      ? oval.getCenterPoint()
      : getLogicalCenter();
    const targetLeft = shapeCenter?.x ?? getLogicalCenter().x;
    const targetTop  = (shapeCenter?.y ?? getLogicalCenter().y) + yOffset;

    obj.set({
      originX: 'center',
      originY: 'center',
      left: targetLeft,
      top:  targetTop
    });
  }

  function normalizeHexColor(input, fallback = '#000000') {
    if (!input && input !== 0) return fallback;
    let value = String(input).trim();
    if (!value) return fallback;
    if (/^rgba?\(/i.test(value)) {
      const parts = value.replace(/rgba?\(/i, '').replace(/\)/, '').split(',');
      if (parts.length >= 3) {
        const clamp = (n) => {
          const num = parseFloat(String(n).trim());
          if (!Number.isFinite(num)) return 0;
          return Math.max(0, Math.min(255, Math.round(num)));
        };
        const r = clamp(parts[0]);
        const g = clamp(parts[1]);
        const b = clamp(parts[2]);
        return `#${[r, g, b].map(n => n.toString(16).padStart(2, '0')).join('').toUpperCase()}`;
      }
      return fallback;
    }
    if (!value.startsWith('#')) value = `#${value}`;
    if (/^#([0-9a-f]{3})$/i.test(value)) {
      const h = value.slice(1);
      value = `#${h.split('').map(ch => `${ch}${ch}`).join('')}`;
    }
    if (/^#([0-9a-f]{6})$/i.test(value)) {
      return value.toUpperCase();
    }
    return fallback;
  }

  function applySocialColor(target, color) {
    const hex = normalizeHexColor(color);
    if (!target) return hex;
    const applyTo = (item) => {
      if (!item || typeof item.set !== 'function') return;
      if (item.fill !== undefined && item.fill !== null && item.fill !== 'none') {
        item.set('fill', hex);
      }
      if (item.stroke !== undefined && item.stroke !== null && item.stroke !== 'none') {
        item.set('stroke', hex);
      }
    };
    if (typeof target.forEachObject === 'function') {
      target.forEachObject(child => applyTo(child));
    }
    applyTo(target);
    target._socialColor = hex;
    target._isSocial = true;
    target.set('dirty', true);
    if (typeof target.setCoords === 'function') target.setCoords();
    return hex;
  }

  function detectSocialColor(target) {
    if (!target) return null;
    if (target._socialColor) return target._socialColor;
    let found = null;
    const inspect = (item) => {
      if (!item || found) return;
      if (item.fill && item.fill !== 'none') {
        found = item.fill;
      } else if (item.stroke && item.stroke !== 'none') {
        found = item.stroke;
      }
    };
    if (typeof target.forEachObject === 'function') {
      target.forEachObject(child => inspect(child));
    }
    inspect(target);
    return found;
  }

  function enforceSocialTransformLocks(target) {
    if (!target) return;
    target.lockScalingX = true;
    target.lockScalingY = true;
    target.lockScalingFlip = true;
    target.lockSkewingX = true;
    target.lockSkewingY = true;
    target.lockRotation = true;
    target.lockUniScaling = true;
    target.hasRotatingPoint = false;
    if (typeof target.set === 'function') {
      target.set({ hasBorders: true });
    }
    if (typeof target.setControlsVisibility === 'function') {
      target.setControlsVisibility({
        tl: false, tr: false, bl: false, br: false,
        ml: false, mt: false, mr: false, mb: false,
        mtr: false
      });
    }
  }

  function captureSocialScale(target) {
    if (!target) return 1;
    const scaleX = Number.isFinite(target.scaleX) ? Math.abs(target.scaleX) : 1;
    const scaleY = Number.isFinite(target.scaleY) ? Math.abs(target.scaleY) : 1;
    const average = (scaleX + scaleY) / 2 || 1;
    const stored = Number.isFinite(target._socialScale) ? target._socialScale : null;
    const normalized = stored && stored > 0 ? stored : average;
    target._socialScale = normalized;
    return normalized;
  }

  function reapplySocialConstraints() {
    if (!canvas || typeof canvas.getObjects !== 'function') return;
    const objects = canvas.getObjects().slice();
    objects.forEach(item => {
      if (!isSocialObject(item)) return;
      let target = item;
      if (target.type !== 'group') {
        target = ensureSocialGroup(target) || target;
      }
      enforceSocialTransformLocks(target);
      captureSocialScale(target);
    });
  }

  function isSocialObject(obj) {
    return !!(obj && (obj._isSocial || obj._socialBrand || /social/i.test(obj._historyId || '')));
  }

  function detectSocialLabel(target) {
    if (!target) return null;
    if (typeof target._socialLabel === 'string') return target._socialLabel;
    let label = null;
    const inspect = (item) => {
      if (!item || label) return;
      if (item.type === 'i-text' && typeof item.text === 'string') {
        label = item.text;
      }
    };
    if (typeof target.forEachObject === 'function') {
      target.forEachObject(child => inspect(child));
    }
    inspect(target);
    return label;
  }

  function detectSocialLabelFont(target) {
    if (!target) return null;
    if (typeof target._socialFont === 'string') return target._socialFont;
    let font = null;
    const inspect = (item) => {
      if (!item || font) return;
      if (item.type === 'i-text' && typeof item.fontFamily === 'string') {
        font = item.fontFamily;
      }
    };
    if (typeof target.forEachObject === 'function') {
      target.forEachObject(child => inspect(child));
    }
    inspect(target);
    return font;
  }

  function resolveSocialTarget(obj) {
    if (!obj) return null;
    if (isSocialObject(obj)) return obj;
    if (obj.group && isSocialObject(obj.group)) return obj.group;
    return null;
  }

  function ensureSocialGroup(target) {
    const resolved = resolveSocialTarget(target);
    if (!resolved) return null;
    if (resolved.type === 'group') return resolved;

    const icon = resolved;
    const center = icon.getCenterPoint ? icon.getCenterPoint() : { x: icon.left || 0, y: icon.top || 0 };
    const spacing = icon._socialSpacing || SOCIAL_SPACING;

    icon.set({ left: 0, top: 0, originX: 'center', originY: 'center' });

    const group = new fabric.Group([icon], {
      originX: 'center',
      originY: 'center'
    });

    group._isSocial = true;
    group._socialBrand = icon._socialBrand;
    group._socialColor = icon._socialColor;
    group._socialLabel = icon._socialLabel || '';
    group._socialSpacing = spacing;
    group._socialFont = icon._socialFont || detectSocialLabelFont(icon) || currentSocialFont;
    if (icon._historyId) group._historyId = icon._historyId;

    const insertGroup = () => {
      const objects = canvas.getObjects();
      const idx = objects.indexOf(icon);
      canvas.remove(icon);
      if (idx >= 0) {
        canvas.insertAt(group, idx);
      } else {
        canvas.add(group);
      }
    };

    if (historyService?.withoutRecording instanceof Function) {
      historyService.withoutRecording(insertGroup);
    } else {
      insertGroup();
    }

    group.set({ left: center.x, top: center.y });
    layoutSocialGroup(group, spacing);
    const parts = extractSocialParts(group);
    if (parts.label) {
      parts.label.set({ fontSize: SOCIAL_LABEL_FONT, fontFamily: group._socialFont || currentSocialFont });
      if (typeof parts.label.setCoords === 'function') parts.label.setCoords();
    }
    applySocialColor(group, group._socialColor || currentSocialColor);
    enforceSocialTransformLocks(group);
    captureSocialScale(group);
    ensureHistoryId(group, 'social');
    if (canvas.getActiveObject() === icon) {
      canvas.setActiveObject(group);
    }
    canvas.requestRenderAll();
    return group;
  }

  function extractSocialParts(target) {
    const result = { icon: null, label: null };
    if (!target) return result;
    const consider = (item) => {
      if (!item) return;
      if (!result.label && item.type === 'i-text') {
        result.label = item;
      } else if (!result.icon) {
        result.icon = item;
      }
    };
    if (typeof target.forEachObject === 'function') {
      target.forEachObject(child => consider(child));
    }
    consider(target);
    return result;
  }

  function layoutSocialGroup(target, spacingOverride) {
    if (!isSocialObject(target)) return;
    if (!target._socialFont) target._socialFont = currentSocialFont;
    const spacing = spacingOverride ?? target._socialSpacing ?? SOCIAL_SPACING;
    const parts = extractSocialParts(target);
    const icon = parts.icon;
    const label = parts.label;

    if (icon) {
      icon.set({ originX: 'center', originY: 'center' });
    }

    if (!icon) return;

    const iconWidth = (typeof icon.getScaledWidth === 'function') ? icon.getScaledWidth() : (icon.width || 0) * (icon.scaleX || 1);

    const hasLabel = Boolean(label && typeof label.text === 'string' && label.text.trim().length);
    let textWidth = (hasLabel && label)
      ? (label.width || 0) * (label.scaleX || 1)
      : 0;

    if (!hasLabel) {
      icon.set({ left: 0, top: 0 });
      if (label) {
        label.text = '';
        label.visible = false;
        label.set({ left: iconWidth / 2 + spacing, top: 0 });
      }
    } else {
      label.visible = true;
      label.set({ originX: 'left', originY: 'center' });
      const fontFamily = target._socialFont || label.fontFamily || currentSocialFont;
      label.fontFamily = fontFamily;
      target._socialFont = fontFamily;
      label.fontSize = SOCIAL_LABEL_FONT;
      if (typeof label.initDimensions === 'function') label.initDimensions();
      textWidth = (label.width || 0) * (label.scaleX || 1);
      const gap = Math.max(2, spacing * 0.18);
      const totalWidth = iconWidth + gap + textWidth;
      const leftBoundary = -totalWidth / 2;
      const iconCenterX = leftBoundary + iconWidth / 2;
      const textLeft = leftBoundary + iconWidth + gap;
      icon.set({ left: iconCenterX, top: 0 });
      label.set({ left: textLeft, top: 0 });
    }

    if (target.type === 'group') {
      target._socialSpacing = spacing;
      if (typeof target._calcBounds === 'function') target._calcBounds();
      if (typeof target._updateObjectsCoords === 'function') target._updateObjectsCoords();
      if (typeof target.setCoords === 'function') target.setCoords();
    } else if (typeof target.setCoords === 'function') {
      target.setCoords();
    }
  }
    const SOCIAL_ICON_BASE = 17.5;
    const SOCIAL_LABEL_FONT = 14;
    const SOCIAL_SPACING = 12;
    const SOCIAL_SCALE_PERCENT_MIN = 60;
    const SOCIAL_SCALE_PERCENT_MAX = 200;
    const SOCIAL_SCALE_PERCENT_DEFAULT = 100;
    const SOCIAL_FONT_DEFAULT = 'Playfair Display';
    const SOCIALS=['instagram','facebook','whatsapp','youtube','tiktok','x','threads','snapchat','telegram','pinterest','reddit'];
    const SOCIAL_LABELS = {
      instagram: 'Instagram',
      facebook: 'Facebook',
      whatsapp: 'WhatsApp',
      youtube: 'YouTube',
      tiktok: 'TikTok',
      x: 'X',
      threads: 'Threads',
      snapchat: 'Snapchat',
      telegram: 'Telegram',
      pinterest: 'Pinterest',
      reddit: 'Reddit'
    };
    let SOCIAL_ASSET_URLS = {};
    try {
      SOCIAL_ASSET_URLS = JSON.parse(document.getElementById('social-icon-assets')?.textContent || '{}');
    } catch (error) {
      console.warn('Social-Icon-Zuordnung konnte nicht gelesen werden.', error);
    }
    const grid=document.getElementById('social-grid');
    const socialColorInput = document.getElementById('social-color-input');
    const socialLabelWrapper = document.getElementById('social-text-wrapper');
    const socialLabelTitle = document.getElementById('social-text-label');
    const socialLabelInput = document.getElementById('social-text-input');
    const socialEditorStatus = document.getElementById('social-editor-status');
    const socialPlatformLabel = document.getElementById('social-platform-label');
    const socialTextHint = document.getElementById('social-text-hint');
    socialSizeSlider = document.getElementById('social-size-slider');
    socialSizeValue = document.getElementById('social-size-value');
    let currentSocialColor = normalizeHexColor(socialColorInput?.value || '#000000');
    let currentSocialFont = SOCIAL_FONT_DEFAULT;
    let socialLabelRevision = 0;
    let socialLabelBoundTarget = null;
    const socialLabelEdits = new WeakMap();
    let socialAddInFlight = false;
    let socialStatusError = false;

    function socialFieldDetails(brand) {
      const name = SOCIAL_LABELS[brand] || 'Social';
      if (brand === 'whatsapp') return {
        label: 'Telefonnummer (optional)', placeholder: '+49 170 1234567', inputMode: 'tel',
        hint: 'Deine Telefonnummer wird neben dem WhatsApp-Symbol aufgedruckt. Leer lassen für nur das Symbol.'
      };
      if (brand === 'facebook') return {
        label: 'Profil- oder Seitenname (optional)', placeholder: 'Dein Name oder Seitenname', inputMode: 'text',
        hint: 'Dein Profil- oder Seitenname wird neben dem Facebook-Symbol aufgedruckt. Leer lassen für nur das Symbol.'
      };
      if (brand === 'youtube') return {
        label: 'YouTube-Kanalname (optional)', placeholder: 'Dein Kanalname', inputMode: 'text',
        hint: 'Dein Kanalname wird neben dem YouTube-Symbol aufgedruckt. Leer lassen für nur das Symbol.'
      };
      return {
        label: `${name}-${brand === 'reddit' || brand === 'telegram' ? 'Benutzername' : 'Profilname'} (optional)`,
        placeholder: brand === 'reddit' ? 'u/deinname' : brand === 'pinterest' ? 'Dein Profilname' : '@deinname',
        inputMode: 'text',
        hint: `Dein Name wird neben dem ${name}-Symbol aufgedruckt. Leer lassen für nur das Symbol.`
      };
    }

    function setSocialEditorStatus(message, { error = false } = {}) {
      socialStatusError = error;
      if (!socialEditorStatus) return;
      if (socialEditorStatus.textContent !== message) socialEditorStatus.textContent = message;
      socialEditorStatus.setAttribute('data-error', String(error));
    }

    function syncSocialEditorInstructions(target) {
      if (socialPlatformLabel) socialPlatformLabel.textContent = target ? 'Weiteres Symbol hinzufügen' : 'Symbol hinzufügen';
      if (!socialAddInFlight && !socialStatusError) {
        const name = SOCIAL_LABELS[target?._socialBrand] || 'Social';
        setSocialEditorStatus(target
          ? `${name}-Symbol ausgewählt. Änderungen am Text werden sofort im Design übernommen.`
          : 'Wähle eine Plattform. Das Symbol wird direkt in dein Design eingefügt.');
      }
    }

    function setSocialAddPending(pending) {
      socialAddInFlight = pending;
      if (!grid) return;
      grid.setAttribute('aria-busy', String(pending));
      grid.querySelectorAll('.social-tile[data-social-brand]').forEach(tile => { tile.disabled = pending; });
    }

    function syncSocialTileState(target = resolveSocialTarget(canvas.getActiveObject())) {
      if (!grid) return;
      const activeBrand = target?._socialBrand || '';
      grid.style.setProperty('--social-icon-color', currentSocialColor);
      grid.querySelectorAll('.social-tile[data-social-brand]').forEach(tile => {
        const isActive = tile.dataset.socialBrand === activeBrand;
        tile.classList.toggle('is-active', isActive);
        tile.setAttribute('aria-pressed', String(isActive));
      });
    }

    function getSocialScaleBounds() {
      const minAttr = Number(socialSizeSlider?.min);
      const maxAttr = Number(socialSizeSlider?.max);
      const min = Number.isFinite(minAttr) ? minAttr : SOCIAL_SCALE_PERCENT_MIN;
      const max = Number.isFinite(maxAttr) ? maxAttr : SOCIAL_SCALE_PERCENT_MAX;
      const defaultValue = Math.min(max, Math.max(min, SOCIAL_SCALE_PERCENT_DEFAULT));
      return { min, max, defaultValue };
    }

    function clampSocialPercent(value) {
      const { min, max, defaultValue } = getSocialScaleBounds();
      const numeric = Number(value);
      if (!Number.isFinite(numeric)) return defaultValue;
      return Math.min(max, Math.max(min, numeric));
    }

    function updateSocialSizeSliderUI(value) {
      if (!socialSizeSlider) return;
      const { min, max } = getSocialScaleBounds();
      const percent = clampSocialPercent(value);
      const fill = max > min ? ((percent - min) / (max - min)) * 100 : 0;
      socialSizeSlider.style.setProperty('--fill', `${fill}%`);
      if (socialSizeValue) {
        socialSizeValue.textContent = `${Math.round(percent)}%`;
      }
    }

    function deriveSocialScalePercent(target) {
      if (!target) return clampSocialPercent(SOCIAL_SCALE_PERCENT_DEFAULT);
      const social = target.type === 'group' ? target : resolveSocialTarget(target);
      if (!social) return clampSocialPercent(SOCIAL_SCALE_PERCENT_DEFAULT);
      const scale = captureSocialScale(social);
      return clampSocialPercent(scale * 100);
    }

    function syncSocialSizeControl() {
      if (!socialSizeSlider) return;
      const { defaultValue } = getSocialScaleBounds();
      const active = canvas.getActiveObject();
      let socialTarget = resolveSocialTarget(active);
      if (socialTarget && socialTarget.type !== 'group') {
        socialTarget = ensureSocialGroup(socialTarget) || socialTarget;
      }
      if (!socialTarget || !isSocialObject(socialTarget)) {
        socialSizeSlider.disabled = true;
        socialSizeSlider.value = defaultValue;
        updateSocialSizeSliderUI(defaultValue);
        return;
      }
      enforceSocialTransformLocks(socialTarget);
      const percent = deriveSocialScalePercent(socialTarget);
      socialSizeSlider.disabled = false;
      socialSizeSlider.value = percent;
      updateSocialSizeSliderUI(percent);
    }

    function applySocialScale(percent, { commit = false } = {}) {
      if (!socialSizeSlider || historyService?.isRestoring?.()) return;
      let active = resolveSocialTarget(canvas.getActiveObject());
      if (!active) return;
      active = ensureSocialGroup(active) || active;
      if (!active) return;
      const clamped = clampSocialPercent(percent);
      const scale = clamped / 100;
      const prevCenter = active.getCenterPoint ? active.getCenterPoint() : null;
      const prevAngle = Number.isFinite(active.angle) ? active.angle : 0;
      active.scaleX = scale;
      active.scaleY = scale;
      active._socialScale = scale;
      active.set({ angle: prevAngle });
      if (prevCenter) {
        active.set({ left: prevCenter.x, top: prevCenter.y });
      }
      enforceSocialTransformLocks(active);
      if (typeof active.setCoords === 'function') active.setCoords();
      if (typeof active.forEachObject === 'function') {
        active.forEachObject(child => {
          if (typeof child.setCoords === 'function') child.setCoords();
        });
      }
      canvas.requestRenderAll();
      captureSocialScale(active);
      syncSocialSizeControl();
      if (commit && !historyService?.isRestoring?.()) {
        pushHistory('Social-Größe angepasst', { immediate: true });
      }
    }

    if (socialSizeSlider) {
      const { defaultValue } = getSocialScaleBounds();
      const initialValue = clampSocialPercent(socialSizeSlider.value || defaultValue);
      socialSizeSlider.value = initialValue;
      updateSocialSizeSliderUI(initialValue);
      socialSizeSlider.disabled = true;

      const handleSocialSizeInput = (commit) => {
        const value = clampSocialPercent(socialSizeSlider.value);
        updateSocialSizeSliderUI(value);
        applySocialScale(value, { commit });
      };

      socialSizeSlider.addEventListener('input', () => handleSocialSizeInput(false));
      socialSizeSlider.addEventListener('change', () => handleSocialSizeInput(true));
    }

    function syncSocialColorInput({ focus = false, source = '' } = {}) {
      if (!socialColorInput) return;
      const active = canvas.getActiveObject();
      const socialTarget = resolveSocialTarget(active);
      const targetChanged = socialLabelBoundTarget !== socialTarget;
      if (targetChanged) {
        socialLabelBoundTarget = socialTarget;
        socialStatusError = false;
      }
      if (socialTarget) {
        const detected = normalizeHexColor(socialTarget._socialColor || detectSocialColor(socialTarget) || currentSocialColor, currentSocialColor);
        currentSocialColor = detected;
        if (socialColorInput.value !== detected) {
          socialColorInput.value = detected;
        }
        socialColorInput.style.backgroundColor = detected;
        if (socialLabelInput) {
          const label = detectSocialLabel(socialTarget);
          const pendingEdit = socialLabelEdits.get(socialTarget);
          if (targetChanged || !pendingEdit?.pending) {
            socialLabelInput.value = pendingEdit?.pending ? pendingEdit.value : (typeof label === 'string' ? label : '');
          }
          // Existing selection/drag events request focus too. Only an explicit
          // tile insertion may move focus into the name field.
          if (focus && source === 'insert') {
            const focusTarget = socialTarget;
            setTimeout(() => {
              const panel = document.getElementById('social');
              if (!socialLabelInput || !panel?.classList.contains('active')
                || resolveSocialTarget(canvas.getActiveObject()) !== focusTarget
                || !canvas.contains(focusTarget)) return;
              try {
                socialLabelInput.focus();
              } catch (err) {
                // A hidden/removed field must never interrupt the editor.
              }
            }, 0);
          }
        }
        const labelFont = detectSocialLabelFont(socialTarget) || currentSocialFont;
        currentSocialFont = labelFont;
        if (socialLabelWrapper) {
          socialLabelWrapper.hidden = false;
          socialLabelWrapper.style.display = 'block';
        }
        if (socialLabelTitle) {
          socialLabelTitle.textContent = socialFieldDetails(socialTarget._socialBrand).label;
        }
        const details = socialFieldDetails(socialTarget._socialBrand);
        if (socialLabelInput) {
          socialLabelInput.placeholder = details.placeholder;
          socialLabelInput.setAttribute('inputmode', details.inputMode);
          socialLabelInput.setAttribute('autocapitalize', 'off');
          socialLabelInput.setAttribute('spellcheck', 'false');
        }
        if (socialTextHint) {
          socialTextHint.textContent = details.hint;
        }
      } else {
        const normalized = normalizeHexColor(currentSocialColor);
        currentSocialColor = normalized;
        if (socialColorInput.value !== normalized) {
          socialColorInput.value = normalized;
        }
        socialColorInput.style.backgroundColor = normalized;
        if (socialLabelWrapper) {
          socialLabelWrapper.hidden = true;
          socialLabelWrapper.style.display = 'none';
        }
        if (socialLabelInput) {
          socialLabelInput.value = '';
        }
        if (socialLabelTitle) {
          socialLabelTitle.textContent = 'Profilname (optional)';
        }
        if (socialTextHint) socialTextHint.textContent = 'Wähle zuerst ein Symbol aus.';
      }
      syncSocialEditorInstructions(socialTarget);
      syncSocialTileState(socialTarget);
      syncSocialSizeControl();
    }

    if (socialColorInput) {
      currentSocialColor = normalizeHexColor(socialColorInput.value || currentSocialColor);
      socialColorInput.value = currentSocialColor;
      socialColorInput.style.backgroundColor = currentSocialColor;
      const handleSocialColorChange = () => {
        const newHex = normalizeHexColor(socialColorInput.value || currentSocialColor, currentSocialColor);
        if (socialColorInput.value !== newHex) {
          socialColorInput.value = newHex;
        }
        socialColorInput.style.backgroundColor = newHex;
        const active = resolveSocialTarget(canvas.getActiveObject());
        currentSocialColor = newHex;
        if (grid) grid.style.setProperty('--social-icon-color', newHex);
        if (active) {
          const prev = normalizeHexColor(active._socialColor || detectSocialColor(active) || newHex, newHex);
          const applied = applySocialColor(active, newHex);
          if (applied !== prev && !historyService.isRestoring()) {
            pushHistory('Social-Farbe geändert', { immediate: true });
          }
          canvas.requestRenderAll();
        }
      };
      socialColorInput.addEventListener('input', handleSocialColorChange);
      socialColorInput.addEventListener('change', handleSocialColorChange);
    }

    if (socialLabelInput) {
      const handleSocialLabelChange = async (evt) => {
        const value = socialLabelInput.value || '';
        const commit = evt?.type === 'change';
        const revision = ++socialLabelRevision;
        let active = resolveSocialTarget(canvas.getActiveObject());
        if (!active) return;
        active = ensureSocialGroup(active);
        if (!active) return;
        socialLabelBoundTarget = active;
        const target = active;
        const edit = { revision, value, pending: true };
        socialLabelEdits.set(target, edit);
        const originalLabel = detectSocialLabel(target) || '';
        const isCurrentForm = () => socialLabelBoundTarget === target
          && resolveSocialTarget(canvas.getActiveObject()) === target;
        const isCurrentEdit = () => socialLabelEdits.get(target) === edit
          && canvas.contains(target)
          && !historyService.isRestoring()
          && (detectSocialLabel(target) || '') === originalLabel
          && (!isCurrentForm() || socialLabelInput.value === value);
        const targetFont = active._socialFont || currentSocialFont;
        currentSocialFont = targetFont;
        const text = commit ? value.trim() : value;
        try {
          if (text.trim().length) await ensureFontLoaded(targetFont, ['400', '700'], ['normal', 'italic']);
          if (!isCurrentEdit()) return;
          // Font controls may have changed this target while its earlier font
          // was loading. Keep the user's current font when finishing the text.
          const appliedFont = active._socialFont || targetFont;
          const prevCenter = active.getCenterPoint ? active.getCenterPoint() : { x: active.left || 0, y: active.top || 0 };
          const restoreCenter = () => {
            active.set({ left: prevCenter.x, top: prevCenter.y });
            if (typeof active.setCoords === 'function') active.setCoords();
          };
          // Read again after font loading: an older input may have been replaced,
          // cleared, or its object removed while the font was pending.
          let label = extractSocialParts(active).label;
          if (!text.trim().length) {
            if (label && active.type === 'group') {
              if (typeof active.removeWithUpdate === 'function') active.removeWithUpdate(label);
              else active.remove(label);
            }
            active._socialLabel = '';
            layoutSocialGroup(active);
            restoreCenter();
            canvas.requestRenderAll();
            scheduleTextMetricRefresh([0, 140]);
            if (!historyService.isRestoring() && commit) pushHistory('Social-Text geändert');
            if (commit && isCurrentForm() && socialLabelInput.value === value) socialLabelInput.value = '';
            return;
          }

          if (!label) {
            label = new fabric.IText(text, {
              fontFamily: appliedFont,
              fontSize: SOCIAL_LABEL_FONT,
              fill: active._socialColor || currentSocialColor,
              originX: 'left',
              originY: 'center'
            });
            if (active.type === 'group') active.addWithUpdate(label);
            else label.set({ left: 0, top: 0 });
          }

          label.set({ text, fill: active._socialColor || currentSocialColor, visible: true, fontSize: SOCIAL_LABEL_FONT, fontFamily: appliedFont });
          if (typeof label.setCoords === 'function') label.setCoords();
          active._socialLabel = text;
          active._socialFont = appliedFont;
          layoutSocialGroup(active);
          restoreCenter();
          canvas.requestRenderAll();
          scheduleTextMetricRefresh([0, 140]);
          if (commit && isCurrentForm() && socialLabelInput.value === value && socialLabelInput.value !== text) {
            socialLabelInput.value = text;
          }
          if (!historyService.isRestoring() && commit) pushHistory('Social-Text geändert');
        } finally {
          edit.pending = false;
        }
      };
      socialLabelInput.addEventListener('input', handleSocialLabelChange);
      socialLabelInput.addEventListener('change', handleSocialLabelChange);
    }

    reapplySocialConstraints();
    syncSocialColorInput();
    syncSocialSizeControl();

    if (grid) {
      SOCIALS.forEach(brand => {
        const tile = document.createElement('button');
        tile.type = 'button';
        tile.className = 'social-tile';
        tile.dataset.socialBrand = brand;
        tile.setAttribute('aria-label', `${SOCIAL_LABELS[brand] || brand} einfügen`);
        tile.setAttribute('aria-pressed', 'false');
        const icon = document.createElement('span');
        icon.className = 'social-tile__icon';
        icon.setAttribute('aria-hidden', 'true');
        const iconUrl = SOCIAL_ASSET_URLS[brand];
        if (iconUrl) icon.style.setProperty('--social-icon', `url("${iconUrl}")`);
        const label = document.createElement('span');
        label.className = 'social-tile__label';
        label.textContent = SOCIAL_LABELS[brand] || brand;
        tile.append(icon, label);
        tile.addEventListener('click', () => addSocialIcon(brand));
        grid.appendChild(tile);
      });
      syncSocialTileState(null);
    }
    async function addSocialIcon(brand){
      if (socialAddInFlight) return null;
      const name = SOCIAL_LABELS[brand] || brand;
      const color = currentSocialColor;
      const font = currentSocialFont;
      const activeAtClick = canvas.getActiveObject();
      const socialPanelAtClick = document.getElementById('social');
      const socialPanelWasActive = !!socialPanelAtClick?.classList.contains('active');
      setSocialAddPending(true);
      setSocialEditorStatus(`${name}-Symbol wird geladen …`);
      try{
        const source = SOCIAL_ASSET_URLS[brand] || `https://cdn.simpleicons.org/${encodeURIComponent(brand)}/000`;
        const controller = new AbortController();
        const fetchTimeout = setTimeout(() => controller.abort(), 10000);
        let svg;
        try {
          const r=await fetch(source, { signal: controller.signal });
          if (!r.ok) throw new Error(`Social-Icon konnte nicht geladen werden (${r.status}).`);
          svg=await r.text();
        } finally { clearTimeout(fetchTimeout); }
        if (!/<svg(?:\s|>)/i.test(svg)) throw new Error('Social-Icon ist ungültig.');
        const fixed=svg.replace(/fill="[^"]*"/g,'fill="#000"').replace(/stroke="[^"]*"/g,'stroke="#000"');
        const icon = await new Promise((resolve, reject) => {
          const parseTimeout = setTimeout(() => reject(new Error('Social-Icon konnte nicht gezeichnet werden.')), 10000);
          try {
            fabric.loadSVGFromString(fixed, (objs, opts) => {
              clearTimeout(parseTimeout);
              try {
                if (!objs?.length) throw new Error('Social-Icon enthält keine Grafik.');
                const parsed = fabric.util.groupSVGElements(objs, opts);
                if (!(parsed?.width > 0 && parsed?.height > 0)) throw new Error('Social-Icon hat keine gültige Größe.');
                resolve(parsed);
              } catch (error) { reject(error); }
            });
          } catch (error) { clearTimeout(parseTimeout); reject(error); }
        });
          const target=SOCIAL_ICON_BASE;
          const baseWidth = icon.width || 24;
          const scale=Math.max(0.01, target/baseWidth);
          icon.set({
            originX:'center',
            originY:'center',
            left:0,
            top:0,
            scaleX:scale,
            scaleY:scale
          });

          const spacing = SOCIAL_SPACING;

          const group = new fabric.Group([icon], {
            originX:'center',
            originY:'center'
          });

          group._isSocial = true;
          group._socialBrand = brand;
          group._socialLabel = '';
          group._socialSpacing = spacing;
          group._socialFont = font;

          layoutSocialGroup(group, spacing);
          enforceSocialTransformLocks(group);
          captureSocialScale(group);
          const applied = applySocialColor(group, color);

          centerOnShape(group, getRy() * 0.6);
          ensureHistoryId(group, 'social');
          const activateInserted = canvas.getActiveObject() === activeAtClick
            && socialPanelWasActive && socialPanelAtClick.classList.contains('active');
          canvas.add(group);
          if (activateInserted) {
            currentSocialColor = applied;
            canvas.setActiveObject(group);
          }
          canvas.bringToFront(group);
          canvas.renderAll();
          syncSocialColorInput(activateInserted ? { focus: true, source: 'insert' } : {});
          syncSocialTileState();
          syncSocialSizeControl();
          setSocialEditorStatus(activateInserted
            ? `${name}-Symbol hinzugefügt. Ergänze bei Bedarf den passenden Text oder verwende nur das Symbol.`
            : `${name}-Symbol hinzugefügt. Wähle es im Design aus, um einen Namen zu ergänzen.`);
          return group;
      }catch(e){
        console.warn('Social-Symbol konnte nicht eingefügt werden:', e);
        setSocialEditorStatus(`${name}-Symbol konnte nicht geladen werden. Bitte versuche es erneut.`, { error: true });
        return null;
      } finally {
        setSocialAddPending(false);
      }
    }

    const fontChoiceButtons = Array.from(document.querySelectorAll('[data-font-family]'));
    const fontApplyAllInput = document.getElementById('font-apply-all');
    const fontSelectionStatus = document.getElementById('font-selection-status');

    function isFontEditableText(object) {
      return !!(
        object &&
        object.type === 'i-text' &&
        !object.isEmoji &&
        !object._qrPart
      );
    }

    function selectedFontTarget() {
      const selected = canvas.getActiveObject();
      if (isFontEditableText(selected)) {
        return { kind: 'text', object: selected, family: selected.fontFamily || currentTextFont };
      }
      const social = resolveSocialTarget(selected);
      if (social) {
        return {
          kind: 'social',
          object: social,
          family: social._socialFont || detectSocialLabelFont(social) || currentSocialFont
        };
      }
      return null;
    }

    function syncFontPanel() {
      const target = selectedFontTarget();
      const appliesToAll = !!fontApplyAllInput?.checked;
      const activeFamily = target?.family || (appliesToAll ? currentTextFont : '');

      fontChoiceButtons.forEach(button => {
        const active = !!activeFamily && button.dataset.fontFamily === activeFamily;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', String(active));
        button.disabled = !target && !appliesToAll;
      });

      if (!fontSelectionStatus) return;
      if (appliesToAll) {
        fontSelectionStatus.textContent = 'Die nächste Auswahl wird auf alle Schriften angewendet.';
      } else if (target?.kind === 'social') {
        fontSelectionStatus.textContent = 'Ausgewählt: Social-Beschriftung';
      } else if (target?.kind === 'text') {
        fontSelectionStatus.textContent = `Ausgewählt: ${target.object._inputLabel || 'Text'}`;
      } else {
        fontSelectionStatus.textContent = 'Text oder Social-Element auswählen.';
      }
    }
    window.__nhSyncFontPanel = syncFontPanel;

    function applyFontToText(object, fontFamily) {
      if (!isFontEditableText(object)) return false;
      const center = object.getCenterPoint?.() || { x: object.left || 0, y: object.top || 0 };
      object.set({ fontFamily });
      object._clearCache?.();
      object.initDimensions?.();
      object.setPositionByOrigin?.(center, 'center', 'center');
      object.setCoords?.();
      return true;
    }

    function applyFontToSocial(object, fontFamily) {
      let social = resolveSocialTarget(object);
      if (!social) return false;
      social = ensureSocialGroup(social);
      if (!social) return false;
      const center = social.getCenterPoint?.() || { x: social.left || 0, y: social.top || 0 };
      social._socialFont = fontFamily;
      const label = extractSocialParts(social).label;
      if (label) {
        label.set({ fontFamily });
        label._clearCache?.();
        label.initDimensions?.();
      }
      layoutSocialGroup(social);
      social.set({ left: center.x, top: center.y });
      social.setCoords?.();
      return true;
    }

    async function applySelectedFont(fontFamily) {
      const family = String(fontFamily || '').trim();
      if (!family) return;
      const applyToAll = !!fontApplyAllInput?.checked;
      const selected = selectedFontTarget();
      if (!selected && !applyToAll) {
        syncFontPanel();
        return;
      }

      fontChoiceButtons.forEach(button => { button.disabled = true; });
      if (fontSelectionStatus) fontSelectionStatus.textContent = 'Schrift wird geladen …';
      await ensureFontLoaded(family, ['400', '700'], ['normal', 'italic'], 48);

      let changed = false;
      if (applyToAll) {
        canvas.getObjects().forEach(object => {
          if (isFontEditableText(object)) {
            changed = applyFontToText(object, family) || changed;
          } else if (isSocialObject(object)) {
            changed = applyFontToSocial(object, family) || changed;
          }
        });
      } else if (selected.kind === 'text') {
        changed = applyFontToText(selected.object, family);
      } else if (selected.kind === 'social') {
        changed = applyFontToSocial(selected.object, family);
      }

      currentTextFont = family;
      currentSocialFont = family;
      canvas.requestRenderAll();
      scheduleTextMetricRefresh([0, 120, 360]);
      if (changed && !historyService.isRestoring()) {
        pushHistory(
          applyToAll ? 'Schriftart für alle Texte geändert' : 'Schriftart geändert',
          { immediate: true }
        );
      }
      syncFontPanel();
    }

    fontChoiceButtons.forEach(button => {
      button.addEventListener('click', () => applySelectedFont(button.dataset.fontFamily));
    });
    fontApplyAllInput?.addEventListener('change', syncFontPanel);
    ['selection:created', 'selection:updated', 'selection:cleared', 'object:modified', 'object:removed']
      .forEach(eventName => canvas.on(eventName, syncFontPanel));
    window.addEventListener('load', syncFontPanel);

  canvas.on('object:added', (e) => {
    const obj = e?.target;
    if (!obj || historyService.isRestoring() || !isTrackableObject(obj)) return;
    ensureHistoryId(obj, obj.type || 'obj');
    pushHistory(describeHistoryAction('added', obj), { immediate: true });
    if (obj.type === 'i-text' && obj._historyId !== 'text-top' && obj._historyId !== 'text-bottom') {
      rebuildDynamicTextInputs();
    }
  });

  canvas.on('object:removed', (e) => {
    const obj = e?.target;
    if (!obj || historyService.isRestoring() || !isTrackableObject(obj)) return;
    pushHistory(describeHistoryAction('removed', obj), { immediate: true });
    if (obj.type === 'i-text' && obj._historyId !== 'text-top' && obj._historyId !== 'text-bottom') {
      rebuildDynamicTextInputs();
    }
  });

  canvas.on('object:modified', (e) => {
    const obj = e?.target;
    if (!obj || historyService.isRestoring() || !isTrackableObject(obj)) return;
    pushHistory(describeHistoryAction('modified', obj), { immediate: true });
  });

  const maybeRebuildDynamicTextInputs = (selection = []) => {
    if (!Array.isArray(selection)) selection = [selection].filter(Boolean);
    if (selection.some(o => o?.type === 'i-text' && o !== textTop && o !== textBottom)) {
      rebuildDynamicTextInputs();
    }
  };

  canvas.on('selection:created', (e) => maybeRebuildDynamicTextInputs(e?.selected));
  canvas.on('selection:updated', (e) => maybeRebuildDynamicTextInputs(e?.selected));

  canvas.on('text:changed', (e) => {
    const obj = e?.target;
    if (!obj || historyService.isRestoring() || !isTrackableObject(obj)) return;
    ensureCenteredTextOrigin(obj);
    pushHistory(describeHistoryAction('modified', obj));
    const socialParent = resolveSocialTarget(obj);
    if (socialParent) {
      const label = detectSocialLabel(socialParent) || '';
      socialParent._socialLabel = label;
      layoutSocialGroup(socialParent);
      if (socialLabelInput && (canvas.getActiveObject() === socialParent || canvas.getActiveObject() === obj)) {
        socialLabelInput.value = label;
      }
      canvas.requestRenderAll();
    }
  });

      const pickerEl = document.getElementById('emoji-panel-picker');
      if (pickerEl) {
        const germanDataSrc = 'https://cdn.jsdelivr.net/npm/emoji-picker-element-data@1.8.0/de/cldr/data.json';
        pickerEl.setAttribute('locale', 'de');
        pickerEl.locale = 'de';
        pickerEl.setAttribute('data-source', germanDataSrc);
        pickerEl.dataSource = germanDataSrc;
        pickerEl.addEventListener('emoji-click', (e) => {
          const ch = emojiCharFromPickerDetail(e.detail);
          if (ch) addEmojiToCanvasFromChar(ch);
        });
      }

      (async () => {
        if (pickerEl) {
          if (!customElements.get('emoji-picker')) {
            try {
              await import('https://cdn.jsdelivr.net/npm/emoji-picker-element@1.29.1/index.js');
            } catch (err) {
              console.warn('Emoji-Picker ließ sich nicht laden:', err);
            }
          }
          const applySearchPlaceholder = () => {
            const shadowSearch = pickerEl.shadowRoot?.querySelector('input[type="search"]');
            if (shadowSearch) {
              shadowSearch.placeholder = 'Suche';
              return true;
            }
            return false;
          };

          try {
            const mod = await import('https://cdn.jsdelivr.net/npm/emoji-picker-element@1.29.1/i18n/de.js');
            if (mod?.default) {
              pickerEl.i18n = mod.default;
              const ensurePlaceholder = () => {
                if (!applySearchPlaceholder()) {
                  requestAnimationFrame(() => applySearchPlaceholder());
                }
              };
              const updateComplete = pickerEl.updateComplete;
              if (updateComplete && typeof updateComplete.then === 'function') {
                updateComplete.then(() => ensurePlaceholder()).catch(() => ensurePlaceholder());
              } else {
                ensurePlaceholder();
              }
            }
          } catch (err) {
            console.warn('Emoji-Picker i18n (de) konnte nicht geladen werden:', err);
          }
        }
      })();

    // ===============================
    // 🟡 EMOJI SUPPORT – Schritt 4
    // ===============================

    // 4a) Unicode → Twemoji-SVG-URL

    // 👉 fester Upload-Endpunkt deiner Netlify Function
const NETLIFY_FN = "https://shopify-netthieraufkleber.bh-printdesigns.workers.dev";



      // Blob -> Base64 (data:-Prefix NICHT anhängen, sendet nur den nackten Base64)
      async function blobToBase64(blob) {
        const buf = await blob.arrayBuffer();
        let binary = '';
        const bytes = new Uint8Array(buf);
        const chunk = 0x8000;
        for (let i = 0; i < bytes.length; i += chunk) {
          binary += String.fromCharCode.apply(null, bytes.subarray(i, i + chunk));
        }
        return btoa(binary);
      }
    // Blob -> dataURL (nutzt deinen blobToBase64)
    async function blobToDataURL(blob){
      const b64 = await blobToBase64(blob);
      const mime = blob.type || 'image/png';
      return `data:${mime};base64,${b64}`;
    }

    // Beliebige Bild-/SVG-DataURL in PNG-DataURL rastern (für Logos)
    async function toPngDataURL(dataUrl, maxPx = 512, options = {}) {
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.onload = () => {
          const round = options.round === true;
          const longestSide = Math.max(img.width || 1, img.height || 1);
          const targetLongest = Math.min(maxPx, longestSide);
          const scale = targetLongest / longestSide;
          const scaledWidth = Math.max(1, Math.round((img.width || 1) * scale));
          const scaledHeight = Math.max(1, Math.round((img.height || 1) * scale));

          const canvas = document.createElement('canvas');
          if (round) {
            const side = Math.max(1, Math.min(scaledWidth, scaledHeight));
            canvas.width = side;
            canvas.height = side;
          } else {
            canvas.width = scaledWidth;
            canvas.height = scaledHeight;
          }

          const ctx = canvas.getContext('2d');
          ctx.clearRect(0, 0, canvas.width, canvas.height);

          let restoreClip = false;
          if (round) {
            ctx.save();
            ctx.beginPath();
            const radius = canvas.width / 2;
            ctx.arc(radius, radius, radius, 0, Math.PI * 2);
            ctx.closePath();
            ctx.clip();
            restoreClip = true;
          }

          const offsetX = round ? (canvas.width - scaledWidth) / 2 : 0;
          const offsetY = round ? (canvas.height - scaledHeight) / 2 : 0;

          ctx.drawImage(
            img,
            0,
            0,
            img.width || 1,
            img.height || 1,
            offsetX,
            offsetY,
            scaledWidth,
            scaledHeight
          );

          if (restoreClip) ctx.restore();

          resolve(canvas.toDataURL('image/png'));
        };
        img.onerror = reject;
        img.src = dataUrl; // funktioniert auch für SVG-DataURLs
      });
    }

    // DataURL → Blob
    function dataURLtoBlob(dataUrl){
      const [hdr, b64] = dataUrl.split(',');
      const mime = (hdr.match(/data:(.*);base64/)||[])[1] || 'image/jpeg';
      const bin = atob(b64), len = bin.length;
      const u8 = new Uint8Array(len);
      for (let i=0;i<len;i++) u8[i] = bin.charCodeAt(i);
      return new Blob([u8], { type: mime });
    }
    // PNG (mit Alpha) auf Weiß "flatten" und als JPEG (ohne Alpha) zurückgeben
    async function flattenToJpeg(dataUrl, bg = '#ffffff', quality = 0.95, clip = null){
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.onload = () => {
          const c = document.createElement('canvas');
          c.width = img.width; c.height = img.height;
          const ctx = c.getContext('2d', { alpha: false }); // erzwingt opak
          ctx.fillStyle = bg;
          ctx.fillRect(0, 0, c.width, c.height);
          if (clip && clip.type === 'ellipse') {
            const cx = Number.isFinite(clip.cx) ? clip.cx : c.width / 2;
            const cy = Number.isFinite(clip.cy) ? clip.cy : c.height / 2;
            const rx = Number.isFinite(clip.rx) ? clip.rx : c.width / 2;
            const ry = Number.isFinite(clip.ry) ? clip.ry : c.height / 2;
            ctx.save();
            ctx.beginPath();
            ctx.ellipse(cx, cy, Math.max(0, rx), Math.max(0, ry), 0, 0, Math.PI * 2);
            ctx.clip();
            ctx.drawImage(img, 0, 0);
            ctx.restore();
          } else {
            ctx.drawImage(img, 0, 0);
          }
          resolve(c.toDataURL('image/jpeg', quality));
        };
        img.onerror = reject;
        img.src = dataUrl;
      });
    }

    // Datei herunterladen
    function downloadBlob(blob, filename){
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url; a.download = filename;
      document.body.appendChild(a); a.click();
      setTimeout(()=>{ URL.revokeObjectURL(url); a.remove(); }, 0);
    }

      // robustes Kopieren (HTTPS-Clipboard API + Fallback)
      async function writeClipboard(text) {
        const fallbackCopy = () => {
          const ta = document.createElement('textarea');
          ta.value = text;
          ta.setAttribute('readonly', '');
          ta.style.position = 'fixed';
          ta.style.left = '-9999px';
          document.body.appendChild(ta);
          ta.select();
          const ok = document.execCommand('copy');
          document.body.removeChild(ta);
          return ok;
        };

        try {
          if (!navigator.clipboard || typeof navigator.clipboard.writeText !== 'function') {
            return fallbackCopy();
          }
          await Promise.race([
            navigator.clipboard.writeText(text),
            new Promise((_, reject) => {
              setTimeout(() => reject(new Error('Clipboard timeout')), 800);
            })
          ]);
          return true;
        } catch {
          return fallbackCopy();
        }
      }

    window.saveJPGPreview = async function saveJPGPreview(opts = {}) {
      const {
        maxWidthPx = 2000,
        quality = 0.92,
        background = '#ffffff',
        stampDesignId = false,
        idText = ''
      } = opts;

      // Viewport neutralisieren (wegen responsive Preview)
      const vt = canvas.viewportTransform ? canvas.viewportTransform.slice() : null;
      const oldZoom = typeof canvas.getZoom === 'function' ? canvas.getZoom() : 1;
      canvas.setViewportTransform([1, 0, 0, 1, 0, 0]);

      // Hilfsobjekte (z.B. Hilfslinien) ausblenden
      const toHide = canvas.getObjects().filter(o => o.excludeFromExport || o._helperUI);
      const prevVis = new Map(toHide.map(o => [o, o.visible]));
      toHide.forEach(o => o.visible = false);
      canvas.discardActiveObject();
      canvas.requestRenderAll();

      if (typeof ensureBleedGuide === 'function') {
        try { ensureBleedGuide(); } catch (err) { console.warn('Bleed guide refresh failed', err); }
      }

      // Cropping-Rechteck anhand der Hintergrundform
      function cropOfShape(shape) {
        if (!shape) return null;
        if (shape.type === 'ellipse') {
          const vw = shape.rx * 2, vh = shape.ry * 2;
          return { left: shape.left - shape.rx, top: shape.top - shape.ry, width: vw, height: vh };
        }
        if (shape.type === 'rect') {
          return { left: shape.left - shape.width/2, top: shape.top - shape.height/2, width: shape.width, height: shape.height };
        }
        const r = shape.getBoundingRect(true);
        return { left: r.left, top: r.top, width: r.width, height: r.height };
      }
      function cropFromBleedState() {
        if (!bleedClipState?.ready) return null;
        const width = bleedClipState.innerWidth;
        const height = bleedClipState.innerHeight;
        const centerX = bleedClipState.centerX;
        const centerY = bleedClipState.centerY;
        if (!(Number.isFinite(width) && Number.isFinite(height) && Number.isFinite(centerX) && Number.isFinite(centerY))) {
          return null;
        }
        if (width <= 0 || height <= 0) return null;
        return {
          left: centerX - width / 2,
          top: centerY - height / 2,
          width,
          height
        };
      }
      function sanitizeCropRect(rect) {
        if (!rect) return null;
        let { left, top, width, height } = rect;
        if (![left, top, width, height].every(Number.isFinite)) return null;
        const canvasWidth = canvas.getWidth();
        const canvasHeight = canvas.getHeight();
        if (width <= 0 || height <= 0) return null;
        if (canvasWidth && canvasHeight) {
          const maxLeft = canvasWidth - width;
          const maxTop = canvasHeight - height;
          left = Math.min(Math.max(0, left), Number.isFinite(maxLeft) ? Math.max(maxLeft, 0) : left);
          top = Math.min(Math.max(0, top), Number.isFinite(maxTop) ? Math.max(maxTop, 0) : top);
        }
        return { left, top, width, height };
      }

      const restore = () => {
        // Sichtbarkeit wiederherstellen
        toHide.forEach(o => o.visible = prevVis.get(o));
        // Viewport zurück
        if (vt) canvas.setViewportTransform(vt);
        if (typeof oldZoom === 'number') canvas.setZoom(oldZoom);
        canvas.requestRenderAll();
      };

      try {
        const shape =
          (window.oval && canvas.contains(window.oval) && window.oval) ||
          canvas.getObjects().find(o => o && o._isBackground) ||
          canvas.getObjects().find(o => o && !o._helperUI && o.selectable === false);
        const bleedRect = sanitizeCropRect(cropFromBleedState());
        const rect = bleedRect || sanitizeCropRect(cropOfShape(shape));
        if (!rect) throw new Error('Kein Cropping-Shape gefunden.');

        const { left, top, width: vw, height: vh } = rect;

        // Auflösung wählen (Multiplikator aus Zielbreite ableiten, deckeln für Mobile)
        const mult = Math.max(2, Math.min(8, Math.ceil(maxWidthPx / Math.max(1, vw))));

        // PNG mit Alpha rendern
        const pngDataUrl = canvas.toDataURL({
          format: 'png',
          multiplier: mult,
          left, top, width: vw, height: vh,
          enableRetinaScaling: false
        });

        let clipShape = null;
        if (bleedRect && bleedClipState?.ready && bleedClipState.type === 'ellipse') {
          clipShape = {
            type: 'ellipse',
            rx: (vw / 2) * mult,
            ry: (vh / 2) * mult,
            cx: (vw / 2) * mult,
            cy: (vh / 2) * mult
          };
        } else if (!bleedRect && shape?.type === 'ellipse') {
          clipShape = {
            type: 'ellipse',
            rx: (vw / 2) * mult,
            ry: (vh / 2) * mult,
            cx: (vw / 2) * mult,
            cy: (vh / 2) * mult
          };
        }

        // Auf Weiß "flatten" → JPEG-DataURL
        const jpegDataUrl = await flattenToJpeg(pngDataUrl, background, quality, clipShape);

        // Optional: Design-ID aufstempeln (ohne Canvas-Inhalt zu verändern)
        async function stampId(dataUrl, text) {
          if (!text) return dataUrl;
          const img = await new Promise((res, rej) => {
            const i = new Image();
            i.onload = () => res(i);
            i.onerror = rej;
            i.src = dataUrl;
          });
          const c = document.createElement('canvas');
          c.width = img.width; c.height = img.height;
          const ctx = c.getContext('2d');
          ctx.drawImage(img, 0, 0);

          const minDim = Math.min(c.width, c.height);
          const pad = Math.max(16, Math.round(minDim * 0.02));
          const fontPx = Math.max(32, Math.round(minDim * 0.08));
          ctx.font = `700 ${fontPx}px Inter, system-ui, -apple-system, Segoe UI, Roboto, Arial, sans-serif`;
          ctx.textBaseline = 'alphabetic';
          ctx.textAlign = 'left';

          const textMetrics = ctx.measureText(text);
          const textW = Math.ceil(textMetrics.width);
          const rectW = textW + pad * 2;
          const rectH = Math.ceil(fontPx + pad * 1.2);
          const margin = Math.max(24, Math.round(minDim * 0.03));
          const rectX = margin;
          const rectY = c.height - rectH - margin;

          ctx.fillStyle = 'rgba(0, 0, 0, 0.65)';
          ctx.fillRect(rectX, rectY, rectW, rectH);

          ctx.fillStyle = 'rgba(255, 255, 255, 0.92)';
          ctx.fillText(text, rectX + pad, rectY + rectH - pad * 0.6);

          try {
            let logo = null;
            if (window.__cachedLogoImage) {
              logo = window.__cachedLogoImage;
            } else if (typeof window.__EMBEDDED_LOGO === 'string') {
              logo = await new Promise((resolve, reject) => {
                const imageEl = new Image();
                imageEl.onload = () => resolve(imageEl);
                imageEl.onerror = reject;
                imageEl.src = window.__EMBEDDED_LOGO;
              });
              window.__cachedLogoImage = logo;
            }
            if (logo) {
              const logoSize = Math.max(64, Math.round(minDim * 0.1));
              const logoX = margin;
              const logoY = rectY - logoSize - Math.round(pad * 0.6);
              ctx.drawImage(logo, logoX, logoY, logoSize, logoSize);
            }
          } catch (logoErr) {
            console.warn('Logo konnte nicht eingeblendet werden', logoErr);
          }

          return c.toDataURL('image/jpeg', quality);
      }

      const finalDataUrl = stampDesignId ? await stampId(jpegDataUrl, idText) : jpegDataUrl;

      // DataURL → Blob
        return dataURLtoBlob(finalDataUrl);
      } finally {
        restore();
      }
    };

      function closeIdModal(options = {}) {
        const modal = document.getElementById('id-modal');
        if (!modal) return;

        const { restoreFocus = true } = options;
        modal.setAttribute('aria-hidden', 'true');

        if (releaseIdModalFocusTrap) {
          releaseIdModalFocusTrap();
          releaseIdModalFocusTrap = null;
        }

        if (copyFeedbackTimer) {
          clearTimeout(copyFeedbackTimer);
          copyFeedbackTimer = null;
        }

        const feedbackNode = document.getElementById('copy-feedback');
        if (feedbackNode) {
          feedbackNode.classList.remove('is-visible');
          feedbackNode.textContent = '';
        }

        const dialog = modal.querySelector('.id-dialog');
        const animationDuration = dialog ? 220 : 0;

        setTimeout(() => {
          modal.style.display = 'none';
          if (restoreFocus && previousActiveElement && typeof previousActiveElement.focus === 'function') {
            try {
              previousActiveElement.focus();
            } catch {
              // Ignorieren – Element existiert ggf. nicht mehr
            }
          }
          previousActiveElement = null;
        }, animationDuration);
      }

      function getFocusableWithin(container) {
        if (!container) return [];
        const nodes = Array.from(container.querySelectorAll(MODAL_FOCUSABLE_SELECTOR));
        return nodes.filter((node) => {
          if (!node) return false;
          if (node.hasAttribute('disabled')) return false;
          if (node.getAttribute('aria-hidden') === 'true') return false;
          const style = window.getComputedStyle(node);
          return style.visibility !== 'hidden' && style.display !== 'none';
        });
      }

      function activateIdModalFocusTrap(modal) {
        if (!modal) return;
        const dialog = modal.querySelector('.id-dialog');
        if (!dialog) return;

        previousActiveElement = document.activeElement instanceof HTMLElement ? document.activeElement : null;

        const handleKeydown = (event) => {
          if (event.key === 'Escape') {
            event.preventDefault();
            closeIdModal();
            return;
          }

          if (event.key === 'Enter' && !event.shiftKey) {
            const target = event.target;
            const isButton = target && (target.tagName === 'BUTTON' || target.getAttribute?.('role') === 'button');
            const preventEnter = target && target.hasAttribute && target.hasAttribute('data-id-modal-prevent-enter');
            if (!isButton && !preventEnter) {
              event.preventDefault();
              const continueBtn = dialog.querySelector('#id-modal-continue');
              if (continueBtn) continueBtn.click();
            }
            return;
          }

          if (event.key !== 'Tab') return;

          const focusable = getFocusableWithin(dialog);
          if (!focusable.length) {
            event.preventDefault();
            return;
          }

          const first = focusable[0];
          const last = focusable[focusable.length - 1];
          const current = document.activeElement;

          if (event.shiftKey) {
            if (current === first || !dialog.contains(current)) {
              event.preventDefault();
              last.focus();
            }
          } else {
            if (current === last) {
              event.preventDefault();
              first.focus();
            }
          }
        };

        modal.addEventListener('keydown', handleKeydown);
        releaseIdModalFocusTrap = () => {
          modal.removeEventListener('keydown', handleKeydown);
        };
      }

      function showCopyFeedback(message, tone = 'success') {
        const feedbackNode = document.getElementById('copy-feedback');
        if (!feedbackNode) return;

        feedbackNode.textContent = message;
        feedbackNode.classList.toggle('is-error', tone === 'error');
        feedbackNode.classList.add('is-visible');

        if (copyFeedbackTimer) {
          clearTimeout(copyFeedbackTimer);
        }

        copyFeedbackTimer = setTimeout(() => {
          feedbackNode.classList.remove('is-visible');
          feedbackNode.classList.remove('is-error');
          if (feedbackNode.textContent === message) {
            feedbackNode.textContent = '';
          }
          copyFeedbackTimer = null;
        }, 1500);
      }

		      const NH_SCROLL_LOCK_STATE_KEY = '__nhScrollLockState';
		      function nhLockScroll() {
		        try {
		          const body = document.body;
		          const docEl = document.documentElement;
		          if (!body || !docEl) return;

		          const state = window[NH_SCROLL_LOCK_STATE_KEY] || { count: 0, scrollY: 0, body: {}, html: {} };
		          state.count = (Number(state.count) || 0) + 1;
		          if (state.count > 1) {
		            window[NH_SCROLL_LOCK_STATE_KEY] = state;
		            return;
		          }

		          const scrollY = window.scrollY || window.pageYOffset || 0;
		          state.scrollY = scrollY;
		          state.body = {
		            overflow: body.style.overflow,
		            position: body.style.position,
		            top: body.style.top,
		            width: body.style.width,
		            paddingRight: body.style.paddingRight
		          };
		          state.html = { overflow: docEl.style.overflow };

		          const scrollbarWidth = (window.innerWidth || 0) - (docEl.clientWidth || 0);
		          if (scrollbarWidth > 0) {
		            body.style.paddingRight = `${scrollbarWidth}px`;
		          }

		          docEl.style.overflow = 'hidden';
		          body.style.overflow = 'hidden';
		          body.style.position = 'fixed';
		          body.style.top = `-${scrollY}px`;
		          body.style.width = '100%';

		          window[NH_SCROLL_LOCK_STATE_KEY] = state;
		        } catch (_) { /* noop */ }
		      }

		      function nhUnlockScroll() {
		        try {
		          const state = window[NH_SCROLL_LOCK_STATE_KEY];
		          if (!state || !state.count) return;
		          state.count = Math.max(0, (Number(state.count) || 0) - 1);
		          if (state.count > 0) {
		            window[NH_SCROLL_LOCK_STATE_KEY] = state;
		            return;
		          }

		          const body = document.body;
		          const docEl = document.documentElement;
		          if (body && docEl) {
		            body.style.overflow = state.body?.overflow || '';
		            body.style.position = state.body?.position || '';
		            body.style.top = state.body?.top || '';
		            body.style.width = state.body?.width || '';
		            body.style.paddingRight = state.body?.paddingRight || '';
		            docEl.style.overflow = state.html?.overflow || '';
		          }

		          const scrollY = Number(state.scrollY) || 0;
		          window[NH_SCROLL_LOCK_STATE_KEY] = null;
		          try { window.scrollTo(0, scrollY); } catch (_) { /* noop */ }
		        } catch (_) { /* noop */ }
		      }

		      function closePreviewModal() {
		        const modal = document.getElementById('preview-modal');
		        if (!modal) return;
		        modal.dataset.context = '';
		        modal.setAttribute('aria-hidden', 'true');
                deactivateEditorDialog(modal);
		        modal.style.display = 'none';
	        const feedback = document.getElementById('preview-main-id-feedback');
	        if (feedback) {
	          feedback.textContent = '';
	          feedback.classList.remove('is-error');
	        }
	        if (previewMainIdFeedbackTimer) {
	          clearTimeout(previewMainIdFeedbackTimer);
	          previewMainIdFeedbackTimer = null;
	        }
		        const card = modal.querySelector('.preview-card');
		        if (card) card.removeAttribute('tabindex');
		        previewContext = null;
		        nhUnlockScroll();
		      }

      // Focus and background isolation for the two steps of the order dialog.
      const editorDialogStates = new Map();
      let editorDialogReturnTarget = null;
      let editorDialogInertNodes = [];

      function releaseEditorDialogIsolation() {
        editorDialogInertNodes.forEach(({ node, wasInert }) => { node.inert = wasInert; });
        editorDialogInertNodes = [];
      }

      function isolateEditorDialog(modal) {
        releaseEditorDialogIsolation();
        let branch = modal;
        while (branch?.parentElement) {
          const parent = branch.parentElement;
          Array.from(parent.children).forEach(node => {
            if (node === branch || /^(SCRIPT|STYLE|LINK)$/.test(node.tagName)) return;
            editorDialogInertNodes.push({ node, wasInert: !!node.inert });
            node.inert = true;
          });
          if (parent === document.body) break;
          branch = parent;
        }
      }

      function focusEditorDialog(modal) {
        const focusable = getFocusableWithin(modal).filter(node => !node.inert && node.getClientRects().length);
        const target = focusable[0] || modal.querySelector('.preview-card, .export-content, [role="dialog"]') || modal;
        if (!target.hasAttribute('tabindex') && !focusable.length) target.setAttribute('tabindex', '-1');
        target.focus?.({ preventScroll: true });
      }

      function activateEditorDialog(modal) {
        if (!modal || editorDialogStates.has(modal)) return;
        if (modal.id === 'preview-modal' || modal.id === 'export-modal') dismissWelcomeForEditorDialog();
        if (!editorDialogReturnTarget) {
          const active = document.activeElement;
          editorDialogReturnTarget = active && active !== document.body && !modal.contains(active)
            ? active : document.getElementById('export-action');
        }
        editorDialogStates.set(modal, { trigger: document.activeElement });
        isolateEditorDialog(modal);
        focusEditorDialog(modal);
      }

      function deactivateEditorDialog(modal) {
        const state = editorDialogStates.get(modal);
        if (!editorDialogStates.delete(modal)) return;
        releaseEditorDialogIsolation();
        const remaining = Array.from(editorDialogStates.keys()).pop();
        if (remaining) {
          isolateEditorDialog(remaining);
          if (state?.trigger?.isConnected && remaining.contains(state.trigger) && !state.trigger.inert) {
            state.trigger.focus?.({ preventScroll: true });
          } else focusEditorDialog(remaining);
          return;
        }
        requestAnimationFrame(() => {
          if (editorDialogStates.size) return;
          const target = editorDialogReturnTarget;
          editorDialogReturnTarget = null;
          if (target?.isConnected && !target.inert) target.focus?.({ preventScroll: true });
        });
      }

      function syncEditorDialogs() {
        const modals = ['preview-modal', 'export-modal', 'product-info-modal', 'loading-modal', 'nh-design-share-modal', 'nh-shared-design-loading-modal'].map(id => document.getElementById(id)).filter(Boolean);
        modals.forEach(modal => {
          const open = !modal.hidden && modal.getAttribute('aria-hidden') !== 'true' && window.getComputedStyle(modal).display !== 'none';
          if (!open) deactivateEditorDialog(modal);
        });
        modals.forEach(modal => {
          if (!modal.hidden && modal.getAttribute('aria-hidden') !== 'true' && window.getComputedStyle(modal).display !== 'none') activateEditorDialog(modal);
        });
        const importModal = document.getElementById('nh-shared-design-loading-modal');
        const shareModal = importModal && editorDialogStates.has(importModal) ? importModal : document.getElementById('nh-design-share-modal');
        if (shareModal && editorDialogStates.has(shareModal) && Array.from(editorDialogStates.keys()).pop() !== shareModal) {
          const state = editorDialogStates.get(shareModal);
          editorDialogStates.delete(shareModal);
          editorDialogStates.set(shareModal, state);
          isolateEditorDialog(shareModal);
          if (!shareModal.contains(document.activeElement)) focusEditorDialog(shareModal);
        }
      }

      if (typeof MutationObserver === 'function') {
        const dialogObserver = new MutationObserver(syncEditorDialogs);
        ['preview-modal', 'export-modal', 'product-info-modal', 'loading-modal', 'nh-design-share-modal', 'nh-shared-design-loading-modal'].forEach(id => {
          const modal = document.getElementById(id);
          if (modal) dialogObserver.observe(modal, { attributes: true, attributeFilter: ['aria-hidden', 'style', 'hidden'] });
        });
      }
      document.addEventListener('keydown', event => {
        const modal = Array.from(editorDialogStates.keys()).pop();
        if (!modal) return;
        if (event.key === 'Escape') {
          event.preventDefault();
          event.stopPropagation();
          if (modal.id === 'preview-modal') {
            const wasReorder = getPreviewContext() === 'reorder';
            closePreviewModal();
            if (wasReorder) clearNhEditorReorderState();
          } else if (modal.id === 'nh-design-share-modal') {
            event.stopImmediatePropagation();
            modal.querySelector('[data-nh-share-close]')?.click();
          } else if (modal.id === 'product-info-modal') {
            // Let the product-info component clear its own content and trigger.
            modal.querySelector('.product-info-close')?.click();
          } else if (modal.id !== 'loading-modal' && modal.id !== 'nh-shared-design-loading-modal') closeExportModal();
          return;
        }
        if (event.key !== 'Tab') return;
        const focusable = getFocusableWithin(modal).filter(node => !node.inert && node.getClientRects().length);
        const first = focusable[0], last = focusable[focusable.length - 1];
        if (!first) { event.preventDefault(); focusEditorDialog(modal); return; }
        if (event.shiftKey && (document.activeElement === first || !modal.contains(document.activeElement))) {
          event.preventDefault(); last.focus();
        } else if (!event.shiftKey && (document.activeElement === last || !modal.contains(document.activeElement))) {
          event.preventDefault(); first.focus();
        }
      }, true);
      document.addEventListener('focusin', event => {
        const modal = Array.from(editorDialogStates.keys()).pop();
        if (modal && !modal.contains(event.target)) focusEditorDialog(modal);
      });

      const PREVIEW_STORAGE_PREFIX = 'NH_PREVIEW_';
      const hasSessionStorage = (() => {
        try {
          const key = '__nh_preview_test__';
          sessionStorage.setItem(key, 'ok');
          sessionStorage.removeItem(key);
          return true;
        } catch {
          return false;
        }
      })();

      function storePreviewForId(id, dataUrl) {
        if (!hasSessionStorage || !id || !dataUrl) return;
        try {
          sessionStorage.setItem(`${PREVIEW_STORAGE_PREFIX}${id}`, dataUrl);
        } catch (err) {
          console.warn('Preview sessionStorage write failed', err);
        }
      }

      function persistPreviewForCurrentDesign() {
        const currentId = window.__lastDesignId || safeGetItem('NH_LAST_ID');
        if (!currentId) return;
        const dataUrl = window.__lastPreviewDataUrl || window.__pendingPreviewDataUrl || '';
        if (!dataUrl) return;
        storePreviewForId(currentId, dataUrl);
        window.__pendingPreviewDataUrl = '';
      }

	      function rememberLatestPreviewData(dataUrl) {
	        window.__lastPreviewDataUrl = dataUrl || '';
	        if (!dataUrl) return;
	        const currentId = window.__lastDesignId || safeGetItem('NH_LAST_ID');
	        if (currentId) {
	          storePreviewForId(currentId, dataUrl);
	        } else {
	          window.__pendingPreviewDataUrl = dataUrl;
	        }
	      }

	      const MAIN_DESIGN_STORAGE = {
	        snapshot: 'NH_MAIN_SNAPSHOT',
	        id: 'NH_MAIN_ID'
	      };

      // Each open editor keeps its own identity; localStorage is shared by other tabs.
      const mainDesignIdsBySnapshot = new Map();
      function rememberMainDesignIdForSnapshot(snapshot, mainId) {
        const snap = String(snapshot || '').trim();
        const id = String(mainId || '').trim();
        if (!id) return id;
        if (snap) mainDesignIdsBySnapshot.set(snap, id);
        try {
          if (snap) {
            safeSetItem(MAIN_DESIGN_STORAGE.snapshot, snap);
            safeSetItem(DESIGN_CODE_STORAGE.snapshot, snap);
          }
          safeSetItem(MAIN_DESIGN_STORAGE.id, id);
          safeSetItem(DESIGN_CODE_STORAGE.value, id.replace(/^M-/i, ''));
        } catch (err) {
          console.warn('Main-ID cache failed', err);
        }
        return id;
      }
      function mainDesignIdForSnapshot(snapshot) {
        const snap = String(snapshot || '').trim();
        const rememberedId = snap ? mainDesignIdsBySnapshot.get(snap) : '';
        if (rememberedId) return rememberMainDesignIdForSnapshot(snap, rememberedId);
        const storedSnap = safeGetItem(MAIN_DESIGN_STORAGE.snapshot);
        const storedId = safeGetItem(MAIN_DESIGN_STORAGE.id);
        if (snap && storedSnap && storedId && storedSnap === snap && /^M-/.test(storedId)) {
          return rememberMainDesignIdForSnapshot(snap, storedId);
        }
        const code = (typeof ensureDesignCodeForSnapshot === 'function')
          ? ensureDesignCodeForSnapshot(snap)
          : (typeof generateDesignCodeCore === 'function' ? generateDesignCodeCore() : Date.now().toString(36));
        return rememberMainDesignIdForSnapshot(snap, `M-${code}`);
      }

	      function currentMainDesignId() {
	        const snap = (typeof currentDesignFingerprint === 'function') ? currentDesignFingerprint() : '';
	        return mainDesignIdForSnapshot(snap);
	      }

	      function setPreviewMainIdUi(mainId) {
	        const output = document.getElementById('preview-main-id');
	        if (!output) return;
	        const value = mainId || '';
	        if ('value' in output) output.value = value;
	        output.textContent = value;
	      }

	      let previewMainIdFeedbackTimer = null;
	      function showPreviewMainIdFeedback(message, tone = 'success') {
	        const node = document.getElementById('preview-main-id-feedback');
	        if (!node) return;
	        node.textContent = message || '';
	        node.classList.toggle('is-error', tone === 'error');
	        if (previewMainIdFeedbackTimer) {
	          clearTimeout(previewMainIdFeedbackTimer);
	          previewMainIdFeedbackTimer = null;
	        }
	        if (!message) return;
	        previewMainIdFeedbackTimer = setTimeout(() => {
	          node.textContent = '';
	          node.classList.remove('is-error');
	          previewMainIdFeedbackTimer = null;
	        }, 1800);
	      }

	      function utf8ToBase64(text) {
	        const value = String(text || '');
	        try {
	          const bytes = new TextEncoder().encode(value);
	          const chunk = 0x8000;
	          let binary = '';
	          for (let i = 0; i < bytes.length; i += chunk) {
	            binary += String.fromCharCode(...bytes.subarray(i, i + chunk));
	          }
	          return btoa(binary);
	        } catch (err) {
	          console.warn('utf8ToBase64 failed', err);
	          try {
	            return btoa(unescape(encodeURIComponent(value)));
	          } catch {
	            return '';
	          }
	        }
	      }

      async function postToWorker(payload, { signal } = {}) {
	        if (!NETLIFY_FN) throw new Error('NETLIFY_FN fehlt.');
	        const response = await fetch(NETLIFY_FN, {
	          method: 'POST',
	          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload || {}),
          ...(signal ? { signal } : {})
	        });
	        const text = await response.text().catch(() => '');
	        let json;
	        try {
	          json = text ? JSON.parse(text) : {};
	        } catch {
	          throw new Error('Worker-Antwort war kein JSON.');
	        }
	        if (!json || json.ok !== true) {
	          throw new Error(json?.error || 'Worker-Upload fehlgeschlagen.');
	        }
	        return json;
	      }

	      async function compressPreviewForUpload(dataUrl, maxEdge = 720, quality = 0.86) {
	        if (!dataUrl) return '';
	        const img = await loadImageForPreview(dataUrl);
	        const width = img.naturalWidth || img.width || 0;
	        const height = img.naturalHeight || img.height || 0;
	        if (!width || !height) return '';

	        const largest = Math.max(width, height);
	        const scale = largest > maxEdge ? (maxEdge / largest) : 1;
	        const out = document.createElement('canvas');
	        out.width = Math.max(1, Math.round(width * scale));
	        out.height = Math.max(1, Math.round(height * scale));
	        const ctx = out.getContext('2d', { alpha: false });
	        ctx.fillStyle = '#ffffff';
	        ctx.fillRect(0, 0, out.width, out.height);
	        ctx.drawImage(img, 0, 0, out.width, out.height);
	        return out.toDataURL('image/jpeg', quality);
	      }

	      const mainDesignUploadCache = window.__nhMainDesignUploadCache || new Map();
	      window.__nhMainDesignUploadCache = mainDesignUploadCache;

	      async function ensureMainDesignUploadedInBackground() {
	        const mainId = currentMainDesignId();
	        if (!mainId) return null;
	        window.__nhMainDesignId = mainId;

	        const cached = mainDesignUploadCache.get(mainId);
	        if (cached) {
	          return await cached;
	        }

	        const job = (async () => {
	          const snapshot = (typeof createHiddenDraftSnapshot === 'function') ? createHiddenDraftSnapshot() : null;
	          if (!snapshot || !snapshot.payload) throw new Error('Design konnte nicht gespeichert werden.');

	          const payload = {
	            kind: 'nh-main-design',
	            version: 1,
	            mainId,
	            createdAt: new Date().toISOString(),
	            fingerprint: snapshot.fingerprint || null,
	            payload: snapshot.payload
	          };
	          const jsonBase64 = utf8ToBase64(JSON.stringify(payload));
	          if (jsonBase64) {
	            await postToWorker({
	              type: 'main',
	              id: mainId,
	              fileName: `${mainId}.json`,
	              jsonBase64
	            });
                markDesignSaved(snapshot.fingerprint);
	          }

	          const previewRaw = window.__lastPreviewDataUrl || window.__pendingPreviewDataUrl || '';
	          if (previewRaw) {
	            const previewJpeg = await compressPreviewForUpload(previewRaw, 720, 0.86);
	            if (previewJpeg) {
	              await postToWorker({
	                type: 'preview',
	                id: mainId,
	                previewBase64: previewJpeg,
	                fileName: `${mainId}-preview.jpg`
	              });
	            }
	          }
	          return { ok: true, mainId };
	        })()
	          .catch((err) => {
	            console.warn('[NH Main] Upload fehlgeschlagen', err);
	            return { ok: false, mainId, error: err?.message ? String(err.message) : 'Upload fehlgeschlagen' };
	          });

	        mainDesignUploadCache.set(mainId, job);
	        job.then((res) => {
	          mainDesignUploadCache.set(mainId, res);
	        });
	        return job;
	      }

	      function normalizeDesignIdInput(raw) {
	        const value = String(raw || '').trim();
	        if (!value) return '';
	        let normalized = value.replace(/[‑–—−]/g, '-');
	        try {
	          if (/^https?:\/\//i.test(normalized)) {
	            const url = new URL(normalized);
	            normalized = (url.pathname.split('/').pop() || normalized).trim();
	          }
	        } catch (_) { /* noop */ }
	        normalized = normalized.replace(/[?#].*$/, '');
	        const withoutExt = normalized.replace(/\.(pdf|json|jpg|jpeg|png)$/i, '');
	        return withoutExt.replace(/-preview$/i, '').trim();
	      }

	      function normalizeDesignSuffix(raw) {
	        const value = normalizeDesignIdInput(raw);
	        if (!value) return '';
	        const idx = value.indexOf('-');
	        if (idx === -1) return value;
	        const prefix = value.slice(0, idx).trim();
	        const rest = value.slice(idx + 1).trim();
	        if (!rest) return value;
	        if (/^[a-zA-Z]{1,4}$/.test(prefix)) return rest;
	        return value;
	      }

	      function mainIdFromAnyDesignId(raw) {
	        const cleaned = normalizeDesignIdInput(raw);
	        if (!cleaned) return '';
	        if (/^M-/i.test(cleaned)) return cleaned;
	        const suffix = normalizeDesignSuffix(cleaned);
	        return suffix ? `M-${suffix}` : '';
	      }

	      function extractMainPayload(json) {
	        if (!json || typeof json !== 'object') return null;
	        if (json.payload && typeof json.payload === 'object') return json.payload;
	        if (json.snapshot && typeof json.snapshot === 'object' && json.snapshot.payload && typeof json.snapshot.payload === 'object') return json.snapshot.payload;
	        if (json.design && typeof json.design === 'object' && json.design.payload && typeof json.design.payload === 'object') return json.design.payload;
	        if (Array.isArray(json.objects)) return json;
	        return null;
	      }

		      function readLookupMain(json) {
		        if (!json || typeof json !== 'object') return null;
		        const rawMain = json.main || json.mainDesign || json.main_design || json.mainFile || json.main_file;
		        if (!rawMain || typeof rawMain !== 'object') return null;
		        const jsonUrl = rawMain.jsonUrl || rawMain.json_url || rawMain.url || rawMain.viewUrl || rawMain.view_url || '';
		        const designId = rawMain.designId || rawMain.design_id || rawMain.id || '';
		        if (!jsonUrl) return null;
		        return { designId: String(designId || ''), jsonUrl: String(jsonUrl) };
		      }

		      function readLookupProfiles(json) {
		        if (!json || typeof json !== 'object') return {};
		        const out = {};

		        const takeProfile = (profileKey, raw) => {
		          if (!profileKey || !raw || typeof raw !== 'object') return;
		          const pdfUrl = raw.pdfUrl || raw.pdf_url || raw.url || raw.viewUrl || raw.view_url || '';
		          if (!pdfUrl) return;
		          const designId = raw.designId || raw.design_id || raw.id || '';
		          out[String(profileKey)] = { designId: String(designId || ''), pdfUrl: String(pdfUrl || '') };
		        };

		        const buckets = [json.profiles, json.results, json.files];
		        buckets.forEach((bucket) => {
		          if (!bucket || typeof bucket !== 'object') return;
		          Object.entries(bucket).forEach(([k, v]) => takeProfile(k, v));
		        });

		        const arr = json.items || json.assets;
		        if (Array.isArray(arr)) {
		          arr.forEach((item) => {
		            if (!item || typeof item !== 'object') return;
		            takeProfile(item.profileKey || item.profile || item.key, item);
		          });
		        }

		        return out;
		      }

		      const NH_EDITOR_REORDER_STATE_KEY = '__nhEditorReorderState';
		      const NH_REORDER_AVAILABLE_KEY = '__nhReorderAvailableProfiles';
		      const NH_REORDER_SHAPE_KEY = '__nhReorderShape';
		      const NH_REORDER_AVAILABILITY_FLAG = '__nhUseReorderAvailability';

		      function computeShapeFromAvailability(available) {
		        const supportsOval = !!(available?.sticker_normal_oval || available?.sticker_mini_oval || available?.sticker_xxl_oval || available?.beerdeckel || available?.beer_mug);
		        const supportsRect = !!(
		          available?.sticker_normal_rect ||
		          available?.sticker_mini_rect ||
		          available?.sticker_xxl_rect ||
		          available?.beer_mug ||
		          available?.flag_100x58 ||
		          available?.flag_150x86 ||
		          available?.flag_200x115 ||
		          available?.flag_300x173
		        );
		        if (supportsOval && supportsRect) return 'both';
		        if (supportsRect) return 'rect';
		        if (supportsOval) return 'oval';
		        return 'both';
		      }

		      function clearNhEditorReorderState() {
		        try { window[NH_EDITOR_REORDER_STATE_KEY] = null; } catch (_) { /* noop */ }
		        try { window[NH_REORDER_AVAILABILITY_FLAG] = false; } catch (_) { /* noop */ }
		        try { window[NH_REORDER_AVAILABLE_KEY] = null; } catch (_) { /* noop */ }
		        try { window[NH_REORDER_SHAPE_KEY] = null; } catch (_) { /* noop */ }
		        try { document.getElementById('shopifySelector')?.dispatchEvent(new Event('nh:force-sync')); } catch (_) { /* noop */ }
		      }
		      window.clearNhEditorReorderState = clearNhEditorReorderState;

		      async function resolveLookupPreviewSource({ previewUrl, profiles } = {}) {
		        const remote = String(previewUrl || '').trim();
		        if (remote) return remote;
		        const anyPdf = Object.values(profiles || {}).find((entry) => entry && entry.pdfUrl)?.pdfUrl;
		        if (!anyPdf) return '';
		        if (typeof window.nhPdfFirstPageThumbnailDataUrl === 'function') {
		          try {
		            const dataUrl = await window.nhPdfFirstPageThumbnailDataUrl(anyPdf, 360);
		            return String(dataUrl || '');
		          } catch (err) {
		            console.warn('[NH Load] PDF-Vorschau fehlgeschlagen', err);
		          }
		        }
		        return '';
		      }

		      async function activateEditorReorderMode({ inputId, mainId, previewUrl, profiles } = {}) {
		        const cleaned = String(inputId || '').trim();
		        const buckets = (profiles && typeof profiles === 'object') ? profiles : {};
		        if (!cleaned || !Object.keys(buckets).length) {
		          throw new Error('Design-ID nicht gefunden.');
		        }

		        clearNhEditorReorderState();

		        const available = {};
		        Object.keys(buckets).forEach((profileKey) => { available[profileKey] = true; });
		        const shape = computeShapeFromAvailability(available);
		        const previewSource = await resolveLookupPreviewSource({ previewUrl, profiles: buckets });

		        try {
		          window[NH_EDITOR_REORDER_STATE_KEY] = {
		            kind: 'prefix-reorder',
		            rawDesignId: cleaned,
		            mainId: String(mainId || ''),
		            previewUrl: String(previewUrl || ''),
		            previewSource: String(previewSource || ''),
		            profiles: buckets,
		            availableProfiles: available,
		            shape
		          };
		        } catch (_) { /* noop */ }

		        try { window[NH_REORDER_AVAILABILITY_FLAG] = true; } catch (_) { /* noop */ }
		        try { window[NH_REORDER_AVAILABLE_KEY] = available; } catch (_) { /* noop */ }
		        try { window[NH_REORDER_SHAPE_KEY] = shape; } catch (_) { /* noop */ }

		        try { if (typeof window.nhResetProductSelection === 'function') window.nhResetProductSelection(); } catch (_) { /* noop */ }
		        try { document.getElementById('shopifySelector')?.dispatchEvent(new Event('nh:force-sync')); } catch (_) { /* noop */ }

		        closeLoadDesignModal();
		        openPreviewModal('reorder');
		      }

      async function lookupMainDesignFile(rawDesignId, { signal } = {}) {
		        const input = normalizeDesignIdInput(rawDesignId);
		        if (!input) throw new Error('Bitte eine Design-ID eingeben.');
		        const mainId = mainIdFromAnyDesignId(input);
		        if (!mainId) throw new Error('Bitte eine Design-ID eingeben.');
		        const suffix = normalizeDesignSuffix(input);
		        const candidates = {};
		        Object.entries(window.__exportProfiles || {}).forEach(([profileKey, profile]) => {
		          if (profile && profile.idPrefix) candidates[profileKey] = `${profile.idPrefix}${suffix}`;
		        });

		        // Old FH files are read-only fallback candidates, never new exports.
            candidates.flag_legacy = `FH-${suffix}`;
            const payload = {
		          type: 'lookup',
		          id: input,
		          designId: input,
		          inputId: input,
		          suffix,
		          candidates: Object.keys(candidates).length ? { ...candidates, main: mainId } : undefined
		        };

        let json = await postToWorker(payload, { signal });
            if (typeof window.nhResolveLegacyFlagLookup === 'function') {
              json = await window.nhResolveLegacyFlagLookup(json);
            } else if (!readLookupMain(json) && Object.entries(json?.profiles || {}).some(([key, value]) =>
              key === 'flag_legacy' || /^FH-/i.test(String(value?.designId || '')) || /\/FH-[^/]+\.pdf(?:[?#]|$)/i.test(String(value?.pdfUrl || value?.url || '')))) {
              throw new Error('Die Fahnengröße dieses älteren Designs konnte nicht geprüft werden. Bitte die Main-ID verwenden oder die Seite neu laden.');
            }
		        const main = readLookupMain(json);
		        const profiles = readLookupProfiles(json);
		        const previewUrl = (json && typeof json === 'object')
		          ? (json.previewUrl || json.preview || json.previewRemoteUrl || json.preview_remote_url || json.preview_view_url || '')
		          : '';

		        return {
		          inputId: input,
		          mainId,
		          main: (main && main.jsonUrl) ? { designId: String(main.designId || mainId), jsonUrl: String(main.jsonUrl) } : null,
		          profiles,
		          previewUrl: String(previewUrl || '')
		        };
		      }

      async function fetchMainDesignPayload(jsonUrl, { signal } = {}) {
	        const url = String(jsonUrl || '').trim();
	        if (!url) throw new Error('Main-Datei-URL fehlt.');
        const resp = await fetch(url, { cache: 'no-store', credentials: 'omit', ...(signal ? { signal } : {}) });
	        if (!resp.ok) {
	          throw new Error(`Main-Datei konnte nicht geladen werden (${resp.status}).`);
	        }
	        const text = await resp.text();
	        let json;
	        try { json = text ? JSON.parse(text) : {}; }
	        catch { throw new Error('Main-Datei ist kein gültiges JSON.'); }
	        const payload = extractMainPayload(json);
	        if (!payload || typeof payload !== 'object') {
	          throw new Error('Main-Datei enthält kein Design-Payload.');
	        }
	        return payload;
	      }

      function finalizeLoadedDesignPayload(label, { resetHistory = true } = {}) {
	          try { rebindCoreReferences?.(); } catch (_) { /* noop */ }
              try { window.__nhSyncShapeChoiceButtons?.(); } catch (_) { /* noop */ }
	          try { rebuildDynamicTextInputs?.(); } catch (_) { /* noop */ }
	          try { refreshLayerList?.(); } catch (_) { /* noop */ }
	          try { updateColorPickersUI?.(); } catch (_) { /* noop */ }
	          try { clampAllAboveBackground?.(); } catch (_) { /* noop */ }
	          try { resyncQrStateFromCanvas?.(); } catch (_) { /* noop */ }
	          try { resetGuideHelpers?.(); } catch (_) { /* noop */ }
	          try { ensureCenterGuides?.(); hideCenterGuides?.(); } catch (_) { /* noop */ }
	          try { ensureBleedGuide?.(); applyBleedClipToAllObjects?.(); hideBleedGuide?.(); } catch (_) { /* noop */ }
	          try { syncOpacityControl?.(); } catch (_) { /* noop */ }
	          try { syncRemoveButtonState?.(); } catch (_) { /* noop */ }
	          try { window.__nhSyncFontPanel?.(); } catch (_) { /* noop */ }
	          try { reapplySocialConstraints?.(); } catch (_) { /* noop */ }
	          try { canvas.requestRenderAll?.(); } catch (_) { /* noop */ }
	          try { fitCanvasToPreview?.({ force: true }); } catch (_) { /* noop */ }
	          try { updateQrPreview?.(); autoUpdateQR?.(); } catch (_) { /* noop */ }
	          try { scheduleTextMetricRefresh?.([0, 120, 360]); } catch (_) { /* noop */ }
	          try {
	            if (resetHistory && historyService && typeof historyService.reset === 'function') {
	              historyBaselineSynced = false;
	              historyService.reset(label);
	              historyBaselineSynced = true;
	            }
	          } catch (_) { /* noop */ }
	        }

      async function applyLoadedDesignPayload(payload, { label = 'Design geladen' } = {}) {
        if (!payload) throw new Error('Design-Payload fehlt.');
        if (!canvas || typeof canvas.loadFromJSON !== 'function') throw new Error('Canvas ist nicht bereit.');


	        return new Promise((resolve, reject) => {
	          try {
	            const load = () => {
	              canvas.loadFromJSON(payload, () => {
	                try {
	                  finalizeLoadedDesignPayload(label);
	                  resolve(true);
	                } catch (err) {
	                  reject(err);
	                }
	              });
	            };

	            if (historyService && typeof historyService.withoutRecording === 'function') {
	              historyService.withoutRecording(load);
	            } else {
	              load();
	            }
	          } catch (err) {
	            reject(err);
	          }
	        });
	      }

      function adoptMainDesignIdForCurrentSnapshot(mainId) {
        const id = String(mainId || '').trim();
        if (!id) return;
        const snap = (typeof currentDesignFingerprint === 'function') ? currentDesignFingerprint() : '';
        if (!snap) return;
        rememberMainDesignIdForSnapshot(snap, id);
        window.__nhMainDesignId = id;
        markDesignSaved(snap);
      }

	      function setLoadDesignStatus(message, tone = 'muted') {
	        const node = document.getElementById('nh-load-design-status');
	        if (!node) return;
	        node.textContent = message || '';
	        node.classList.toggle('is-error', tone === 'error');
	      }

		      function openLoadDesignModal() {
		        const modal = document.getElementById('nh-load-design-modal');
		        if (!modal) return;
		        nhLockScroll();
		        setLoadDesignStatus('', 'muted');
		        modal.setAttribute('aria-hidden', 'false');
		        const input = document.getElementById('nh-load-design-input');
		        if (input) {
	          input.value = '';
	          input.setAttribute('value', '');
	          setTimeout(() => {
	            try { input.focus({ preventScroll: true }); input.select?.(); } catch (_) { /* noop */ }
	          }, 0);
	        }
	      }

		      function closeLoadDesignModal() {
		        const modal = document.getElementById('nh-load-design-modal');
		        if (!modal) return;
		        modal.setAttribute('aria-hidden', 'true');
		        setLoadDesignStatus('', 'muted');
		        nhUnlockScroll();
		      }

		      async function handleLoadDesignSubmit(rawId) {
		        const submitBtn = document.getElementById('nh-load-design-submit');
		        const inputEl = document.getElementById('nh-load-design-input');
		        if (submitBtn) submitBtn.disabled = true;
		        if (inputEl) inputEl.disabled = true;
		        try {
		          setLoadDesignStatus('Suche Design…', 'muted');
		          const { inputId, mainId, main, profiles, previewUrl } = await lookupMainDesignFile(rawId);
		          if (main && main.jsonUrl) {
		            const resolvedMainId = main.designId ? String(main.designId) : mainId;
		            clearNhEditorReorderState();
		            setLoadDesignStatus(`Lade Design ${resolvedMainId}…`, 'muted');
		            const payload = await fetchMainDesignPayload(main.jsonUrl);
		            await applyLoadedDesignPayload(payload, { label: 'Design geladen' });
		            adoptMainDesignIdForCurrentSnapshot(resolvedMainId);
		            setLoadDesignStatus(`Design geladen: ${resolvedMainId}`, 'muted');
		            setTimeout(() => closeLoadDesignModal(), 350);
		            return;
		          }

		          if (profiles && Object.keys(profiles).length) {
		            setLoadDesignStatus('Design gefunden. Öffne Produktauswahl…', 'muted');
		            await activateEditorReorderMode({ inputId, mainId, previewUrl, profiles });
		            return;
		          }

		          throw new Error('Design-ID nicht gefunden.');
		        } catch (err) {
		          console.warn('[NH Load] failed', err);
		          setLoadDesignStatus(err?.message ? String(err.message) : 'Design konnte nicht geladen werden.', 'error');
		        } finally {
		          if (submitBtn) submitBtn.disabled = false;
		          if (inputEl) inputEl.disabled = false;
		        }
		      }

	      (function bindLoadDesignUi(){
		        const triggers = Array.from(document.querySelectorAll('[data-nh-load-design-trigger]'));
		        const modal = document.getElementById('nh-load-design-modal');
		        const closeBtn = document.getElementById('nh-load-design-close');
		        const form = document.getElementById('nh-load-design-form');
		        const input = document.getElementById('nh-load-design-input');
		        const backdrop = modal ? modal.querySelector('.modal-backdrop') : null;
		        if (!triggers.length || !modal || !form || !input) return;

		        triggers.forEach((btn) => {
		          btn.addEventListener('click', (e) => {
		            try { e.preventDefault(); } catch (_) { /* noop */ }
		            openLoadDesignModal();
		          });
		        });

	        if (closeBtn) {
	          closeBtn.addEventListener('click', (e) => {
	            try { e.preventDefault(); } catch (_) { /* noop */ }
	            closeLoadDesignModal();
	          });
	        }

	        if (backdrop) {
	          backdrop.addEventListener('click', () => closeLoadDesignModal());
	        }

	        window.addEventListener('keydown', (e) => {
	          if (e && e.key === 'Escape' && modal.getAttribute('aria-hidden') === 'false') {
	            try { e.preventDefault(); } catch (_) { /* noop */ }
	            closeLoadDesignModal();
	          }
	        });

	        form.addEventListener('submit', (e) => {
	          try { e.preventDefault(); } catch (_) { /* noop */ }
	          const raw = input.value || '';
	          handleLoadDesignSubmit(raw);
	        });
	      })();

	      async function loadEditableMainDesign(rawDesignId, { label = 'Vorlage geladen', preparedMain = null } = {}) {
            let resolvedMainId;
            let payload;
            if (preparedMain) {
              const expectedId = String(mainIdFromAnyDesignId(rawDesignId) || '').toUpperCase();
              resolvedMainId = String(preparedMain.mainId || '').toUpperCase();
              if (!expectedId || resolvedMainId !== expectedId || !Array.isArray(preparedMain.payload?.objects)) {
                throw new Error('Die vorbereitete Vorlage passt nicht zur Design-ID.');
              }
              // Fabric may change the supplied JSON. Keep the shared payload cache immutable.
              payload = JSON.parse(JSON.stringify(preparedMain.payload));
            } else {
              const { mainId, main } = await lookupMainDesignFile(rawDesignId);
              if (!main?.jsonUrl) {
                throw new Error('Für diese Vorlage wurde keine bearbeitbare Master-Datei gefunden.');
              }
              resolvedMainId = String(main.designId || mainId);
              payload = await fetchMainDesignPayload(main.jsonUrl);
            }
            clearNhEditorReorderState();
            await applyLoadedDesignPayload(payload, { label });
            adoptMainDesignIdForCurrentSnapshot(resolvedMainId);
            window.__nhSyncFontPanel?.();
            return { mainId: resolvedMainId };
          }
          window.__nhLoadEditableMainDesign = loadEditableMainDesign;

      // Shared designs use a detached canvas until every asset and local-change guard passes.
      (function installDesignShareBridge() {
        const MAIN_ID_PATTERN = /^M-\d{8}-\d{4}-[A-Z0-9]{4}$/i;
        const shareSaves = new Map();
        const sharePreviews = new Map();
        const scrollLockedDialogs = new WeakSet();
        let loadRevision = 0;
        let inputRevision = 0;
        const localChangesError = () => shareError('LOCAL_CHANGES', 'Du hast dieses Design inzwischen bearbeitet. Bitte öffne den geteilten Link in einem neuen Tab.');
        function shareError(code, message) {
          const error = new Error(message);
          error.code = code;
          return error;
        }
        function checkSignal(signal) {
          if (!signal?.aborted) return;
          const error = new Error('Der Vorgang wurde abgebrochen.');
          error.name = 'AbortError';
          throw error;
        }
        function abortable(promise, signal) {
          checkSignal(signal);
          if (!signal) return Promise.resolve(promise);
          return new Promise((resolve, reject) => {
            const onAbort = () => {
              signal.removeEventListener('abort', onAbort);
              try { checkSignal(signal); } catch (error) { reject(error); }
            };
            signal.addEventListener('abort', onAbort, { once: true });
            Promise.resolve(promise).then(value => {
              signal.removeEventListener('abort', onAbort);
              if (signal.aborted) onAbort(); else resolve(value);
            }, error => { signal.removeEventListener('abort', onAbort); reject(error); });
          });
        }
        // Guard input that has not reached Fabric yet (for example an async font change).
        const noteLocalInput = event => {
          const target = event.target;
          if (!event.isTrusted || !document.getElementById('nh-editor')?.contains(target)) return;
          if (target.closest?.('#nh-design-share-modal, #nh-shared-design-status, #export-modal, #preview-modal, #shopifySelector, #nh-load-design-modal')) return;
          if (event.type === 'click') {
            if (target.closest?.('[data-font-family]')) inputRevision += 1;
          } else if (/^(INPUT|TEXTAREA|SELECT)$/.test(target.tagName || '')) inputRevision += 1;
        };
        document.addEventListener('input', noteLocalInput, true);
        document.addEventListener('change', noteLocalInput, true);
        document.addEventListener('click', noteLocalInput, true);

        const ready = Promise.all([designShareInitialized, initialTextsReady]).then(() => {
          // Font metrics may settle after window.load. Only refresh the untouched start baseline.
          if (!inputRevision && historyService.state()?.size <= 1) {
            hiddenDraftBaselineFingerprint = currentDesignFingerprint();
            window.__nhBaselineFingerprint = hiddenDraftBaselineFingerprint;
          }
          try { window.dispatchEvent(new Event('nh:design-share-ready')); } catch (_) { /* noop */ }
        });

        async function save({ signal } = {}) {
          await abortable(ready, signal);
          checkSignal(signal);
          if (window.__nhEditorReorderState?.kind === 'prefix-reorder') {
            throw shareError('REORDER_ONLY', 'Dieses ältere Design bitte zuerst über seine Main-ID laden.');
          }
          if (isExporting) throw shareError('BUSY', 'Dein Design wird gerade exportiert. Bitte versuche es gleich erneut.');
          historyService.flush?.();
          // Snapshot, fingerprint and ID are captured together, before the first network await.
          const snapshot = createHiddenDraftSnapshot();
          if (!snapshot?.payload || !snapshot.fingerprint) throw new Error('Design konnte nicht gespeichert werden.');
          const mainId = mainDesignIdForSnapshot(snapshot.fingerprint);
          if (!MAIN_ID_PATTERN.test(mainId)) throw new Error('Die Main-ID ist ungültig. Bitte versuche es erneut.');
          const cacheKey = `${mainId}:${snapshot.fingerprint}`;
          let cached = shareSaves.get(cacheKey);
          if (cached?.signal?.aborted) { shareSaves.delete(cacheKey); cached = null; }
          if (cached) return abortable(cached.promise, signal);
          const payload = { kind: 'nh-main-design', version: 1, mainId,
            createdAt: new Date().toISOString(), fingerprint: snapshot.fingerprint, payload: snapshot.payload };
          const jsonBase64 = utf8ToBase64(JSON.stringify(payload));
          if (!jsonBase64) throw new Error('Design konnte nicht gespeichert werden.');
          const entry = { signal, promise: null };
          entry.promise = (async () => {
            const result = await postToWorker({ type: 'main', id: mainId, fileName: `${mainId}.json`, jsonBase64 }, { signal });
            checkSignal(signal);
            if (result?.ok !== true) throw new Error('Design konnte nicht gespeichert werden.');
            markDesignSaved(snapshot.fingerprint);
            entry.signal = null;
            return { ok: true, mainId };
          })().catch(error => {
            if (shareSaves.get(cacheKey) === entry) shareSaves.delete(cacheKey);
            throw error;
          });
          shareSaves.set(cacheKey, entry);
          return abortable(entry.promise, signal);
        }

        async function prepareSharePreview(rawId, { signal } = {}) {
          const mainId = String(rawId || '').trim().toUpperCase();
          if (!MAIN_ID_PATTERN.test(mainId)) throw new Error('Die Main-ID ist ungültig. Bitte versuche es erneut.');
          await abortable(ready, signal);
          checkSignal(signal);
          historyService.flush?.();
          const snapshot = createHiddenDraftSnapshot();
          if (!snapshot?.payload || !snapshot.fingerprint) throw new Error('Die Designvorschau konnte nicht erstellt werden.');
          const fingerprint = snapshot.fingerprint;
          const initialInputs = inputRevision;
          const guard = () => {
            checkSignal(signal);
            const current = createHiddenDraftSnapshot();
            if (!current?.fingerprint || current.fingerprint !== fingerprint || inputRevision !== initialInputs ||
                mainDesignIdForSnapshot(current.fingerprint) !== mainId) {
              throw shareError('LOCAL_CHANGES', 'Dein Design hat sich geändert. Bitte teile die aktuelle Version erneut.');
            }
          };
          guard();
          if (window.__nhEditorReorderState?.kind === 'prefix-reorder' || isExporting) {
            throw shareError('BUSY', 'Die Designvorschau ist gerade nicht verfügbar.');
          }
          const cacheKey = `${mainId}:${fingerprint}`;
          let cached = sharePreviews.get(cacheKey);
          if (cached?.signal?.aborted) { sharePreviews.delete(cacheKey); cached = null; }
          if (cached) {
            const result = await abortable(cached.promise, signal);
            guard();
            return result;
          }
          const entry = { signal, promise: null };
          entry.promise = (async () => {
            if (typeof window.NH_getProductArtwork !== 'function') throw new Error('Die Designvorschau ist noch nicht verfügbar.');
            // This getter captures the current artwork offscreen; it never reuses a review thumbnail.
            const artwork = await abortable(window.NH_getProductArtwork(), signal);
            guard();
            if (!artwork || typeof artwork.dataUrl !== 'string' || !artwork.dataUrl.startsWith('data:image/png;base64,')) {
              throw new Error('Die Designvorschau konnte nicht erstellt werden.');
            }
            const image = await abortable(loadImageForPreview(artwork.dataUrl), signal);
            guard();
            const width = Number(image.naturalWidth || image.width);
            const height = Number(image.naturalHeight || image.height);
            if (!Number.isFinite(width) || !Number.isFinite(height) || width <= 0 || height <= 0) {
              throw new Error('Die Designvorschau enthält kein gültiges Bild.');
            }
            const output = document.createElement('canvas');
            output.width = 1200;
            output.height = 630;
            const context = output.getContext('2d', { alpha: false });
            if (!context) throw new Error('Die Designvorschau konnte nicht erstellt werden.');
            context.fillStyle = '#f7f6f2';
            context.fillRect(0, 0, output.width, output.height);
            const scale = Math.min(1120 / width, 590 / height);
            const drawWidth = width * scale;
            const drawHeight = height * scale;
            context.drawImage(image, (output.width - drawWidth) / 2, (output.height - drawHeight) / 2, drawWidth, drawHeight);
            const jpeg = output.toDataURL('image/jpeg', 0.9);
            if (typeof jpeg !== 'string' || !jpeg.startsWith('data:image/jpeg;base64,')) {
              throw new Error('Die Designvorschau konnte nicht erstellt werden.');
            }
            guard();
            const result = await abortable(postToWorker({ type: 'preview', id: mainId,
              previewBase64: jpeg, fileName: `${mainId}-preview.jpg` }, { signal }), signal);
            guard();
            let previewUrl;
            try {
              const url = new URL(result?.viewUrl || '');
              if (url.protocol === 'https:' && url.hostname === 'cdn.shopify.com' && !url.username && !url.password && url.pathname !== '/') {
                url.hash = '';
                previewUrl = url.href;
              }
            } catch (_) { /* A successful upload must include a usable public Shopify image URL. */ }
            if (result?.ok !== true || !previewUrl) throw new Error('Die Designvorschau konnte nicht gespeichert werden.');
            entry.signal = null;
            return { ok: true, mainId, previewUrl };
          })().catch(error => {
            if (sharePreviews.get(cacheKey) === entry) sharePreviews.delete(cacheKey);
            throw error;
          });
          sharePreviews.set(cacheKey, entry);
          return abortable(entry.promise, signal);
        }

        async function loadFonts(payload, signal) {
          if (typeof document.fonts?.load !== 'function') return;
          const fonts = new Set();
          const visit = object => {
            if (!object || typeof object !== 'object') return;
            if (/^(i-text|text|textbox)$/.test(object.type || '')) {
              const add = style => {
                const family = String(style.fontFamily || object.fontFamily || '').replace(/["\\]/g, '').trim();
                if (family) fonts.add(`${style.fontStyle || object.fontStyle || 'normal'} ${style.fontWeight || object.fontWeight || '400'} 32px "${family}"`);
              };
              add(object);
              Object.values(object.styles || {}).forEach(line => Object.values(line || {}).forEach(add));
            }
            (object.objects || []).forEach(visit);
            if (object.clipPath) visit(object.clipPath);
          };
          (payload.objects || []).forEach(visit);
          await abortable(Promise.all(Array.from(fonts, font => document.fonts.load(font))), signal);
        }
        function validateLoadedObjects(source, loaded) {
          if (!Array.isArray(source) || source.length !== loaded.length) throw new Error('Ein Bestandteil des Designs konnte nicht geladen werden.');
          source.forEach((data, index) => {
            const object = loaded[index];
            if (!object || object.type !== data.type) throw new Error('Ein Bestandteil des Designs konnte nicht geladen werden.');
            if (data.type === 'image') {
              const element = object.getElement?.() || object._element;
              if (!element || !(Number(element.naturalWidth || element.width) > 0) || !(Number(object.width) > 0) || !(Number(object.height) > 0)) {
                throw new Error('Ein Bild des Designs konnte nicht geladen werden.');
              }
            }
            if (Array.isArray(data.objects)) validateLoadedObjects(data.objects, object.getObjects?.() || object._objects || []);
            if (data.clipPath) validateLoadedObjects([data.clipPath], [object.clipPath]);
          });
        }
        function stagePayload(payload, signal) {
          const stage = new fabric.StaticCanvas(document.createElement('canvas'), {
            width: canvas.getWidth(), height: canvas.getHeight(), enableRetinaScaling: false, renderOnAddRemove: false
          });
          let completed = false;
          let abandoned = false;
          const loaded = new Promise((resolve, reject) => {
            try {
              stage.loadFromJSON(JSON.parse(JSON.stringify(payload)), () => {
                completed = true;
                if (abandoned || signal?.aborted) { stage.dispose(); return; }
                try {
                  validateLoadedObjects(payload.objects, stage.getObjects());
                  if (payload.backgroundImage) validateLoadedObjects([payload.backgroundImage], [stage.backgroundImage]);
                  if (payload.overlayImage) validateLoadedObjects([payload.overlayImage], [stage.overlayImage]);
                  if (payload.clipPath) validateLoadedObjects([payload.clipPath], [stage.clipPath]);
                  resolve(stage);
                } catch (error) { stage.dispose(); reject(error); }
              });
            } catch (error) { completed = true; stage.dispose(); reject(error); }
          });
          return abortable(loaded, signal).catch(error => {
            abandoned = true;
            // Fabric's outstanding image callbacks must finish before disposal.
            if (completed) { try { stage.dispose(); } catch (_) { /* noop */ } }
            throw error;
          });
        }
        function canvasProperties(target) {
          return { backgroundColor: target.backgroundColor, overlayColor: target.overlayColor,
            backgroundImage: target.backgroundImage, overlayImage: target.overlayImage, clipPath: target.clipPath };
        }
        function replaceObjects(objects, properties) {
          canvas.discardActiveObject();
          canvas.clear();
          canvas.set(properties);
          [properties.backgroundImage, properties.overlayImage].forEach(image => { if (image) image.canvas = canvas; });
          objects.forEach(object => canvas.add(object));
        }
        async function load(rawId, { signal } = {}) {
          const mainId = String(rawId || '').trim().toUpperCase();
          if (!MAIN_ID_PATTERN.test(mainId)) throw new Error('Dieser Link enthält keine gültige Main-ID.');
          const revision = ++loadRevision;
          await abortable(ready, signal);
          checkSignal(signal);
          // A retry must not erase edits entered before it started, even if a prior load failed.
          if (inputRevision || hasUnsavedDesignChanges()) throw localChangesError();
          if (isExporting) throw shareError('BUSY', 'Dein Design wird gerade exportiert. Bitte versuche es gleich erneut.');
          const initialFingerprint = currentDesignFingerprint();
          const initialInputs = inputRevision;
          const guard = () => {
            checkSignal(signal);
            if (revision !== loadRevision) {
              const error = new Error('Ein neuerer Ladevorgang wurde gestartet.'); error.name = 'AbortError'; throw error;
            }
            if (inputRevision !== initialInputs || currentDesignFingerprint() !== initialFingerprint) throw localChangesError();
          };
          let stage;
          try {
            const lookup = await abortable(lookupMainDesignFile(mainId, { signal }), signal);
            guard();
            if (!lookup.main?.jsonUrl) throw new Error('Für dieses Design wurde keine bearbeitbare Main-Datei gefunden.');
            if (lookup.main.designId && String(lookup.main.designId).trim().toUpperCase() !== mainId) {
              throw new Error('Die geladene Main-Datei passt nicht zur angeforderten Design-ID.');
            }
            const payload = await abortable(fetchMainDesignPayload(lookup.main.jsonUrl, { signal }), signal);
            guard();
            if (!Array.isArray(payload.objects) || !payload.objects.some(object => object?._isBackground && /^(ellipse|rect)$/.test(object.type || ''))) {
              throw new Error('Die Main-Datei enthält kein gültiges bearbeitbares Design.');
            }
            await loadFonts(payload, signal);
            guard();
            stage = await stagePayload(payload, signal);
            guard();
            const importedObjects = stage.getObjects().slice();
            const importedProperties = canvasProperties(stage);
            const previousObjects = canvas.getObjects().slice();
            const previousProperties = canvasProperties(canvas);
            const previousSelection = canvas.getActiveObject();
            // Detach first: StaticCanvas.dispose must never dispose objects now owned by the live canvas.
            importedObjects.forEach(object => stage.remove(object));
            stage.backgroundImage = stage.overlayImage = stage.clipPath = null;
            const commit = () => {
              try {
                replaceObjects(importedObjects, importedProperties);
                finalizeLoadedDesignPayload('Geteiltes Design geladen', { resetHistory: false });
              } catch (error) {
                replaceObjects(previousObjects, previousProperties);
                finalizeLoadedDesignPayload('Design wiederhergestellt', { resetHistory: false });
                if (previousSelection && previousObjects.includes(previousSelection)) canvas.setActiveObject(previousSelection);
                throw error;
              }
            };
            historyService.withoutRecording(commit);
            clearNhEditorReorderState();
            window.nhResetProductSelection?.();
            adoptMainDesignIdForCurrentSnapshot(mainId);
            const fingerprint = currentDesignFingerprint();
            // An unchanged import already exists publicly; sharing it again must not upload or replace it.
            shareSaves.set(`${mainId}:${fingerprint}`, { signal: null, promise: Promise.resolve({ ok: true, mainId }) });
            mainDesignUploadCache.set(mainId, { ok: true, mainId });
            historyService.reset('Geteiltes Design geladen');
            historyBaselineSynced = true;
            return { ok: true, mainId };
          } finally {
            if (stage) { try { stage.dispose(); } catch (_) { /* noop */ } }
          }
        }
        function openDialog(modal) {
          if (!modal) return;
          if (!scrollLockedDialogs.has(modal)) { scrollLockedDialogs.add(modal); nhLockScroll(); }
          activateEditorDialog(modal);
          syncEditorDialogs();
        }
        function closeDialog(modal) {
          if (!modal) return;
          deactivateEditorDialog(modal);
          if (scrollLockedDialogs.delete(modal)) nhUnlockScroll();
        }
        window.__nhDesignShareBridge = { ready, save, load, prepareSharePreview, openDialog, closeDialog };
      })();

	      (function bindTemplateCatalog(){
	        const TEMPLATE_CATALOG_ID = 'M-TEMPLATE-CATALOG';
	        const grid = document.getElementById('template-catalog-grid');
	        const status = document.getElementById('template-catalog-status');
	        const search = document.getElementById('template-search-input');
	        const refresh = document.getElementById('template-refresh-btn');
	        if (!grid || !status) return;

	        let catalog = [];
	        let catalogLoaded = false;
	        let catalogLoading = null;
            let catalogRequestVersion = 0;
            const templateMasterJobs = new Map();
	        const generatedPreviewCache = new Map();
	        const generatedPreviewJobs = new Map();

	        const setStatus = (message, tone = '') => {
	          status.textContent = message || '';
	          status.classList.toggle('is-error', tone === 'error');
	          status.classList.toggle('is-success', tone === 'success');
	        };

	        const normalizeTemplate = (entry, index) => {
	          if (!entry || typeof entry !== 'object' || entry.isPublished === false) return null;
	          const designId = String(entry.designId || entry.id || '').trim();
	          if (!designId) return null;
	          return {
	            designId,
	            title: String(entry.title || `Vorlage ${index + 1}`).trim() || `Vorlage ${index + 1}`,
	            subtitle: String(entry.subtitle || '').trim(),
	            category: String(entry.category || 'Vorlage').trim() || 'Vorlage',
	            previewURL: String(entry.previewURL || entry.previewUrl || entry.preview || '').trim(),
	            sortOrder: Number.isFinite(Number(entry.sortOrder)) ? Number(entry.sortOrder) : 100
	          };
	        };

	        const safePreviewURL = rawValue => {
	          const value = String(rawValue || '').trim();
	          if (!value) return '';
	          if (/^data:image\//i.test(value)) return value;
	          try {
	            const url = new URL(value, window.location.href);
	            return /^https?:$/i.test(url.protocol) ? url.href : '';
	          } catch (_) {
	            return '';
	          }
	        };

            const directCatalogURL = () => {
              const raw = String(grid.dataset.catalogUrl || '').trim();
              if (!raw) return '';
              try {
                const url = new URL(raw, window.location.href);
                const store = new URL(window.location.href);
                if (url.protocol !== 'https:' || (url.origin !== store.origin && url.hostname !== 'cdn.shopify.com')) return '';
                url.hash = '';
                return url.href;
              } catch (_) { return ''; }
            };

            const getTemplateMaster = template => {
              const designId = String(template?.designId || '').trim();
              const cacheKey = designId.toUpperCase();
              if (!cacheKey) return Promise.reject(new Error('Vorlagen-ID fehlt.'));
              if (templateMasterJobs.has(cacheKey)) return templateMasterJobs.get(cacheKey);
              const job = (async () => {
                const catalogURL = directCatalogURL();
                if (catalogURL && /^M-[A-Z0-9]+(?:-[A-Z0-9]+)*$/.test(cacheKey)) {
                  const url = new URL(encodeURIComponent(cacheKey) + '.json', catalogURL);
                  url.search = '';
                  try {
                    const payload = await fetchMainDesignPayload(url.href);
                    if (!Array.isArray(payload?.objects)) throw new Error('Vorlage enthält kein bearbeitbares Design.');
                    return { mainId: cacheKey, payload };
                  } catch (_) { /* Legacy lookup remains the fallback for moved or missing files. */ }
                }
                const { mainId, main } = await lookupMainDesignFile(designId);
                if (!main?.jsonUrl) throw new Error('Bearbeitbare Vorlagendatei fehlt.');
                const payload = await fetchMainDesignPayload(main.jsonUrl);
                if (!Array.isArray(payload?.objects)) throw new Error('Vorlage enthält kein bearbeitbares Design.');
                return { mainId: String(main.designId || mainId).toUpperCase(), payload };
              })();
              templateMasterJobs.set(cacheKey, job);
              job.then(() => {}, () => {
                if (templateMasterJobs.get(cacheKey) === job) templateMasterJobs.delete(cacheKey);
              });
              return job;
            };

	        const generateTemplatePreview = template => {
	          const designId = String(template?.designId || '').trim();
	          if (!designId || typeof fabric?.StaticCanvas !== 'function') {
	            return Promise.reject(new Error('Vorlage kann nicht gerendert werden.'));
	          }
	          if (generatedPreviewCache.has(designId)) {
	            return Promise.resolve(generatedPreviewCache.get(designId));
	          }
	          if (generatedPreviewJobs.has(designId)) {
	            return generatedPreviewJobs.get(designId);
	          }

	          const job = (async () => {
                const preparedMain = await getTemplateMaster(template);
                const payload = JSON.parse(JSON.stringify(preparedMain.payload));
	            if (document.fonts?.ready) await document.fonts.ready;

	            const sourceWidth = Math.max(1, Number(BASE_W) || 450);
	            const sourceHeight = Math.max(1, Number(BASE_H) || 290);
	            const previewCanvasElement = document.createElement('canvas');
	            previewCanvasElement.width = sourceWidth;
	            previewCanvasElement.height = sourceHeight;
	            const previewCanvas = new fabric.StaticCanvas(previewCanvasElement, {
	              width: sourceWidth,
	              height: sourceHeight,
	              renderOnAddRemove: false,
	              enableRetinaScaling: false
	            });

	            try {
	              await new Promise((resolve, reject) => {
	                let settled = false;
	                const finish = () => {
	                  if (settled) return;
	                  settled = true;
	                  resolve();
	                };
	                try {
	                  const maybePromise = previewCanvas.loadFromJSON(payload, finish);
	                  if (maybePromise && typeof maybePromise.then === 'function') {
	                    maybePromise.then(finish).catch(reject);
	                  }
	                } catch (error) {
	                  reject(error);
	                }
	              });
	              previewCanvas.renderAll();
	              const dataURL = previewCanvas.toDataURL({ format: 'png', multiplier: 0.7 });
	              generatedPreviewCache.set(designId, dataURL);
	              return dataURL;
	            } finally {
	              previewCanvas.dispose();
	            }
	          })();

	          generatedPreviewJobs.set(designId, job);
	          job.then(
	            () => generatedPreviewJobs.delete(designId),
	            () => generatedPreviewJobs.delete(designId)
	          );
	          return job;
	        };

	        const renderCatalog = () => {
	          const query = String(search?.value || '').trim().toLocaleLowerCase('de');
	          const visible = catalog.filter(template => {
	            if (!query) return true;
	            return [template.title, template.subtitle, template.category]
	              .join(' ')
	              .toLocaleLowerCase('de')
	              .includes(query);
	          });

	          grid.replaceChildren();
	          if (!visible.length) {
	            const empty = document.createElement('p');
	            empty.className = 'template-catalog-empty';
	            empty.textContent = catalog.length
	              ? 'Keine passende Vorlage gefunden.'
	              : 'Hier erscheinen bald veröffentlichte Vorlagen. Du kannst dein Motiv bereits selbst gestalten.';
	            grid.appendChild(empty);
	            return;
	          }

	          visible.forEach((template, index) => {
	            const card = document.createElement('article');
	            card.className = 'template-card';

	            const preview = document.createElement('div');
	            preview.className = 'template-card__preview';
	            const previewURL = safePreviewURL(template.previewURL);
	            const showPlaceholder = () => {
	              if (!preview.isConnected) return;
	              preview.replaceChildren();
	              preview.classList.remove('is-generating');
	              preview.classList.add('has-placeholder');
	              preview.removeAttribute('aria-busy');
	            };
	            const showImage = (source, onError) => {
	              const image = document.createElement('img');
	              image.alt = '';
	              image.loading = 'lazy';
	              image.addEventListener('error', onError, { once: true });
	              image.src = source;
	              preview.replaceChildren(image);
	            };
	            const showGeneratedPreview = () => {
	              preview.replaceChildren();
	              preview.classList.remove('has-placeholder');
	              preview.classList.add('is-generating');
	              preview.setAttribute('aria-busy', 'true');
	              generateTemplatePreview(template)
	                .then(source => {
	                  if (!preview.isConnected) return;
	                  preview.classList.remove('is-generating', 'has-placeholder');
	                  preview.removeAttribute('aria-busy');
	                  showImage(source, showPlaceholder);
	                })
	                .catch(error => {
	                  console.warn('[NH Templates] Vorschau konnte nicht erzeugt werden', error);
	                  showPlaceholder();
	                });
	            };
	            if (previewURL) showImage(previewURL, showGeneratedPreview);
	            else showGeneratedPreview();

	            const copy = document.createElement('div');
	            copy.className = 'template-card__copy';
	            const category = document.createElement('span');
	            category.className = 'template-card__category';
	            category.textContent = template.category;
	            const title = document.createElement('strong');
	            title.textContent = template.title;
	            copy.append(category, title);
	            if (template.subtitle) {
	              const subtitle = document.createElement('span');
	              subtitle.className = 'template-card__subtitle';
	              subtitle.textContent = template.subtitle;
	              copy.appendChild(subtitle);
	            }

	            const action = document.createElement('button');
	            action.type = 'button';
	            action.className = 'btn template-card__action';
	            action.textContent = 'Vorlage verwenden';
	            action.addEventListener('click', async () => {
	              action.disabled = true;
	              card.classList.add('is-loading');
	              setStatus(`„${template.title}“ wird geladen …`);
	              try {
                    const preparedMain = await getTemplateMaster(template);
	                await loadEditableMainDesign(template.designId, { label: `Vorlage geladen: ${template.title}`, preparedMain });
                    nhFunnelCall('emit', 'design_started');
	                setStatus(`Vorlage „${template.title}“ ist bereit.`, 'success');
	                window.__nhActivateEditorPanel?.('text', { skipFocus: true });
	              } catch (error) {
	                console.warn('[NH Templates] Vorlage konnte nicht geladen werden', error);
	                setStatus(
	                  'Diese Vorlage konnte gerade nicht geladen werden. Bitte versuche es erneut.',
	                  'error'
	                );
	              } finally {
	                action.disabled = false;
	                card.classList.remove('is-loading');
	              }
	            });

	            card.append(preview, copy, action);
	            grid.appendChild(card);
                // Only a few visible choices are warmed; no whole-catalog payload sweep.
                if (index < 3 && previewURL) getTemplateMaster(template).catch(() => {});
	          });
	        };

            const readCatalog = async url => {
              const freshURL = new URL(url, window.location.href);
              // Shopify's CDN varies this file on v; an unrelated nonce can keep an old catalog cached.
              freshURL.searchParams.set('v', String(Date.now()));
              const response = await fetch(freshURL.href, { cache: 'no-store', credentials: 'omit' });
              if (!response.ok) throw new Error(`Vorlagenkatalog konnte nicht geladen werden (${response.status}).`);
              const json = await response.json();
              const entries = Array.isArray(json?.templates) ? json.templates : Array.isArray(json?.items) ? json.items : null;
              if (!entries) throw new Error('Vorlagenkatalog hat kein gültiges Vorlagenformat.');
              const normalized = entries.map((entry, index) => {
                const template = normalizeTemplate(entry, index);
                if (!template && entry?.isPublished !== false) throw new Error('Vorlagenkatalog enthält eine ungültige Vorlage.');
                return template;
              }).filter(Boolean);
              return normalized.sort((a, b) => a.sortOrder - b.sortOrder || a.title.localeCompare(b.title, 'de'));
            };

            const loadCatalog = async () => {
              const directURL = directCatalogURL();
              if (directURL) {
                try { return await readCatalog(directURL); }
                catch (_) { /* A missing/unavailable CDN URL can still use the existing lookup. */ }
              }
              const lookup = await lookupMainDesignFile(TEMPLATE_CATALOG_ID);
              if (!lookup.main?.jsonUrl) throw new Error('Vorlagenkatalog noch nicht veröffentlicht.');
              return readCatalog(lookup.main.jsonUrl);
            };

            const fetchCatalog = async ({ force = false } = {}) => {
              // A previously loaded list is usable immediately, even during revalidation.
              if (catalogLoaded && !force) {
                renderCatalog();
                if (catalogLoading) return catalog;
              } else if (catalogLoading && !force) {
                return catalogLoading;
              }
              const background = catalogLoaded && !force;
              const version = ++catalogRequestVersion;
              const job = (async () => {
                setStatus(catalogLoaded ? 'Vorlagen werden aktualisiert …' : 'Vorlagen werden geladen …');
                refresh?.classList.add('is-loading');
                if (refresh) refresh.disabled = !background;
                try {
                  const freshCatalog = await loadCatalog();
                  if (version !== catalogRequestVersion) return catalog;
                  catalog = freshCatalog;
                  catalogLoaded = true;
                  setStatus(catalog.length === 1 ? '1 Vorlage verfügbar' :
                    (catalog.length ? `${catalog.length} Vorlagen verfügbar` : 'Noch keine Vorlagen veröffentlicht'),
                    catalog.length ? 'success' : '');
                  renderCatalog();
                  return catalog;
                } catch (error) {
                  if (version !== catalogRequestVersion) return catalog;
                  console.warn('[NH Templates] Katalog konnte nicht geladen werden', error);
                  setStatus(catalogLoaded
                    ? 'Aktualisierung gerade nicht möglich. Deine bisherigen Vorlagen bleiben verfügbar.'
                    : 'Vorlagen konnten gerade nicht geladen werden. Bitte versuche es später erneut.', 'error');
                  renderCatalog();
                  return catalog;
                } finally {
                  if (version === catalogRequestVersion) {
                    refresh?.classList.remove('is-loading');
                    if (refresh) refresh.disabled = false;
                    catalogLoading = null;
                  }
                }
              })();
              catalogLoading = job;
              if (background) return catalog;
              return job;
            };

	        search?.addEventListener('input', renderCatalog);
	        refresh?.addEventListener('click', () => fetchCatalog({ force: true }));
	        window.__nhEnsureTemplateCatalog = () => fetchCatalog();
	      })();

      function loadImageForPreview(dataUrl) {
        return new Promise((resolve, reject) => {
          const img = new Image();
          img.onload = () => resolve(img);
          img.onerror = reject;
          img.src = dataUrl;
        });
      }

      async function flattenPreviewBackground(dataUrl) {
        if (!dataUrl) return '';
        const img = await loadImageForPreview(dataUrl);
        const out = document.createElement('canvas');
        out.width = img.width || 1;
        out.height = img.height || 1;
        const ctx = out.getContext('2d');
        ctx.fillStyle = '#ffffff';
        ctx.fillRect(0, 0, out.width, out.height);
        ctx.drawImage(img, 0, 0, out.width, out.height);
        return out.toDataURL('image/png');
      }

      async function generatePreviewDataUrl(multiplier) {
        if (!canvas || typeof canvas.toDataURL !== 'function') return '';
        const options = {
          format: 'png',
          multiplier,
          enableRetinaScaling: false
        };
        const raw = canvas.toDataURL(options);
        if (!raw) return '';
        try {
          return await flattenPreviewBackground(raw);
        } catch (err) {
          console.warn('Preview background flatten failed', err);
          return raw;
        }
      }

	      function renderPreviewImage() {
	        const modal = document.getElementById('preview-modal');
	        const context = previewContext || modal?.dataset?.context || 'review';
	        const reorderState = window[NH_EDITOR_REORDER_STATE_KEY];
	        if (context === 'reorder' && reorderState && reorderState.kind === 'prefix-reorder') {
	          const img = document.getElementById('preview-image');
	          const emptyState = document.getElementById('preview-empty-state');
	          const stage = document.querySelector('.preview-stage-inner');
	          const source = String(reorderState.previewSource || reorderState.previewUrl || '').trim();

	          if (img) {
	            if (source) {
	              img.loading = 'eager';
	              img.hidden = false;
	              img.style.opacity = '1';
	              img.src = source;
	            } else {
	              img.hidden = true;
	              img.removeAttribute('src');
	              img.style.opacity = '0';
	            }
	          }
	          if (emptyState) {
	            if (source) {
	              emptyState.hidden = true;
	              emptyState.style.display = 'none';
	            } else {
	              emptyState.hidden = false;
	              emptyState.style.display = 'flex';
	              const text = emptyState.querySelector('p');
	              if (text) text.textContent = 'Keine Vorschau verfügbar.';
	            }
	          }
	          if (stage) {
	            stage.classList.toggle('has-image', !!source);
	          }
	          nhFunnelCall('emit', source ? 'preview_ready' : 'preview_error', source
                    ? { stage: 'preview' } : { stage: 'preview', error: 'preview_failed' });
	          return;
	        }

	        const img = document.getElementById('preview-image');
	        const emptyState = document.getElementById('preview-empty-state');
	        const stage = document.querySelector('.preview-stage-inner');

        if (img) {
          img.hidden = true;
          img.removeAttribute('src');
          img.style.opacity = '0';
        }
        if (emptyState) {
          emptyState.hidden = false;
          emptyState.style.display = 'flex';
          const text = emptyState.querySelector('p');
          if (text) text.textContent = 'Vorschau wird aufgebaut…';
        }
        if (stage) {
          stage.classList.remove('has-image');
        }

        requestAnimationFrame(() => {
          const multiplier = Math.min(2, Math.max(1, window.devicePixelRatio || 1));
          generatePreviewDataUrl(multiplier)
            .then((dataUrl) => {
              if (img) {
                if (dataUrl) {
                  img.loading = 'eager';
                  img.hidden = false;
                  img.style.opacity = '1';
                  img.src = dataUrl;
                } else {
                  img.hidden = true;
                  img.removeAttribute('src');
                  img.style.opacity = '0';
                }
              }
              if (emptyState) {
                if (dataUrl) {
                  emptyState.hidden = true;
                  emptyState.style.display = 'none';
                } else {
                  emptyState.hidden = false;
                  emptyState.style.display = 'flex';
                }
              }
              if (stage) {
                stage.classList.toggle('has-image', !!dataUrl);
              }
              rememberLatestPreviewData(dataUrl);
              nhFunnelCall('emit', dataUrl ? 'preview_ready' : 'preview_error', dataUrl
                ? { stage: 'preview' } : { stage: 'preview', error: 'preview_failed' });
            })
            .catch((err) => {
              console.warn('Preview render failed', err);
              nhFunnelCall('emit', 'preview_error', { stage: 'preview', error: 'preview_failed' });
              if (img) {
                img.hidden = true;
                img.removeAttribute('src');
                img.style.opacity = '0';
              }
              if (emptyState) {
                emptyState.hidden = false;
                emptyState.style.display = 'flex';
                const text = emptyState.querySelector('p');
                if (text) {
                  text.textContent = 'Vorschau konnte nicht geladen werden. Bitte überprüfe deine Elemente.';
                }
              }
              if (stage) {
                stage.classList.remove('has-image');
              }
            });
	        });
	      }

	      let __nhPreviewUiDefaults = null;
	      function ensurePreviewUiDefaults(modal) {
	        if (__nhPreviewUiDefaults) return __nhPreviewUiDefaults;
	        const safeModal = modal || document.getElementById('preview-modal');
	        __nhPreviewUiDefaults = {
	          label: safeModal?.querySelector('.preview-main-id__label')?.textContent || 'Deine Design-ID',
	          hint: safeModal?.querySelector('.preview-main-id__hint')?.textContent || '',
	          subtitle: safeModal?.querySelector('.preview-subtitle')?.textContent || '',
	          back: document.getElementById('preview-back-btn')?.textContent || 'Weiter bearbeiten'
	        };
	        return __nhPreviewUiDefaults;
	      }

	      function applyPreviewUiVariant({ mode = 'main', modal = null, designId = '' } = {}) {
	        const safeModal = modal || document.getElementById('preview-modal');
	        if (!safeModal) return;
	        const defaults = ensurePreviewUiDefaults(safeModal);
	        const labelNode = safeModal.querySelector('.preview-main-id__label');
	        const hintNode = safeModal.querySelector('.preview-main-id__hint');
	        const subtitleNode = safeModal.querySelector('.preview-subtitle');
	        const backBtn = document.getElementById('preview-back-btn');

	        if (mode === 'reorder') {
	          if (labelNode) labelNode.textContent = 'Design‑ID';
	          if (hintNode) hintNode.textContent = 'Dieses Design hat keine Main‑ID und kann hier nicht bearbeitet werden. Du kannst aber vorhandene Produkte nachbestellen.';
	          if (subtitleNode) subtitleNode.textContent = defaults.subtitle || 'Prüfe dein Motiv und wähle danach das gewünschte Produkt.';
	          if (backBtn) backBtn.textContent = 'Schließen';
	          setPreviewMainIdUi(designId || '');
	          return;
	        }

	        if (labelNode) labelNode.textContent = defaults.label;
	        if (hintNode) hintNode.textContent = defaults.hint;
	        if (subtitleNode) subtitleNode.textContent = defaults.subtitle;
	        if (backBtn) backBtn.textContent = defaults.back;
	      }

			      function openPreviewModal(context = 'review') {
			        const modal = document.getElementById('preview-modal');
			        if (!modal) return;
                dismissWelcomeForEditorDialog();
			        nhLockScroll();
                updateTextOverflowWarning();
			        previewContext = context;
			        modal.dataset.context = context;

        Object.assign(modal.style, {
          display: 'flex',
          position: 'fixed',
          top: '0',
          left: '0',
          width: '100%',
          height: '100%',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: '12000'
        });
		        modal.setAttribute('aria-hidden', 'false');
                activateEditorDialog(modal);
                nhFunnelCall('setStage', 'preview');
                nhFunnelCall('emit', 'preview_open', { stage: 'preview' });

		        const reorderState = window[NH_EDITOR_REORDER_STATE_KEY];
		        if (context === 'reorder' && reorderState && reorderState.kind === 'prefix-reorder') {
		          applyPreviewUiVariant({ mode: 'reorder', modal, designId: reorderState.rawDesignId || '' });
		        } else {
		          applyPreviewUiVariant({ mode: 'main', modal });
		          try {
		            const mainId = currentMainDesignId();
		            setPreviewMainIdUi(mainId);
		            if (context === 'export') {
		              setTimeout(() => {
		                try { ensureMainDesignUploadedInBackground(); } catch (_) { /* noop */ }
		              }, 0);
		            }
		          } catch (err) {
		            console.warn('[NH Main] Vorbereitung fehlgeschlagen', err);
		          }
		        }

		        renderPreviewImage();

        const card = modal.querySelector('.preview-card');
        if (card && typeof card.focus === 'function') {
          card.setAttribute('tabindex', '-1');
          card.focus();
        }
      }

      function getPreviewContext() {
        const modal = document.getElementById('preview-modal');
        if (previewContext) return previewContext;
        if (modal && modal.dataset && modal.dataset.context) return modal.dataset.context;
        return 'review';
      }

      function focusIdCard() {
        const input = document.getElementById('id-code-input');
        if (input && typeof input.focus === 'function') {
          input.focus({ preventScroll: true });
          if (typeof input.select === 'function') {
            input.select();
          }
        }
      }

      function focusOrderButton() {
        const orderBtn = document.getElementById('export-action');
        if (orderBtn && typeof orderBtn.focus === 'function') {
          orderBtn.focus();
        }
      }

	      // Buttons im ID-Modal
	      document.addEventListener('click', (e) => {
	        const target = e.target;
	        const previewCopyBtn = target && target.closest ? target.closest('#preview-copy-main-id') : null;
	        if (previewCopyBtn) {
	          const input = document.getElementById('preview-main-id');
	          const value = input
	            ? String(('value' in input ? input.value : input.textContent) || '').trim()
	            : '';
	          if (!value) {
	            showPreviewMainIdFeedback('Keine ID gefunden', 'error');
	            return;
	          }
	          if (input && typeof input.focus === 'function') {
	            try { input.focus({ preventScroll: true }); } catch (_) {}
	            if (typeof input.select === 'function') {
	              try { input.select(); } catch (_) {}
	            }
	          }
	          writeClipboard(value).then(ok => {
	            showPreviewMainIdFeedback(ok ? 'Kopiert' : 'Kopieren fehlgeschlagen', ok ? 'success' : 'error');
	          }).catch(() => {
	            showPreviewMainIdFeedback('Kopieren fehlgeschlagen', 'error');
	          });
	          return;
	        }
	        const copyBtn = target && target.closest ? target.closest('#copy-id-btn') : null;
	        if (copyBtn) {
	          const input = document.getElementById('id-code-input');
	          const value = input ? (input.value || '').trim() : '';
	          if (input && typeof input.focus === 'function') {
            input.focus({ preventScroll: true });
            if (typeof input.select === 'function') input.select();
          }
          if (!value) {
            showCopyFeedback('Keine ID gefunden', 'error');
            return;
          }
          writeClipboard(value).then(ok => {
            showCopyFeedback(ok ? 'Kopiert' : 'Kopieren fehlgeschlagen', ok ? 'success' : 'error');
          }).catch(() => {
            showCopyFeedback('Kopieren fehlgeschlagen', 'error');
          });
          return;
        }

        const previewBtn = target && target.closest ? target.closest('#preview-design-btn') : null;
        if (previewBtn) {
          e.preventDefault();
          openPreviewModal('review');
          return;
        }

	        if (target && target.id === 'preview-back-btn') {
	          e.preventDefault();
	          const context = getPreviewContext();
	          closePreviewModal();
	          if (context === 'reorder') {
	            clearNhEditorReorderState();
	            return;
	          }
	          if (context === 'review') {
	            focusIdCard();
	          } else if (context === 'export') {
	            focusOrderButton();
	          }
	          return;
	        }
		        if (target && target.id === 'preview-continue-btn') {
		          e.preventDefault();
		          const context = getPreviewContext();
		          closePreviewModal();
		          if (context === 'export' || context === 'reorder') {
		            nhLockScroll();
		            const exportModal = document.getElementById('export-modal');
		            if (exportModal) {
		              exportModal.style.display = 'flex';
		              exportModal.setAttribute('aria-hidden', 'false');
		            }
		          } else {
		            focusOrderButton();
		          }
		          return;
		        }
	        if (target.closest && target.closest('#preview-modal .preview-close')) {
	          const context = getPreviewContext();
	          closePreviewModal();
	          if (context === 'reorder') {
	            clearNhEditorReorderState();
	            return;
	          }
	          if (context === 'review') {
	            focusIdCard();
	          } else if (context === 'export') {
	            focusOrderButton();
	          }
	          return;
	        }
	        if (target.classList && target.classList.contains('preview-backdrop')) {
	          const context = getPreviewContext();
	          closePreviewModal();
	          if (context === 'reorder') {
	            clearNhEditorReorderState();
	            return;
	          }
	          if (context === 'review') {
	            focusIdCard();
	          } else if (context === 'export') {
	            focusOrderButton();
	          }
	          return;
	        }
	        if (target && target.id === 'id-modal-continue') {
	          closeIdModal({ restoreFocus: false });
	          // erst jetzt das Produkt-Popup öffnen
	          nhLockScroll();
	          const exportModal = document.getElementById('export-modal');
	          if (exportModal) {
	            exportModal.style.display = 'flex';
	            exportModal.setAttribute('aria-hidden', 'false');
	          }
	        }
        // X schließen (funktioniert für .modal-close oder .id-close)
        if (target.closest && target.closest('#id-modal .id-close')) {
          closeIdModal();
          return;
        }

        if (target.closest && target.closest('[data-dismiss="id-modal"]')) {
          closeIdModal();
          return;
        }


      });

// 👉 PDF an den Worker schicken (preferiert als Blob)
async function uploadPdfBase64(idMaybe, product, data, extra = {}) {
  const metaId = idMaybe || '';
  const metaProduct = product || '';
  const fallbackName = `${metaProduct || 'design'}_${metaId || Date.now()}.pdf`;
  const desiredName = (extra && typeof extra.fileName === 'string' && extra.fileName.trim())
    ? extra.fileName.trim()
    : fallbackName;
  const safeName = desiredName.replace(/[^\w.\-]+/g, '_');
  const isBlob = typeof Blob !== 'undefined' && data instanceof Blob;
  let response;
  const controller = new AbortController();
  const timeout = window.setTimeout(() => controller.abort(), 60000);
  try {
  if (isBlob) {
    const headers = { "Content-Type": data.type || "application/pdf" };
    const headerMap = {
      "X-Design-Id": metaId,
      "X-Design-Product": metaProduct,
      "X-Design-Profile": extra?.profileKey || '',
      "X-File-Name": safeName
    };
    Object.entries(headerMap).forEach(([key, value]) => {
      if (value) headers[key] = value;
    });

    response = await fetch(NETLIFY_FN, {
      method: "POST",
      headers,
      body: data,
      signal: controller.signal
    });
  } else {
    const payload = {
      id: metaId,
      product: metaProduct,
      pdfBase64: typeof data === 'string' ? data : '',
      ...extra
    };
    if (!payload.fileName) payload.fileName = safeName;

    response = await fetch(NETLIFY_FN, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
      signal: controller.signal
    });
  }

  const text = await response.text();
  let json;
  try {
    json = JSON.parse(text);
  } catch (e) {
    console.error("Antwort war kein JSON:", text.slice(0, 300));
    throw new Error("Worker nicht getroffen oder Worker-Error (kein JSON).");
  }

  if (!json.ok) throw new Error(json.error || "Upload failed");
  return json;
  } catch (error) {
    if (error?.name === 'AbortError') throw nhFunnelMarkError(new Error('Der Druckdatei-Upload dauert zu lange. Bitte Verbindung prüfen und erneut versuchen.'), 'upload_failed');
    throw nhFunnelMarkError(error, 'upload_failed');
  } finally {
    window.clearTimeout(timeout);
  }
}



    // Native emoji use the picker's actual system-font stack, never substitute artwork.
    const EMOJI_DEFAULT_SIZE = 48;
    const EMOJI_NATIVE_FONT_PX = 1024;
    // Conservative detail estimate: the verified Apple bitmap strikes end at 160px.
    // The larger PNG is a render container and does not create new source detail.
    const EMOJI_NATIVE_DETAIL_PX = 160;
    const EMOJI_MAX_WORK_PX = 4096;

    function emojiCharFromPickerDetail(detail) {
      const candidates = [detail?.unicode, detail?.emoji?.unicode, detail?.emoji, detail?.char];
      return candidates.find(value => typeof value === 'string' && value.trim()) || '';
    }

    function setEmojiStatus(message = '', error = false) {
      const picker = document.getElementById('emoji-panel-picker');
      if (!picker) return;
      let status = document.getElementById('nh-emoji-status');
      if (!status) {
        status = document.createElement('p');
        status.id = 'nh-emoji-status';
        status.className = 'upload-status';
        status.setAttribute('role', 'status');
        status.setAttribute('aria-live', 'polite');
        picker.insertAdjacentElement('beforebegin', status);
      }
      status.textContent = message;
      status.hidden = !message;
      status.setAttribute('data-error', String(error));
    }

    function nativeEmojiFont() {
      const root = document.getElementById('emoji-panel-picker')?.shadowRoot;
      const cell = root?.querySelector('.tabpanel button.emoji:not(.custom-emoji)')
        || root?.querySelector('.favorites button.emoji:not(.custom-emoji)')
        || root?.querySelector('#skintone-button');
      if (!cell) throw new Error('Emoji-Auswahl ist noch nicht bereit');
      const style = window.getComputedStyle(cell);
      if (!style.fontFamily?.trim()) throw new Error('Emoji-Schrift konnte nicht bestimmt werden');
      return {
        family: style.fontFamily,
        style: style.fontStyle || 'normal',
        weight: style.fontWeight || '400',
        stretch: style.fontStretch || 'normal',
        kerning: style.fontKerning || 'auto',
        color: style.color || '#000000',
        direction: style.direction === 'rtl' ? 'rtl' : 'ltr'
      };
    }

    function applyNativeEmojiFont(context, font, fontSize) {
      context.font = `${font.style} ${font.weight} ${fontSize}px ${font.family}`;
      context.fillStyle = font.color;
      context.textAlign = 'left';
      context.textBaseline = 'alphabetic';
      context.direction = font.direction;
      if ('fontStretch' in context) context.fontStretch = font.stretch;
      if ('fontKerning' in context) context.fontKerning = font.kerning;
    }

    function emojiInkBounds(pixels, width, height) {
      let left = width, top = height, right = -1, bottom = -1;
      for (let y = 0; y < height; y++) {
        for (let x = 0; x < width; x++) {
          if (pixels[(y * width + x) * 4 + 3] === 0) continue;
          if (x < left) left = x;
          if (x > right) right = x;
          if (y < top) top = y;
          if (y > bottom) bottom = y;
        }
      }
      return right >= left && bottom >= top ? { left, top, right, bottom, width: right - left + 1, height: bottom - top + 1 } : null;
    }

    function renderNativeEmojiSurface(emoji, font, fontSize) {
      const work = document.createElement('canvas');
      let context = work.getContext('2d', { willReadFrequently: true });
      if (!context) throw new Error('Emoji-Zeichenfläche nicht verfügbar');
      applyNativeEmojiFont(context, font, fontSize);
      const metrics = context.measureText(emoji);
      const left = Number.isFinite(metrics.actualBoundingBoxLeft) ? metrics.actualBoundingBoxLeft : 0;
      const right = Number.isFinite(metrics.actualBoundingBoxRight) ? metrics.actualBoundingBoxRight : metrics.width;
      const ascent = metrics.actualBoundingBoxAscent > 0 ? metrics.actualBoundingBoxAscent : fontSize;
      const descent = metrics.actualBoundingBoxDescent >= 0 ? metrics.actualBoundingBoxDescent : fontSize / 4;
      let bounds = null;
      let padding = fontSize / 4;
      for (let attempt = 0; attempt < 2; attempt++, padding *= 2) {
        const workWidth = Math.ceil(Math.max(metrics.width, Math.max(0, left) + Math.max(0, right), fontSize) + padding * 2);
        const workHeight = Math.ceil(Math.max(ascent + descent, fontSize) + padding * 2);
        if (!(workWidth > 0 && workHeight > 0) || workWidth > EMOJI_MAX_WORK_PX || workHeight > EMOJI_MAX_WORK_PX) {
          throw new Error('Emoji-Zeichenfläche ist zu groß');
        }
        work.width = workWidth;
        work.height = workHeight;
        context = work.getContext('2d', { willReadFrequently: true });
        applyNativeEmojiFont(context, font, fontSize);
        context.fillText(emoji, padding + Math.max(0, left), padding + ascent);
        bounds = emojiInkBounds(context.getImageData(0, 0, work.width, work.height).data, work.width, work.height);
        if (!bounds) throw new Error('Emoji wurde nicht gezeichnet');
        const clipped = bounds.left < 2 || bounds.top < 2 || bounds.right >= work.width - 2 || bounds.bottom >= work.height - 2;
        if (!clipped) break;
        if (attempt === 1) throw new Error('Emoji konnte nicht vollständig gezeichnet werden');
      }
      return { work, bounds };
    }

    function renderNativeEmojiPng(emoji) {
      const font = nativeEmojiFont();
      const { work, bounds } = renderNativeEmojiSurface(emoji, font, EMOJI_NATIVE_FONT_PX);
      // Measure visible native detail at a conservative 160px sampling size too.
      const detail = renderNativeEmojiSurface(emoji, font, EMOJI_NATIVE_DETAIL_PX).bounds;
      const border = 4;
      const result = document.createElement('canvas');
      result.width = bounds.width + border * 2;
      result.height = bounds.height + border * 2;
      const resultContext = result.getContext('2d');
      if (!resultContext) throw new Error('Emoji-Bild konnte nicht erstellt werden');
      // A 1:1 crop preserves the exact glyph proportions and transparent edges.
      resultContext.drawImage(work, bounds.left, bounds.top, bounds.width, bounds.height, border, border, bounds.width, bounds.height);
      const dataUrl = result.toDataURL('image/png');
      if (!dataUrl.startsWith('data:image/png;base64,')) throw new Error('Emoji-Bild ist ungültig');
      const detailPixels = Math.min(EMOJI_NATIVE_DETAIL_PX, Math.max(detail.width, detail.height));
      const detailScale = Math.min(1, detailPixels / Math.max(result.width, result.height));
      return {
        dataUrl, width: result.width, height: result.height,
        detailWidth: Math.max(1, Math.floor(result.width * detailScale)),
        detailHeight: Math.max(1, Math.floor(result.height * detailScale))
      };
    }

    function isNativeRasterEmoji(object) {
      return !!(object?.type === 'image' && object.isEmoji === true && typeof object._emojiChar === 'string'
        && object._originalBase64?.startsWith('data:image/png;base64,')
        && object._originalWidth > 0 && object._originalHeight > 0);
    }

    async function addEmojiToCanvasFromChar(emojiChar) {
      if (typeof emojiChar !== 'string' || !emojiChar.trim()) return null;
      try {
        const rendered = renderNativeEmojiPng(emojiChar);
        const image = await new Promise((resolve, reject) => {
          const timeout = window.setTimeout(() => reject(new Error('Emoji-Bild konnte nicht geladen werden')), 10000);
          try {
            fabric.Image.fromURL(rendered.dataUrl, (object, error) => {
              window.clearTimeout(timeout);
              if (error || !(object?.width > 0 && object?.height > 0)) reject(new Error('Ungültiges Emoji-Bild'));
              else resolve(object);
            });
          } catch (error) { window.clearTimeout(timeout); reject(error); }
        });
        const scale = EMOJI_DEFAULT_SIZE / Math.max(image.width, image.height);
        image.set({ scaleX: scale, scaleY: scale, originX: 'center', originY: 'center' });
        centerOnShape(image);
        image.isEmoji = true;
        image._emojiChar = emojiChar;
        image._originalBase64 = rendered.dataUrl;
        image._originalWidth = rendered.detailWidth;
        image._originalHeight = rendered.detailHeight;
        canvas.add(image).setActiveObject(image);
        canvas.bringToFront(image);
        canvas.requestRenderAll();
        setEmojiStatus();
        return image;
      } catch (error) {
        console.warn('Emoji konnte nicht eingefügt werden:', error);
        setEmojiStatus('Dieses Emoji konnte nicht eingefügt werden. Bitte wähle es erneut aus.', true);
        return null;
      }
    }
  // 📦 RGB → HEX Helper
  function rgbToHex(rgb) {
    if (!rgb) return '#000000';
    if (typeof rgb === 'object') {
      if (Array.isArray(rgb.colorStops) && rgb.colorStops.length) {
        const firstStop = rgb.colorStops[0];
        if (firstStop && typeof firstStop.color === 'string') {
          return firstStop.color;
        }
      }
      return '#000000';
    }
    const value = String(rgb);
    if (value.startsWith('#')) return value;
    const result = value.match(/\d+/g);
    return result && result.length >= 3
      ? '#' + result.slice(0, 3).map(x => ('0' + parseInt(x, 10).toString(16)).slice(-2)).join('')
      : '#000000';
  }

  function hexToRgbObject(hex) {
    if (typeof hex !== 'string') return { r: 0, g: 0, b: 0 };
    let value = hex.trim().replace(/^#/, '');
    if (value.length === 3) value = value.split('').map(ch => ch + ch).join('');
    if (value.length !== 6) return { r: 0, g: 0, b: 0 };
    const num = Number.parseInt(value, 16);
    return {
      r: (num >> 16) & 255,
      g: (num >> 8) & 255,
      b: num & 255
    };
  }

  function hexToRgba(hex, alpha = 1) {
    const { r, g, b } = hexToRgbObject(hex);
    const normalizedAlpha = Math.min(Math.max(Number(alpha) || 0, 0), 1);
    return `rgba(${r}, ${g}, ${b}, ${normalizedAlpha})`;
  }

  function mixWithWhite(rgb, factor = 0.7) {
    const clampChannel = (value) => Math.max(0, Math.min(255, Math.round(value)));
    return {
      r: clampChannel(rgb.r + (255 - rgb.r) * factor),
      g: clampChannel(rgb.g + (255 - rgb.g) * factor),
      b: clampChannel(rgb.b + (255 - rgb.b) * factor)
    };
  }

  function rgbaFromRgb(rgb, alpha = 1) {
    const normalizedAlpha = Math.min(Math.max(Number(alpha) || 0, 0), 1);
    return `rgba(${rgb.r}, ${rgb.g}, ${rgb.b}, ${normalizedAlpha})`;
  }

  function updateSidebarAccentStyles(color) {
    const root = document?.documentElement;
    if (!root) return;
    const normalized = normalizeHexColor(color, '#ffff00');
    const baseRgb = hexToRgbObject(normalized);
    const hoverTint = mixWithWhite(baseRgb, 0.68);
    const activeStartTint = mixWithWhite(baseRgb, 0.82);
    const activeEndTint = mixWithWhite(baseRgb, 0.72);

    root.style.setProperty('--nav-hover-bg', rgbaFromRgb(hoverTint, 0.7));
    root.style.setProperty('--nav-hover-border', rgbaFromRgb(baseRgb, 0.55));
    root.style.setProperty('--nav-active-bg-start', rgbaFromRgb(activeStartTint, 0.95));
    root.style.setProperty('--nav-active-bg-end', rgbaFromRgb(activeEndTint, 0.88));
    root.style.setProperty('--nav-active-border', rgbaFromRgb(baseRgb, 0.6));
    root.style.setProperty('--nav-active-shadow', rgbaFromRgb(baseRgb, 0.28));
  }

  function fabricColorToHex(color) {
    try {
      const fabricColor = new fabric.Color(color);
      return `#${fabricColor.toHex()}`;
    } catch (err) {
      return '#000000';
    }
  }

  function fabricColorAlpha(color) {
    try {
      const source = new fabric.Color(color).getSource();
      return typeof source[3] === 'number' ? source[3] : 1;
    } catch (err) {
      return 1;
    }
  }

  const clamp = (value, min, max) => Math.min(Math.max(Number.isFinite(value) ? value : min, min), max);

  function updateOpacitySliderUI(value) {
    if (!opacityControl) return;
    const numeric = Number(value);
    const safeValue = clamp(Number.isFinite(numeric) ? numeric : parseFloat(value) || 0, 0, 1);
    const percent = `${Math.round(safeValue * 100)}%`;
    opacityControl.style.setProperty('--fill', percent);
    if (opacityValueDisplay) {
      opacityValueDisplay.textContent = percent;
    }
  }

  function initializeOpacityControl() {
    opacityControl = document.getElementById('opacity-slider');
    opacityValueDisplay = document.getElementById('opacity-value-display');
    if (!opacityControl) return;
    if (opacityControl.__initialized) {
      updateOpacitySliderUI(opacityControl.value);
      return;
    }

    const handleOpacity = (commit) => {
      if (historyService?.isRestoring?.()) return;
      const obj = canvas.getActiveObject();
      if (!obj || obj._helperUI || obj._isBackground) return;
      const value = clamp(parseFloat(opacityControl.value), 0, 1);
      obj.set('opacity', value);
      obj.dirty = true;
      obj.setCoords?.();
      canvas.requestRenderAll();
      updateOpacitySliderUI(value);
      if (commit && !historyService?.isRestoring?.()) {
        pushHistory('Transparenz angepasst');
      }
    };

    opacityControl.addEventListener('input', () => {
      updateOpacitySliderUI(opacityControl.value);
      handleOpacity(false);
    });

    opacityControl.addEventListener('change', () => {
      updateOpacitySliderUI(opacityControl.value);
      handleOpacity(true);
    });

    opacityControl.__initialized = true;
    updateOpacitySliderUI(opacityControl.value || 1);
  }

  function syncOpacityControl() {
    if (!opacityControl) return;
    const obj = canvas.getActiveObject();
    const usable = obj && !obj._helperUI && !obj._isBackground;
    opacityControl.disabled = !usable;
    const value = usable ? clamp(obj.opacity ?? 1, 0, 1) : 1;
    opacityControl.value = value;
    updateOpacitySliderUI(value);
  }

  var backgroundController = window.backgroundController;
  if (!backgroundController) {
    backgroundController = (() => {
      const state = {
        baseColor: '#ffff00'
      };

      const inputs = {
        base: null
      };

      let listenersAttached = false;

      function snapshot() {
        return {
          baseColor: state.baseColor
        };
      }

      function computeFill(target = oval) {
        return state.baseColor;
      }

      function applyFill(target = oval) {
        if (!target) return;
        const fill = computeFill(target);
        target.set('fill', fill);
        target._bgGradientState = snapshot();
        target.dirty = true;
        target.setCoords?.();
      }

      function applyAppearance({ commitHistory = false, historyLabel = 'Hintergrund angepasst' } = {}) {
        if (!oval) return;
        applyFill(oval);
        oval.set({ stroke: null, strokeWidth: 0, strokeUniform: true });
        oval.setCoords?.();
        canvas.requestRenderAll();
        if (commitHistory && !historyService.isRestoring()) {
          pushHistory(historyLabel);
        }
      }

      function syncInputs() {
        if (inputs.base) {
          inputs.base.value = state.baseColor;
          inputs.base.style.backgroundColor = state.baseColor;
        }
        updateColorPickersUI?.();
      }

      function setBaseColor(color, { commit = false, force = false } = {}) {
        const candidate = typeof color === 'string' && color ? color : '#ffff00';
        if (!force && candidate.toLowerCase() === state.baseColor.toLowerCase()) {
          syncInputs();
          updateSidebarAccentStyles(state.baseColor);
          return;
        }
        state.baseColor = candidate;
        syncInputs();
        updateSidebarAccentStyles(state.baseColor);
        applyAppearance({ commitHistory: commit, historyLabel: 'Hintergrundfarbe geändert' });
      }

      function ensureInputRefs() {
        inputs.base = document.getElementById('bg-color-input');
      }

      function deriveColorFromFill(fill) {
        if (!fill) return state.baseColor;
        if (typeof fill === 'string') return fill;
        if (fill && typeof fill === 'object' && fill.type === 'linear' && Array.isArray(fill.colorStops) && fill.colorStops.length) {
          const firstStop = fill.colorStops[0];
          if (firstStop && typeof firstStop.color === 'string' && firstStop.color) {
            return firstStop.color;
          }
        }
        return rgbToHex(fill);
      }

      function initialize() {
        ensureInputRefs();

        if (inputs.base && typeof inputs.base.value === 'string' && inputs.base.value) {
          state.baseColor = inputs.base.value;
        } else if (oval) {
          state.baseColor = deriveColorFromFill(oval.fill);
        }

        syncInputs();
        updateSidebarAccentStyles(state.baseColor);

        if (!listenersAttached) {
          listenersAttached = true;

          inputs.base?.addEventListener('input', event => {
            if (historyService.isRestoring()) return;
            setBaseColor(event.target.value, { commit: false });
          });
          inputs.base?.addEventListener('change', event => {
            if (historyService.isRestoring()) return;
            setBaseColor(event.target.value, { commit: true });
          });
        }
      }

      function syncFromCanvas() {
        if (!oval) return;
        const stored = oval._bgGradientState;
        if (stored && typeof stored === 'object' && typeof stored.baseColor === 'string') {
          state.baseColor = stored.baseColor;
        } else {
          state.baseColor = deriveColorFromFill(oval.fill);
        }
        syncInputs();
        updateSidebarAccentStyles(state.baseColor);
      }

      return {
        initialize,
        applyAppearance,
        applyFill,
        computeFill,
        setBaseColor,
        syncInputs,
        syncFromCanvas,
        snapshot,
        state
      };
    })();

    window.backgroundController = backgroundController;
  }

  function applyBackgroundFill(target = oval) {
    backgroundController.applyFill(target);
  }

  function applyBackgroundAppearance({ commitHistory = false, historyLabel = 'Hintergrund angepasst' } = {}) {
    backgroundController.applyAppearance({ commitHistory, historyLabel });
  }

  function setBackgroundBaseColor(color, options) {
    backgroundController.setBaseColor(color, options);
  }

  function syncBackgroundInputsFromState() {
    backgroundController.syncInputs();
  }

  function initializeBackgroundEnhancements() {
    backgroundController.initialize();
    initializeOpacityControl();
    backgroundController.applyAppearance({ commitHistory: false });
    syncOpacityControl();
  }

  function syncBackgroundStateFromCanvas() {
    backgroundController.syncFromCanvas();
  }

  var alignPanelController = window.alignPanelController;
  if (!alignPanelController) {
    alignPanelController = (() => {
      let buttons = [];

      function getTarget() {
        const obj = canvas.getActiveObject();
        if (!obj || obj._helperUI || obj._isBackground) return null;
        return obj;
      }

      function align(mode) {
        const target = getTarget();
        if (!target || !oval) return;

        const bgRect = oval.getBoundingRect(true);
        const objRect = target.getBoundingRect(true);

        let deltaX = 0;
        let deltaY = 0;

        if (mode === 'center-x') {
          deltaX = (bgRect.left + bgRect.width / 2) - (objRect.left + objRect.width / 2);
        } else if (mode === 'middle') {
          deltaY = (bgRect.top + bgRect.height / 2) - (objRect.top + objRect.height / 2);
        } else {
          return;
        }

        if (!deltaX && !deltaY) return;
        target.set({
          left: target.left + deltaX,
          top: target.top + deltaY
        });
        target.setCoords?.();

        if ((target._isQr || target === window.qrObject) && typeof updateQrLogoPlacement === 'function') {
          try {
            updateQrLogoPlacement();
          } catch (err) {
            console.warn('QR-Logo konnte nach Ausrichtung nicht aktualisiert werden', err);
          }
        }

        canvas.requestRenderAll();
        if (!historyService.isRestoring()) {
          pushHistory('Objekt ausgerichtet');
        }
      }

      function syncButtons() {
        const available = !!getTarget();
        buttons.forEach(btn => {
          btn.disabled = !available;
          btn.classList.toggle('is-disabled', !available);
        });
      }

      function initialize() {
        const container = document.getElementById('align');
        if (!container || container.dataset.initialized === 'true') return;
        buttons = Array.from(container.querySelectorAll('[data-align]'));
        buttons.forEach(btn => {
          btn.addEventListener('click', () => align(btn.dataset.align));
        });

        canvas.on('selection:created', syncButtons);
        canvas.on('selection:updated', syncButtons);
        canvas.on('selection:cleared', syncButtons);

        syncButtons();
        container.dataset.initialized = 'true';
      }

      return { initialize };
    })();

    window.alignPanelController = alignPanelController;
  }

    window.__qrLogoDataURL = window.__qrLogoDataURL ?? null;

    // Einmal definieren
    function keepCentered(o){
      if (!o || o.type !== 'i-text') return;
      // nur Ursprung/Textausrichtung setzen, nicht die x-Position
      o.set({ originX: 'center', textAlign: 'center' });
    }

    // nur initial beim Hinzufügen mittig setzen (einmalig)
    canvas.on('object:added', e => {
      const o = e.target;
      if (!o || o.type !== 'i-text') return;
      if (historyService?.isRestoring?.()) return;
      if (o.__wasCenteredOnce) return;
      o.set({ originX: 'center', left: oval.left, textAlign: 'center' });
      o.__wasCenteredOnce = true;
    });

    function getQrDisplaySize() {
      // QR automatisch ~40% der kürzeren Kantenlänge der Form
      const base = oval;
      let shorter;
      if (isOval) {
        shorter = Math.min(oval.rx * 2, oval.ry * 2);
      } else {
        shorter = Math.min(oval.width, oval.height);
      }
      const s = Math.round(shorter * 0.40);
      // sanft begrenzen, damit’s nicht zu winzig/zu groß wird
      return Math.max(80, Math.min(s, 240));
    }

    function qrOptions(){
      const size        = getQrDisplaySize();
      const data        = document.getElementById('qr-url').value || '';
      const style       = document.getElementById('qr-style').value;
      const color       = document.getElementById('qr-color')?.value || '#000000';
      const rounded     = style === 'rounded';
      const transparent = isQrBackgroundTransparent();
      const bgColor     = qrBgColorValue || DEFAULT_QR_BG_COLOR;

      return {
        width: size,
        height: size,
        data,
        margin: 0,
        qrOptions: { errorCorrectionLevel: 'H' },
        image: null, // 👈 kein Logo mehr
        dotsOptions:           { color, type: rounded ? "rounded" : "square" },
        backgroundOptions:     { color: transparent ? '#00000000' : bgColor },
        cornersSquareOptions:  { type: rounded ? "extra-rounded" : "square", color },
        ...(rounded ? { cornersDotOptions: { type: "dot", color } } : {})
      };
    }

    async function placeQrRaster() {
        const url = (document.getElementById('qr-url').value || '').trim();

        // ✨ Leere URL ⇒ QR aus Canvas und Panel entfernen
    if (!url) {
      if (qrObject) { canvas.remove(qrObject); qrObject = null; window.qrObject = null; }
      if (qrLogoImage) { canvas.remove(qrLogoImage); qrLogoImage = null; window.qrLogoImage = null; }
      window.__qrLogoDataURL = null;
      canvas.requestRenderAll();
      applyQrPanelState({ url: '' });
      recordQrHistory('QR entfernt');
      return;
    }

        const displaySize = getQrDisplaySize();

        // hochauflösend rendern
        const UPSCALE = 6;
        const renderSize = Math.max(600, Math.round(displaySize * UPSCALE));

        // aktuelle Optionen + echte Daten setzen
        const opts = { ...qrOptions(), data: url, width: renderSize, height: renderSize };

        // PNG erzeugen und als Fabric-Image einsetzen
        const blob = await new QRCodeStyling(opts).getRawData('png');
        const dataUrl = await blobToDataURL(blob);

        fabric.Image.fromURL(dataUrl, (img) => {
          img.set({ originX: 'center', originY: 'center', objectCaching: false, lockUniScaling: true });
          const base = Math.max(img.width||1, img.height||1);
          const scale = displaySize / base;
          img.scale(scale);

          if (qrObject) {
            const p = qrObject.getCenterPoint();
            canvas.remove(qrObject);
            img.set({ left: p.x, top: p.y });
          } else {
            centerOnShape(img);
          }

          img._isQr = true;
          img._originalBase64 = dataUrl;
          img._qrState = getCurrentQrState();

          qrObject = img;
          window.qrObject = img;
          canvas.add(img).setActiveObject(img);
          oval.sendToBack();
          canvas.requestRenderAll();
          resyncQrStateFromCanvas();
          recordQrHistory('QR aktualisiert');
        });
      }

    function updateQrPreview() {}

   let __qrDebounce;
   let suppressQrAutoUpdate = 0;
   let qrLogoReadCounter = 0;
   let qrTargetRenders = new WeakMap();
   let qrNewRenderId = 0;
   let qrPendingUpdate = null;
   let qrPendingTarget = null;
   let qrTargetIntents = new Map();
   let qrLogoTargetReads = new Map();
   let qrLogoReadEpoch = 0;
   let qrNewLogoPending = false;
   let qrTargetErrors = new Map();

   function rememberQrError(target, message) {
     if (target) qrTargetErrors.set(ensureQrId(target), message);
     if (target && qrOwnerFromTarget(canvas.getActiveObject()) !== target) return;
     setQrEditorStatus(message, { editing: !!target, error: true });
   }

   function reserveQrRender(target) {
     const renderId = ++qrRenderCounter;
     if (target) qrTargetRenders.set(target, renderId);
     else qrNewRenderId = renderId;
     return renderId;
   }

   function flushPendingQrUpdate() {
     clearTimeout(__qrDebounce);
     __qrDebounce = null;
     if (qrPendingUpdate) qrPendingUpdate();
   }

   function cancelPendingQrWork(options = {}) {
     clearTimeout(__qrDebounce);
     __qrDebounce = null;
     qrPendingUpdate = null;
     qrPendingTarget = null;
     if (!options.preserveNewInsert) qrNewRenderId = ++qrRenderCounter;
     if (options.target) qrTargetRenders.delete(options.target);
     if (options.allEdits) {
       qrTargetRenders = new WeakMap();
       qrTargetIntents = new Map();
       qrLogoTargetReads = new Map();
       qrTargetErrors = new Map();
       qrLogoReadEpoch += 1;
     }
     if (options.logo !== false) {
       qrLogoReadCounter += 1;
       qrNewLogoPending = false;
       const logoInput = document.getElementById('qr-logo-upload');
       if (logoInput) logoInput.value = '';
     }
   }

   function withSuppressedQrAutoUpdate(fn) {
     suppressQrAutoUpdate += 1;
     try {
       return typeof fn === 'function' ? fn() : undefined;
     } finally {
       suppressQrAutoUpdate = Math.max(0, suppressQrAutoUpdate - 1);
     }
   }

   function withoutQrHistory(fn) {
     if (historyService?.withoutRecording) {
       return historyService.withoutRecording(fn);
     }
     return typeof fn === 'function' ? fn() : undefined;
   }
  function ensureQrId(target) {
    if (!target) return '';
    if (!target._qrId) {
      qrIdCounter += 1;
      target._qrId = `qr-${qrIdCounter}`;
    } else {
      const numericId = parseInt(String(target._qrId).replace(/[^0-9]/g, ''), 10);
      if (Number.isFinite(numericId)) qrIdCounter = Math.max(qrIdCounter, numericId);
    }
    return target._qrId;
  }

  function qrOwnerFromTarget(target) {
    if (!target) return null;
    if (target._isQr) return target;
    if (!target._qrPart) return null;
    const ownerId = target._qrOwnerId;
    return canvas.getObjects().find(object => object?._isQr && object._qrId === ownerId) || null;
  }

  function qrLogoForTarget(target) {
    const owner = qrOwnerFromTarget(target) || target;
    if (!owner?._isQr) return null;
    const ownerId = ensureQrId(owner);
    return canvas.getObjects().find(object => object?._qrPart && object._qrOwnerId === ownerId) || null;
  }

  function removeQrTarget(target, options = {}) {
    const skipResync = options.skipResync === true;
    const owner = qrOwnerFromTarget(target) || (target?._isQr ? target : null);
    if (!owner) return false;
    const ownerId = ensureQrId(owner);
    canvas.getObjects().slice().forEach(object => {
      if (object === owner || (object?._qrPart && object._qrOwnerId === ownerId)) {
        canvas.remove(object);
      }
    });

    if (qrObject === owner || qrObject?._qrId === ownerId) {
      qrObject = null;
      qrLogoImage = null;
      window.qrObject = null;
      window.qrLogoImage = null;
      window.__qrLogoDataURL = null;
    }
    if (!skipResync) resyncQrStateFromCanvas();
    return true;
  }

  // Wird nur für vollständige Resets und ältere gespeicherte Entwürfe benötigt.
  function removeAllQrFromCanvas(options = {}) {
    const skipResync = options.skipResync === true;
    canvas.getObjects().slice().forEach(object => {
      if (object?._isQr || object?._qrPart) canvas.remove(object);
    });
    qrObject = null;
    qrLogoImage = null;
    window.qrObject = null;
    window.qrLogoImage = null;
    window.__qrLogoDataURL = null;
    if (!skipResync) resyncQrStateFromCanvas();
  }
  function getQrPlacement(target = qrObject) {
    if (!target) return null;
    const point = typeof target.left === "number" && typeof target.top === "number"
      ? { x: target.left, y: target.top }
      : (typeof target.getCenterPoint === "function" ? target.getCenterPoint() : { x: 0, y: 0 });

    return {
      left: point.x,
      top: point.y,
      scaleX: typeof target.scaleX === "number" ? target.scaleX : 1,
      scaleY: typeof target.scaleY === "number" ? target.scaleY : 1,
      angle: typeof target.angle === "number" ? target.angle : 0,
      skewX: typeof target.skewX === "number" ? target.skewX : 0,
      skewY: typeof target.skewY === "number" ? target.skewY : 0,
      flipX: !!target.flipX,
      flipY: !!target.flipY
    };
  }

  function applyQrPlacement(target, placement) {
    if (!target || !placement) return false;
    const {
      left,
      top,
      scaleX,
      scaleY,
      angle,
      skewX,
      skewY,
      flipX,
      flipY
    } = placement;

    target.set({
      left: typeof left === "number" ? left : target.left,
      top: typeof top === "number" ? top : target.top,
      angle: typeof angle === "number" ? angle : target.angle,
      skewX: typeof skewX === "number" ? skewX : target.skewX,
      skewY: typeof skewY === "number" ? skewY : target.skewY,
      flipX: typeof flipX === "boolean" ? flipX : target.flipX,
      flipY: typeof flipY === "boolean" ? flipY : target.flipY
    });

    if (typeof scaleX === "number") target.scaleX = scaleX;
    if (typeof scaleY === "number") target.scaleY = scaleY;
    if (typeof target.setCoords === "function") target.setCoords();
    return true;
  }


   function updateQrLogoPlacement(targetQr = qrObject) {
  if (!targetQr) return;
  const targetLogo = qrLogoForTarget(targetQr);
  if (!targetLogo) return;
  const ratio = targetLogo._qrLogoRatio ?? window.__qrLogoRatio ?? 0.22;
  const base = Math.max(targetQr.getScaledWidth() || 1, targetQr.getScaledHeight() || 1);
  const targetSize = base * ratio;
  const sourceSize = Math.max(targetLogo._originalWidth || targetLogo.width || 1, targetLogo._originalHeight || targetLogo.height || 1);
  const scale = targetSize / Math.max(sourceSize, 1);

  targetLogo.set({
    originX: 'center',
    originY: 'center',
    left: targetQr.left,
    top: targetQr.top,
    angle: targetQr.angle,
    scaleX: scale,
    scaleY: scale
  });
  if (typeof targetLogo.setCoords === 'function') targetLogo.setCoords();

  const objs = canvas.getObjects();
  const groupIndex = objs.indexOf(targetQr);
  if (groupIndex >= 0) {
    canvas.moveTo(targetLogo, Math.min(groupIndex + 1, objs.length - 1));
  }
  if (targetQr === qrObject) {
    qrLogoImage = targetLogo;
    window.qrLogoImage = targetLogo;
  }
  canvas.requestRenderAll();
}

   function attachQrLogoSyncHandlers(group) {
     if (!group) return;
     const events = ['moving', 'scaling', 'rotating', 'skewing', 'modified'];
     events.forEach(evt => {
       group.on(evt, () => {
         if (qrLogoForTarget(group)) {
           updateQrLogoPlacement(group);
           canvas.requestRenderAll();
         }
       });
     });
   }

   async function placeQrSVG(options = {}) {
     const renderState = options.state || getCurrentQrState();
     const url = (renderState.url || '').trim();
     const createNew = options.createNew === true;
     const targetQr = createNew ? null : (options.target || qrObject);
     const insertActiveObject = createNew ? canvas.getActiveObject() : null;
     const insertPanelSnapshot = createNew ? snapshotQrState() : null;

    // Eine vorübergehend leere Eingabe darf das Motiv nicht verändern.
    if (!url) {
      cancelPendingQrWork({ logo: false, target: targetQr });
      elUrl?.setAttribute('aria-invalid', 'true');
      setQrEditorStatus('Bitte zuerst einen Link oder Text eingeben.', { editing: !!targetQr, error: true });
      return;
    }
    if (targetQr && !canvas.getObjects().includes(targetQr)) return;

     const preservedLogoDataURL = Object.prototype.hasOwnProperty.call(options, 'logoDataURL')
       ? options.logoDataURL : window.__qrLogoDataURL;
     const previousPlacement = targetQr ? getQrPlacement(targetQr) : null;
     const qrId = targetQr ? ensureQrId(targetQr) : `qr-${++qrIdCounter}`;
     const renderId = options.renderId || reserveQrRender(targetQr);
     const isCurrentRender = () => targetQr
       ? qrTargetRenders.get(targetQr) === renderId && canvas.getObjects().includes(targetQr)
       : qrNewRenderId === renderId;
     const isForegroundEdit = () => targetQr
       ? qrOwnerFromTarget(canvas.getActiveObject()) === targetQr
       : canvas.getActiveObject() === insertActiveObject &&
         document.getElementById('qr')?.classList.contains('active') && snapshotQrState() === insertPanelSnapshot;
     if (!isCurrentRender()) return;
     if (targetQr) qrTargetErrors.delete(qrId);
     if (isForegroundEdit()) elUrl?.removeAttribute('aria-invalid');

     try {
       const TARGET = getQrDisplaySize();
       const opts = { ...(options.qrOptions || qrOptions()), data: url };
       if (targetQr) qrTargetIntents.set(qrId, { state: { ...renderState }, qrOptions: opts, logoDataURL: preservedLogoDataURL });

       // SVG vom Generator holen (Vektordots, Loch für Logo)
       const svgBlob = await new QRCodeStyling(opts).getRawData('svg');
       const svgText = await svgBlob.text();
       if (!isCurrentRender()) return;

       fabric.loadSVGFromString(svgText, (objects, svgOptions) => {
         if (!isCurrentRender()) return;
         try {
         if (!Array.isArray(objects) || !objects.some(Boolean)) throw new Error('QR SVG enthält keine Grafik');
         const group = fabric.util.groupSVGElements(objects, svgOptions);
         if (!group || !Number.isFinite(group.width) || !Number.isFinite(group.height) || group.width <= 0 || group.height <= 0) {
           throw new Error('QR SVG hat ungültige Abmessungen');
         }
         group.set({ originX: 'center', originY: 'center', objectCaching: false, lockUniScaling: true });

         const base = Math.max(group.width || 1, group.height || 1);
         group.scale(TARGET / base);

         group._isQr = true;
         group._qrId = qrId;
         group._qrState = { ...renderState };
         group._qrLogoDataURL = preservedLogoDataURL || null;

         const currentPlacement = targetQr ? getQrPlacement(targetQr) : previousPlacement;
         const placementApplied = applyQrPlacement(group, currentPlacement);
         if (!placementApplied) {
           centerOnShape(group);
           const existingCount = canvas.getObjects().filter(object => object?._isQr && object !== targetQr).length;
           if (existingCount > 0) {
             group.set({
               left: group.left + Math.min(36, existingCount * 14),
               top: group.top + Math.min(28, existingCount * 10)
             });
           }
         }

         const logo = preservedLogoDataURL;
         if (logo) {
           const logoRatio = opts.imageOptions?.imageSize ?? window.__qrLogoRatio ?? 0.30;
           overlayLogoOnQrGroup(group, logo, logoRatio, currentPlacement, {
             targetQr,
             qrId,
             isCurrentRender,
             isForegroundEdit,
             keepPanelState: options.keepPanelState === true,
             historyLabel: createNew ? 'QR hinzugefügt' : 'QR aktualisiert'
           });
         } else {
          const foreground = isForegroundEdit();
          withSuppressedQrAutoUpdate(() => withoutQrHistory(() => {
            if (targetQr) removeQrTarget(targetQr, { skipResync: true });
            canvas.add(group);
            if (foreground) {
              qrObject = group;
              window.qrObject = group;
              qrLogoImage = null;
              window.qrLogoImage = null;
              window.__qrLogoDataURL = null;
              canvas.setActiveObject(group);
            }
          }));
          attachQrLogoSyncHandlers(group);
          oval.sendToBack();
          canvas.requestRenderAll();
          if (foreground && !options.keepPanelState) resyncQrStateFromCanvas();
          pushHistory(createNew ? 'QR hinzugefügt' : 'QR angepasst', { immediate: true });
        }
        } catch (err) {
          reportRenderError(err);
        }
      });
    } catch (err) {
      reportRenderError(err);
    }

    function reportRenderError(err) {
      if (!isCurrentRender()) return;
      console.error('QR SVG error:', err);
      if (!targetQr && !isForegroundEdit()) return;
      rememberQrError(targetQr, 'Der QR-Code konnte nicht erstellt werden. Bitte erneut versuchen.');
    }
  }
  function autoUpdateQR(options = {}) {
      const delay = Number.isFinite(options.debounce) ? Math.max(0, options.debounce) : 220;
      const force = options.force === true;
      const createNew = options.createNew === true;
      const target = createNew ? null : (options.target || qrOwnerFromTarget(canvas.getActiveObject()));
      if (!createNew && (!target || !canvas.getObjects().includes(target))) return;
      if (!force && (suppressQrAutoUpdate > 0 || historyService?.isRestoring?.())) return;
      // Zustand vor der Pause festhalten. Ein später gewählter QR-Code darf
      // weder Datenquelle noch Ziel dieser bereits beabsichtigten Änderung sein.
      const state = getCurrentQrState();
      if (qrPendingUpdate && qrPendingTarget !== target) flushPendingQrUpdate();
      clearTimeout(__qrDebounce);
      const renderId = reserveQrRender(target);
      const capturedOptions = qrOptions();
      const logoDataURL = window.__qrLogoDataURL;
      if (target) qrTargetIntents.set(ensureQrId(target), { state: { ...state }, qrOptions: capturedOptions, logoDataURL });
      const run = () => {
        if (qrPendingUpdate !== run) return;
        qrPendingUpdate = null;
        qrPendingTarget = null;
        __qrDebounce = null;
        if (!force && historyService?.isRestoring?.()) return;
        if (target && (!canvas.getObjects().includes(target) || qrTargetRenders.get(target) !== renderId)) return;
        placeQrSVG({ createNew, target, state, qrOptions: capturedOptions, logoDataURL, renderId });
      };
      qrPendingUpdate = run;
      qrPendingTarget = target;
      if (delay === 0 || options.immediate) run();
      else __qrDebounce = setTimeout(run, delay);
    }

const elUrl        = document.getElementById('qr-url');
const elStyle      = document.getElementById('qr-style');
const elColor      = document.getElementById('qr-color');
const elBgColor    = document.getElementById('qr-bg-color');
const elBgTransparentBtn = document.getElementById('qr-bg-transparent-btn');
const elBgColorOption = document.getElementById('qr-bg-color-option');
const elQrApply = document.getElementById('qr-apply-btn');
const elQrApplyLabel = document.getElementById('qr-apply-label');
const elQrNew = document.getElementById('qr-new-btn');
const elQrEditorStatus = document.getElementById('qr-editor-status');
const elQrLogoStatus = document.getElementById('qr-logo-status');
const elQrLogoRemove = document.getElementById('qr-logo-remove');
const qrStyleChoices = Array.from(document.querySelectorAll('[data-qr-style]'));
let __lastQrSnapshot = null;
  const DEFAULT_QR_BG_COLOR = '#ffffff';
  const DEFAULT_QR_STYLE = elStyle ? elStyle.value : 'square';
  const DEFAULT_QR_COLOR = elColor ? elColor.value : '#000000';

  if (elColor) elColor.style.backgroundColor = elColor.value;
  if (elBgColor) elBgColor.style.backgroundColor = elBgColor.value;

  let qrBgTransparent = true;
  let qrBgColorValue = (elBgColor && elBgColor.value) || DEFAULT_QR_BG_COLOR;
  let lastSolidQrBg = qrBgColorValue;
  if (elBgColor) elBgColor.value = qrBgColorValue;

  function syncQrStyleButtons() {
    qrStyleChoices.forEach(button => {
      const active = button.dataset.qrStyle === (elStyle?.value || DEFAULT_QR_STYLE);
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  }
  qrStyleChoices.forEach(button => {
    button.addEventListener('click', () => {
      if (elStyle) elStyle.value = button.dataset.qrStyle || DEFAULT_QR_STYLE;
      syncQrStyleButtons();
      updateQrPreview();
      requestQrLiveUpdate({ immediate: true });
    });
  });
  syncQrStyleButtons();

  function getCurrentQrState() {
    return {
      url: (elUrl?.value || '').trim(),
      style: elStyle?.value || DEFAULT_QR_STYLE,
      color: elColor?.value || DEFAULT_QR_COLOR,
      bgTransparent: !!qrBgTransparent,
      bgColor: qrBgColorValue || DEFAULT_QR_BG_COLOR
    };
  }

  function snapshotQrState() {
    const state = getCurrentQrState();
    return JSON.stringify({
      ...state,
      logo: window.__qrLogoDataURL ? window.__qrLogoDataURL.length : 0
    });
  }

  function applyQrPanelState(partialState = {}, options = {}) {
    const current = getCurrentQrState();
    const next = {
      url: typeof partialState.url === 'string' ? partialState.url.trim() : current.url,
      style: partialState.style !== undefined ? partialState.style : current.style,
      color: partialState.color !== undefined ? partialState.color : current.color,
      bgTransparent: partialState.bgTransparent !== undefined ? !!partialState.bgTransparent : current.bgTransparent,
      bgColor: partialState.bgColor !== undefined ? partialState.bgColor : current.bgColor
    };

    withSuppressedQrAutoUpdate(() => {
      if (elUrl) elUrl.value = next.url || '';
      if (elStyle && next.style !== undefined) {
        elStyle.value = next.style;
        syncQrStyleButtons();
      }
      if (elColor && next.color !== undefined) {
        elColor.value = next.color;
        elColor.style.backgroundColor = next.color;
      }

      qrBgTransparent = next.bgTransparent;
      qrBgColorValue = next.bgColor || DEFAULT_QR_BG_COLOR;
      if (!qrBgTransparent) {
        lastSolidQrBg = qrBgColorValue;
      }

      if (elBgColor) {
        elBgColor.value = qrBgColorValue;
        elBgColor.style.backgroundColor = qrBgTransparent ? 'transparent' : qrBgColorValue;
      }

      updateQrBgControlsUI();
    });

    if (options.updatePreview !== false) {
      updateQrPreview();
    }

    __lastQrSnapshot = snapshotQrState();
  }

  function recordQrHistory(reason = 'QR aktualisiert') {
    const snap = snapshotQrState();
    if (__lastQrSnapshot === snap) return;
    __lastQrSnapshot = snap;
    pushHistory(reason, { immediate: true });
  }

  function setQrEditorStatus(message, options = {}) {
    if (!elQrEditorStatus) return;
    elQrEditorStatus.classList.toggle('is-editing', options.editing === true);
    elQrEditorStatus.classList.toggle('is-error', options.error === true);
    const label = elQrEditorStatus.querySelector('span:last-child');
    if (label) label.textContent = message || '';
  }

  function syncQrEditorUI() {
    const qrItems = canvas.getObjects().filter(object => object?._isQr);
    const qrCount = qrItems.length;
    const activeQr = qrOwnerFromTarget(canvas.getActiveObject());
    const editing = !!(activeQr && qrItems.includes(activeQr));
    if (editing) {
      qrObject = activeQr;
      window.qrObject = activeQr;
    }
    const selectedIndex = editing ? qrItems.indexOf(activeQr) + 1 : 0;
    if (elQrApplyLabel) {
      elQrApplyLabel.textContent = qrNewLogoPending && !editing ? 'Logo wird vorbereitet…' : 'QR-Code hinzufügen';
    }
    if (elQrApply) {
      elQrApply.hidden = editing;
      elQrApply.dataset.mode = 'add';
      elQrApply.disabled = qrNewLogoPending && !editing;
      elQrApply.setAttribute('aria-busy', qrNewLogoPending && !editing ? 'true' : 'false');
      const leading = elQrApply.querySelector('[aria-hidden="true"]');
      if (leading) leading.textContent = '+';
    }
    if (elQrNew) {
      elQrNew.hidden = !editing;
      elQrNew.textContent = 'Weiteren QR-Code hinzufügen';
    }
    const targetError = editing ? qrTargetErrors.get(ensureQrId(activeQr)) : null;
    setQrEditorStatus(
      targetError || (editing
        ? `QR-Code ${qrCount > 1 ? `${selectedIndex} von ${qrCount} ` : ''}bearbeiten · Änderungen werden direkt übernommen`.replace(/\s+/g, ' ').trim()
        : (qrNewLogoPending ? 'Logo wird vorbereitet…' : qrCount ? `Neuen QR-Code hinzufügen · ${qrCount} ${qrCount === 1 ? 'QR-Code bereits' : 'QR-Codes bereits'} im Motiv` : 'Neuen QR-Code hinzufügen')),
      { editing, error: !!targetError }
    );
    if (elQrLogoStatus) {
      elQrLogoStatus.textContent = window.__qrLogoDataURL ? 'Logo ausgewählt' : 'Kein Logo ausgewählt';
    }
    if (elQrLogoRemove) {
      elQrLogoRemove.hidden = !window.__qrLogoDataURL;
    }
  }

  function prepareNewQrEditor(options = {}) {
    flushPendingQrUpdate();
    cancelPendingQrWork({ preserveNewInsert: options.focus === false });
    elUrl?.removeAttribute('aria-invalid');
    qrObject = null;
    qrLogoImage = null;
    window.qrObject = null;
    window.qrLogoImage = null;
    window.__qrLogoDataURL = null;
    canvas.discardActiveObject();
    if (options.clearUrl !== false && elUrl) elUrl.value = '';
    const logoInput = document.getElementById('qr-logo-upload');
    if (logoInput) logoInput.value = '';
    updateQrPreview();
    syncQrEditorUI();
    canvas.requestRenderAll();
    if (options.focus !== false) elUrl?.focus();
  }

  function requestQrLiveUpdate(options = {}) {
    updateQrPreview();
    if (suppressQrAutoUpdate > 0 || historyService?.isRestoring?.()) return;
    const selectedQr = qrOwnerFromTarget(canvas.getActiveObject());
    const url = (elUrl?.value || '').trim();
    if (!selectedQr || !canvas.getObjects().includes(selectedQr)) {
      if (url) {
        elUrl?.removeAttribute('aria-invalid');
        syncQrEditorUI();
      }
      return;
    }
    if (!url) {
      cancelPendingQrWork({ logo: false, target: selectedQr });
      elUrl?.setAttribute('aria-invalid', 'true');
      setQrEditorStatus('Bitte einen Link oder Text eingeben. Der bisherige QR-Code bleibt erhalten.', { editing: true, error: true });
      return;
    }

    elUrl?.removeAttribute('aria-invalid');
    qrTargetErrors.delete(ensureQrId(selectedQr));
    syncQrEditorUI();
    qrObject = selectedQr;
    window.qrObject = selectedQr;
    autoUpdateQR({
      target: selectedQr,
      immediate: options.immediate === true,
      debounce: Number.isFinite(options.debounce) ? options.debounce : 180
    });
  }

  function resyncQrStateFromCanvas() {
    if (historyService?.isRestoring?.()) cancelPendingQrWork({ allEdits: true });
    const qrCandidates = canvas.getObjects().filter(o => o && o._isQr);
    qrCandidates.forEach(ensureQrId);

    const logoCandidates = canvas.getObjects().filter(o => o && o._qrPart);
    logoCandidates.forEach(logo => {
      if (!logo._qrOwnerId && qrCandidates.length) {
        const logoCenter = logo.getCenterPoint?.() || { x: logo.left || 0, y: logo.top || 0 };
        const nearest = qrCandidates.reduce((best, candidate) => {
          const center = candidate.getCenterPoint?.() || { x: candidate.left || 0, y: candidate.top || 0 };
          const distance = Math.hypot(center.x - logoCenter.x, center.y - logoCenter.y);
          return !best || distance < best.distance ? { candidate, distance } : best;
        }, null)?.candidate;
        if (nearest) logo._qrOwnerId = ensureQrId(nearest);
      }
    });

    const activeQr = qrOwnerFromTarget(canvas.getActiveObject());
    const currentId = qrObject?._qrId;
    const currentQr = currentId
      ? qrCandidates.find(candidate => candidate._qrId === currentId)
      : null;
    qrObject = activeQr || currentQr || (qrCandidates.length ? qrCandidates[qrCandidates.length - 1] : null);
    window.qrObject = qrObject;

    if (!qrObject && logoCandidates.length) {
      logoCandidates.forEach(o => canvas.remove(o));
    }

    qrLogoImage = qrObject ? qrLogoForTarget(qrObject) : null;
    window.qrLogoImage = qrLogoImage;

    if (qrLogoImage) {
      window.__qrLogoDataURL = qrObject?._qrLogoDataURL || qrLogoImage._originalBase64 || null;
      qrObject._qrLogoDataURL = window.__qrLogoDataURL;
      qrLogoImage.set({ selectable: false, evented: false });
      if (typeof qrLogoImage.setCoords === 'function') qrLogoImage.setCoords();
      updateQrLogoPlacement(qrObject);
    } else {
      window.__qrLogoDataURL = qrObject?._qrLogoDataURL || null;
    }

    if (qrObject && qrObject._qrState) {
      const desiredState = {
        url: typeof qrObject._qrState.url === 'string' ? qrObject._qrState.url : '',
        style: qrObject._qrState.style || DEFAULT_QR_STYLE,
        color: qrObject._qrState.color || DEFAULT_QR_COLOR,
        bgTransparent: qrObject._qrState.bgTransparent !== undefined ? !!qrObject._qrState.bgTransparent : true,
        bgColor: qrObject._qrState.bgColor || DEFAULT_QR_BG_COLOR
      };
      const currentState = getCurrentQrState();
      const statesMatch =
        (desiredState.url || '').trim() === (currentState.url || '').trim() &&
        desiredState.style === currentState.style &&
        desiredState.color === currentState.color &&
        Boolean(desiredState.bgTransparent) === Boolean(currentState.bgTransparent) &&
        (desiredState.bgColor || '') === (currentState.bgColor || '');

      if (!statesMatch) {
        applyQrPanelState(desiredState);
      } else {
        __lastQrSnapshot = snapshotQrState();
      }
    } else if (!qrObject) {
      applyQrPanelState({ url: '', bgTransparent: true });
    } else {
      __lastQrSnapshot = snapshotQrState();
    }
    syncQrEditorUI();
  }

function updateQrBgControlsUI(){
    if (elBgTransparentBtn) {
      elBgTransparentBtn.classList.toggle('active', qrBgTransparent);
      elBgTransparentBtn.setAttribute('aria-pressed', qrBgTransparent ? 'true' : 'false');
    }

    if (elBgColorOption) {
      elBgColorOption.classList.toggle('is-active', !qrBgTransparent);
    }

    if (elBgColor) {
      elBgColor.classList.toggle('is-transparent', qrBgTransparent);
      elBgColor.style.opacity = 1;
      const target = qrBgColorValue || DEFAULT_QR_BG_COLOR;
      if (!qrBgTransparent && elBgColor.value !== target) {
        elBgColor.value = target;
      }
      elBgColor.style.backgroundColor = qrBgTransparent ? 'transparent' : target;
    }
  }
  updateQrBgControlsUI();
  __lastQrSnapshot = snapshotQrState();

  function isQrBackgroundTransparent(){
    return qrBgTransparent;
  }
   // 🔧 Generelle Logo-Größe (Anteil der QR-Kantenlänge)
   // z.B. 0.18 = 18%, 0.22 = 22%, 0.30 = 30% …
   window.__qrLogoRatio = 0.30;

  const BYTES_PER_MB = 1024 * 1024;
  const MAX_QR_LOGO_RESULT_BYTES = 0.6 * BYTES_PER_MB;
  const MAX_IMAGE_RESULT_BYTES = 2.5 * BYTES_PER_MB;
  const IMAGE_UPLOAD_MAX_DIMENSION = 1800;
  const MIN_COMPRESS_DIMENSION = 320;
  const COMPRESS_SCALE_FACTOR = 0.85;
  const QUALITY_STEP = 0.1;
  const SUPPORTS_WEBP = (() => {
    try {
      const c = document.createElement('canvas');
      return !!(c.getContext && typeof c.toDataURL === 'function' && c.toDataURL('image/webp').startsWith('data:image/webp'));
    } catch (err) {
      return false;
    }
  })();

  function dataURLBytes(dataUrl) {
    if (!dataUrl || typeof dataUrl !== 'string') return 0;
    const parts = dataUrl.split(',');
    if (parts.length < 2) return 0;
    const base64 = parts[1];
    const padding = (base64.match(/=+$/) || [''])[0].length;
    return Math.max(0, Math.round((base64.length * 3) / 4) - padding);
  }

  function loadImageAsync(src) {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.onload = () => resolve(img);
      img.onerror = reject;
      img.crossOrigin = 'anonymous';
      img.src = src;
    });
  }

  function toDataURLSafe(canvasEl, mime, quality) {
    try {
      if (typeof quality === 'number') {
        return canvasEl.toDataURL(mime, quality);
      }
      return canvasEl.toDataURL(mime);
    } catch (err) {
      console.warn('toDataURL failed for', mime, err);
      return null;
    }
  }

  async function compressCanvasToDataURL(canvasEl, options = {}) {
    const {
      maxBytes = MAX_IMAGE_RESULT_BYTES,
      hasAlpha = false,
      initialQuality,
      minQuality = 0.4,
      preferLossless = false,
      allowWebP = false
    } = options;

    let workCanvas = canvasEl;
    const canUseWebP = hasAlpha && SUPPORTS_WEBP && !preferLossless && allowWebP;
    const mime = hasAlpha ? (canUseWebP ? 'image/webp' : 'image/png') : 'image/jpeg';
    let quality = typeof initialQuality === 'number'
      ? initialQuality
      : mime === 'image/jpeg'
        ? 0.55
        : 0.8;

    if (preferLossless) {
      quality = 1;
    }

    let dataUrl = toDataURLSafe(workCanvas, mime, mime === 'image/png' || preferLossless ? undefined : quality) || workCanvas.toDataURL();
    let bytes = dataURLBytes(dataUrl);

    if (mime !== 'image/png' && !preferLossless) {
      while (bytes > maxBytes && quality > minQuality) {
        quality = Math.max(minQuality, quality - QUALITY_STEP);
        const attempt = toDataURLSafe(workCanvas, mime, quality);
        if (attempt) {
          dataUrl = attempt;
          bytes = dataURLBytes(dataUrl);
        } else {
          break;
        }
      }
    }

    while (bytes > maxBytes && (workCanvas.width > MIN_COMPRESS_DIMENSION || workCanvas.height > MIN_COMPRESS_DIMENSION)) {
      const targetW = workCanvas.width > MIN_COMPRESS_DIMENSION
        ? Math.max(MIN_COMPRESS_DIMENSION, Math.round(workCanvas.width * COMPRESS_SCALE_FACTOR))
        : workCanvas.width;
      const targetH = workCanvas.height > MIN_COMPRESS_DIMENSION
        ? Math.max(MIN_COMPRESS_DIMENSION, Math.round(workCanvas.height * COMPRESS_SCALE_FACTOR))
        : workCanvas.height;

      if (targetW === workCanvas.width && targetH === workCanvas.height) break;

      try {
        workCanvas = await resizeWithPicaToCanvas(workCanvas, targetW, targetH);
      } catch (err) {
        console.warn('pica resize fallback', err);
        const fallback = document.createElement('canvas');
        fallback.width = targetW;
        fallback.height = targetH;
        const ctx = fallback.getContext('2d');
        ctx.drawImage(workCanvas, 0, 0, targetW, targetH);
        workCanvas = fallback;
      }

      const attempt = toDataURLSafe(workCanvas, mime, mime === 'image/png' || preferLossless ? undefined : quality);
      if (attempt) {
        dataUrl = attempt;
        bytes = dataURLBytes(dataUrl);
      }

      if (mime !== 'image/png' && !preferLossless && bytes > maxBytes && quality > minQuality) {
        quality = Math.max(minQuality, quality - QUALITY_STEP);
        const retry = toDataURLSafe(workCanvas, mime, quality);
        if (retry) {
          dataUrl = retry;
          bytes = dataURLBytes(dataUrl);
        }
      }
    }

    return {
      dataUrl,
      bytes,
      mime,
      width: workCanvas.width,
      height: workCanvas.height,
      quality
    };
  }

  async function ensureDataUrlMaxSize(dataUrl, options = {}) {
    const maxBytes = options.maxBytes || MAX_IMAGE_RESULT_BYTES;
    if (!dataUrl || dataURLBytes(dataUrl) <= maxBytes) return dataUrl;
    try {
      const img = await loadImageAsync(dataUrl);
      const canvasEl = document.createElement('canvas');
      canvasEl.width = img.width;
      canvasEl.height = img.height;
      canvasEl.getContext('2d').drawImage(img, 0, 0);
      const result = await compressCanvasToDataURL(canvasEl, {
        maxBytes,
        hasAlpha: options.hasAlpha ?? /image\/(png|webp|gif)/i.test(dataUrl),
        initialQuality: options.initialQuality,
        minQuality: options.minQuality,
        preferLossless: options.preferLossless,
        allowWebP: options.allowWebP
      });
      return result.dataUrl;
    } catch (err) {
      console.warn('ensureDataUrlMaxSize failed', err);
      return dataUrl;
    }
  }

   const elLogo = document.getElementById('qr-logo-upload');
   if (elLogo) {
     elLogo.addEventListener('change', async (e) => {
       const file = e.target.files && e.target.files[0];
       if (!file) return; // Ein abgebrochener Dateidialog behält das bisherige Logo.
       const readId = ++qrLogoReadCounter;
       const readEpoch = qrLogoReadEpoch;
       const selectedQr = qrOwnerFromTarget(canvas.getActiveObject());
       const selectedId = selectedQr ? ensureQrId(selectedQr) : null;
       const initialState = getCurrentQrState();
       const initialOptions = qrOptions();
       if (selectedId) {
         qrLogoTargetReads.set(selectedId, readId);
         qrTargetErrors.delete(selectedId);
       }
       else qrNewLogoPending = true;
       syncQrEditorUI();
       if (elQrLogoStatus) elQrLogoStatus.textContent = 'Logo wird vorbereitet…';
       const currentTarget = () => selectedId
         ? canvas.getObjects().find(object => object?._isQr && object._qrId === selectedId) || null
         : null;
       const isCurrentRead = () => readEpoch === qrLogoReadEpoch && (selectedId
         ? qrLogoTargetReads.get(selectedId) === readId && !!currentTarget()
         : readId === qrLogoReadCounter && !qrOwnerFromTarget(canvas.getActiveObject()));
       try {
         const dataUrl = await new Promise((res, rej) => {
           const reader = new FileReader();
           reader.onload = () => res(reader.result);
           reader.onerror = rej;
           reader.readAsDataURL(file);
         });
         if (!isCurrentRead()) return;
         const scaledLogo = await toPngDataURL(dataUrl, 420);
         if (!isCurrentRead()) return;
         const preparedLogo = await ensureDataUrlMaxSize(scaledLogo, {
           maxBytes: MAX_QR_LOGO_RESULT_BYTES,
           hasAlpha: true,
           initialQuality: 0.9,
           minQuality: 0.55,
           allowWebP: false
         });
         if (!isCurrentRead()) return;
         const target = currentTarget();
         const foreground = selectedId ? qrOwnerFromTarget(canvas.getActiveObject()) === target : true;
         if (foreground) {
           if (!selectedId) qrNewLogoPending = false;
           window.__qrLogoDataURL = preparedLogo;
           syncQrEditorUI();
           if (elQrLogoStatus) elQrLogoStatus.textContent = file.name || 'Logo ausgewählt';
         }
         if (target) {
           const latestIntent = qrTargetIntents.get(selectedId);
           const state = latestIntent?.state || target._qrState || initialState;
           const capturedOptions = latestIntent?.qrOptions || initialOptions;
           if (qrPendingTarget === target) {
             clearTimeout(__qrDebounce);
             qrPendingUpdate = null;
             qrPendingTarget = null;
           }
           placeQrSVG({ target, state, qrOptions: capturedOptions, logoDataURL: preparedLogo,
             keepPanelState: foreground && !(elUrl?.value || '').trim() });
         }
       } catch (err) {
         if (isCurrentRead()) {
           console.warn('QR logo upload failed', err);
           if (!selectedId) qrNewLogoPending = false;
           const target = currentTarget();
           if (!selectedId || qrOwnerFromTarget(canvas.getActiveObject()) === target) syncQrEditorUI();
           rememberQrError(target, 'Das Logo konnte nicht geladen werden. Bitte eine andere Datei versuchen.');
         }
       } finally {
         if (readId === qrLogoReadCounter) e.target.value = '';
       }
     });
   }

if (elUrl) {
  elUrl.addEventListener('input', () => requestQrLiveUpdate({ debounce: 260 }));
  elUrl.addEventListener('change', () => requestQrLiveUpdate({ immediate: true }));
}

if (elStyle) {
  elStyle.addEventListener('change', () => requestQrLiveUpdate({ immediate: true }));
}

if (elColor) {
  const handleQrColor = (event) => {
    elColor.style.backgroundColor = elColor.value;
    updateQrPreview();
    requestQrLiveUpdate({
      immediate: event.type === 'change',
      debounce: event.type === 'input' ? 90 : 0
    });
  };
  ['input', 'change'].forEach(evt => elColor.addEventListener(evt, handleQrColor));
}

if (elBgColor) {
  const handleBgColor = (event) => {
    const value = elBgColor.value || DEFAULT_QR_BG_COLOR;
    qrBgTransparent = false;
    qrBgColorValue = value;
    lastSolidQrBg = value;
    updateQrBgControlsUI();
    updateQrPreview();
    requestQrLiveUpdate({
      immediate: event.type === 'change',
      debounce: event.type === 'input' ? 90 : 0
    });
  };
  ['input','change'].forEach(evt => elBgColor.addEventListener(evt, handleBgColor));
}

if (elBgTransparentBtn) {
  elBgTransparentBtn.addEventListener('click', (event) => {
    event.preventDefault();
    if (!qrBgTransparent) {
      qrBgTransparent = true;
      qrBgColorValue = lastSolidQrBg || DEFAULT_QR_BG_COLOR;
      updateQrBgControlsUI();
      updateQrPreview();
      requestQrLiveUpdate({ immediate: true });
    }
  });
}

if (elQrLogoRemove) {
  elQrLogoRemove.addEventListener('click', () => {
    qrLogoReadCounter += 1;
    qrNewLogoPending = false;
    const selectedQr = qrOwnerFromTarget(canvas.getActiveObject());
    if (selectedQr) qrLogoTargetReads.delete(ensureQrId(selectedQr));
    window.__qrLogoDataURL = null;
    if (elLogo) elLogo.value = '';
    syncQrEditorUI();
    requestQrLiveUpdate({ immediate: true });
  });
}

if (elQrNew) {
  elQrNew.addEventListener('click', () => prepareNewQrEditor({ clearUrl: true, focus: true }));
}

if (elQrApply) {
  elQrApply.addEventListener('click', () => {
    if (qrNewLogoPending) {
      setQrEditorStatus('Das Logo wird noch vorbereitet. Bitte einen Moment warten.');
      return;
    }
    const url = (elUrl?.value || '').trim();
    if (!url) {
      elUrl?.setAttribute('aria-invalid', 'true');
      setQrEditorStatus('Bitte zuerst einen Link oder Text eingeben.', { error: true });
      elUrl?.focus();
      return;
    }
    elUrl?.removeAttribute('aria-invalid');
    placeQrSVG({ createNew: true, target: null });
  });
}

const syncSelectedQrToPanel = () => {
  if (suppressQrAutoUpdate > 0) return;
  if (historyService?.isRestoring?.()) {
    cancelPendingQrWork({ allEdits: true });
    return;
  }
  flushPendingQrUpdate();
  cancelPendingQrWork({ preserveNewInsert: true });
  elUrl?.removeAttribute('aria-invalid');
  const selectedQr = qrOwnerFromTarget(canvas.getActiveObject());
  if (!selectedQr) {
    if (document.getElementById('qr')?.classList.contains('active')) {
      qrObject = null;
      qrLogoImage = null;
      window.qrObject = null;
      window.qrLogoImage = null;
      window.__qrLogoDataURL = null;
      applyQrPanelState({ url: '' });
      syncQrEditorUI();
    }
    return;
  }
  qrObject = selectedQr;
  window.qrObject = selectedQr;
  qrLogoImage = qrLogoForTarget(selectedQr);
  window.qrLogoImage = qrLogoImage;
  window.__qrLogoDataURL = selectedQr._qrLogoDataURL || qrLogoImage?._originalBase64 || null;
  if (selectedQr._qrState) applyQrPanelState(selectedQr._qrState);
  syncQrEditorUI();
};
canvas.on('selection:created', syncSelectedQrToPanel);
canvas.on('selection:updated', syncSelectedQrToPanel);
canvas.on('selection:cleared', syncSelectedQrToPanel);
canvas.on('canvas:cleared', () => cancelPendingQrWork({ allEdits: true }));
canvas.on('object:removed', event => {
  if (suppressQrAutoUpdate > 0 || (!event.target?._isQr && !event.target?._qrPart)) return;
  const owner = event.target._isQr ? event.target : qrOwnerFromTarget(event.target);
  if (owner) {
    qrTargetRenders.delete(owner);
    qrLogoTargetReads.delete(owner._qrId);
    qrTargetIntents.delete(owner._qrId);
    qrTargetErrors.delete(owner._qrId);
  }
  if (qrPendingTarget === owner) cancelPendingQrWork({ logo: false, target: owner });
});

    // Hilfsfunktion: sorgt für viewBox auf <svg>
    function ensureSvgHasViewBox(svgText) {
      if (/viewBox=/i.test(svgText)) return svgText;
      const m = svgText.match(/<svg[^>]*\b(width|height)\s*=\s*["']?([\d.]+)(px)?["'][^>]*\b(height|width)\s*=\s*["']?([\d.]+)(px)?["'][^>]*>/i);
      if (!m) return svgText;
      const w = parseFloat(m[2]), h = parseFloat(m[5]);
      if (!isFinite(w) || !isFinite(h)) return svgText;
      return svgText.replace(/<svg/i, `<svg viewBox="0 0 ${w} ${h}"`);
    }

  function overlayLogoOnQrGroup(qrGroup, logoDataURL, ratio = 0.22, placement = null, options = {}) {
    const targetQr = options.targetQr || null;
    const qrId = options.qrId || ensureQrId(qrGroup);
    const isCurrent = () => (!options.isCurrentRender || options.isCurrentRender()) &&
      (!targetQr || canvas.getObjects().includes(targetQr));

    // Erst das Logo laden, dann QR und Logo gemeinsam ersetzen. Bei Ladefehlern
    // bleibt der bisherige QR-Code einschließlich Logo und History erhalten.
    const commit = (img) => {
      if (!isCurrent()) return;
      qrGroup._isQr = true;
      qrGroup._qrId = qrId;
      qrGroup._qrLogoDataURL = logoDataURL || null;
      qrGroup.lockUniScaling = true;
      const currentPlacement = targetQr ? getQrPlacement(targetQr) : placement;
      const placementApplied = currentPlacement ? applyQrPlacement(qrGroup, currentPlacement) : false;
      if (!placementApplied && (!Number.isFinite(qrGroup.left) || !Number.isFinite(qrGroup.top))) centerOnShape(qrGroup);
      qrGroup.setCoords();
      if (img) {
        img.set({ originX: 'center', originY: 'center', selectable: false, evented: false });
        img._qrPart = true;
        img._qrOwnerId = qrId;
        img._qrLogoRatio = ratio;
        img._originalWidth = img.width || 1;
        img._originalHeight = img.height || 1;
        img._originalBase64 = logoDataURL;
      }
      const foreground = options.isForegroundEdit ? options.isForegroundEdit()
        : (!targetQr || qrOwnerFromTarget(canvas.getActiveObject()) === targetQr);
      withSuppressedQrAutoUpdate(() => withoutQrHistory(() => {
        if (targetQr) removeQrTarget(targetQr, { skipResync: true });
        canvas.add(qrGroup);
        if (img) canvas.add(img);
        if (foreground) {
          qrObject = qrGroup;
          window.qrObject = qrGroup;
          qrLogoImage = img || null;
          window.qrLogoImage = qrLogoImage;
          window.__qrLogoDataURL = logoDataURL || null;
          canvas.setActiveObject(qrGroup);
        }
      }));
      if (foreground && !options.keepPanelState && qrGroup._qrState) applyQrPanelState({ ...qrGroup._qrState });
      attachQrLogoSyncHandlers(qrGroup);
      if (img) updateQrLogoPlacement(qrGroup);
      oval.sendToBack();
      canvas.requestRenderAll();
      if (foreground && !options.keepPanelState) resyncQrStateFromCanvas();
      pushHistory(options.historyLabel || 'QR angepasst', { immediate: true });
    };

    if (!logoDataURL) {
      commit(null);
      return;
    }
    fabric.Image.fromURL(logoDataURL, (img, isError) => {
      if (!isCurrent()) return;
      if (isError || !img) {
        console.warn('QR logo image could not be loaded');
        if (targetQr || !options.isForegroundEdit || options.isForegroundEdit()) {
          rememberQrError(targetQr, 'Das Logo konnte nicht geladen werden. Bitte eine andere Datei versuchen.');
        }
        return;
      }
      commit(img);
    }, { crossOrigin: 'anonymous' });
  }

  // 🎯 Live-Farben synchronisieren
  function syncColorInputs() {
    backgroundController.syncFromCanvas();
    backgroundController.syncInputs();

    const textInput = document.getElementById('text-color-input');
    const textTopColor = textTop ? rgbToHex(textTop.fill) : '#000000';
    if (textInput) {
      textInput.value = textTopColor;
      textInput.style.backgroundColor = textTopColor;
    }
    if (backgroundController?.state?.baseColor) {
      setColorPickerDisplay('bg-color-input', backgroundController.state.baseColor);
    }
    setColorPickerDisplay('text-color-input', textTopColor);
    currentTextColor = textTopColor;
  }
    // ==== PNG-Einstellungen (einfach an/aus) ====
    window.PNG_QUANTIZE = true;   // auf false setzen, wenn du keine Quantisierung willst
    const PNG_COLORS     = 192;   // 64..256: 192 spart gut, sieht aber noch crisp aus

    // Canvas → Canvas hochwertig verkleinern (Lanczos + leichte Schärfung)
    async function resizeWithPicaToCanvas(sourceImg, targetW, targetH){
      const src = document.createElement('canvas');
      src.width = sourceImg.width;
      src.height = sourceImg.height;
      src.getContext('2d').drawImage(sourceImg, 0, 0);

      const dst = document.createElement('canvas');
      dst.width = targetW;
      dst.height = targetH;

      await pica().resize(src, dst, {
        quality: 3,          // höchste Qualität
        alpha: true,
        unsharpAmount: 80,   // sanftes Nachschärfen
        unsharpRadius: 0.8,
        unsharpThreshold: 10
      });

      return dst;
    }

    function imageDpiForPrintSize(imageObject, widthMm, heightMm) {
      const shapeW = Math.max(1, isOval ? (oval.rx || 0) * 2 : oval.width || BASE_W);
      const shapeH = Math.max(1, isOval ? (oval.ry || 0) * 2 : oval.height || BASE_H);
      const printWidthInches = ((imageObject.getScaledWidth() / shapeW) * widthMm) / 25.4;
      const printHeightInches = ((imageObject.getScaledHeight() / shapeH) * heightMm) / 25.4;
      const nativeEmoji = isNativeRasterEmoji(imageObject);
      const sourceWidth = nativeEmoji ? imageObject._originalWidth : (imageObject._optimizedWidth || imageObject.width || 1);
      const sourceHeight = nativeEmoji ? imageObject._originalHeight : (imageObject._optimizedHeight || imageObject.height || 1);
      return Math.max(1, Math.round(Math.min(
        sourceWidth / Math.max(0.01, printWidthInches),
        sourceHeight / Math.max(0.01, printHeightInches)
      )));
    }

    function editableRasterImages() {
      return canvas.getObjects().filter(object => object?.type === 'image'
        && !object._qrPart && !object.isEmoji && !object._emojiChar
        && !object._helperUI && object.visible !== false && object.opacity !== 0);
    }

    function syncRestoredImageUploadStatus() {
      const status = document.getElementById('image-upload-status');
      if (!status) return;
      const active = canvas.getActiveObject();
      const images = editableRasterImages();
      const image = images.includes(active) ? active
        : (images.includes(window.__nhLastUploadedImage) ? window.__nhLastUploadedImage : images.slice(-1)[0]);
      window.__nhLastUploadedImage = image || null;
      if (!image) {
        status.textContent = 'Noch kein Bild ausgewählt.';
        return;
      }
      const width = Math.round(Number(image._optimizedWidth || image.width));
      const height = Math.round(Number(image._optimizedHeight || image.height));
      const label = image._inputLabel || 'Bild';
      status.textContent = width > 0 && height > 0
        ? `${label} · ${width} × ${height} Pixel` : label;
    }

    // Shared with the product selector: evaluate the actual output size instead
    // of applying the normal-sticker estimate to XXL or other print products.
    window.nhImageQualityForProfiles = function (profileKeys = []) {
      const images = [...editableRasterImages(), ...canvas.getObjects().filter(object => isNativeRasterEmoji(object)
        && !object._helperUI && object.visible !== false && object.opacity !== 0)];
      if (!images.length) return [];
      return [...new Set(profileKeys)].flatMap(profileKey => {
        const profile = EXPORT_PROFILES[profileKey];
        if (!profile) return [];
        let widthMm = Number(profile.designBoxMm?.width || profile.pdfWidthMm);
        let heightMm = Number(profile.designBoxMm?.height || profile.pdfHeightMm);
        if (!(widthMm > 0 && heightMm > 0)) return [];
        if (profile.fit === 'contain') {
          const shapeW = Math.max(1, isOval ? (oval.rx || 0) * 2 : oval.width || BASE_W);
          const shapeH = Math.max(1, isOval ? (oval.ry || 0) * 2 : oval.height || BASE_H);
          const scale = Math.min(widthMm / Math.ceil(shapeW), heightMm / Math.ceil(shapeH));
          widthMm = Math.ceil(shapeW) * scale;
          heightMm = Math.ceil(shapeH) * scale;
        }
        const dpi = Math.min(...images.map(image => imageDpiForPrintSize(image, widthMm, heightMm)));
        return [{ profileKey, label: profile.label, dpi, level: dpi < 150 ? 'low' : dpi < 220 ? 'warning' : 'good' }];
      });
    };

    function updateImageQualityStatus(preferredObject = null) {
      const status = document.getElementById('image-quality-status');
      if (!status) return;
      const activeObject = preferredObject || canvas.getActiveObject();
      const imageObject = activeObject?.type === 'image' && !activeObject._qrPart && !activeObject.isEmoji
        ? activeObject : (canvas.contains(window.__nhLastUploadedImage) ? window.__nhLastUploadedImage : editableRasterImages().slice(-1)[0]);
      if (!imageObject || !canvas.contains(imageObject)) {
        status.hidden = true;
        status.textContent = '';
        status.classList.remove('is-warning', 'is-error');
        return;
      }
      const dpi = imageDpiForPrintSize(imageObject, 145, 82);
      const reference = 'Für Normal (14,5 × 8,2 cm): ';
      status.hidden = false;
      status.classList.remove('is-warning', 'is-error');
      if (dpi >= 300) {
        status.textContent = `${reference}sehr gute Druckauflösung (ca. ${dpi} dpi).`;
      } else if (dpi >= 220) {
        status.textContent = `${reference}gute Druckauflösung (ca. ${dpi} dpi).`;
      } else if (dpi >= 150) {
        status.classList.add('is-warning');
        status.textContent = `${reference}noch ausreichend (ca. ${dpi} dpi). Nicht stärker vergrößern.`;
      } else {
        status.classList.add('is-error');
        status.textContent = `${reference}Auflösung zu niedrig (ca. ${dpi} dpi). Größeres Bild verwenden oder kleiner platzieren.`;
      }
      status.textContent += ' Die gewählte Produktgröße wird in der Produktauswahl geprüft.';
    }

    function overflowingTextLabels() {
      const shape = window.oval;
      if (!shape) return [];
      const width = Math.max(1, bleedClipState?.innerWidth || (isOval ? shape.rx * 2 : shape.width) - BLEED_MARGIN_PX * 2);
      const height = Math.max(1, bleedClipState?.innerHeight || (isOval ? shape.ry * 2 : shape.height) - BLEED_MARGIN_PX * 2);
      const center = shape.getCenterPoint?.() || { x: shape.left, y: shape.top };
      return canvas.getObjects().filter(object => ['i-text', 'text', 'textbox'].includes(object?.type)
        && object.visible !== false && object.opacity !== 0 && !object._helperUI
        && String(object.text || '').trim()).filter(object => {
          const bounds = object.getBoundingRect(true, true);
          const points = object.getCoords?.(true, true) || [
            { x: bounds.left, y: bounds.top },
            { x: bounds.left + bounds.width, y: bounds.top },
            { x: bounds.left, y: bounds.top + bounds.height },
            { x: bounds.left + bounds.width, y: bounds.top + bounds.height }
          ];
          return points.some(point => {
            const dx = Math.abs(point.x - center.x), dy = Math.abs(point.y - center.y);
            return isOval
              ? (dx / (width / 2 + 1)) ** 2 + (dy / (height / 2 + 1)) ** 2 > 1
              : dx > width / 2 + 1 || dy > height / 2 + 1;
          });
        }).map(object => object._inputLabel || String(object.text).trim().slice(0, 30));
    }

    function updateTextOverflowWarning() {
      const labels = overflowingTextLabels();
      const message = labels.length
        ? `Bitte prüfen: ${[...new Set(labels)].join(', ')} reicht möglicherweise über den Druckrand und kann abgeschnitten werden. Text kleiner setzen oder nach innen verschieben.` : '';
      ['nh-text-overflow-warning', 'nh-preview-overflow-warning'].forEach(id => {
        const node = document.getElementById(id);
        if (node) { node.textContent = message; node.hidden = !message; }
      });
      return labels;
    }

    let textOverflowFrame = null;
    function scheduleTextOverflowCheck() {
      if (textOverflowFrame !== null) return;
      textOverflowFrame = requestAnimationFrame(() => {
        textOverflowFrame = null;
        updateTextOverflowWarning();
      });
    }
    window.nhCheckTextOverflow = updateTextOverflowWarning;
    ['object:added', 'object:removed', 'object:modified', 'object:scaling', 'object:moving', 'text:changed']
      .forEach(eventName => canvas.on(eventName, scheduleTextOverflowCheck));
    historyService.onChange(() => { scheduleTextOverflowCheck(); updateImageQualityStatus(); });
    ['object:scaling', 'object:modified', 'selection:created', 'selection:updated', 'selection:cleared']
      .forEach(eventName => canvas.on(eventName, event => updateImageQualityStatus(event?.target)));
    window.__nhUpdateImageQualityStatus = updateImageQualityStatus;

    const imageCropDom = {
      modal: document.getElementById('image-crop-modal'),
      source: document.getElementById('image-crop-source'),
      close: document.getElementById('image-crop-close'),
      cancel: document.getElementById('image-crop-cancel'),
      apply: document.getElementById('image-crop-apply'),
      reset: document.getElementById('image-crop-reset'),
      zoom: document.getElementById('image-crop-zoom'),
      zoomValue: document.getElementById('image-crop-zoom-value'),
      status: document.getElementById('image-crop-status'),
      scroll: document.getElementById('image-crop-scroll'),
      editSelected: document.getElementById('image-edit-selected-btn')
    };
    if (imageCropDom.modal && imageCropDom.modal.parentElement !== document.body) {
      document.body.appendChild(imageCropDom.modal);
    }
    const imageCropModeButtons = Array.from(document.querySelectorAll('[data-crop-mode]'));
    let imageCropper = null;
    let imageCropPayload = null;
    let imageCropMode = 'free';
    let imageCropBaseRatio = 1;
    let imageCropZoomBaseline = null;
    let imageCropZoomSessionActive = false;
    let imageCropPreviousFocus = null;

    function selectedEditableImage() {
      const target = canvas.getActiveObject();
      return target?.type === 'image' && !target._qrPart ? target : null;
    }

    function syncImageEditButton() {
      if (!imageCropDom.editSelected) return;
      imageCropDom.editSelected.hidden = !selectedEditableImage();
    }
    ['selection:created', 'selection:updated', 'selection:cleared', 'object:removed']
      .forEach(eventName => canvas.on(eventName, syncImageEditButton));

    function setImageCropMode(mode = 'free') {
      imageCropMode = ['free', 'square', 'circle'].includes(mode) ? mode : 'free';
      imageCropModeButtons.forEach(button => {
        const active = button.dataset.cropMode === imageCropMode;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
      imageCropDom.modal?.classList.toggle('is-circle', imageCropMode === 'circle');
      if (imageCropper) {
        imageCropper.setAspectRatio(imageCropMode === 'free' ? NaN : 1);
      }
    }

    function setImageCropZoomDisplay(percent = 100) {
      const safePercent = Math.max(100, Math.min(200, Number(percent) || 100));
      if (imageCropDom.zoom) imageCropDom.zoom.value = String(safePercent);
      if (imageCropDom.zoomValue) imageCropDom.zoomValue.textContent = `${safePercent}%`;
    }

    function captureImageCropZoomBaseline() {
      if (!imageCropper) return;
      const canvasData = imageCropper.getCanvasData?.();
      const cropBoxData = imageCropper.getCropBoxData?.();
      const imageData = imageCropper.getImageData?.();
      const rotation = Math.abs(Number(imageData?.rotate) || 0) % 180;
      const naturalWidth = rotation === 90
        ? Number(imageData?.naturalHeight)
        : Number(imageData?.naturalWidth);
      imageCropBaseRatio = canvasData?.width && naturalWidth
        ? canvasData.width / naturalWidth
        : imageCropBaseRatio || 1;
      imageCropZoomBaseline = {
        canvasData: canvasData ? { ...canvasData } : null,
        cropBoxData: cropBoxData ? { ...cropBoxData } : null
      };
      imageCropZoomSessionActive = false;
      setImageCropZoomDisplay(100);
    }

    function restoreImageCropZoomBaseline() {
      if (!imageCropper || !imageCropZoomBaseline) return;
      const { canvasData, cropBoxData } = imageCropZoomBaseline;
      if (canvasData) imageCropper.setCanvasData({ ...canvasData });
      if (cropBoxData) imageCropper.setCropBoxData({ ...cropBoxData });
      imageCropper.crop?.();
    }

    function fitWholeImageInCropPreview() {
      if (!imageCropper || imageCropMode !== 'free') {
        captureImageCropZoomBaseline();
        return;
      }

      const containerData = imageCropper.getContainerData?.();
      const imageData = imageCropper.getImageData?.();
      const containerWidth = Number(containerData?.width) || 0;
      const containerHeight = Number(containerData?.height) || 0;
      const rotation = Math.abs(Number(imageData?.rotate) || 0) % 180;
      const naturalWidth = rotation === 90
        ? Number(imageData?.naturalHeight)
        : Number(imageData?.naturalWidth);
      const naturalHeight = rotation === 90
        ? Number(imageData?.naturalWidth)
        : Number(imageData?.naturalHeight);

      if (!containerWidth || !containerHeight || !naturalWidth || !naturalHeight) {
        captureImageCropZoomBaseline();
        return;
      }

      const scale = Math.min(containerWidth / naturalWidth, containerHeight / naturalHeight);
      const width = Math.max(1, naturalWidth * scale);
      const height = Math.max(1, naturalHeight * scale);
      const left = (Number(containerData?.left) || 0) + (containerWidth - width) / 2;
      const top = (Number(containerData?.top) || 0) + (containerHeight - height) / 2;

      // A tiny crop box briefly removes Cropper's cover constraint so the
      // complete rotated source can be fitted before the crop box follows it.
      imageCropper.setCropBoxData({
        left: left + width / 2 - 1,
        top: top + height / 2 - 1,
        width: 2,
        height: 2
      });
      imageCropper.setCanvasData({ left, top, width, height });
      imageCropper.setCropBoxData({ left, top, width, height });
      imageCropper.crop?.();
      captureImageCropZoomBaseline();
    }

    function closeImageCropDialog() {
      imageCropper?.destroy();
      imageCropper = null;
      imageCropPayload = null;
      imageCropZoomBaseline = null;
      imageCropZoomSessionActive = false;
      if (imageCropDom.source) {
        imageCropDom.source.onload = null;
        imageCropDom.source.removeAttribute('src');
      }
      if (imageCropDom.modal) {
        imageCropDom.modal.setAttribute('aria-hidden', 'true');
        imageCropDom.modal.classList.remove('is-circle');
      }
      document.body?.classList.remove('image-crop-open');
      if (imageCropDom.status) imageCropDom.status.textContent = '';
      if (imageCropPreviousFocus?.focus) imageCropPreviousFocus.focus();
      imageCropPreviousFocus = null;
    }

    function openImageCropDialog(payload) {
      if (!payload?.sourceDataUrl) return;
      const uploadStatus = document.getElementById('image-upload-status');
      if (typeof window.Cropper !== 'function' || !imageCropDom.modal || !imageCropDom.source) {
        if (uploadStatus) uploadStatus.textContent = 'Die Bildbearbeitung konnte nicht geladen werden. Bitte die Seite neu laden.';
        return;
      }

      imageCropPreviousFocus = document.activeElement;
      imageCropPayload = payload;
      imageCropDom.modal.setAttribute('aria-hidden', 'false');
      document.body?.classList.add('image-crop-open');
      if (imageCropDom.scroll) imageCropDom.scroll.scrollTop = 0;
      if (imageCropDom.apply) {
        imageCropDom.apply.textContent = payload.target ? 'Bild aktualisieren' : 'Bild einfügen';
        imageCropDom.apply.disabled = true;
      }
      setImageCropZoomDisplay(100);
      if (imageCropDom.status) imageCropDom.status.textContent = 'Bild wird vorbereitet …';
      setImageCropMode(payload.cropMode || 'free');

      imageCropDom.source.onload = () => {
        imageCropper?.destroy();
        imageCropper = new window.Cropper(imageCropDom.source, {
          viewMode: 1,
          dragMode: 'move',
          autoCropArea: 1,
          responsive: true,
          restore: false,
          guides: true,
          center: true,
          highlight: false,
          background: false,
          cropBoxMovable: true,
          cropBoxResizable: true,
          toggleDragModeOnDblclick: false,
          ready() {
            setImageCropMode(imageCropMode);
            requestAnimationFrame(() => {
              if (imageCropMode === 'free') fitWholeImageInCropPreview();
              else captureImageCropZoomBaseline();
              if (imageCropDom.apply) imageCropDom.apply.disabled = false;
              if (imageCropDom.status) imageCropDom.status.textContent = '';
            });
          }
        });
      };
      imageCropDom.source.src = payload.sourceDataUrl;
      window.setTimeout(() => imageCropDom.close?.focus(), 0);
    }

    async function insertCroppedImage(dataUrl, payload, outputMeta = {}) {
      const uploadStatus = document.getElementById('image-upload-status');
      let imgObject;
      try {
        imgObject = await new Promise((resolve, reject) => {
          fabric.Image.fromURL(dataUrl, object => {
            if (object) resolve(object);
            else reject(new Error('fabric.Image.fromURL lieferte kein Objekt'));
          });
        });
      } catch (loadErr) {
        console.error('Konnte bearbeitetes Bild nicht laden', loadErr);
        if (uploadStatus) uploadStatus.textContent = 'Das bearbeitete Bild konnte nicht eingefügt werden.';
        return;
      }

      const previous = payload.target && canvas.getObjects().includes(payload.target)
        ? payload.target
        : null;
      const previousIndex = previous ? canvas.getObjects().indexOf(previous) : -1;

      imgObject.set({
        originX: 'center',
        originY: 'center',
        selectable: true
      });

      if (previous) {
        const previousWidth = Math.max(1, previous.getScaledWidth?.() || previous.width || 1);
        const previousHeight = Math.max(1, previous.getScaledHeight?.() || previous.height || 1);
        const scale = Math.min(
          previousWidth / Math.max(1, imgObject.width || 1),
          previousHeight / Math.max(1, imgObject.height || 1)
        );
        imgObject.set({
          left: previous.left,
          top: previous.top,
          angle: previous.angle || 0,
          flipX: !!previous.flipX,
          flipY: !!previous.flipY,
          opacity: Number.isFinite(previous.opacity) ? previous.opacity : 1,
          scaleX: scale,
          scaleY: scale
        });
      } else {
        const fit = 0.35;
        const shapeW = isOval ? oval.rx * 2 : oval.width;
        const shapeH = isOval ? oval.ry * 2 : oval.height;
        const scale = Math.min(
          (shapeW * fit) / Math.max(1, imgObject.width || 1),
          (shapeH * fit) / Math.max(1, imgObject.height || 1)
        );
        imgObject.set({ scaleX: scale, scaleY: scale });
        centerOnShape(imgObject);
      }

      imgObject._originalBase64 = dataUrl;
      imgObject._optimizedBase64 = dataUrl;
      imgObject._imageEditSource = payload.sourceDataUrl;
      imgObject._imageCropMode = outputMeta.mode || 'free';
      imgObject._sourceWidth = payload.sourceWidth || outputMeta.width || imgObject.width;
      imgObject._sourceHeight = payload.sourceHeight || outputMeta.height || imgObject.height;
      imgObject._optimizedWidth = outputMeta.width || imgObject.width;
      imgObject._optimizedHeight = outputMeta.height || imgObject.height;
      imgObject._inputLabel = payload.fileName || previous?._inputLabel || 'Bild';

      // Commit an image replacement as one undoable action, never the empty
      // intermediate canvas between removing the old and adding the new image.
      if (previous?._historyId) imgObject._historyId = previous._historyId;
      ensureHistoryId(imgObject, 'image');
      historyService.flush();
      historyService.withoutRecording(() => {
        if (previous) canvas.remove(previous);
        if (previousIndex >= 0) {
          canvas.insertAt(imgObject, Math.max(1, previousIndex), false);
        } else {
          canvas.add(imgObject);
        }
      });
      canvas.setActiveObject(imgObject);
      imgObject.setCoords();
      window.__nhLastUploadedImage = imgObject;
      canvas.requestRenderAll();
      updateImageQualityStatus(imgObject);
      syncImageEditButton();
      pushHistory(previous ? 'Bild bearbeitet' : 'Bild hinzugefügt', { immediate: true });
      if (uploadStatus) {
        uploadStatus.textContent = `${imgObject._inputLabel} · ${Math.round(imgObject._optimizedWidth)} × ${Math.round(imgObject._optimizedHeight)} Pixel`;
      }
    }

    async function applyImageCrop() {
      if (!imageCropper || !imageCropPayload || imageCropDom.apply?.disabled) return;
      if (imageCropDom.apply) imageCropDom.apply.disabled = true;
      if (imageCropDom.status) imageCropDom.status.textContent = 'Bild wird übernommen …';

      try {
        let cropped = imageCropper.getCroppedCanvas({
          maxWidth: IMAGE_UPLOAD_MAX_DIMENSION,
          maxHeight: IMAGE_UPLOAD_MAX_DIMENSION,
          imageSmoothingEnabled: true,
          imageSmoothingQuality: 'high'
        });
        if (!cropped || !cropped.width || !cropped.height) throw new Error('Leerer Bildausschnitt');

        if (imageCropMode === 'circle') {
          const size = Math.min(cropped.width, cropped.height);
          const circleCanvas = document.createElement('canvas');
          circleCanvas.width = size;
          circleCanvas.height = size;
          const circleContext = circleCanvas.getContext('2d');
          const sourceX = Math.max(0, (cropped.width - size) / 2);
          const sourceY = Math.max(0, (cropped.height - size) / 2);
          circleContext.drawImage(cropped, sourceX, sourceY, size, size, 0, 0, size, size);
          circleContext.globalCompositeOperation = 'destination-in';
          circleContext.beginPath();
          circleContext.arc(size / 2, size / 2, size / 2, 0, Math.PI * 2);
          circleContext.fill();
          circleContext.globalCompositeOperation = 'source-over';
          cropped = circleCanvas;
        }

        const hasAlpha = imageCropMode === 'circle' || canvasHasTransparency(cropped);
        const compressed = await compressCanvasToDataURL(cropped, {
          maxBytes: MAX_IMAGE_RESULT_BYTES,
          hasAlpha,
          initialQuality: hasAlpha ? 0.95 : 0.9,
          minQuality: hasAlpha ? 0.76 : 0.68,
          allowWebP: false
        });
        const payload = imageCropPayload;
        const mode = imageCropMode;
        closeImageCropDialog();
        await insertCroppedImage(compressed.dataUrl, payload, {
          width: compressed.width,
          height: compressed.height,
          mode
        });
      } catch (err) {
        console.error('Bildzuschnitt fehlgeschlagen', err);
        if (imageCropDom.status) imageCropDom.status.textContent = 'Der Ausschnitt konnte nicht übernommen werden. Bitte erneut versuchen.';
        if (imageCropDom.apply) imageCropDom.apply.disabled = false;
      }
    }

    async function prepareImageFile(file) {
      const uploadStatus = document.getElementById('image-upload-status');
      const extensionAllowed = /\.(jpe?g|png|webp)$/i.test(file.name || '');
      const mimeAllowed = !file.type || /^image\/(jpeg|png|webp)$/i.test(file.type);
      if (!extensionAllowed || !mimeAllowed) {
        if (uploadStatus) uploadStatus.textContent = 'Dieses Dateiformat wird nicht unterstützt. Bitte JPG, PNG oder WebP verwenden.';
        return;
      }

      if (uploadStatus) uploadStatus.textContent = `${file.name} wird vorbereitet …`;
      try {
        const originalBase64 = await new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onload = event => resolve(event.target.result);
          reader.onerror = reject;
          reader.readAsDataURL(file);
        });
        const img = await loadImageAsync(originalBase64);
        const originalWidth = img.naturalWidth || img.width;
        const originalHeight = img.naturalHeight || img.height;
        let width = originalWidth;
        let height = originalHeight;
        if (width > height && width > IMAGE_UPLOAD_MAX_DIMENSION) {
          height = Math.round(height * (IMAGE_UPLOAD_MAX_DIMENSION / width));
          width = IMAGE_UPLOAD_MAX_DIMENSION;
        } else if (height > IMAGE_UPLOAD_MAX_DIMENSION) {
          width = Math.round(width * (IMAGE_UPLOAD_MAX_DIMENSION / height));
          height = IMAGE_UPLOAD_MAX_DIMENSION;
        }

        let preparedCanvas;
        if (width !== originalWidth || height !== originalHeight) {
          preparedCanvas = await resizeWithPicaToCanvas(img, width, height);
        } else {
          preparedCanvas = document.createElement('canvas');
          preparedCanvas.width = width;
          preparedCanvas.height = height;
          preparedCanvas.getContext('2d').drawImage(img, 0, 0, width, height);
        }

        const rawAlpha = /png|webp/i.test(file.type || file.name);
        const hasAlpha = rawAlpha && canvasHasTransparency(preparedCanvas);
        if (!hasAlpha) {
          const context = preparedCanvas.getContext('2d');
          context.globalCompositeOperation = 'destination-over';
          context.fillStyle = '#ffffff';
          context.fillRect(0, 0, width, height);
          context.globalCompositeOperation = 'source-over';
        }

        const compressed = await compressCanvasToDataURL(preparedCanvas, {
          maxBytes: MAX_IMAGE_RESULT_BYTES,
          hasAlpha,
          initialQuality: hasAlpha ? 0.95 : 0.9,
          minQuality: hasAlpha ? 0.76 : 0.68,
          allowWebP: false
        });
        openImageCropDialog({
          sourceDataUrl: compressed.dataUrl,
          sourceWidth: originalWidth,
          sourceHeight: originalHeight,
          fileName: file.name || 'Bild',
          cropMode: 'free',
          target: null
        });
      } catch (err) {
        console.error('Bildvorbereitung fehlgeschlagen', err);
        if (uploadStatus) uploadStatus.textContent = 'Die Bilddatei ist beschädigt oder konnte nicht gelesen werden.';
      }
    }

    function handleImageUpload() {
      const input = document.getElementById('image-upload');
      const file = input?.files?.[0];
      if (!file) return;
      prepareImageFile(file);
      input.value = '';
    }

    imageCropModeButtons.forEach(button => {
      button.addEventListener('click', () => {
        setImageCropMode(button.dataset.cropMode);
        requestAnimationFrame(() => {
          if (imageCropMode === 'free') fitWholeImageInCropPreview();
          else captureImageCropZoomBaseline();
        });
      });
    });
    document.querySelectorAll('[data-crop-rotate]').forEach(button => {
      button.addEventListener('click', () => {
        imageCropper?.rotate(Number(button.dataset.cropRotate) || 0);
        requestAnimationFrame(() => requestAnimationFrame(() => {
          if (imageCropMode === 'free') fitWholeImageInCropPreview();
          else captureImageCropZoomBaseline();
        }));
      });
    });
    imageCropDom.zoom?.addEventListener('input', () => {
      const percent = Number(imageCropDom.zoom.value) || 100;
      if (!imageCropper) return;
      if (!imageCropZoomSessionActive) {
        captureImageCropZoomBaseline();
        imageCropZoomSessionActive = true;
      }
      setImageCropZoomDisplay(percent);
      if (percent === 100) {
        restoreImageCropZoomBaseline();
        imageCropZoomSessionActive = false;
        return;
      }
      imageCropper.zoomTo(imageCropBaseRatio * (percent / 100));
    });
    imageCropDom.reset?.addEventListener('click', () => {
      imageCropper?.reset();
      setImageCropMode(imageCropMode);
      requestAnimationFrame(() => {
        if (imageCropMode === 'free') fitWholeImageInCropPreview();
        else captureImageCropZoomBaseline();
      });
    });
    imageCropDom.close?.addEventListener('click', closeImageCropDialog);
    imageCropDom.cancel?.addEventListener('click', closeImageCropDialog);
    imageCropDom.modal?.querySelector('.image-crop-backdrop')?.addEventListener('click', closeImageCropDialog);
    imageCropDom.apply?.addEventListener('click', applyImageCrop);
    imageCropDom.editSelected?.addEventListener('click', () => {
      const target = selectedEditableImage();
      if (!target) return;
      openImageCropDialog({
        sourceDataUrl: target._imageEditSource || target._originalBase64 || target._element?.src,
        sourceWidth: target._sourceWidth || target.width,
        sourceHeight: target._sourceHeight || target.height,
        fileName: target._inputLabel || 'Bild',
        cropMode: target._imageCropMode || 'free',
        target
      });
    });
    window.addEventListener('keydown', event => {
      if (event.key === 'Escape' && imageCropDom.modal?.getAttribute('aria-hidden') === 'false') {
        closeImageCropDialog();
      }
    });

  function syncTextFormatButtons() {
    const object = canvas.getActiveObject();
    const isText = object?.type === 'i-text';
    const label = document.getElementById('text-selection-label');
    const formatButtons = document.querySelectorAll('.format-btn[data-format]');

    formatButtons.forEach(button => {
      const format = button.dataset.format;
      const active = isText && (
        (format === 'bold' && (object.fontWeight === 'bold' || Number(object.fontWeight) >= 600)) ||
        (format === 'italic' && object.fontStyle === 'italic') ||
        (format === 'underline' && object.underline === true)
      );
      button.disabled = !isText;
      button.classList.toggle('is-active', !!active);
      button.setAttribute('aria-pressed', String(!!active));
    });

    if (label) {
      const objectLabel = object?._inputLabel || (typeof object?.text === 'string' ? object.text.trim() : '');
      label.textContent = isText
        ? `${objectLabel || 'Text'} ausgewählt`
        : 'Text im Motiv auswählen';
    }
  }

  ['selection:created', 'selection:updated', 'selection:cleared', 'object:modified']
    .forEach(eventName => canvas.on(eventName, syncTextFormatButtons));
  window.addEventListener('load', syncTextFormatButtons);

  // Text bearbeiten
  function toggleBold() {
    const obj = canvas.getActiveObject();
    if (obj && obj.type === 'i-text') {
      obj.set('fontWeight', obj.fontWeight === 'bold' ? '' : 'bold');
      canvas.requestRenderAll();
      scheduleTextMetricRefresh([0, 120]);
      if (!historyService.isRestoring()) {
        pushHistory('Text Fett umgeschaltet', { immediate: true });
      }
      syncTextFormatButtons();
    }
  }

  function toggleItalic() {
    const obj = canvas.getActiveObject();
    if (obj && obj.type === 'i-text') {
      obj.set('fontStyle', obj.fontStyle === 'italic' ? '' : 'italic');
      canvas.requestRenderAll();
      scheduleTextMetricRefresh([0, 120]);
      if (!historyService.isRestoring()) {
        pushHistory('Text Kursiv umgeschaltet', { immediate: true });
      }
      syncTextFormatButtons();
    }
  }

  function toggleUnderline() {
    const obj = canvas.getActiveObject();
    if (obj && obj.type === 'i-text') {
      obj.set('underline', !obj.underline);
      canvas.requestRenderAll();
      scheduleTextMetricRefresh([0, 120]);
      if (!historyService.isRestoring()) {
        pushHistory('Text Unterstreichung umgeschaltet', { immediate: true });
      }
      syncTextFormatButtons();
    }
  }

    function isDynamicTextObject(obj) {
      if (!obj || obj.type !== 'i-text') return false;
      if (obj === textTop || obj === textBottom) return false;
      const id = obj._historyId || '';
      if (id === 'text-top' || id === 'text-bottom') return false;
      if (obj._isDynamicTextLine) return true;
      if (typeof obj._linkedInputId === 'string' && obj._linkedInputId.startsWith('text-')) return true;
      return id.startsWith('text-');
    }

    function addNewTextLine() {
      const newText = new fabric.IText('Neuer Text', {
        fontFamily: currentTextFont,
        fill: currentTextColor,
        fontSize: 16,
        selectable: true,
        textAlign: 'center',
        originX: 'center',
        originY: 'center',
        padding: 8
      });

      const existingDynamicCount = canvas
        .getObjects('i-text')
        .filter(isDynamicTextObject)
        .length;
      const lineNumber = Math.max(3, existingDynamicCount + 3);

      // ✅ Zoom-sichere Position: mittig, 80px über unterem Rand
      centerOnShape(newText, getRy() * 0.6);

      window.__NEXT_ID = (window.__NEXT_ID || 0) + 1;
      newText._createdAt = Date.now();
      newText._isDynamicTextLine = true;
      newText._inputLabel = `Textzeile ${lineNumber}`;
      newText._historyId = newText._historyId || `text-${window.__NEXT_ID}`;
      newText._linkedInputId = `${newText._historyId}-input`;
      ensureHistoryId(newText, 'text');

      canvas.add(newText).setActiveObject(newText);
      syncRemoveButtonState();
      canvas.requestRenderAll();
      requestAnimationFrame(() => {
        rebuildDynamicTextInputs();
        focusDynamicTextInput(newText);
      });
      newText.__wasCenteredOnce = true;
      ensureCenteredTextOrigin(newText);
      scheduleTextMetricRefresh([0, 120]);
    }

  // 🧲 Fixieren / Lösen
  function fixSelection() {
    const obj = canvas.getActiveObject();
    if (obj) {
      obj.lockMovementX = obj.lockMovementY = true;
      obj.set({ borderColor: 'blue', cornerColor: 'blue' });
      canvas.renderAll();
    }
  }

  function unfixSelection() {
    const obj = canvas.getActiveObject();
    if (obj) {
      obj.lockMovementX = obj.lockMovementY = false;
      obj.set({ borderColor: 'black', cornerColor: 'black' });
      canvas.renderAll();
    }
  }

    function toggleShape() {
      if (!oval) return;
      const currentlyOval = oval?.type === 'ellipse';

      historyService.withoutRecording(() => {
        const prevLeft  = oval.left;
        const prevTop   = oval.top;
        const prevAngle = oval.angle || 0;

        let w, h;
        if (currentlyOval) {
          w = (oval.rx || 0) * 2;
          h = (oval.ry || 0) * 2;
        } else {
          w = oval.width;
          h = oval.height;
        }

        canvas.remove(oval);

        if (currentlyOval) {
          oval = new fabric.Rect({
            width: w,
            height: h,
            fill: backgroundController.state.baseColor,
            left: prevLeft,
            top: prevTop,
            angle: prevAngle,
            originX: 'center',
            originY: 'center',
            selectable: false,
            evented: false,
            hasControls: false,
            strokeUniform: true
          });
          oval._isBackground = true;
          oval._historyId = 'background';
        } else {
          oval = new fabric.Ellipse({
            rx: w / 2,
            ry: h / 2,
            fill: backgroundController.state.baseColor,
            left: prevLeft,
            top: prevTop,
            angle: prevAngle,
            originX: 'center',
            originY: 'center',
            selectable: false,
            evented: false,
            hasControls: false,
            strokeUniform: true
          });
          oval._isBackground = true;
          oval._historyId = 'background';
        }

        isOval = !currentlyOval;
        window.isOval = isOval;

        canvas.add(oval);
        oval.sendToBack();
        window.oval = oval;

        const bgInput = document.getElementById('bg-color-input');
        if (bgInput) {
          bgInput.value = backgroundController.state.baseColor;
          bgInput.style.backgroundColor = backgroundController.state.baseColor;
        }

        applyBackgroundAppearance({ commitHistory: false });
        syncBackgroundInputsFromState();
        ensureBleedGuide();
        hideBleedGuide();
      });

      ensureHistoryId(oval, 'background');
      if (typeof window.__nhSyncShapeChoiceButtons === 'function') {
        window.__nhSyncShapeChoiceButtons();
      }
      pushHistory('Form gewechselt', { immediate: true });
    }

    function setColorPickerDisplay(id, color) {
      if (!id || typeof color !== 'string') return;
      const normalized = color.toUpperCase();
      const swatchEl = document.querySelector(`[data-color-swatch="${id}"]`);
      if (swatchEl) swatchEl.style.background = color;
      const triggerEl = document.querySelector(`.color-trigger[data-color-input="${id}"]`);
      if (triggerEl) {
        const baseLabel = triggerEl.dataset.colorLabel || 'Farbe auswählen';
        triggerEl.setAttribute('aria-label', `${baseLabel} (${normalized})`);
      }
    }

    function initializeEnhancedColorPickers() {
      document.querySelectorAll('.color-trigger[data-color-input]').forEach(button => {
        const targetId = button.dataset.colorInput;
        if (!targetId) return;
        const input = document.getElementById(targetId);
        if (!input) return;
        button.addEventListener('click', () => input.click());
        button.addEventListener('keydown', evt => {
          if (evt.key === 'Enter' || evt.key === ' ') {
            evt.preventDefault();
            input.click();
          }
        });
      });
    }

    function updateColorPickersUI() {
      ['bg-color-input', 'text-color-input', 'qr-color'].forEach(id => {
        const input = document.getElementById(id);
        if (!input) return;
        input.style.backgroundColor = input.value;
        setColorPickerDisplay(id, input.value);
      });
    }

  // 🚀 Init
  window.addEventListener('load', () => {
    syncColorInputs();
    updateColorPickersUI();
    initializeEnhancedColorPickers();

    const objects = canvas.getObjects();
    if (!objects.includes(oval)) {
      canvas.add(oval);
      oval.sendToBack();
    }
    if (!objects.includes(textTop)) {
      canvas.add(textTop);
    }
    if (!objects.includes(textBottom)) {
      canvas.add(textBottom);
    }

    canvas.setZoom(1);
    canvas.renderAll();
    fitCanvasToPreview({ force: true });
    updateQrPreview();
    autoUpdateQR();
    initializeBackgroundEnhancements();
    alignPanelController.initialize();
    historyService.initialize('Startzustand');

    try {
      if (typeof currentDesignFingerprint === 'function') {
        hiddenDraftBaselineFingerprint = currentDesignFingerprint();
        window.__nhBaselineFingerprint = hiddenDraftBaselineFingerprint;
      }
    } catch (err) {
      hiddenDraftBaselineFingerprint = null;
    }
    nhFunnelEditorInitialized = true;
    nhFunnelCall('ready');


    requestAnimationFrame(() => {
      try {
        if (!designShareRequestedAtBoot && typeof safeRemoveItem === 'function') safeRemoveItem(HIDDEN_DRAFT_STORAGE_KEY);
      } catch (_) { /* noop */ }
      try {
        if (typeof showWelcomeModal === 'function') {
          showWelcomeModal().catch(() => {});
        }
      } catch (err) {
        console.warn('Welcome modal failed', err);
      }
    });

    const ensureBaseline = () => syncHistoryBaseline('Startzustand');
    if (document?.fonts?.ready instanceof Promise) {
      document.fonts.ready.then(() => setTimeout(ensureBaseline, 0));
    }
    setTimeout(ensureBaseline, 400);
    resolveDesignShareInitialized();
  });

  // Panel-Navigation: vier Arbeitsbereiche mit kontextbezogenen Unterwerkzeugen.
  const sidebarMoreButton = document.querySelector('.sidebar-more');
  const sidebarSheet = document.getElementById('sidebar-sheet');

  const collapseSidebarSheet = () => {
    if (!sidebarMoreButton || !sidebarSheet) return;
    sidebarMoreButton.setAttribute('aria-expanded', 'false');
    sidebarSheet.hidden = true;
  };

  const editorRoot = document.getElementById('nh-editor');
  const navItems = Array.from(document.querySelectorAll('.nav-item[data-panel]'));
  const primaryNavItems = Array.from(document.querySelectorAll('.nav-item[data-nav-group="primary"]'));
  const subtoolRows = Array.from(document.querySelectorAll('.editor-subtools[data-subtools]'));
  const lastPanelByMode = {
    text: 'text',
    design: 'colors',
    insert: 'image',
    details: 'layers'
  };

  function activateEditorPanel(itemOrPanel, options = {}) {
    const requestedItem = typeof itemOrPanel === 'string'
      ? navItems.find(nav => nav.dataset.panel === itemOrPanel)
      : itemOrPanel;
    if (!requestedItem) return;

    const mode = requestedItem.dataset.editorMode || 'text';
    const isPrimary = requestedItem.dataset.navGroup === 'primary';
    const targetPanel = isPrimary
      ? (lastPanelByMode[mode] || requestedItem.dataset.panel)
      : requestedItem.dataset.panel;
    const panel = document.getElementById(targetPanel);
    if (!panel) return;

    lastPanelByMode[mode] = targetPanel;
    if (editorRoot) editorRoot.dataset.editorMode = mode;

    primaryNavItems.forEach(nav => {
      const active = nav.dataset.editorMode === mode;
      nav.classList.toggle('active', active);
      nav.setAttribute('aria-pressed', String(active));
    });

    document.querySelectorAll('.editor-subtools .nav-item[data-panel]').forEach(nav => {
      const active = nav.dataset.editorMode === mode && nav.dataset.panel === targetPanel;
      nav.classList.toggle('active', active);
      nav.setAttribute('aria-pressed', String(active));
    });

    subtoolRows.forEach(row => {
      row.hidden = row.dataset.subtools !== mode;
    });

    document.querySelectorAll('.panel').forEach(candidate => {
      candidate.classList.toggle('active', candidate === panel);
    });

    const panelContainer = document.querySelector('.panel-container');
    if (!options.preserveScroll && panelContainer) {
      panelContainer.scrollTop = 0;
    }

    if (targetPanel === 'text' || targetPanel === 'colors') {
      syncColorInputs();
    } else if (targetPanel === 'opacity') {
      syncOpacityControl();
    } else if (targetPanel === 'qr') {
      const selectedQr = qrOwnerFromTarget(canvas.getActiveObject());
      if (selectedQr) {
        syncSelectedQrToPanel();
      } else {
        prepareNewQrEditor({ clearUrl: true, focus: false });
      }
    } else if (targetPanel === 'font' && typeof window.__nhSyncFontPanel === 'function') {
      window.__nhSyncFontPanel();
    } else if (targetPanel === 'templates' && typeof window.__nhEnsureTemplateCatalog === 'function') {
      window.__nhEnsureTemplateCatalog();
    } else if (targetPanel === 'layers' && typeof window.__nhRefreshLayerList === 'function') {
      window.__nhRefreshLayerList();
    }

    if (!options.skipFocus && window.matchMedia('(max-width: 760px)').matches) {
      panel.setAttribute('tabindex', '-1');
    }

    requestAnimationFrame(() => {
      if (typeof fitCanvasToPreview === 'function') fitCanvasToPreview({ force: true });
    });

    if (sidebarSheet && sidebarSheet.contains(requestedItem)) {
      collapseSidebarSheet();
    }
  }

  navItems.forEach(item => {
    item.addEventListener('click', () => activateEditorPanel(item));
  });
  window.__nhActivateEditorPanel = activateEditorPanel;
  document.getElementById('nh-template-catalog-btn')?.addEventListener('click', () => {
    activateEditorPanel('templates');
  });

  const shapeChoiceButtons = Array.from(document.querySelectorAll('[data-shape-choice]'));
  function syncShapeChoiceButtons() {
    const currentIsOval = oval?.type === 'ellipse';
    shapeChoiceButtons.forEach(button => {
      const active = button.dataset.shapeChoice === (currentIsOval ? 'oval' : 'rect');
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', String(active));
    });
    const toast = document.getElementById('shape-toast');
    if (toast) toast.textContent = `Form: ${currentIsOval ? 'Oval' : 'Rechteckig'}`;
  }

  shapeChoiceButtons.forEach(button => {
    button.addEventListener('click', () => {
      const wantsOval = button.dataset.shapeChoice === 'oval';
      const currentIsOval = oval?.type === 'ellipse';
      if (wantsOval !== currentIsOval && typeof toggleShape === 'function') {
        toggleShape();
      }
      syncShapeChoiceButtons();
    });
  });
  window.__nhSyncShapeChoiceButtons = syncShapeChoiceButtons;
  syncShapeChoiceButtons();

  const textColorInputEl = document.getElementById('text-color-input');
  if (textColorInputEl) {
    textColorInputEl.addEventListener('input', e => {
      const color = e.target.value; // Farbe vom Picker
      currentTextColor = color;     // Merken für neue Texte

      // ALLE Texte auf der Leinwand färben
      canvas.getObjects('i-text').forEach(textObj => {
        textObj.set({ fill: color });
      });

      // Hintergrundfarbe vom Picker selbst anpassen
      e.target.style.backgroundColor = color;
      setColorPickerDisplay('text-color-input', color);

      // Canvas neu zeichnen
      canvas.requestRenderAll();
      if (!historyService.isRestoring()) {
        pushHistory('Textfarbe geändert');
      }
    });
  }

  if (sidebarMoreButton && sidebarSheet) {
    sidebarMoreButton.addEventListener('click', () => {
      const expanded = sidebarMoreButton.getAttribute('aria-expanded') === 'true';
      sidebarMoreButton.setAttribute('aria-expanded', String(!expanded));
      sidebarSheet.hidden = expanded;
      if (!expanded) {
        sidebarSheet.scrollTop = 0;
      }
    });

    sidebarSheet.querySelectorAll('.nav-item[data-panel], #shape-toggle').forEach(button => {
      button.addEventListener('click', () => collapseSidebarSheet());
    });

    document.addEventListener('keydown', event => {
      if (event.key === 'Escape' && sidebarMoreButton.getAttribute('aria-expanded') === 'true') {
        collapseSidebarSheet();
      }
    });
  }

// Titel: falls gelöscht, neu erzeugen
const titleInput = document.getElementById('title-input');
function normalizeTextareaValue(value = '') {
  return String(value).replace(/\r\n/g, '\n').replace(/\r/g, '\n');
}

if (titleInput) {
  const applyTitleChange = (rawValue, { skipHistory = false, force = false } = {}) => {
    const value = normalizeTextareaValue(rawValue);
    if (!force && value === normalizeTextareaValue(textTop?.text || '') && textTop?.visible === (value.trim().length > 0)) return;
    if (historyService.isRestoring() && !skipHistory) return;
    const centerX = (window.oval && window.oval.left) || (canvas.getWidth() / 2);
    if (!canvas.contains(textTop)) {
      textTop = new fabric.IText('', {
        fontSize: 45,
        top: 80,
        left: centerX,
        fill: currentTextColor,
        fontFamily: currentTextFont,
        textAlign: 'center',
        selectable: true,
        originX: 'center',
        padding: 8
      });
      canvas.add(textTop);
      textTop._historyId = 'text-top';
      textTop._inputLabel = 'Titel';
      textTop._linkedInputId = 'title-input';
      ensureHistoryId(textTop, 'text');
      window.textTop = textTop;
      rebuildDynamicTextInputs();
    }

    ensureCenteredTextOrigin(textTop);
    textTop.set({ padding: 8 });
    textTop.set('text', value);
    textTop.visible = value.trim().length > 0;
    textTop.dirty = true;
    if (typeof textTop._clearCache === 'function') textTop._clearCache();
    if (typeof textTop.initDimensions === 'function') textTop.initDimensions();
    if (typeof textTop.setCoords === 'function') textTop.setCoords();
    canvas.requestRenderAll();
    scheduleTextMetricRefresh([0, 100]);
    if (!skipHistory && !historyService.isRestoring()) {
      pushHistory('Titel geändert');
    }
  };

  titleInput.addEventListener('input', e => applyTitleChange(e.target.value));
  titleInput.addEventListener('keydown', () => {
    requestAnimationFrame(() => applyTitleChange(titleInput.value, { skipHistory: true, force: true }));
  });
}

const sloganInput = document.getElementById('slogan-input');
if (sloganInput) {
  const applySloganChange = (rawValue, { skipHistory = false, force = false } = {}) => {
    const value = normalizeTextareaValue(rawValue);
    if (!force && value === normalizeTextareaValue(textBottom?.text || '') && textBottom?.visible === (value.trim().length > 0)) return;
    if (historyService.isRestoring() && !skipHistory) return;
    const centerX = (window.oval && window.oval.left) || (canvas.getWidth() / 2);
    if (!canvas.contains(textBottom)) {
      textBottom = new fabric.IText('', {
        fontSize: 21,
        top: 170,
        left: centerX,
        fill: currentTextColor,
        fontFamily: currentTextFont,
        textAlign: 'center',
        selectable: true,
        originX: 'center',
        padding: 8
      });
      canvas.add(textBottom);
      textBottom._historyId = 'text-bottom';
      textBottom._inputLabel = 'Slogan';
      textBottom._linkedInputId = 'slogan-input';
      ensureHistoryId(textBottom, 'text');
      window.textBottom = textBottom;
      rebuildDynamicTextInputs();
    }

    ensureCenteredTextOrigin(textBottom);
    textBottom.set({ padding: 8 });
    textBottom.set('text', value);
    textBottom.visible = value.trim().length > 0;
    textBottom.dirty = true;
    if (typeof textBottom._clearCache === 'function') textBottom._clearCache();
    if (typeof textBottom.initDimensions === 'function') textBottom.initDimensions();
    if (typeof textBottom.setCoords === 'function') textBottom.setCoords();
    canvas.requestRenderAll();
    scheduleTextMetricRefresh([0, 100]);
    if (!skipHistory && !historyService.isRestoring()) {
      pushHistory('Slogan geändert');
    }
  };

  sloganInput.addEventListener('input', e => applySloganChange(e.target.value));
  sloganInput.addEventListener('keydown', () => {
    requestAnimationFrame(() => applySloganChange(sloganInput.value, { skipHistory: true, force: true }));
  });
}

const textPanelEl = document.getElementById('text');
if (textPanelEl) {
  const activateTextForField = event => {
    const inputId = event.target?.id;
    if (!inputId) return;
    const linkedObject = inputId === 'title-input'
      ? textTop
      : inputId === 'slogan-input'
        ? textBottom
        : canvas.getObjects().find(object => object?.type === 'i-text' && object._linkedInputId === inputId);
    if (!linkedObject) return;
    canvas.setActiveObject(linkedObject);
    linkedObject.setCoords();
    canvas.requestRenderAll();
    if (typeof syncTextFormatButtons === 'function') syncTextFormatButtons();
  };
  textPanelEl.addEventListener('focusin', activateTextForField);
  textPanelEl.addEventListener('click', activateTextForField);
}

const SNAP_THRESHOLD = 6;
const GUIDE_COLOR = '#16a34a';
const BLEED_MARGIN_PX = 6;
const BLEED_COLOR = '#ff4d4d';
const BLEED_ICON_OFFSET = 12;
const centerGuides = { vertical: null, horizontal: null };
const bleedGuide = { frame: null, icon: null };
	const bleedClipState = {
	  type: null,
	  innerWidth: 0,
	  innerHeight: 0,
	  centerX: 0,
	  centerY: 0,
	  ready: false
	};
	window.bleedClipState = bleedClipState;

	const LIVE_TRIM_CANVAS_VIEW = true;
	const LIVE_TRIM_VIEWPORT_CLASS = 'nh-live-trim-viewport';

	function ensureLiveTrimViewport() {
	  const wrap = canvas?.wrapperEl;
	  if (!wrap?.parentElement) return null;

	  const parent = wrap.parentElement;
	  if (parent.classList?.contains(LIVE_TRIM_VIEWPORT_CLASS)) return parent;

	  const viewport = document.createElement('div');
	  viewport.className = LIVE_TRIM_VIEWPORT_CLASS;
	  viewport.style.position = 'relative';
	  viewport.style.overflow = 'hidden';
	  viewport.style.display = 'inline-block';
	  viewport.style.lineHeight = '0';

	  parent.insertBefore(viewport, wrap);
	  viewport.appendChild(wrap);
	  return viewport;
	}

	function clearLiveTrimView() {
	  const wrap = canvas?.wrapperEl;
	  if (!wrap) return;
	  const viewport = wrap.parentElement?.classList?.contains(LIVE_TRIM_VIEWPORT_CLASS)
	    ? wrap.parentElement
	    : null;
	  wrap.style.transform = '';
	  wrap.style.transformOrigin = '';
	  wrap.style.clipPath = '';
	  wrap.style.webkitClipPath = '';
	  wrap.style.willChange = '';
	  wrap.style.removeProperty('--nh-live-trim-offset-y');
	  if (viewport) {
	    viewport.style.removeProperty('--nh-live-trim-visible-height');
	    delete viewport.dataset.trimReady;
	  }
	}

	function updateLiveTrimView() {
	  if (!LIVE_TRIM_CANVAS_VIEW) return;
	  const wrap = canvas?.wrapperEl;
	  if (!wrap) return;

	  const zoom = getZoomSafe() || 1;
	  if (
	    Number.isFinite(__nhEditorBaseZoom) &&
	    Number.isFinite(zoom) &&
	    Math.abs(zoom - __nhEditorBaseZoom) > 0.001
	  ) {
	    return;
	  }

	  const trimViewport = ensureLiveTrimViewport();

	  if (
	    !bleedClipState?.ready ||
	    !Number.isFinite(bleedClipState.innerWidth) ||
	    !Number.isFinite(bleedClipState.innerHeight) ||
	    bleedClipState.innerWidth <= 0 ||
	    bleedClipState.innerHeight <= 0
	  ) {
	    clearLiveTrimView();
	    return;
	  }

	  const outerWidth = Math.max(
	    1,
	    (oval && isOval ? (oval.rx * 2) : (oval?.width || BASE_W)) || BASE_W
	  );
	  const outerHeight = Math.max(
	    1,
	    (oval && isOval ? (oval.ry * 2) : (oval?.height || BASE_H)) || BASE_H
	  );
	  const innerWidth = bleedClipState.innerWidth;
	  const innerHeight = bleedClipState.innerHeight;

	  const scaleX = outerWidth / innerWidth;
	  const scaleY = outerHeight / innerHeight;
	  let scale = Math.sqrt(scaleX * scaleY);
	  if (!Number.isFinite(scale) || scale <= 0) scale = 1;
	  const maxScaleX = BASE_W / innerWidth;
	  const maxScaleY = BASE_H / innerHeight;
	  if (Number.isFinite(maxScaleX) && maxScaleX > 0) scale = Math.min(scale, maxScaleX);
	  if (Number.isFinite(maxScaleY) && maxScaleY > 0) scale = Math.min(scale, maxScaleY);
	  scale = Math.max(1, Math.min(scale, 1.35));

	  const cx = bleedClipState.centerX * zoom;
	  const cy = bleedClipState.centerY * zoom;
	  const rx = Math.max(0, (innerWidth / 2) * zoom);
	  const ry = Math.max(0, (innerHeight / 2) * zoom);

	  wrap.style.willChange = 'transform';
	  wrap.style.transformOrigin = `${cx}px ${cy}px`;
	  wrap.style.transform = scale === 1 ? '' : `scale(${scale})`;

	  let clip = '';
	  if (bleedClipState.type === 'ellipse') {
	    clip = `ellipse(${rx}px ${ry}px at ${cx}px ${cy}px)`;
	  } else if (bleedClipState.type === 'rect') {
	    const canvasW = canvas.getWidth();
	    const canvasH = canvas.getHeight();
	    const left = cx - rx;
	    const top = cy - ry;
	    const right = canvasW - (cx + rx);
	    const bottom = canvasH - (cy + ry);
	    const safeInset = (value) =>
	      Math.max(0, Number.isFinite(value) ? value : 0);
	    clip = `inset(${safeInset(top)}px ${safeInset(right)}px ${safeInset(bottom)}px ${safeInset(left)}px)`;
	  }

	  if (clip) {
	    wrap.style.clipPath = clip;
	    wrap.style.webkitClipPath = clip;
	    if (trimViewport) {
	      const visibleTop = Math.max(0, cy - (ry * scale));
	      const visibleHeight = Math.min(
	        canvas.getHeight(),
	        Math.max(1, innerHeight * zoom * scale)
	      );
	      wrap.style.setProperty('--nh-live-trim-offset-y', `${-visibleTop}px`);
	      trimViewport.style.setProperty('--nh-live-trim-visible-height', `${visibleHeight}px`);
	      trimViewport.dataset.trimReady = 'true';
	    }
	  } else {
	    wrap.style.clipPath = '';
	    wrap.style.webkitClipPath = '';
	    wrap.style.removeProperty('--nh-live-trim-offset-y');
	    if (trimViewport) {
	      trimViewport.style.removeProperty('--nh-live-trim-visible-height');
	      delete trimViewport.dataset.trimReady;
	    }
	  }
	}

function resetBleedClipState() {
  bleedClipState.type = null;
  bleedClipState.innerWidth = 0;
  bleedClipState.innerHeight = 0;
  bleedClipState.centerX = 0;
  bleedClipState.centerY = 0;
  bleedClipState.ready = false;
}

function updateBleedClipState(next) {
  const EPS = 0.01;
  const changed =
    bleedClipState.type !== next.type ||
    Math.abs(bleedClipState.innerWidth - next.innerWidth) > EPS ||
    Math.abs(bleedClipState.innerHeight - next.innerHeight) > EPS ||
    Math.abs(bleedClipState.centerX - next.centerX) > EPS ||
    Math.abs(bleedClipState.centerY - next.centerY) > EPS ||
    !bleedClipState.ready;

  bleedClipState.type = next.type;
  bleedClipState.innerWidth = next.innerWidth;
  bleedClipState.innerHeight = next.innerHeight;
  bleedClipState.centerX = next.centerX;
  bleedClipState.centerY = next.centerY;
  bleedClipState.ready = true;
  return changed;
}

function createBleedClipPath() {
  if (!bleedClipState.ready || !(window.fabric && fabric.Object)) return null;

  const base = {
    originX: 'center',
    originY: 'center',
    left: bleedClipState.centerX,
    top: bleedClipState.centerY,
    absolutePositioned: true,
    evented: false
  };

  let clip = null;
  if (bleedClipState.type === 'ellipse') {
    clip = new fabric.Ellipse({
      ...base,
      rx: bleedClipState.innerWidth / 2,
      ry: bleedClipState.innerHeight / 2
    });
  } else if (bleedClipState.type === 'rect') {
    clip = new fabric.Rect({
      ...base,
      width: bleedClipState.innerWidth,
      height: bleedClipState.innerHeight
    });
  }

  if (clip) {
    clip._bleedClip = true;
  }
  return clip;
}

function shouldApplyBleedClip(obj) {
  if (!obj) return false;
  if (obj._helperUI || obj._isBackground) return false;
  if (obj.type === 'activeSelection') return false;
  if (obj.clipPath && !obj.clipPath._bleedClip) return false;
  return true;
}

function clearBleedClipFromObject(obj) {
  if (obj?.clipPath && obj.clipPath._bleedClip) {
    obj.clipPath = null;
    obj.dirty = true;
    obj.setCoords?.();
  }
}

function applyBleedClipToObject(obj) {
  if (!shouldApplyBleedClip(obj)) return;

  if (!bleedClipState.ready) {
    clearBleedClipFromObject(obj);
    return;
  }

  const existing = obj.clipPath;
  if (existing && existing._bleedClip) {
    existing.set({
      left: bleedClipState.centerX,
      top: bleedClipState.centerY,
      originX: 'center',
      originY: 'center',
      absolutePositioned: true
    });
    if (existing.type === 'ellipse' && bleedClipState.type === 'ellipse') {
      existing.set({
        rx: bleedClipState.innerWidth / 2,
        ry: bleedClipState.innerHeight / 2
      });
      existing.setCoords?.();
      obj.dirty = true;
      return;
    }
    if (existing.type === 'rect' && bleedClipState.type === 'rect') {
      existing.set({
        width: bleedClipState.innerWidth,
        height: bleedClipState.innerHeight
      });
      existing.setCoords?.();
      obj.dirty = true;
      return;
    }
    clearBleedClipFromObject(obj);
  }

  const clip = createBleedClipPath();
  if (clip) {
    obj.clipPath = clip;
    obj.dirty = true;
    obj.setCoords?.();
  }
}

function clearBleedClipFromAll() {
  if (!canvas || typeof canvas.getObjects !== 'function') return;
  canvas.getObjects().forEach(clearBleedClipFromObject);
}

function applyBleedClipToAllObjects() {
  if (!canvas || typeof canvas.getObjects !== 'function') return;
  canvas.getObjects().forEach(applyBleedClipToObject);
}

function resetGuideHelpers() {
  const allHelpers = canvas.getObjects().filter(o => o?._helperUI);
  allHelpers.forEach(obj => {
    if (!obj) return;
    canvas.remove(obj);
  });

  centerGuides.vertical = null;
  centerGuides.horizontal = null;
  bleedGuide.frame = null;
  bleedGuide.icon = null;
}

function createGuideProps() {
  return {
    stroke: '#16a34a',
    strokeWidth: 0.8,
    strokeDashArray: null,
    selectable: false,
    evented: false,
    excludeFromExport: true,
    _helperUI: true,
    visible: true,
    opacity: 0
  };
}

function getCanvasCenterPoint() {
  const { w, h } = getLogicalSize();
  let centerX = w / 2;
  let centerY = h / 2;
  if (oval && typeof oval.getCenterPoint === 'function') {
    const shapeCenter = oval.getCenterPoint();
    if (shapeCenter && Number.isFinite(shapeCenter.x) && Number.isFinite(shapeCenter.y)) {
      centerX = shapeCenter.x;
      centerY = shapeCenter.y;
    }
  }
  return { x: centerX, y: centerY };
}

function ensureCenterGuides() {
  const { w, h } = getLogicalSize();
  const { x: centerX, y: centerY } = getCanvasCenterPoint();
 if (!centerGuides.vertical) {
    centerGuides.vertical = new fabric.Line([centerX, 0, centerX, h], createGuideProps());
    canvas.add(centerGuides.vertical);
  }

  if (!centerGuides.horizontal) {
    centerGuides.horizontal = new fabric.Line([0, centerY, w, centerY], createGuideProps());
    canvas.add(centerGuides.horizontal);
  }

  centerGuides.vertical.set({ x1: centerX, y1: 0, x2: centerX, y2: h });
  centerGuides.horizontal.set({ x1: 0, y1: centerY, x2: w, y2: centerY });

  [centerGuides.vertical, centerGuides.horizontal].forEach(line => {
    if (typeof line.setCoords === 'function') line.setCoords();
  });

  return { centerX, centerY };
}

function setGuideVisibility(showVertical, showHorizontal) {
  if (centerGuides.vertical) {
    centerGuides.vertical.set({ visible: !!showVertical, opacity: showVertical ? 1 : 0 });
    if (showVertical && typeof canvas.bringToFront === 'function') {
      canvas.bringToFront(centerGuides.vertical);
    }
  }

  if (centerGuides.horizontal) {
    centerGuides.horizontal.set({ visible: !!showHorizontal, opacity: showHorizontal ? 1 : 0 });
    if (showHorizontal && typeof canvas.bringToFront === 'function') {
      canvas.bringToFront(centerGuides.horizontal);
    }
  }
}

function hideCenterGuides() {
  setGuideVisibility(false, false);
}

	function ensureBleedGuide() {
	  const { w, h } = getLogicalSize();
	  if (!Number.isFinite(w) || !Number.isFinite(h) || w <= 0 || h <= 0) return;

  const marginLimit = Math.max(w, h) * 0.12;
  const margin = Math.max(4, Math.min(BLEED_MARGIN_PX, marginLimit));
  const center = getCanvasCenterPoint();
  const innerWidth = Math.max(0, (oval && isOval ? (oval.rx * 2) : (oval?.width || w)) - margin * 2);
  const innerHeight = Math.max(0, (oval && isOval ? (oval.ry * 2) : (oval?.height || h)) - margin * 2);
	  if (innerWidth <= 0 || innerHeight <= 0) {
	    const hadClip = bleedClipState.ready;
	    resetBleedClipState();
	    if (hadClip) clearBleedClipFromAll();
	    updateLiveTrimView();
	    return;
	  }

  const desiredType = isOval ? 'ellipse' : 'rect';

  if (!bleedGuide.frame || bleedGuide.frame.type !== desiredType) {
    if (bleedGuide.frame) canvas.remove(bleedGuide.frame);
    bleedGuide.frame = (desiredType === 'ellipse')
      ? new fabric.Ellipse({
          fill: '',
          stroke: BLEED_COLOR,
          strokeWidth: 0.8,
          strokeDashArray: [10, 6],
          originX: 'center',
          originY: 'center',
          selectable: false,
          evented: false,
          excludeFromExport: true,
          _helperUI: true,
          // initial unsichtbar
          visible: false,
          opacity: 0,
          strokeUniform: true
        })
      : new fabric.Rect({
          fill: '',
          stroke: BLEED_COLOR,
          strokeWidth: 0.8,
          strokeDashArray: [10, 6],
          originX: 'center',
          originY: 'center',
          selectable: false,
          evented: false,
          excludeFromExport: true,
          _helperUI: true,
          // initial unsichtbar
          visible: false,
          opacity: 0,
          strokeUniform: true
        });
    canvas.add(bleedGuide.frame);
  }

  if (bleedGuide.frame.type === 'ellipse') {
    bleedGuide.frame.set({
      rx: innerWidth / 2,
      ry: innerHeight / 2,
      left: center.x,
      top: center.y
    });
  } else {
    bleedGuide.frame.set({
      width: innerWidth,
      height: innerHeight,
      left: center.x,
      top: center.y
    });
  }
  if (typeof bleedGuide.frame.setCoords === 'function') bleedGuide.frame.setCoords();

  const topEdge = center.y - (innerHeight / 2);
  const rightEdge = center.x + (innerWidth / 2);
  const iconTop = topEdge - BLEED_ICON_OFFSET;
  const iconLeft = rightEdge - BLEED_ICON_OFFSET;

  if (!bleedGuide.icon) {
    bleedGuide.icon = new fabric.Text('✂', {
      fontSize: 18,
      fill: BLEED_COLOR,
      fontFamily: 'Inter',
      selectable: false,
      evented: false,
      originX: 'center',
      originY: 'center',
      excludeFromExport: true,
      _helperUI: true,
      // initial unsichtbar
      visible: false,
      opacity: 0
    });
    canvas.add(bleedGuide.icon);
  }

  bleedGuide.icon.set({ left: iconLeft, top: iconTop });
  if (typeof bleedGuide.icon.setCoords === 'function') bleedGuide.icon.setCoords();

  canvas.bringToFront(bleedGuide.frame);
  canvas.bringToFront(bleedGuide.icon);

  const clipChanged = updateBleedClipState({
    type: desiredType,
    innerWidth,
    innerHeight,
    centerX: center.x,
    centerY: center.y
  });
	  if (clipChanged) {
	    applyBleedClipToAllObjects();
	    canvas.requestRenderAll();
	  }
	  updateLiveTrimView();
	}

	function showBleedGuide() {
	  if (LIVE_TRIM_CANVAS_VIEW) {
	    hideBleedGuide();
	    return;
	  }
	  ensureBleedGuide();
	  if (bleedGuide.frame) bleedGuide.frame.set({ visible: true, opacity: 1 });
	  if (bleedGuide.icon) bleedGuide.icon.set({ visible: true, opacity: 1 });
	  if (bleedGuide.frame) canvas.bringToFront(bleedGuide.frame);
  if (bleedGuide.icon) canvas.bringToFront(bleedGuide.icon);
}

function hideBleedGuide() {
  if (bleedGuide.frame) bleedGuide.frame.set({ visible: false, opacity: 0 });
  if (bleedGuide.icon) bleedGuide.icon.set({ visible: false, opacity: 0 });
}

hideBleedGuide();

canvas.on('object:added', function (evt) {
  const target = evt?.target;
  if (!target) return;

  applyBleedClipToObject(target);

  const helperTargets = [centerGuides.vertical, centerGuides.horizontal, bleedGuide.frame, bleedGuide.icon];
  if (helperTargets.includes(target)) return;
  if (historyService?.isRestoring?.()) {
    hideCenterGuides();
    hideBleedGuide();
    return;
  }

  if (target._isQr || target._qrPart) {
    hideCenterGuides();
    hideBleedGuide();
    return;
  }

  if (target._isBackground) {
    ensureBleedGuide();
    hideBleedGuide();
    return;
  }
  ensureCenterGuides();
  hideCenterGuides();
  ensureBleedGuide();
  hideBleedGuide();
});

canvas.on('object:moving', function (e) {
  const obj = e?.target;
  if (!obj || obj._helperUI || e?.e?.shiftKey) {
    hideCenterGuides();
    hideBleedGuide();
    canvas.requestRenderAll();
    return;
  }

  const { centerX, centerY } = ensureCenterGuides();
  const centerPoint = obj.getCenterPoint ? obj.getCenterPoint() : null;
  if (!centerPoint) {
    hideCenterGuides();
    return;
  }

  let deltaX = 0;
  let deltaY = 0;
  let snappedX = false;
  let snappedY = false;

  if (Math.abs(centerPoint.x - centerX) <= SNAP_THRESHOLD) {
    deltaX = centerX - centerPoint.x;
    snappedX = true;
  }

  if (Math.abs(centerPoint.y - centerY) <= SNAP_THRESHOLD) {
    deltaY = centerY - centerPoint.y;
    snappedY = true;
  }

  if (deltaX || deltaY) {
    obj.setPositionByOrigin({ x: centerPoint.x + deltaX, y: centerPoint.y + deltaY }, 'center', 'center');
    if (typeof obj.setCoords === 'function') obj.setCoords();
  }

  setGuideVisibility(snappedX, snappedY);
  if (!obj._helperUI) showBleedGuide();
  canvas.requestRenderAll();
});

canvas.on('object:scaling', function (e) {
  const obj = e?.target;
  if (!obj || obj._helperUI) {
    hideBleedGuide();
    return;
  }
  showBleedGuide();
});

canvas.on('object:scaled', function () {
  hideBleedGuide();
});

canvas.on('object:modified', function () {
  ensureCenterGuides();
  hideCenterGuides();
  hideBleedGuide();
  canvas.requestRenderAll();
});

canvas.on('mouse:up', () => {
  ensureCenterGuides();
  hideCenterGuides();
  hideBleedGuide();
  canvas.requestRenderAll();
  updateRemoveButtonState();
});
canvas.on('selection:created', () => {
  syncSocialColorInput({ focus: true });
  syncSocialSizeControl();
});
canvas.on('selection:updated', () => {
  syncSocialColorInput({ focus: true });
  syncSocialSizeControl();
});
canvas.on('selection:cleared', () => {
  syncSocialColorInput();
  syncSocialSizeControl();
});
canvas.on('mouse:up', () => {
  syncSocialColorInput();
  syncSocialSizeControl();
});
canvas.on('text:editing:entered', () => {
  syncSocialColorInput({ focus: true });
  syncSocialSizeControl();
});

canvas.on('selection:created', syncOpacityControl);
canvas.on('selection:updated', syncOpacityControl);
canvas.on('selection:cleared', syncOpacityControl);
canvas.on('object:removed', syncOpacityControl);


function getActiveTargets() {
  const active = typeof canvas.getActiveObject === 'function' ? canvas.getActiveObject() : null;
  if (!active) return [];
  if (active.type === 'activeSelection') {
    const items = typeof active.getObjects === 'function'
      ? active.getObjects()
      : (Array.isArray(active._objects) ? active._objects : []);
    return [...items].filter(Boolean);
  }
  return [active];
}

function updateRemoveButtonState() {
  if (!removeBtn) return;
  removeBtn.disabled = !getActiveTargets().some(canRemoveObject);
}

canvas.on('selection:created', updateRemoveButtonState);
canvas.on('selection:updated', updateRemoveButtonState);
canvas.on('selection:cleared', updateRemoveButtonState);
canvas.on('object:removed', updateRemoveButtonState);
canvas.on('object:added', updateRemoveButtonState);

function removeActiveSelection() {
  const targets = getActiveTargets().filter(canRemoveObject);
  if (!targets.length) return false;
  historyService.flush();
  historyService.withoutRecording(() => {
    // Ungroup the temporary selection before removing its actual canvas objects.
    canvas.discardActiveObject();
    targets.forEach((target) => {
      if (target._isQr || target._qrPart) {
        removeQrTarget(target, { skipResync: true });
      } else if (target === textTop || target === textBottom) {
        const input = document.getElementById(target === textTop ? 'title-input' : 'slogan-input');
        if (input) input.value = '';
        target.set({ text: '', visible: false });
        target._clearCache?.();
        target.initDimensions?.();
        target.setCoords?.();
      } else {
        canvas.remove(target);
      }
    });
  });
  rebuildDynamicTextInputs();
  resyncQrStateFromCanvas();
  refreshLayerList?.();
  syncOpacityControl?.();
  syncImageEditButton?.();
  canvas.requestRenderAll();
  updateRemoveButtonState();
  pushHistory(targets.length > 1 ? 'Elemente entfernt' : 'Element entfernt', { immediate: true });
  return true;
}

// The toolbar listener above is deliberately the only delete click listener.

function centerTextObject(obj) {
  if (!obj || obj.type !== 'i-text') return;
  const centerX = (window.oval && window.oval.left) || (canvas.getWidth() / 2);
  obj.set({
    originX: 'center',
    left: centerX,
    textAlign: 'center'
  });
  if (typeof obj._clearCache === 'function') obj._clearCache();
  if (typeof obj.initDimensions === 'function') obj.initDimensions();
  if (typeof obj.setCoords === 'function') obj.setCoords();
}

textTop.on('changed', () => {
  const el = document.getElementById('title-input');
  if (el && el !== document.activeElement) el.value = textTop.text;
});
textBottom.on('changed', () => {
  const el = document.getElementById('slogan-input');
  if (el && el !== document.activeElement) el.value = textBottom.text;
});

async function addJsPdfFont(doc, url, vfsName, family, style) {
  const buf = await loadFontBinary(url);
  const b64 = arrayBufferToBase64(buf);
  doc.addFileToVFS(vfsName, b64);
  doc.addFont(vfsName, family, style); // style: normal|italic|bold|bolditalic
}

const LOCAL_FONT_MAP = {
  'Playfair Display': {
    normal: {
      400: [
        'playfair-display-400-normal.woff2',
        'PlayfairDisplay[wght].ttf',
      ],
      700: [
        'playfair-display-700-normal.woff2',
        'PlayfairDisplay[wght].ttf',
      ],
    },
    italic: {
      400: [
        'playfair-display-400-italic.woff2',
        'PlayfairDisplay-Italic[wght].ttf',
      ],
      700: [
        'playfair-display-700-italic.woff2',
        'PlayfairDisplay-Italic[wght].ttf',
      ],
    },
  },
  'Inter': {
    normal: {
      400: [
        'inter-400-normal.woff2',
        'Inter[opsz,wght].ttf',
      ],
      700: [
        'inter-700-normal.woff2',
        'Inter[opsz,wght].ttf',
      ],
    },
    italic: {
      400: [
        'inter-400-italic.woff2',
        'Inter-Italic[opsz,wght].ttf',
      ],
      700: [
        'inter-700-italic.woff2',
        'Inter-Italic[opsz,wght].ttf',
      ],
    },
  },
  'Roboto Slab': {
    normal: {
      400: [
        'roboto-slab-400-normal.woff2',
        'RobotoSlab[wght].ttf',
      ],
      700: [
        'roboto-slab-700-normal.woff2',
        'RobotoSlab[wght].ttf',
      ],
    },
  },
  'Open Sans': {
    normal: {
      400: [
        'open-sans-400-normal.woff2',
        'OpenSans[wdth,wght].ttf',
      ],
      700: [
        'open-sans-700-normal.woff2',
        'OpenSans[wdth,wght].ttf',
      ],
    },
    italic: {
      400: [
        'open-sans-400-italic.woff2',
        'OpenSans-Italic[wdth,wght].ttf',
      ],
      700: [
        'open-sans-700-italic.woff2',
        'OpenSans-Italic[wdth,wght].ttf',
      ],
    },
  },
  'Oswald': {
    normal: {
      400: [
        'oswald-400-normal.woff2',
        'Oswald[wght].ttf',
      ],
      700: [
        'oswald-700-normal.woff2',
        'Oswald[wght].ttf',
      ],
    },
  },
  'Pacifico': {
    normal: {
      400: [
        'pacifico-400-normal.woff2',
        'Pacifico-Regular.ttf',
      ],
    },
  },
  'Lobster': {
    normal: {
      400: [
        'lobster-400-normal.woff2',
        'Lobster-Regular.ttf',
      ],
    },
  },
  'Source Code Pro': {
    normal: {
      400: [
        'source-code-pro-400-normal.woff2',
        'SourceCodePro[wght].ttf',
      ],
      700: [
        'source-code-pro-700-normal.woff2',
        'SourceCodePro[wght].ttf',
      ],
    },
    italic: {
      400: [
        'source-code-pro-400-italic.woff2',
        'SourceCodePro-Italic[wght].ttf',
      ],
      700: [
        'source-code-pro-700-italic.woff2',
        'SourceCodePro-Italic[wght].ttf',
      ],
    },
  },
  'Bebas Neue': {
    normal: {
      400: [
        'bebas-neue-400-normal.woff2',
        'BebasNeue-Regular.ttf',
      ],
    },
  },
  'Quicksand': {
    normal: {
      400: [
        'quicksand-400-normal.woff2',
        'Quicksand[wght].ttf',
      ],
      700: [
        'quicksand-700-normal.woff2',
        'Quicksand[wght].ttf',
      ],
    },
  },
  'Shadows Into Light': {
    normal: {
      400: [
        'shadows-into-light-400-normal.woff2',
        'ShadowsIntoLight.ttf',
      ],
    },
  },
  'Great Vibes': {
    normal: {
      400: [
        'great-vibes-400-normal.woff2',
        'GreatVibes-Regular.ttf',
      ],
    },
  },
  'Abril Fatface': {
    normal: {
      400: [
        'abril-fatface-400-normal.woff2',
        'AbrilFatface-Regular.ttf',
      ],
    },
  },
  'Amatic SC': {
    normal: {
      400: [
        'amatic-sc-400-normal.woff2',
        'AmaticSC-Regular.ttf',
      ],
      700: [
        'amatic-sc-700-normal.woff2',
        'AmaticSC-Bold.ttf',
      ],
    },
  },
  'Permanent Marker': {
    normal: {
      400: [
        'permanent-marker-400-normal.woff2',
        'PermanentMarker-Regular.ttf',
      ],
    },
  },
};
window.LOCAL_FONT_MAP = LOCAL_FONT_MAP;

const FONT_SOURCE_BASE = 'https://cdn.jsdelivr.net/npm/@fontsource';

const PDF_FONT_FALLBACKS = {
  'Playfair Display': {
    normal: {
      400: `${FONT_SOURCE_BASE}/playfair-display@latest/files/playfair-display-latin-400-normal.ttf`,
      700: `${FONT_SOURCE_BASE}/playfair-display@latest/files/playfair-display-latin-700-normal.ttf`,
    },
    italic: {
      400: `${FONT_SOURCE_BASE}/playfair-display@latest/files/playfair-display-latin-400-italic.ttf`,
      700: `${FONT_SOURCE_BASE}/playfair-display@latest/files/playfair-display-latin-700-italic.ttf`,
    },
  },
  'Inter': {
    normal: {
      400: `${FONT_SOURCE_BASE}/inter@latest/files/inter-latin-400-normal.ttf`,
      700: `${FONT_SOURCE_BASE}/inter@latest/files/inter-latin-700-normal.ttf`,
    },
    italic: {
      400: `${FONT_SOURCE_BASE}/inter@latest/files/inter-latin-400-italic.ttf`,
      700: `${FONT_SOURCE_BASE}/inter@latest/files/inter-latin-700-italic.ttf`,
    },
  },
  'Roboto Slab': {
    normal: {
      400: `${FONT_SOURCE_BASE}/roboto-slab@latest/files/roboto-slab-latin-400-normal.ttf`,
      700: `${FONT_SOURCE_BASE}/roboto-slab@latest/files/roboto-slab-latin-700-normal.ttf`,
    },
  },
  'Open Sans': {
    normal: {
      400: `${FONT_SOURCE_BASE}/open-sans@latest/files/open-sans-latin-400-normal.ttf`,
      700: `${FONT_SOURCE_BASE}/open-sans@latest/files/open-sans-latin-700-normal.ttf`,
    },
    italic: {
      400: `${FONT_SOURCE_BASE}/open-sans@latest/files/open-sans-latin-400-italic.ttf`,
      700: `${FONT_SOURCE_BASE}/open-sans@latest/files/open-sans-latin-700-italic.ttf`,
    },
  },
  'Oswald': {
    normal: {
      400: `${FONT_SOURCE_BASE}/oswald@latest/files/oswald-latin-400-normal.ttf`,
      700: `${FONT_SOURCE_BASE}/oswald@latest/files/oswald-latin-700-normal.ttf`,
    },
  },
  'Pacifico': {
    normal: {
      400: `${FONT_SOURCE_BASE}/pacifico@latest/files/pacifico-latin-400-normal.ttf`,
    },
  },
  'Lobster': {
    normal: {
      400: `${FONT_SOURCE_BASE}/lobster@latest/files/lobster-latin-400-normal.ttf`,
    },
  },
  'Source Code Pro': {
    normal: {
      400: `${FONT_SOURCE_BASE}/source-code-pro@latest/files/source-code-pro-latin-400-normal.ttf`,
      700: `${FONT_SOURCE_BASE}/source-code-pro@latest/files/source-code-pro-latin-700-normal.ttf`,
    },
    italic: {
      400: `${FONT_SOURCE_BASE}/source-code-pro@latest/files/source-code-pro-latin-400-italic.ttf`,
      700: `${FONT_SOURCE_BASE}/source-code-pro@latest/files/source-code-pro-latin-700-italic.ttf`,
    },
  },
  'Bebas Neue': {
    normal: {
      400: `${FONT_SOURCE_BASE}/bebas-neue@latest/files/bebas-neue-latin-400-normal.ttf`,
    },
  },
  'Quicksand': {
    normal: {
      400: `${FONT_SOURCE_BASE}/quicksand@latest/files/quicksand-latin-400-normal.ttf`,
      700: `${FONT_SOURCE_BASE}/quicksand@latest/files/quicksand-latin-700-normal.ttf`,
    },
  },
  'Shadows Into Light': {
    normal: {
      400: `${FONT_SOURCE_BASE}/shadows-into-light@latest/files/shadows-into-light-latin-400-normal.ttf`,
    },
  },
  'Great Vibes': {
    normal: {
      400: `${FONT_SOURCE_BASE}/great-vibes@latest/files/great-vibes-latin-400-normal.ttf`,
    },
  },
  'Abril Fatface': {
    normal: {
      400: `${FONT_SOURCE_BASE}/abril-fatface@latest/files/abril-fatface-latin-400-normal.ttf`,
    },
  },
  'Amatic SC': {
    normal: {
      400: `${FONT_SOURCE_BASE}/amatic-sc@latest/files/amatic-sc-latin-400-normal.ttf`,
      700: `${FONT_SOURCE_BASE}/amatic-sc@latest/files/amatic-sc-latin-700-normal.ttf`,
    },
  },
  'Permanent Marker': {
    normal: {
      400: `${FONT_SOURCE_BASE}/permanent-marker@latest/files/permanent-marker-latin-400-normal.ttf`,
    },
  },
};

const PDF_FONT_FILES = buildPdfFontSources(LOCAL_FONT_MAP, PDF_FONT_FALLBACKS);

function resolveAssetUrl(src) {
  if (!src) return src;
  const assetMap = window.__NH_ASSET_URLS || {};
  const candidates = [];
  const pushCandidate = (value) => {
    if (!value) return;
    candidates.push(value);
    const trimmed = value.split('/').pop();
    if (trimmed && trimmed !== value) candidates.push(trimmed);
  };
  pushCandidate(src);
  pushCandidate(canonicalizeFontKey(src));
  for (const key of candidates) {
    if (key && assetMap[key]) {
      return assetMap[key];
    }
  }
  try {
    return new URL(src, window.location.href).href;
  } catch (err) {
    return src;
  }
}

function arrayBufferToBase64(buf) {
  let binary = '';
  const bytes = new Uint8Array(buf || []);
  const chunk = 0x8000; // 32k
  for (let i = 0; i < bytes.length; i += chunk) {
    binary += String.fromCharCode.apply(null, bytes.subarray(i, i + chunk));
  }
  return btoa(binary);
}

function describeFontSource(src) {
  const lower = String(src || '').toLowerCase();
  if (lower.includes('.woff2')) return { mime: 'font/woff2', format: 'woff2' };
  if (lower.includes('.woff')) return { mime: 'font/woff', format: 'woff' };
  if (lower.includes('.otf')) return { mime: 'font/otf', format: 'opentype' };
  return { mime: 'font/ttf', format: 'truetype' };
}

function canonicalizeFontKey(value) {
  if (!value) return null;
  let key = String(value).replace(/\\+/g, '/');
  const match = key.match(/fonts\/custom\/.+$/i);
  if (match) key = match[0];
  key = key.replace(/^\.\//, '');
  key = key.replace(/^\//, '');
  return key;
}

function lookupEmbeddedFontData(src) {
  const inline = window.LOCAL_FONT_DATA || {};
  if (!Object.keys(inline).length) return null;

  const candidates = [];
  const push = (value) => {
    if (!value) return;
    candidates.push(value);
    candidates.push(value.toLowerCase());
    const canon = canonicalizeFontKey(value);
    if (canon) {
      candidates.push(canon);
      candidates.push(canon.toLowerCase());
    }
  };

  push(src);
  const resolved = resolveAssetUrl(src);
  push(resolved);

  try {
    const urlObj = new URL(resolved);
    push(urlObj.pathname);
  } catch (err) {}

  if (resolved && resolved.startsWith('file://')) {
    push(resolved.replace('file://', ''));
  }

  for (const candidate of candidates) {
    if (candidate && inline[candidate]) {
      return inline[candidate];
    }
  }
  return null;
}

function dataUriToArrayBuffer(dataUri) {
  if (!dataUri || typeof dataUri !== 'string') return null;
  const match = dataUri.match(/base64,([A-Za-z0-9+/=]+)$/);
  if (!match) return null;
  const base64 = match[1];
  const binary = atob(base64);
  const len = binary.length;
  const bytes = new Uint8Array(len);
  for (let i = 0; i < len; i += 1) {
    bytes[i] = binary.charCodeAt(i);
  }
  return bytes.buffer;
}

async function loadFontBinary(src) {
  const resolved = resolveAssetUrl(src);
  if (!resolved) throw new Error('Font source missing');

  const embedded = lookupEmbeddedFontData(src) || lookupEmbeddedFontData(resolved);
  if (embedded) {
    const ab = dataUriToArrayBuffer(embedded);
    if (ab) return ab;
  }

  try {
    const response = await fetch(resolved, { cache: 'force-cache' });
    if (!response.ok) throw new Error(`Status ${response.status}`);
    return await response.arrayBuffer();
  } catch (err) {
    const isFileProtocol = resolved.startsWith('file://') || window.location.protocol === 'file:';
    if (!isFileProtocol) throw err;

    return await new Promise((resolve, reject) => {
      try {
        const xhr = new XMLHttpRequest();
        xhr.open('GET', resolved, true);
        xhr.responseType = 'arraybuffer';
        if (typeof xhr.overrideMimeType === 'function') {
          xhr.overrideMimeType('application/octet-stream');
        }
        xhr.onload = function () {
          const status = xhr.status;
          if (status === 0 || (status >= 200 && status < 300)) {
            resolve(xhr.response);
          } else {
            reject(new Error(`XHR status ${status}`));
          }
        };
        xhr.onerror = () => reject(new Error('XHR network error while loading font.'));
        xhr.ontimeout = () => reject(new Error('XHR timeout while loading font.'));
        xhr.send();
      } catch (xhrErr) {
        reject(xhrErr);
      }
    });
  }
}

function fontSourcePriority(src) {
  const lower = String(src || '').toLowerCase();
  if (/\.(ttf|otf)(\?|$)/.test(lower)) return 0;
  if (/\.(woff2?)(\?|$)/.test(lower)) return 1;
  return 2;
}

function buildPdfFontSources(localMap = {}, fallbackMap = {}) {
  const result = {};
  const families = new Set([
    ...Object.keys(localMap || {}),
    ...Object.keys(fallbackMap || {}),
  ]);

  families.forEach(family => {
    const localEntry = localMap[family] || {};
    const fallbackEntry = fallbackMap[family] || {};
    const styles = new Set([
      ...Object.keys(localEntry),
      ...Object.keys(fallbackEntry),
    ]);

    styles.forEach(style => {
      const localStyle = localEntry[style] || {};
      const fallbackStyle = fallbackEntry[style] || {};
      const weights = new Set([
        ...Object.keys(localStyle),
        ...Object.keys(fallbackStyle),
      ]);

      weights.forEach(weight => {
        const sources = [];
        const localVal = localStyle[weight];
        if (Array.isArray(localVal)) sources.push(...localVal);
        else if (localVal) sources.push(localVal);

        const fallbackVal = fallbackStyle[weight];
        if (Array.isArray(fallbackVal)) sources.push(...fallbackVal);
        else if (fallbackVal) sources.push(fallbackVal);

        if (!sources.length) return;
        const unique = [];
        sources.forEach(src => {
          if (src && !unique.includes(src)) unique.push(src);
        });
        if (!unique.length) return;
        const ordered = unique.slice().sort((a, b) => fontSourcePriority(a) - fontSourcePriority(b));
        if (!result[family]) result[family] = {};
        if (!result[family][style]) result[family][style] = {};
        result[family][style][weight] = ordered;
      });
    });
  });

  return result;
}


async function registerFontsInJsPdf(doc, families = []) {
  const seen = new Set();
  const tasks = [];
  (families || []).forEach(family => {
    const entry = PDF_FONT_FILES[family];
    if (!entry) return;
    Object.entries(entry).forEach(([style, weights]) => {
      Object.entries(weights).forEach(([weight, value]) => {
        const sources = Array.isArray(value) ? value : value ? [value] : [];
        if (!sources.length) return;
        const key = `${family}|${style}|${weight}`;
        if (seen.has(key)) return;
        seen.add(key);
        const numericWeight = Number(weight) || 400;
        const jsPdfStyle =
          style === 'italic'
            ? (numericWeight >= 700 ? 'bolditalic' : 'italic')
            : (numericWeight >= 700 ? 'bold' : 'normal');
        const vfsName = `${family.replace(/[^a-z0-9]/gi,'')}-${style}-${weight}.ttf`;
        tasks.push((async () => {
          for (const src of sources) {
            try {
              await addJsPdfFont(doc, src, vfsName, family, jsPdfStyle);
              return;
            } catch (err) {
              console.warn(`PDF-Font konnte nicht geladen werden: ${family} ${style} ${weight} (${src})`, err);
            }
          }
          console.warn(`Falle auf Standard zurück: ${family} ${style} ${weight}`);
        })());
      });
    });
  });
  if (tasks.length) {
    await Promise.allSettled(tasks);
  }
}

// erzeugt @font-face mit **eingebetteter** Base64-WOFF2
async function embedGoogleFont(fontName, weights = ['400','700'], styles = ['normal','italic']) {
  const parts = [];
  const apiName = encodeURIComponent(fontName).replace(/%20/g, '+');

  for (const weight of weights) {
    for (const style of styles) {
      const ital = style === 'italic' ? 1 : 0;
      const cssUrl = `https://fonts.googleapis.com/css2?family=${apiName}:ital,wght@${ital},${weight}&display=swap`;
      try {
        const css = await fetch(cssUrl).then(r => r.text());
        const fontUrl = pickLatinWoff2(css);
        if (!fontUrl) continue;

        const bin = await fetch(fontUrl).then(r => r.arrayBuffer());
        const b64 = arrayBufferToBase64(bin);

        parts.push(
`@font-face{
  font-family:'${fontName}';
  font-style:${style};
  font-weight:${weight};
  src:url(data:font/woff2;base64,${b64}) format('woff2');
}`
        );
      } catch (e) {
        console.warn(`Einbetten fehlgeschlagen für ${fontName} ${style} ${weight}`, e);
      }
    }
  }
  return parts.join('\n');
}

async function embedFontFamily(family) {
  if (!family) return '';
  let css = '';

  if (typeof embedLocalFont === 'function') {
    css = await embedLocalFont(family);
  }

  if (css) return css;

  if (typeof embedGoogleFont === 'function') {
    return await embedGoogleFont(family);
  }

  return '';
}

window.buildSVGWithEmbeddedFonts = async function buildSVGWithEmbeddedFonts() {

  // ggf. Hilfsobjekte ausblenden (Preview frei machen)
  const toHide = canvas.getObjects().filter(o => o.excludeFromExport || o._helperUI);
  const prevVis = new Map();
  toHide.forEach(o => { prevVis.set(o, o.visible); o.visible = false; });
  canvas.discardActiveObject();
  canvas.requestRenderAll();

  // Fabric → SVG
  let svg = canvas.toSVG({ suppressPreamble: false });

  // Sichtbarkeit wiederherstellen
  toHide.forEach(o => o.visible = prevVis.get(o));
  canvas.requestRenderAll();

  // verwendete Schriften sammeln
  const fams = new Set();
  canvas.getObjects('i-text').forEach(o => {
    const fam = (o.fontFamily||'').split(',')[0].replace(/["']/g,'').trim();
    if (fam) fams.add(fam);
  });

  // @font-face als data:woff2 ins SVG einbetten
  let fontCSS = '';
  for (const fam of fams) {
    fontCSS += await embedFontFamily(fam);
  }

  if (fontCSS) {
    const inject = `<defs><style type="text/css"><![CDATA[\n${fontCSS}\n]]></style></defs>`;
    const i = svg.indexOf('>');
    if (i !== -1) svg = svg.slice(0, i+1) + inject + svg.slice(i+1);
  }
  return svg;
}
// ⬅️ HINZUFÜGEN (oberhalb von saveVectorPDF)
function ensureViewBoxOnSvg(svgText) {
  // width/height aus dem Wurzel-SVG holen
  const m = svgText.match(/<svg[^>]*\bwidth="([^"]+)"[^>]*\bheight="([^"]+)"/i);
  if (!m) return svgText;

  const w = parseFloat(m[1]);
  const h = parseFloat(m[2]);
  if (!isFinite(w) || !isFinite(h)) return svgText;

  // wenn schon viewBox vorhanden → nichts tun
  if (/viewBox="/i.test(svgText)) return svgText;

  // viewBox reinpatchen, knapp nach <svg ...>
  return svgText.replace(
    /<svg/i,
    `<svg viewBox="0 0 ${w} ${h}"`
  );
}

// ✅ Alle im Canvas verwendeten Schriftfamilien einsammeln
function collectUsedFontFamilies() {
  const fams = new Set();
  canvas.getObjects('i-text').forEach(o => {
    const fam = (o.fontFamily || '').split(',')[0].replace(/["']/g,'').trim();
    if (fam) fams.add(fam);
  });
  return fams;
}

async function fabricToSVGWithFonts(familiesToEmbed = []) {
  // Hilfsobjekte kurz ausblenden
  const toHide = canvas.getObjects().filter(o => o.excludeFromExport || o._helperUI);
  const prevVis = new Map();
  toHide.forEach(o => { prevVis.set(o, o.visible); o.visible = false; });
  canvas.discardActiveObject();
  canvas.requestRenderAll();

  // SVG aus Fabric ziehen
  let svg = canvas.toSVG({ suppressPreamble: false });

  // Sichtbarkeit zurück
  toHide.forEach(o => o.visible = prevVis.get(o));
  canvas.requestRenderAll();

  // 1) Fonts einbetten – lokal bevorzugt, sonst Fallback
  let fontCSS = '';
  for (const fam of familiesToEmbed) {
    fontCSS += await embedFontFamily(fam);
  }

  if (fontCSS) {
    const inject = `<defs><style type="text/css"><![CDATA[\n${fontCSS}\n]]></style></defs>`;
    const i = svg.indexOf('>');
    if (i !== -1) svg = svg.slice(0, i+1) + inject + svg.slice(i+1);
  }

  return svg;
}

function fixSvgImages(root){
    const XLINK = 'http://www.w3.org/1999/xlink';

    root.querySelectorAll('image').forEach(img=>{
      // href-Sicherheit: beides setzen
      const href = (img.getAttributeNS && img.getAttributeNS(XLINK,'href')) || img.getAttribute('href');
      if (href){
        if (img.setAttributeNS) img.setAttributeNS(XLINK,'href', href);
        img.setAttribute('href', href);
      }

      // Prozentangaben in absolute Zahlen umrechnen (svg2pdf mag keine %)
      const vb = root.viewBox && root.viewBox.baseVal;
      const vbW = vb?.width  || parseFloat(root.getAttribute('width'))  || 0;
      const vbH = vb?.height || parseFloat(root.getAttribute('height')) || 0;

      ['x','y','width','height'].forEach(attr=>{
        const v = img.getAttribute(attr);
        if (v && /%$/.test(v)){
          const p = parseFloat(v) / 100;
          const base = (attr==='x' || attr==='width') ? vbW : vbH;
          const abs = p * base;
          if (isFinite(abs)) img.setAttribute(attr, String(abs));
        }
      });

      if (!img.hasAttribute('preserveAspectRatio')) {
        img.setAttribute('preserveAspectRatio','xMidYMid meet');
      }
    });
  }
// Mobile-Erkennung
const __IS_IOS = /iP(ad|hone|od)/i.test(navigator.userAgent);
const __IS_ANDROID = /Android/i.test(navigator.userAgent);
const __IS_MOBILE = __IS_IOS || __IS_ANDROID;

// jsPDF-Blob sicher erzeugen (manche Engines zicken bei 'blob')
function jsPdfOutputBlobSafe(doc){
  try {
    const b = doc.output('blob');
    if (b && typeof Blob !== 'undefined' && b instanceof Blob) return b;
  } catch (e) {}
  const ab = doc.output('arraybuffer');
  return new Blob([ab], { type: 'application/pdf' });
}

function normalizeExportBounds(rect) {
  if (!rect || typeof rect !== 'object') {
    return { left: 0, top: 0, width: 0, height: 0 };
  }
  const left = Number(rect.left);
  const top = Number(rect.top);
  const width = Number(rect.width);
  const height = Number(rect.height);
  return {
    left: Number.isFinite(left) ? left : 0,
    top: Number.isFinite(top) ? top : 0,
    width: Number.isFinite(width) ? Math.max(0, width) : 0,
    height: Number.isFinite(height) ? Math.max(0, height) : 0
  };
}

function expandExportBounds(rect, padding = 0) {
  const base = normalizeExportBounds(rect);

  let padX = 0;
  let padY = 0;

  if (typeof padding === 'number') {
    const pad = Math.max(0, Number(padding) || 0);
    padX = padY = pad;
  } else if (padding && typeof padding === 'object') {
    const rawX = Number(padding.x ?? padding.padX ?? padding.horizontal);
    const rawY = Number(padding.y ?? padding.padY ?? padding.vertical);
    padX = Number.isFinite(rawX) ? Math.max(0, rawX) : 0;
    padY = Number.isFinite(rawY) ? Math.max(0, rawY) : 0;
  }

  if (padX === 0 && padY === 0) {
    return base;
  }

  return {
    left: base.left - padX,
    top: base.top - padY,
    width: Math.max(0, base.width + padX * 2),
    height: Math.max(0, base.height + padY * 2)
  };
}

function computeShadowPadding(obj) {
  if (!obj) return { padX: 0, padY: 0 };

  const shadow = obj.shadow || {};
  const blur = Math.max(0, Number(shadow.blur) || 0);
  const offsetX = Number(shadow.offsetX) || 0;
  const offsetY = Number(shadow.offsetY) || 0;

  let padX = Math.ceil(blur * 1.35 + Math.abs(offsetX)) + 2;
  let padY = Math.ceil(blur * 1.35 + Math.abs(offsetY)) + 2;

  if (obj.type === 'i-text' || obj.type === 'text' || obj.type === 'textbox') {
    const overhang = Math.ceil((obj.fontSize || 24) * 0.18);
    padX += overhang;
    padY += Math.ceil(overhang * 0.5);
  }

  return { padX, padY };
}

async function renderObjectToPng(obj, bounds, options = {}) {
  if (!obj || typeof fabric?.StaticCanvas !== 'function') {
    return {
      dataUrl: obj?._originalBase64 || null,
      usedFallback: true,
      paddingAppliedX: 0,
      paddingAppliedY: 0
    };
  }

  const rect = normalizeExportBounds(bounds || (typeof obj.getBoundingRect === 'function' ? obj.getBoundingRect(true, true) : null));

  const basePadding = Number(options.padding) || 0;
  let padX = Math.max(0, Number(options.paddingX ?? basePadding) || 0);
  let padY = Math.max(0, Number(options.paddingY ?? basePadding) || 0);

  if (!options.ignoreShadowPadding) {
    const shadowPad = computeShadowPadding(obj);
    if (shadowPad.padX > padX) padX = shadowPad.padX;
    if (shadowPad.padY > padY) padY = shadowPad.padY;
  }

  const widthBase = rect.width || (typeof obj.getScaledWidth === 'function' ? obj.getScaledWidth() : 0) || 1;
  const heightBase = rect.height || (typeof obj.getScaledHeight === 'function' ? obj.getScaledHeight() : 0) || 1;

  const width = Math.max(1, Math.ceil(widthBase + padX * 2));
  const height = Math.max(1, Math.ceil(heightBase + padY * 2));

  const clone = await new Promise(resolve => {
    try {
      obj.clone(cloned => resolve(cloned));
    } catch (err) {
      console.warn('renderObjectToPng clone failed', err);
      resolve(null);
    }
  });
  if (!clone) {
    return {
      dataUrl: obj?._originalBase64 || null,
      usedFallback: true,
      paddingAppliedX: 0,
      paddingAppliedY: 0
    };
  }

  if (typeof clone.set === 'function') {
    clone.set({
      left: width / 2,
      top: height / 2,
      originX: 'center',
      originY: 'center'
    });
  }
  clone.objectCaching = false;
  if (typeof clone._clearCache === 'function') clone._clearCache();
  if (typeof clone.setCoords === 'function') clone.setCoords();

  const tmpCanvas = new fabric.StaticCanvas(null, {
    width,
    height,
    enableRetinaScaling: false
  });
  tmpCanvas.add(clone);
  tmpCanvas.renderAll();

  const multiplier = Math.max(1, Number(options.multiplier) || 2);
  let dataUrl = null;
  let usedFallback = false;
  try {
    dataUrl = tmpCanvas.toDataURL({ format: 'png', multiplier });
  } catch (err) {
    console.warn('renderObjectToPng failed', err);
    dataUrl = obj?._originalBase64 || null;
    usedFallback = true;
  } finally {
    if (typeof tmpCanvas.dispose === 'function') tmpCanvas.dispose();
  }

  return {
    dataUrl,
    usedFallback,
    paddingAppliedX: usedFallback ? 0 : Math.max(0, padX),
    paddingAppliedY: usedFallback ? 0 : Math.max(0, padY)
  };
}

// Export-Profile nach Produkttyp
const DEFAULT_EXPORT_PROFILE_KEY = 'sticker_normal_oval';
const EXPORT_PROFILES = {
  sticker_normal_oval: { key: 'sticker_normal_oval', label: 'Sticker Oval',               idPrefix: 'NHO-', pdfWidthMm: 149, pdfHeightMm: 86,   storagePrefix: 'NHO', layout: 'fill' },
  sticker_normal_rect: { key: 'sticker_normal_rect', label: 'Sticker Rechteck',           idPrefix: 'NHR-', pdfWidthMm: 149, pdfHeightMm: 86,   storagePrefix: 'NHR', layout: 'fill' },
  sticker:             { key: 'sticker',             label: 'Sticker (Legacy)',           idPrefix: 'NHO-', pdfWidthMm: 149, pdfHeightMm: 86,   storagePrefix: 'NHO', layout: 'fill' },
  sticker_mini_oval:   { key: 'sticker_mini_oval',   label: 'Sticker Mini Oval',          idPrefix: 'MHO-', pdfWidthMm: 78,  pdfHeightMm: 45,   storagePrefix: 'MHO', layout: 'fill' },
  sticker_mini_rect:   { key: 'sticker_mini_rect',   label: 'Sticker Mini Rechteck',      idPrefix: 'MHR-', pdfWidthMm: 78,  pdfHeightMm: 45,   storagePrefix: 'MHR', layout: 'fill' },
  sticker_xxl_oval:    { key: 'sticker_xxl_oval',    label: 'Sticker XXL Oval',           idPrefix: 'XHO-', pdfWidthMm: 294, pdfHeightMm: 168,  storagePrefix: 'XHO', layout: 'fill', renderMultiplier: 12 },
  sticker_xxl_rect:    { key: 'sticker_xxl_rect',    label: 'Sticker XXL Rechteck',       idPrefix: 'XHR-', pdfWidthMm: 294, pdfHeightMm: 168,  storagePrefix: 'XHR', layout: 'fill', renderMultiplier: 12 },
  beerdeckel:          { key: 'beerdeckel',          label: 'Bierdeckel',                 idPrefix: 'BD-',  pdfWidthMm: 136, pdfHeightMm: 101,  storagePrefix: 'BD',  layout: 'box', designBoxMm: { width: 136, height: 74.5 }, renderMultiplier: 12 },
  flag_100x58:         { key: 'flag_100x58',         label: 'Fahne 100 x 58 cm',          idPrefix: 'FHS-',  pdfWidthMm: 1004, pdfHeightMm: 584,  storagePrefix: 'FHS',  layout: 'box', designBoxMm: { width: 1004, height: 584 }, renderMultiplier: 18 },
  flag_150x86:         { key: 'flag_150x86',         label: 'Fahne 150 x 86.5 cm',        idPrefix: 'FHM-',  pdfWidthMm: 1504, pdfHeightMm: 869,  storagePrefix: 'FHM',  layout: 'box', designBoxMm: { width: 1504, height: 869 }, renderMultiplier: 18 },
  flag_200x115:        { key: 'flag_200x115',        label: 'Fahne 200 x 115.5 cm',       idPrefix: 'FHL-',  pdfWidthMm: 2004, pdfHeightMm: 1159, storagePrefix: 'FHL',  layout: 'box', designBoxMm: { width: 2004, height: 1159 }, renderMultiplier: 18 },
  flag_300x173:        { key: 'flag_300x173',        label: 'Fahne 300 x 173.4 cm',       idPrefix: 'FHXL-',  pdfWidthMm: 3004, pdfHeightMm: 1734, storagePrefix: 'FHXL',  layout: 'box', designBoxMm: { width: 3004, height: 1734 }, renderMultiplier: 18 },
  hoodie:              { key: 'hoodie',              label: 'Hoodie',                     idPrefix: 'KP-',  pdfWidthMm: 350, pdfHeightMm: 280,  storagePrefix: 'HD',  layout: 'box', designBoxMm: { width: 235, height: 135.5 } },
  mug_ceramic:         { key: 'mug_ceramic',         label: 'Tasse Keramik',              idPrefix: 'TK-',  pdfWidthMm: 229, pdfHeightMm: 99,   storagePrefix: 'TK',  layout: 'box', designBoxMm: { width: 143, height: 82.5 } },
  mug_enamel:          { key: 'mug_enamel',          label: 'Tasse Emaille',              idPrefix: 'TE-',  pdfWidthMm: 229, pdfHeightMm: 74,   storagePrefix: 'TE',  layout: 'box', designBoxMm: { width: 105, height: 60.6 } },
  beer_mug:            { key: 'beer_mug',            label: 'Bierkrug',                   idPrefix: 'BK-',  pdfWidthMm: 190, pdfHeightMm: 70,   storagePrefix: 'BK',  layout: 'box', designBoxMm: { width: 184, height: 64 }, fit: 'contain' },
  tshirt:              { key: 'tshirt',              label: 'T-Shirt',                    idPrefix: 'SH-',  pdfWidthMm: 350, pdfHeightMm: 400,  storagePrefix: 'SH',  layout: 'box', designBoxMm: { width: 237, height: 136.8 }, designBoxOffsetMm: { x: 0, y: -55 } } // Canvas weiter oben auf dem 35x40cm Bogen
};
window.__exportProfiles = EXPORT_PROFILES;
window.__defaultExportProfileKey = DEFAULT_EXPORT_PROFILE_KEY;

function resolveExportProfile(profileKey) {
  if (profileKey && EXPORT_PROFILES[profileKey]) return EXPORT_PROFILES[profileKey];
  return EXPORT_PROFILES[DEFAULT_EXPORT_PROFILE_KEY];
}

function normalizeProfileKeys(profileKeys) {
  if (!profileKeys) return [DEFAULT_EXPORT_PROFILE_KEY];
  const list = Array.isArray(profileKeys) ? profileKeys : [profileKeys];
  const unique = Array.from(new Set(list.filter(Boolean)));
  return unique.length ? unique : [DEFAULT_EXPORT_PROFILE_KEY];
}

function storageKeysForProfile(profileKey) {
  if (profileKey === DEFAULT_EXPORT_PROFILE_KEY) {
    return { id: 'NH_LAST_ID', snapshot: 'NH_LAST_SNAPSHOT' };
  }
  const prefix = (EXPORT_PROFILES[profileKey]?.storagePrefix || profileKey || 'nh').toUpperCase();
  return { id: `${prefix}_LAST_ID`, snapshot: `${prefix}_LAST_SNAPSHOT` };
}

const DESIGN_CODE_STORAGE = {
  snapshot: 'NH_LAST_DESIGN_CORE_SNAPSHOT',
  value: 'NH_LAST_DESIGN_CORE_VALUE'
};

window.saveVectorPDF = async function saveVectorPDF(profileOrKey) {
  const profile = resolveExportProfile(typeof profileOrKey === 'string' ? profileOrKey : profileOrKey?.key);
  const { jsPDF } = window.jspdf;
  const pdfWidthMm = Number(profile.pdfWidthMm) || 149;
  const pdfHeightMm = Number(profile.pdfHeightMm) || 86;
  const orientation = pdfWidthMm >= pdfHeightMm ? 'landscape' : 'portrait';

  const __vt = canvas.viewportTransform ? canvas.viewportTransform.slice() : null;
  const __oldZoom = typeof canvas.getZoom === 'function' ? canvas.getZoom() : 1;
  canvas.setViewportTransform([1, 0, 0, 1, 0, 0]);

  const toHide = canvas.getObjects().filter(o => o.excludeFromExport || o._helperUI);
  const prevVis = new Map(toHide.map(o => [o, o.visible]));
  toHide.forEach(o => o.visible = false);
  canvas.discardActiveObject();
  canvas.requestRenderAll();

  let __clipsWereCleared = false;
  if (typeof clearBleedClipFromAll === 'function') {
    clearBleedClipFromAll();
    __clipsWereCleared = true;
  }

  const restore = () => {
    toHide.forEach(o => o.visible = prevVis.get(o));
    if (__vt) {
      try { canvas.setViewportTransform(__vt.slice()); }
      catch (err) { console.warn('Viewport-Restore fehlgeschlagen', err); }
    } else if (typeof __oldZoom === 'number' && typeof canvas.setZoom === 'function') {
      try { canvas.setZoom(__oldZoom); }
      catch (err) { console.warn('Zoom-Restore fehlgeschlagen', err); }
    }
    canvas.requestRenderAll();
    if (typeof fitCanvasToPreview === 'function') {
      try { fitCanvasToPreview(); } catch (err) { console.warn('fitCanvasToPreview restore failed', err); }
    }
  };

  const shapeObj =
    (window.oval && canvas.contains(window.oval) && window.oval) ||
    canvas.getObjects().find(o => o.selectable === false);
  if (!shapeObj) {
    if (__clipsWereCleared && typeof applyBleedClipToAllObjects === 'function') {
      applyBleedClipToAllObjects();
      canvas.requestRenderAll();
    }
    restore();
    return;
  }

  let vx, vy, vw, vh;
  if (shapeObj.type === 'ellipse') {
    vw = shapeObj.rx * 2; vh = shapeObj.ry * 2;
    vx = shapeObj.left - shapeObj.rx; vy = shapeObj.top - shapeObj.ry;
  } else if (shapeObj.type === 'rect') {
    vw = shapeObj.width; vh = shapeObj.height;
    vx = shapeObj.left - vw / 2; vy = shapeObj.top - vh / 2;
  } else {
    const r = shapeObj.getBoundingRect(true);
    vx = r.left; vy = r.top; vw = r.width; vh = r.height;
  }

  async function rasterPdf() {
    const doc = new jsPDF({ orientation, unit: 'mm', format: [pdfWidthMm, pdfHeightMm], pdfVersion: '1.6' });

    const BLEED_PX = 0;
    const multiplier = Number(profile.renderMultiplier) || 6;
    const vxR = Math.floor(vx) - BLEED_PX;
    const vyR = Math.floor(vy) - BLEED_PX;
    const vwR = Math.ceil(vw) + BLEED_PX * 2;
    const vhR = Math.ceil(vh) + BLEED_PX * 2;

    const pngDataUrl = canvas.toDataURL({
      format: 'png',
      multiplier,
      left: vxR, top: vyR, width: vwR, height: vhR,
      enableRetinaScaling: false
    });

    const isBeerdeckel = profile.key === 'beerdeckel';
    let exportDataUrl = pngDataUrl;
    let exportFormat = 'PNG';

    if (isBeerdeckel) {
      // 136 x 101 mm ovaler Hintergrund, Box 136 x 74.5 mm zentriert
      const pdfWpx = Math.max(1, Math.round(pdfWidthMm * multiplier));
      const pdfHpx = Math.max(1, Math.round(pdfHeightMm * multiplier));
      const targetWmm = profile.designBoxMm?.width || pdfWidthMm;
      const targetHmm = profile.designBoxMm?.height || pdfHeightMm;
      const targetPxW = Math.max(1, Math.round(targetWmm * multiplier));
      const targetPxH = Math.max(1, Math.round(targetHmm * multiplier));
      const targetPxX = Math.round((pdfWpx - targetPxW) / 2);
      const targetPxY = Math.round((pdfHpx - targetPxH) / 2);
      const candidateBg = (() => {
        if (typeof canvas.backgroundColor === 'string' && canvas.backgroundColor.trim()) return canvas.backgroundColor;
        if (shapeObj && typeof shapeObj.fill === 'string' && shapeObj.fill.trim()) return shapeObj.fill;
        return '#ffffff';
      })();
      const bgCss = candidateBg;

      const img = await new Promise((resolve, reject) => {
        const im = new Image();
        im.onload = () => resolve(im);
        im.onerror = reject;
        im.src = pngDataUrl;
      });
      const off = document.createElement('canvas');
      off.width = pdfWpx;
      off.height = pdfHpx;
      const ctx = off.getContext('2d');
      ctx.save();
      ctx.beginPath();
      ctx.ellipse(pdfWpx / 2, pdfHpx / 2, pdfWpx / 2, pdfHpx / 2, 0, 0, Math.PI * 2);
      ctx.clip();
      ctx.fillStyle = bgCss;
      ctx.fillRect(0, 0, pdfWpx, pdfHpx);
      ctx.drawImage(img, targetPxX, targetPxY, targetPxW, targetPxH);
      ctx.restore();
      exportDataUrl = off.toDataURL('image/png');
      exportFormat = 'PNG';
    } else {
      const jpegDataUrl = await flattenToJpeg(pngDataUrl, '#ffffff', 0.95);
      exportDataUrl = jpegDataUrl;
      exportFormat = 'JPEG';
    }

    if (profile.layout === 'box' && profile.designBoxMm && !isBeerdeckel) {
      let targetW = Number(profile.designBoxMm.width) || pdfWidthMm;
      let targetH = Number(profile.designBoxMm.height) || pdfHeightMm;
      if (profile.fit === 'contain') {
        const scale = Math.min(targetW / vwR, targetH / vhR);
        targetW = vwR * scale;
        targetH = vhR * scale;
      }
      const offsetX = Number(profile.designBoxOffsetMm?.x) || 0;
      const offsetY = Number(profile.designBoxOffsetMm?.y) || 0;
      const centeredX = (pdfWidthMm - targetW) / 2 + offsetX;
      const centeredY = (pdfHeightMm - targetH) / 2 + offsetY;
      const x = Math.min(Math.max(0, centeredX), Math.max(0, pdfWidthMm - targetW));
      const y = Math.min(Math.max(0, centeredY), Math.max(0, pdfHeightMm - targetH));
      doc.addImage(
        exportDataUrl,
        exportFormat,
        x, y,
        targetW,
        targetH,
        undefined,
        'FAST'
      );
    } else {
      doc.addImage(
        exportDataUrl,
        exportFormat,
        0, 0,
        pdfWidthMm,
        pdfHeightMm,
        undefined,
        'FAST'
      );
    }

    return jsPdfOutputBlobSafe(doc);
  }

  try {
    return await rasterPdf();
  } finally {
    if (__clipsWereCleared && typeof applyBleedClipToAllObjects === 'function') {
      applyBleedClipToAllObjects();
      canvas.requestRenderAll();
    }
    restore();
  }
};

// 🧠 Helfer: Koordinaten für Positionierung von UI-Elementen
fabric.Canvas.prototype.getAbsoluteCoords = function(obj) {
  const zoom = this.getZoom();
  const bound = obj.getBoundingRect();
  const canvasPos = this.upperCanvasEl.getBoundingClientRect();
  return {
    top: canvasPos.top + bound.top * zoom,
    left: canvasPos.left + bound.left * zoom,
    right: canvasPos.left + (bound.left + bound.width) * zoom,
    bottom: canvasPos.top + (bound.top + bound.height) * zoom
  };
};

window.addEventListener('resize', () => canvas.renderAll());

// Gibt die aktuelle Grundform des Designs zurück ('oval' | 'rect')
window.getCurrentShapeType = function getCurrentShapeType() {
  if (!canvas || typeof canvas.getObjects !== 'function') return 'oval';
  const shapes = canvas.getObjects().filter(o => o.selectable === false || o._isBackground);
  // Priorität: Rechteck vor Ellipse, falls beides existiert
  const rectShape = shapes.find(o => o.type === 'rect');
  if (rectShape) return 'rect';
  const ellipseShape = shapes.find(o => o.type === 'ellipse');
  if (ellipseShape) return 'oval';
  return 'oval';
};

    // === Mini-Snapshot für stabile ID ===
    const SNAPSHOT_DROP_KEYS = new Set([
      'version','selectable','evented','visible','excludeFromExport','_helperUI',
      'cacheProperties','fillGradientTransform','fillRule','globalCompositeOperation',
      'crossOrigin','filters','clipPath','backgroundImage',
      '_originalWidth','_originalHeight','_qrLogoRatio','_qrPart','_itemId'
    ]);
    const SNAPSHOT_CONTENT_KEYS = new Set([
      '_originalBase64',
      '_imageEditSource',
      '_qrLogoDataURL',
      'src'
    ]);

    function simpleHash(str) {
      let hash = 2166136261 >>> 0;
      for (let i = 0; i < str.length; i += 1) {
        hash ^= str.charCodeAt(i);
        hash = Math.imul(hash, 16777619);
      }
      return (hash >>> 0).toString(16);
    }

    function secondaryHash(str) {
      let hash = 5381;
      for (let i = 0; i < str.length; i += 1) {
        hash = (Math.imul(hash, 33) ^ str.charCodeAt(i)) >>> 0;
      }
      return hash.toString(16);
    }

    function robustContentHash(value) {
      const text = String(value || '');
      return `${simpleHash(text)}-${secondaryHash(text)}-${text.length.toString(36)}`;
    }

    function sanitizeForSnapshot(json){
      const replacer = (key, value) => {
        if (SNAPSHOT_DROP_KEYS.has(key)) return undefined;
        if (SNAPSHOT_CONTENT_KEYS.has(key) && typeof value === 'string') {
          return `__CONTENT_HASH__${robustContentHash(value)}`;
        }
        if (typeof value === 'string' && value.length > 256) {
          return `__HASH__${robustContentHash(value)}`;
        }
        return value;
      };
      const o = JSON.parse(JSON.stringify(json, replacer));
      if (o && typeof o === 'object') delete o.version;
      return o;
    }
    function currentDesignFingerprint(){
      const sanitized = sanitizeForSnapshot(canvas.toJSON(HISTORY_PROPS));
      const str = JSON.stringify(sanitized);
      return robustContentHash(str);
    }

    // Product mockups read an isolated bitmap; never use the upload/PDF preview path.
    (function installProductArtworkGetter() {
      const MAX_EDGE = 900;
      const LOAD_TIMEOUT_MS = 6000;
      let currentJob = null;

      function snapshotWithoutLiveSerialization(objects) {
        const seen = new WeakMap();
        function viewOf(object) {
          if (!object || typeof object !== 'object') return object;
          if (seen.has(object)) return seen.get(object);
          const view = Object.create(Object.getPrototypeOf(object));
          seen.set(object, view);
          Object.keys(object).forEach(key => {
            Object.defineProperty(view, key, {value: object[key], writable: true, configurable: true, enumerable: true});
          });
          // Group.toObject changes children.includeDefaultValues. Keep those writes
          // on independent serialization views, including nested clips and groups.
          view.canvas = null;
          if (Array.isArray(object._objects)) view._objects = object._objects.map(viewOf);
          if (object.group) view.group = viewOf(object.group);
          if (object.clipPath) view.clipPath = viewOf(object.clipPath);
          return view;
        }
        const view = Object.create(fabric.StaticCanvas.prototype);
        view.includeDefaultValues = true;
        view._objects = objects.map(viewOf);
        view.backgroundColor = canvas.backgroundColor;
        view.overlayColor = canvas.overlayColor;
        view.backgroundImage = viewOf(canvas.backgroundImage);
        view.overlayImage = viewOf(canvas.overlayImage);
        view.clipPath = viewOf(canvas.clipPath);
        return JSON.parse(JSON.stringify(fabric.StaticCanvas.prototype.toObject.call(view, [...HISTORY_PROPS, '_bleedClip'])));
      }

      function readArtworkSnapshot() {
        if (!window.fabric?.StaticCanvas?.prototype?.toObject || !canvas?.getObjects ||
            window.__nhEditorReorderState?.kind === 'prefix-reorder') return null;
        // Fabric 5 serializes an active multi-selection by temporarily transforming
        // its live members, without a finally guard. Do not enter that mutable path.
        if (canvas.getActiveObject?.()?.type === 'activeSelection') return null;
        const objects = canvas.getObjects();
        const background = (window.oval && objects.includes(window.oval) && window.oval) ||
          objects.find(object => object?._isBackground && !object._helperUI);
        if (!background || !['ellipse', 'rect'].includes(background.type) ||
            background.originX !== 'center' || background.originY !== 'center') return null;
        const width = background.type === 'ellipse' ? Number(background.rx) * 2 : Number(background.width);
        const height = background.type === 'ellipse' ? Number(background.ry) * 2 : Number(background.height);
        const left = Number(background.left) - width / 2;
        const top = Number(background.top) - height / 2;
        if (![width, height, left, top].every(Number.isFinite) || width <= 0 || height <= 0) return null;

        // Include the marker in nested clip serialization so user image crops survive.
        const snapshot = snapshotWithoutLiveSerialization(objects);
        function prune(node) {
          if (!node || typeof node !== 'object') return;
          if (node.clipPath?._bleedClip) delete node.clipPath;
          else if (node.clipPath) prune(node.clipPath);
          if (Array.isArray(node.objects)) {
            node.objects = node.objects.filter(object => object && !object._helperUI && !object.excludeFromExport);
            node.objects.forEach(prune);
          }
        }
        prune(snapshot);
        if (!Array.isArray(snapshot.objects) || !snapshot.objects.some(object => object._isBackground)) return null;
        const bounds = {left: Math.floor(left), top: Math.floor(top), width: Math.ceil(width), height: Math.ceil(height)};
        const mask = {
          left: Number(background.left), top: Number(background.top), width, height,
          angle: Number(background.angle) || 0,
          scaleX: Number(background.scaleX) || 1, scaleY: Number(background.scaleY) || 1,
        };
        if (![mask.angle, mask.scaleX, mask.scaleY].every(Number.isFinite)) return null;
        // Match the coaster's existing background fallback without changing its export.
        const backgroundColor = typeof canvas.backgroundColor === 'string' && canvas.backgroundColor.trim()
          ? canvas.backgroundColor
          : typeof background.fill === 'string' && background.fill.trim() ? background.fill : '#ffffff';
        let shapeBackgroundColor = '#ffffff';
        const shapeFill = typeof background.fill === 'string' ? background.fill.trim() : '';
        try {
          if (shapeFill && window.CSS?.supports?.('color', shapeFill)) shapeBackgroundColor = shapeFill;
        } catch (_) { /* Keep a neutral fallback if color validation is unavailable. */ }
        // Unlike the export-ID fingerprint, keep render-affecting visibility, filters and crops.
        const fingerprint = robustContentHash(JSON.stringify({snapshot, bounds, mask, backgroundColor, shapeBackgroundColor}));
        return {snapshot, bounds, mask, shape: background.type === 'ellipse' ? 'oval' : 'rect', fingerprint, backgroundColor, shapeBackgroundColor};
      }

      function cloneIsComplete(expected, actual) {
        if (!Array.isArray(expected) || !Array.isArray(actual) || expected.length !== actual.length) return false;
        return expected.every((object, index) => {
          const clone = actual[index];
          if (!clone || clone.type !== object.type) return false;
          return !Array.isArray(object.objects) || cloneIsComplete(object.objects,
            typeof clone.getObjects === 'function' ? clone.getObjects() : clone._objects);
        });
      }

      function renderArtwork(source) {
        return new Promise(resolve => {
          let clone = null;
          let loaded = false;
          let finished = false;
          const scale = Math.min(MAX_EDGE / source.bounds.width, MAX_EDGE / source.bounds.height);
          const width = Math.max(1, Math.min(MAX_EDGE, Math.ceil(source.bounds.width * scale)));
          const height = Math.max(1, Math.min(MAX_EDGE, Math.ceil(source.bounds.height * scale)));
          function disposeClone() {
            if (!clone) return;
            try { clone.dispose(); } catch (_) { /* Optional preview cleanup cannot affect the editor. */ }
            clone = null;
          }
          function finish(result) {
            if (!finished) {
              finished = true;
              clearTimeout(timer);
              resolve(result);
            }
            // Do not dispose while Fabric is still completing its async image callbacks.
            if (loaded) disposeClone();
          }
          const timer = setTimeout(() => finish(null), LOAD_TIMEOUT_MS);
          try {
            const element = document.createElement('canvas');
            clone = new fabric.StaticCanvas(element, {
              width, height, enableRetinaScaling: false, renderOnAddRemove: false, skipOffscreen: false,
            });
            clone.loadFromJSON(source.snapshot, () => {
              loaded = true;
              if (finished) { disposeClone(); return; }
              function render() {
                if (finished) return;
                try {
                  if (!cloneIsComplete(source.snapshot.objects, clone.getObjects())) { finish(null); return; }
                  clone.setDimensions({width, height});
                  clone.setViewportTransform([scale, 0, 0, scale, -source.bounds.left * scale, -source.bounds.top * scale]);
                  clone.renderAll();
                  const output = document.createElement('canvas');
                  output.width = width;
                  output.height = height;
                  const context = output.getContext('2d');
                  if (!context || !clone.lowerCanvasEl) { finish(null); return; }
                  context.save();
                  context.translate((source.mask.left - source.bounds.left) * scale, (source.mask.top - source.bounds.top) * scale);
                  context.rotate(source.mask.angle * Math.PI / 180);
                  context.scale(source.mask.scaleX * scale, source.mask.scaleY * scale);
                  context.beginPath();
                  if (source.shape === 'oval') context.ellipse(0, 0, source.mask.width / 2, source.mask.height / 2, 0, 0, Math.PI * 2);
                  else context.rect(-source.mask.width / 2, -source.mask.height / 2, source.mask.width, source.mask.height);
                  context.clip();
                  context.setTransform(1, 0, 0, 1, 0, 0);
                  context.drawImage(clone.lowerCanvasEl, 0, 0);
                  context.restore();
                  const dataUrl = output.toDataURL('image/png');
                  finish(typeof dataUrl === 'string' && dataUrl.startsWith('data:image/png;base64,')
                    ? Object.freeze({dataUrl, shape: source.shape, fingerprint: source.fingerprint, backgroundColor: source.backgroundColor, shapeBackgroundColor: source.shapeBackgroundColor}) : null);
                } catch (_) { finish(null); }
              }
              const fontsReady = document.fonts?.ready;
              if (fontsReady && typeof fontsReady.then === 'function') Promise.resolve(fontsReady).then(render, () => finish(null));
              else render();
            });
          } catch (_) {
            loaded = true;
            finish(null);
          }
        });
      }

      window.NH_getProductArtwork = function NH_getProductArtwork() {
        let source;
        try { source = readArtworkSnapshot(); } catch (_) { return Promise.resolve(null); }
        if (!source) return Promise.resolve(null);
        if (currentJob?.fingerprint === source.fingerprint) return currentJob.promise;
        const job = {fingerprint: source.fingerprint, promise: null};
        currentJob = job;
        job.promise = renderArtwork(source).then(result => {
          let current;
          try { current = readArtworkSnapshot(); } catch (_) { /* Fail closed if the design cannot be verified. */ }
          if (currentJob !== job || !current || current.fingerprint !== job.fingerprint) result = null;
          if (!result && currentJob === job) currentJob = null;
          return result;
        }).catch(() => {
          if (currentJob === job) currentJob = null;
          return null;
        });
        return job.promise;
      };
    })();

    function safeGetItem(key){
      try { return localStorage.getItem(key); }
      catch (err) { console.warn('localStorage.getItem failed', err); return null; }
    }
    function safeSetItem(key, value){
      try { localStorage.setItem(key, value); }
      catch (err) { console.warn('localStorage.setItem failed', err); }
    }
    function safeRemoveItem(key){
      try { localStorage.removeItem(key); }
      catch (err) { console.warn('localStorage.removeItem failed', err); }
    }

    function sanitizeDraftPayload(data){
      if (!data || typeof data !== 'object') return data;

      const prune = (list) => {
        if (!Array.isArray(list)) return list;
        return list
          .filter(item => item && !item._helperUI && !item.excludeFromHistory)
          .map(item => {
            if (!item || typeof item !== 'object') return item;
            if (Array.isArray(item.objects)) {
              return { ...item, objects: prune(item.objects) };
            }
            return { ...item };
          });
      };

      const baseObjects = Array.isArray(data.objects) ? data.objects : [];
      return {
        ...data,
        objects: prune(baseObjects)
      };
    }

    function createHiddenDraftSnapshot(){
      if (!canvas || typeof canvas.toJSON !== 'function') return null;
      try {
        const payload = sanitizeDraftPayload(canvas.toJSON(HISTORY_PROPS));
        const fingerprint = typeof currentDesignFingerprint === 'function'
          ? currentDesignFingerprint()
          : null;
        return {
          version: 1,
          timestamp: Date.now(),
          fingerprint,
          payload
        };
      } catch (err) {
        console.warn('Hidden draft snapshot failed', err);
        return null;
      }
    }

    function readHiddenDraft(){
      const raw = safeGetItem(HIDDEN_DRAFT_STORAGE_KEY);
      if (!raw) return null;
      try {
        const parsed = JSON.parse(raw);
        if (parsed && typeof parsed === 'object' && parsed.payload) {
          return parsed;
        }
      } catch (err) {
        console.warn('Hidden draft parse failed', err);
      }
      safeRemoveItem(HIDDEN_DRAFT_STORAGE_KEY);
      return null;
    }

    function clearHiddenDraft(){
      safeRemoveItem(HIDDEN_DRAFT_STORAGE_KEY);
      updateDraftStatus({ hide: true });
    }

    function saveHiddenDraft({ force = false } = {}){
      if (HIDDEN_DRAFTS_DISABLED) return;
      if (!hiddenDraftAutoSaveEnabled && !force) return;
      const snapshot = createHiddenDraftSnapshot();
      if (!snapshot) return;

      // Baseline-Entwurf nicht speichern: verhindert „Weiterzeichnen oder Neustart?“ beim allerersten Besuch.
      if (hiddenDraftBaselineFingerprint && snapshot.fingerprint && snapshot.fingerprint === hiddenDraftBaselineFingerprint) {
        try { safeRemoveItem(HIDDEN_DRAFT_STORAGE_KEY); } catch (_) {}
        updateDraftStatus({ hide: true });
        return;
      }

      try {
        safeSetItem(HIDDEN_DRAFT_STORAGE_KEY, JSON.stringify(snapshot));
        updateDraftStatus({ timestamp: snapshot.timestamp });
      } catch (err) {
        console.warn('Hidden draft storage failed', err);
      }
    }

    function scheduleHiddenDraftSave({ force = false } = {}){
      if (HIDDEN_DRAFTS_DISABLED) return;
      if (!hiddenDraftAutoSaveEnabled && !force) return;
      if (historyService?.isRestoring?.() && !force) return;
      if (hiddenDraftSaveTimer) window.clearTimeout(hiddenDraftSaveTimer);
      const delay = force ? 0 : 800;
      hiddenDraftSaveTimer = window.setTimeout(() => {
        hiddenDraftSaveTimer = null;
        saveHiddenDraft({ force: true });
      }, delay);
    }

    function enableHiddenDraftAutoSave({ immediate = false } = {}){
      if (HIDDEN_DRAFTS_DISABLED) return;
      hiddenDraftAutoSaveEnabled = true;
      if (immediate) scheduleHiddenDraftSave({ force: true });
    }

    function formatDraftTimestamp(ts){
      if (!Number.isFinite(ts)) return '';
      try {
        const date = new Date(ts);
        if (Number.isNaN(date.getTime())) return '';
        return date.toLocaleString('de-DE', { dateStyle: 'short', timeStyle: 'short' });
      } catch (err) {
        return '';
      }
    }
    function updateDraftStatus() {}

    function showHiddenDraftModal(draft){
      const fallback = () => {
        const tsLabel = formatDraftTimestamp(draft.timestamp);
        let promptMessage = 'Da wartet noch ein angefangener Entwurf auf dich.';
        if (tsLabel) promptMessage += `\nZuletzt geöffnet am ${tsLabel}.`;
        promptMessage += '\n\nZurück an den Startpunkt? (OK = Weiterzeichnen, Abbrechen = Neu starten)';
        return window.confirm(promptMessage) ? 'resume' : 'discard';
      };

      if (!draftModalEl || !draftModalResumeBtn || !draftModalDiscardBtn) {
        updateDraftStatus({ timestamp: draft.timestamp, message: 'Entwurf gefunden', temporary: true });
        return Promise.resolve(fallback());
      }

      return new Promise((resolve) => {
        let resolved = false;
        const previousActiveElement = document.activeElement;

        const finish = (choice) => {
          if (resolved) return;
          resolved = true;
          if (draftModalEl) {
            draftModalEl.classList.remove('is-visible');
            draftModalEl.setAttribute('aria-hidden', 'true');
          }
          document.body?.classList?.remove('draft-modal-open');
          draftModalResumeBtn.removeEventListener('click', onResume);
          draftModalDiscardBtn.removeEventListener('click', onDiscard);
          if (draftModalCloseBtn) draftModalCloseBtn.removeEventListener('click', onClose);
          if (draftModalBackdrop) draftModalBackdrop.removeEventListener('click', onBackdrop);
          window.removeEventListener('keydown', onKeyDown);
          if (previousActiveElement && typeof previousActiveElement.focus === 'function') {
            try {
              previousActiveElement.focus({ preventScroll: true });
            } catch (err) {
              try { previousActiveElement.focus(); } catch (_) {}
            }
          }
          resolve(choice);
        };

        const preventDefault = (event) => {
          if (event && typeof event.preventDefault === 'function') {
            try { event.preventDefault(); } catch (_) {}
          }
        };

        const onResume = (event) => {
          preventDefault(event);
          finish('resume');
        };

        const onDiscard = (event) => {
          preventDefault(event);
          finish('discard');
        };

        const onClose = (event) => {
          preventDefault(event);
          finish('discard');
        };

        const onBackdrop = (event) => {
          const target = event ? event.target : null;
          if (target === draftModalBackdrop || target === draftModalEl) {
            finish('discard');
          }
        };

        const onKeyDown = (event) => {
          if (event && event.key === 'Escape') {
            preventDefault(event);
            finish('discard');
          }
        };

        if (draftModalMessageEl) {
          const tsLabel = formatDraftTimestamp(draft.timestamp);
          draftModalMessageEl.textContent = tsLabel
            ? `Zuletzt gespeichert am ${tsLabel}.`
            : 'Gespeicherten Entwurf gefunden.';
        }

        draftModalResumeBtn.addEventListener('click', onResume);
        draftModalDiscardBtn.addEventListener('click', onDiscard);
        if (draftModalCloseBtn) draftModalCloseBtn.addEventListener('click', onClose);
        if (draftModalBackdrop) draftModalBackdrop.addEventListener('click', onBackdrop);
        window.addEventListener('keydown', onKeyDown);

        updateDraftStatus({ timestamp: draft.timestamp, message: 'Entwurf gefunden', temporary: true });

        if (draftModalEl) {
          draftModalEl.classList.add('is-visible');
          draftModalEl.setAttribute('aria-hidden', 'false');
        }
        document.body?.classList?.add('draft-modal-open');

        requestAnimationFrame(() => {
          if (draftModalResumeBtn && typeof draftModalResumeBtn.focus === 'function') {
            try {
              draftModalResumeBtn.focus({ preventScroll: true });
            } catch (err) {
              try { draftModalResumeBtn.focus(); } catch (_) {}
            }
          }
        });
      });
    }

    function applyHiddenDraftPayload(payload, { label = 'Gespeicherter Entwurf' } = {}){
      if (!payload || !canvas || typeof canvas.loadFromJSON !== 'function') return false;
      let applied = false;

      const finalize = () => {
        try {
          ensureBleedGuide();
          hideBleedGuide();
          applyBleedClipToAllObjects();
        } catch (err) {
          console.warn('Trim clip sync failed', err);
        }

        try { canvas.requestRenderAll(); }
        catch (err) { console.warn('Hidden draft render failed', err); }

        try { reapplySocialConstraints(); }
        catch (err) { console.warn('Hidden draft social lock restore failed', err); }

        if (typeof scheduleTextMetricRefresh === 'function') {
          try { scheduleTextMetricRefresh([0, 120, 360]); }
          catch (err) { console.warn('Hidden draft metrics refresh failed', err); }
        }

        try {
          historyBaselineSynced = false;
          historyService.reset(label);
          historyBaselineSynced = true;
        } catch (err) {
          console.warn('Hidden draft history reset failed', err);
        }

        applied = true;
      };

      try {
        historyService.withoutRecording(() => {
          canvas.loadFromJSON(payload, () => {
            historyService.withoutRecording(() => finalize());
          });
        });
      } catch (err) {
        console.warn('Hidden draft apply failed', err);
        applied = false;
      }

      return applied;
    }

    
    function dismissWelcomeForEditorDialog(){
      if (welcomeModalEl?.getAttribute('aria-hidden') === 'false') {
        // Use the existing finish path so listeners and scroll/focus state clear.
        welcomeStartBtn?.click();
      }
    }

    function showWelcomeModal(){
      // Direct entry: keep existing callers compatible without opening an intro.
      return Promise.resolve(true);
    }

    function maybeShowWelcomeModalOnStart(){
      return Promise.resolve(false);
    }

function maybeRestoreHiddenDraftOnStart(){
      const draft = readHiddenDraft();
      if (!draft || !draft.payload) {
        updateDraftStatus({ hide: true });
        enableHiddenDraftAutoSave({ immediate: false });
        if (typeof maybeShowWelcomeModalOnStart === 'function') {
          try { maybeShowWelcomeModalOnStart(); } catch (_) {}
        }
        return Promise.resolve(false);
      }

      return showHiddenDraftModal(draft)
        .then((choice) => {
          let restored = false;
          if (choice === 'resume') {
            restored = applyHiddenDraftPayload(draft.payload, { label: 'Entwurf geladen' });
            if (restored) {
              updateDraftStatus({ timestamp: draft.timestamp, message: 'Entwurf geladen', temporary: true });
            } else {
              clearHiddenDraft();
            }
          } else {
            clearHiddenDraft();
          }

          enableHiddenDraftAutoSave({ immediate: false });
          if (!restored) {
            updateDraftStatus({ hide: true });
          }
          return restored;
        })
        .catch((err) => {
          console.warn('Hidden draft prompt failed', err);
          clearHiddenDraft();
          enableHiddenDraftAutoSave({ immediate: false });
          updateDraftStatus({ hide: true });
          return false;
        });
    }


    window.addEventListener('beforeunload', (event) => {
      // Autosave remains disabled. Warn only when a changed design has no saved
      // master yet; opening the normal cart after a successful save stays quiet.
      try {
        if (hasUnsavedDesignChanges()) {
          event.preventDefault();
          event.returnValue = '';
        }
      } catch (err) {
        console.warn('Design-Änderungen konnten nicht geprüft werden', err);
      }
    });

    // ⬇️ außerhalb des forEach, nur einmal registrieren
async function beginDesignExport(profileKeys, { emitProgress = true } = {}) {
      if (isExporting) return window.__lastDesignExports || null;

      const profiles = normalizeProfileKeys(profileKeys);
      const snap = currentDesignFingerprint();
      const sharedDesignCode = ensureDesignCodeForSnapshot(snap);
      persistPreviewForCurrentDesign();

      isExporting = true;
      const results = {};
      let primaryProfileKey = profiles[0] || DEFAULT_EXPORT_PROFILE_KEY;
      const totalProfiles = profiles.length || 1;
      let completedProfiles = 0;
      if (emitProgress) emitExportProgress(0);

      try {
        await Promise.all(profiles.map(async (profileKey) => {
          const profile = resolveExportProfile(profileKey);
          const keys = storageKeysForProfile(profileKey);
          const prevSnap = safeGetItem(keys.snapshot);
          const prevId = safeGetItem(keys.id);
          const prefix = profile.idPrefix || 'NH-';
          const baseId = `${prefix}${sharedDesignCode}`;
          const id = (prevSnap && prevId && prevSnap === snap) ? prevId : baseId;

          safeSetItem(keys.snapshot, snap);
          safeSetItem(keys.id, id);
          if (profileKey === DEFAULT_EXPORT_PROFILE_KEY) {
            safeSetItem('NH_LAST_SNAPSHOT', snap);
            safeSetItem('NH_LAST_ID', id);
          }

          const pdfBlob = await window.saveVectorPDF(profile);
          if (!pdfBlob) throw new Error('PDF konnte nicht erzeugt werden.');
          const uploadResult = await uploadPdfBase64(
            id,
            profileKey,
            pdfBlob,
            { profileKey, fileName: `${id || 'design'}.pdf` }
          );
          results[profileKey] = {
            id,
            pdfUrl: uploadResult?.viewUrl || '',
            profile
          };
          completedProfiles += 1;
          if (emitProgress) emitExportProgress(completedProfiles / totalProfiles);
        }));

        const primaryResult = results[primaryProfileKey] || results[DEFAULT_EXPORT_PROFILE_KEY] || Object.values(results)[0] || null;
        if (primaryResult) {
          window.__lastDesignId = primaryResult.id;
          safeSetItem('NH_LAST_ID', primaryResult.id);
          safeSetItem('NH_LAST_SNAPSHOT', snap);
          const latestPreview = window.__lastPreviewDataUrl || window.__pendingPreviewDataUrl || '';
          if (latestPreview) {
            try {
              storePreviewForId(primaryResult.id, latestPreview);
              window.__pendingPreviewDataUrl = '';
            } catch (err) {
              console.warn('Preview speichern fehlgeschlagen', err);
            }
          }
        }
        window.__lastDesignPdfUrl = primaryResult?.pdfUrl || '';
    window.__lastDesignPdfUrls = results;
    window.__lastDesignExports = { results, primaryProfile: primaryResult?.profile?.key || primaryProfileKey, snapshot: snap };

    const hint = document.querySelector('.export-hint');
    if (hint) {
      const idsText = Object.values(results).map(r => r.id).join(' · ');
      hint.textContent = `✅ Hochgeladen. Design-ID${Object.keys(results).length > 1 ? 's' : ''}: ${idsText}`;
    }

        if (emitProgress) emitExportProgress(1);
    return window.__lastDesignExports;
  } catch (err) {
    console.error('Export/Upload-Fehler:', err);
    if (emitProgress) emitExportProgress(0);
    throw err;
  } finally {
    isExporting = false;
  }
}

window.beginDesignExport = beginDesignExport;

function exportJobSignature(snapshot, profiles) {
  return `${snapshot || 'unknown'}::${profiles.join('|')}`;
}

function clearBackgroundExportJob(promiseRef) {
  if (backgroundExportJob && (!promiseRef || backgroundExportJob.promise === promiseRef)) {
    backgroundExportJob = null;
    window.__pendingDesignExports = null;
  }
}

function scheduleDesignExportPreparation(profileKeys) {
  if (typeof window.beginDesignExport !== 'function') {
    return Promise.resolve(window.__lastDesignExports || null);
  }
  const normalizedProfiles = normalizeProfileKeys(profileKeys);
  if (!normalizedProfiles.length) {
    return Promise.resolve(window.__lastDesignExports || null);
  }
  const snapshot = typeof currentDesignFingerprint === 'function'
    ? currentDesignFingerprint()
    : (typeof safeGetItem === 'function' ? safeGetItem('NH_LAST_SNAPSHOT') : null);
  if (!snapshot) {
    return Promise.resolve(window.__lastDesignExports || null);
  }

  const signature = exportJobSignature(snapshot, normalizedProfiles);

  if (backgroundExportJob && backgroundExportJob.signature === signature) {
    return backgroundExportJob.promise;
  }

  if (isExporting) {
    if (backgroundExportJob && backgroundExportJob.signature !== signature) {
      return backgroundExportJob.promise
        .catch(() => null)
        .then(() => scheduleDesignExportPreparation(normalizedProfiles));
    }
    return backgroundExportJob?.promise || Promise.resolve(window.__lastDesignExports || null);
  }

  const promise = window.beginDesignExport(normalizedProfiles, { emitProgress: false })
    .then((result) => {
      clearBackgroundExportJob(promise);
      return result;
    })
    .catch((err) => {
      clearBackgroundExportJob(promise);
      throw err;
    });

  backgroundExportJob = {
    snapshot,
    signature,
    promise
  };
  window.__pendingDesignExports = backgroundExportJob;
  return promise;
}

window.scheduleDesignExportPreparation = scheduleDesignExportPreparation;

const exportBtn = document.getElementById('export-action');
exportBtn.addEventListener('click', (e) => {
  e.preventDefault();
  if (isExporting) return;
  openPreviewModal('export');
    });

// Schließe das Popup
function closeExportModal(options = {}) {
	  const modal = document.getElementById('export-modal');
	  if (!modal) return;
	  modal.style.display = 'none';
	  modal.setAttribute('aria-hidden', 'true');
      deactivateEditorDialog(modal);
	  const preserveReorder = !!(options && options.preserveReorderState);
	  if (!preserveReorder && window.__nhEditorReorderState && window.__nhEditorReorderState.kind === 'prefix-reorder') {
	    try { window.clearNhEditorReorderState?.(); } catch (_) { /* noop */ }
	  }
	  nhUnlockScroll();
	}
	
	function backToPreviewFromExportModal() {
	  closeExportModal({ preserveReorderState: true });
	  try {
	    const ctx = (window.__nhEditorReorderState && window.__nhEditorReorderState.kind === 'prefix-reorder') ? 'reorder' : 'export';
	    openPreviewModal(ctx);
	  } catch (err) {
	    console.warn('Preview modal could not be opened', err);
	  }
	}
window.backToPreviewFromExportModal = backToPreviewFromExportModal;

function handleExport(type) {
  const urls = {
    standard: 'https://www.netthieraufkleber.de/product/11624788/nett-hier-aufkleber-selber-gestalten',
    tshirt:'https://www.netthieraufkleber.de/product/20219146/nett-hier-t-shirt-selbst-gestalten',
    tasse: 'https://www.netthieraufkleber.de/product/13771574/nett-hier-tasse-selber-gestalten',
    bierdeckel: 'https://www.netthieraufkleber.de/product/15904305/nett-hier-bierdeckel-selbst-gestalten'
  };

  // 🚪 Weiterleitung ohne Export
  window.open(urls[type], '_blank');

  // 🧼 Modal schließen
  closeExportModal();
}
    // ⬇️ Diese Funktion 1:1 reinkopieren (deine alte ersetzen)
    // ⬇️ Ersetze deine loadAndInjectGoogleFontAsBase64 komplett damit:
    // 🔎 Wählt gezielt die richtige woff2-Datei für lateinische Zeichen
    function pickLatinWoff2(css) {
      // 1) bevorzugt: Block mit /* latin */
      const mLatin = css.match(/\/\*\s*latin\s*\*\/[\s\S]*?url\((https:\/\/fonts\.gstatic\.com\/[^)]+\.woff2)\)/i);
      if (mLatin) return mLatin[1];

      // 2) alternativ: /* latin-ext */
      const mLatinExt = css.match(/\/\*\s*latin-ext\s*\*\/[\s\S]*?url\((https:\/\/fonts\.gstatic\.com\/[^)]+\.woff2)\)/i);
      if (mLatinExt) return mLatinExt[1];

      // 3) Fallback: erste gefundene .woff2 (besser als "die letzte")
      const any = css.match(/url\((https:\/\/fonts\.gstatic\.com\/[^)]+\.woff2)\)/i);
      return any ? any[1] : null;
    }

    // ✅ NEU: ersetzt deine bisherige loadAndInjectGoogleFontAsBase64 komplett
    async function loadAndInjectGoogleFontAsBase64(fontName) {
      const styles = ['normal', 'italic'];
      const weights = ['400', '700'];
      const parts = [];

      for (const weight of weights) {
        for (const style of styles) {
          const ital = style === 'italic' ? 1 : 0;
          const apiName = encodeURIComponent(fontName).replace(/%20/g, '+');

          // Eine Anfrage pro (style, weight) – simpel & robust
          const cssUrl = `https://fonts.googleapis.com/css2?family=${apiName}:ital,wght@${ital},${weight}&display=swap`;

          try {
            const css = await fetch(cssUrl).then(r => r.text());
            const fontUrl = pickLatinWoff2(css);
            if (!fontUrl) {
              console.warn(`Keine passende woff2 für ${fontName} ${style} ${weight} gefunden.`);
              continue;
            }

            const bin = await fetch(fontUrl).then(r => r.arrayBuffer());
            const b64 = arrayBufferToBase64(bin); // 👈 statt btoa(String.fromCharCode(...))

            parts.push(`
    @font-face{
      font-family:'${fontName}';
      font-style:${style};
      font-weight:${weight};
      src:url(data:font/woff2;base64,${b64}) format('woff2');
    }
            `);
          } catch (e) {
            console.warn(`Font-Embed-Fehler "${fontName}" [${style} ${weight}]`, e);
          }
        }
      }

      return parts.join('\n');
    }
    // Betten lokale Fonts (WOFF2/TTF) als data: URL in <style>@font-face</style> ein
    async function embedLocalFont(family) {
        const def = (LOCAL_FONT_MAP && LOCAL_FONT_MAP[family]) || (window.LOCAL_FONT_MAP || {})[family];

      if (!def) return '';
      let css = '';

      for (const style of ['normal','italic']) {
        const styleEntry = def[style];
        if (!styleEntry) continue;
        for (const weight of [400,700]) {
          const value = styleEntry[weight];
          const sources = Array.isArray(value) ? value : value ? [value] : [];
          if (!sources.length) continue;

          let success = false;
          const orderedSources = sources.slice().sort((a, b) => fontSourcePriority(a) - fontSourcePriority(b));
          for (const src of orderedSources) {
            try {
              const bin = await loadFontBinary(src);
              const b64 = arrayBufferToBase64(bin);
              const desc = describeFontSource(src);
              css += `@font-face{
      font-family:'${family}';
      font-style:${style};
      font-weight:${weight};
      src:url(data:${desc.mime};base64,${b64}) format('${desc.format}');
    }\n`;
              success = true;
              break;
            } catch (err) {
              console.warn(`Lokales Fontfile fehlt: ${family} ${style} ${weight} (${src})`, err);
            }
          }
        }
      }
      return css;
    }

function rebindCoreReferences() {
  const objects = canvas.getObjects();

  const background = objects.find(o => o?._isBackground);
  if (background) {
    oval = background;
    window.oval = background;
    isOval = background.type === 'ellipse';
    window.isOval = isOval;
    oval.strokeUniform = true;
    syncBackgroundStateFromCanvas();
  }

  const topText = objects.find(o => o?._historyId === 'text-top');
  if (topText) {
    textTop = topText;
    window.textTop = topText;
  }

  const bottomText = objects.find(o => o?._historyId === 'text-bottom');
  if (bottomText) {
    textBottom = bottomText;
    window.textBottom = bottomText;
  }

  const qr = objects.find(o => o?._isQr);
  qrObject = qr || null;
  window.qrObject = qrObject;

  const titleInput = document.getElementById('title-input');
  if (titleInput && textTop && document.activeElement !== titleInput) {
    titleInput.value = textTop.text || '';
  }
  const sloganInput = document.getElementById('slogan-input');
  if (sloganInput && textBottom && document.activeElement !== sloganInput) {
    sloganInput.value = textBottom.text || '';
  }

  if (textTop && typeof rgbToHex === 'function') {
    currentTextColor = rgbToHex(textTop.fill || currentTextColor);
  }
}

function focusDynamicTextInput(obj) {
  if (!obj || obj.type !== 'i-text') return;
  const panel = document.getElementById('text');
  if (!panel) return;

  const focusTask = () => {
    const target =
      obj._linkedInput ||
      (obj._linkedInputId ? panel.querySelector(`#${obj._linkedInputId}`) : null);
    if (!target) return;

    if (typeof target.focus === 'function') {
      target.focus({ preventScroll: false });
    }
    if (typeof target.setSelectionRange === 'function') {
      const end = target.value?.length ?? 0;
      try { target.setSelectionRange(end, end); } catch {}
    }
    if (typeof target.scrollIntoView === 'function') {
      target.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    }
  };

  requestAnimationFrame(() => requestAnimationFrame(focusTask));
}

function rebuildDynamicTextInputs() {
  const panel = document.getElementById('text');
  if (!panel) return;

  const titleInput = document.getElementById('title-input');
  if (titleInput && textTop) {
    textTop._linkedInputId = 'title-input';
    textTop._linkedInput = titleInput;
    if (document.activeElement !== titleInput) titleInput.value = textTop.text || '';
  }

  const sloganInput = document.getElementById('slogan-input');
  if (sloganInput && textBottom) {
    textBottom._linkedInputId = 'slogan-input';
    textBottom._linkedInput = sloganInput;
    if (document.activeElement !== sloganInput) sloganInput.value = textBottom.text || '';
  }

  const objects = canvas.getObjects();
  const dynamicTexts = objects
    .filter(isDynamicTextObject)
    .sort((a, b) => {
      const orderA = typeof a._createdAt === 'number' ? a._createdAt : 0;
      const orderB = typeof b._createdAt === 'number' ? b._createdAt : 0;
      if (orderA !== orderB) return orderA - orderB;
      return objects.indexOf(a) - objects.indexOf(b);
    });

  // vorhandene dynamische Inputs entfernen
  Array.from(panel.querySelectorAll('[data-dynamic-text]')).forEach(node => node.remove());

  if (!dynamicTexts.length) return;

  const anchorGroup = panel.querySelector('[data-dynamic-anchor="text"]');
  const anchorParent = anchorGroup?.parentNode || panel;

  dynamicTexts.forEach((obj, index) => {
    ensureCenteredTextOrigin(obj);
    ensureHistoryId(obj, 'text');
    if (typeof obj._createdAt !== 'number') {
      obj._createdAt = Date.now() - (dynamicTexts.length - index);
    }
    obj.padding = 8;
    obj._isDynamicTextLine = true;
    const fallbackLabel = `Textzeile ${index + 3}`;
    if (!obj._inputLabel || /^Textzeile\s+\d+$/i.test(obj._inputLabel)) {
      obj._inputLabel = fallbackLabel;
    }
    const labelText = obj._inputLabel;
    obj._linkedInputId = obj._linkedInputId || `${obj._historyId}-input`;

    const wrapper = document.createElement('div');
    wrapper.className = 'dynamic-text-field';
    wrapper.setAttribute('data-dynamic-text', 'group');
    wrapper.dataset.textId = obj._historyId;

    const label = document.createElement('label');
    label.textContent = labelText;
    label.htmlFor = obj._linkedInputId;
    label.setAttribute('data-dynamic-text', 'label');
    wrapper.appendChild(label);

    const input = document.createElement('textarea');
    input.id = obj._linkedInputId;
    input.dataset.textId = obj._historyId;
    input.value = obj.text || '';
    input.rows = Math.max(2, (obj.text || '').split('\n').length);
    input.setAttribute('data-dynamic-text', 'input');
    wrapper.appendChild(input);

    const applyTextareaValue = (event) => {
      if (historyService.isRestoring()) return;
      const next = event.target.value;
      if (obj.text === next) return;
      obj.text = next;
      canvas.requestRenderAll();
      pushHistory(describeHistoryAction('modified', obj));
      scheduleTextMetricRefresh([0, 120]);
    };

    input.addEventListener('input', (event) => {
      const nextRows = Math.max(2, event.target.value.split('\n').length);
      if (input.rows !== nextRows) input.rows = nextRows;
      applyTextareaValue(event);
    });

    input.addEventListener('focus', () => {
      if (canvas.getActiveObject() !== obj) {
        canvas.setActiveObject(obj);
      }
    });

    if (obj._linkedInputChangeHandler) {
      obj.off('changed', obj._linkedInputChangeHandler);
    }
    const handleChanged = () => {
      if (document.activeElement === input) return;
      input.value = obj.text || '';
      const nextRows = Math.max(2, (obj.text || '').split('\n').length);
      if (input.rows !== nextRows) input.rows = nextRows;
    };
    obj._linkedInputChangeHandler = handleChanged;
    obj.on('changed', handleChanged);
    obj._linkedInput = input;

    if (anchorGroup) {
      anchorParent.insertBefore(wrapper, anchorGroup);
    } else {
      anchorParent.appendChild(wrapper);
    }
  });
}

function renderHistoryUI(state, dom) {
  if (!dom) return;
  const { canUndo = false, canRedo = false } = state || {};
  if (dom.undo) dom.undo.disabled = !canUndo;
  if (dom.redo) dom.redo.disabled = !canRedo;
}

function createHistoryService(canvasInstance, config = {}) {
  const maxEntries = Math.max(1, config.maxEntries || 80);
  const defaultDelay = Number.isFinite(config.defaultDelay) ? config.defaultDelay : 320;
  const toJSONProps = Array.isArray(config.toJSONProps) ? config.toJSONProps : [];
  const afterRestore = typeof config.onAfterRestore === 'function' ? config.onAfterRestore : () => {};

  const listeners = new Set();
  const entries = [];
  let pointer = -1;
  let recording = false;
  let restoring = false;
  let suspendDepth = 0;
  let pendingTimer = null;
  let pendingLabel = '';

  function sanitizeHistoryPayload(data) {
    if (!data || typeof data !== 'object') return data;

    const processList = (list) => {
      if (!Array.isArray(list)) return list;
      return list
        .filter(item => item && !item._helperUI && !item.excludeFromHistory)
        .map(item => {
          if (!item || typeof item !== 'object') return item;
          if (Array.isArray(item.objects)) {
            return {
              ...item,
              objects: processList(item.objects)
            };
          }
          return { ...item };
        });
    };

    const baseObjects = Array.isArray(data.objects) ? data.objects : [];

    return {
      ...data,
      objects: processList(baseObjects)
    };
  }

  function getState() {
    return {
      entries: entries.map((entry, idx) => ({
        index: idx,
        label: entry.label,
        timestamp: entry.timestamp,
        isCurrent: idx === pointer
      })),
      index: pointer,
      size: entries.length,
      canUndo: pointer > 0,
      canRedo: pointer >= 0 && pointer < entries.length - 1,
      restoring,
      recording: recording && suspendDepth === 0
    };
  }

  function notify() {
    const snapshot = getState();
    listeners.forEach(fn => {
      try { fn(snapshot); } catch (err) { console.error('History listener error', err); }
    });
  }

  function capture(label, { allowDuplicate = false } = {}) {
    if (!recording) return;
    const payload = canvasInstance.toJSON(toJSONProps);
    const sanitized = sanitizeHistoryPayload(payload);
    const serialized = JSON.stringify(sanitized);

    if (!allowDuplicate && pointer >= 0 && entries[pointer]?.serialized === serialized) {
      entries[pointer].label = label || entries[pointer].label;
      entries[pointer].timestamp = Date.now();
      notify();
      return;
    }

    if (pointer < entries.length - 1) {
      entries.splice(pointer + 1);
    }

    entries.push({
      payload: sanitized,
      serialized,
      label: label || 'Änderung',
      timestamp: Date.now()
    });

    if (entries.length > maxEntries) {
      entries.shift();
      pointer -= 1;
    }

    pointer = entries.length - 1;
    notify();
  }

  function flushPending() {
    if (!pendingTimer) return;
    clearTimeout(pendingTimer);
    pendingTimer = null;
    const label = pendingLabel;
    pendingLabel = '';
    capture(label);
  }

  function record(label, options = {}) {
    if (!recording || restoring || suspendDepth > 0) return;
    const immediate = options.immediate === true;
    const delay = Number.isFinite(options.delay) ? options.delay : defaultDelay;

    if (immediate) {
      flushPending();
      capture(label);
      return;
    }

    pendingLabel = label;
    if (pendingTimer) clearTimeout(pendingTimer);
    pendingTimer = setTimeout(() => {
      pendingTimer = null;
      const lbl = pendingLabel;
      pendingLabel = '';
      capture(lbl);
    }, Math.max(0, delay));
  }

  function restoreTo(targetIndex) {
    if (targetIndex < 0 || targetIndex >= entries.length) return;
    const entry = entries[targetIndex];
    if (!entry) return;

    restoring = true;
    recording = false;

    canvasInstance.loadFromJSON(entry.payload, () => {
      pointer = targetIndex;
      canvasInstance.requestRenderAll();
      try {
        afterRestore();
      } catch (err) {
        console.error('History afterRestore failed', err);
      }
      restoring = false;
      recording = true;
      notify();
    });
  }

  function initialize(label = 'Startzustand') {
    flushPending();
    entries.length = 0;
    pointer = -1;
    recording = true;
    capture(label, { allowDuplicate: true });
    try { afterRestore(); } catch {}
  }

  function reset(label = 'Aktueller Stand') {
    flushPending();
    const payload = canvasInstance.toJSON(toJSONProps);
    const sanitized = sanitizeHistoryPayload(payload);
    const serialized = JSON.stringify(sanitized);
    entries.length = 0;
    entries.push({ payload: sanitized, serialized, label, timestamp: Date.now() });
    pointer = 0;
    recording = true;
    try { afterRestore(); } catch {}
    notify();
  }

  function undo() {
    if (pointer <= 0) return;
    flushPending();
    restoreTo(pointer - 1);
  }

  function redo() {
    if (pointer < 0 || pointer >= entries.length - 1) return;
    flushPending();
    restoreTo(pointer + 1);
  }

  function jumpTo(targetIndex) {
    if (targetIndex === pointer) return;
    if (targetIndex < 0 || targetIndex >= entries.length) return;
    flushPending();
    restoreTo(targetIndex);
  }

  function onChange(fn) {
    if (typeof fn === 'function') listeners.add(fn);
    return () => listeners.delete(fn);
  }

  function withoutRecording(fn) {
    suspendDepth += 1;
    try {
      return fn();
    } finally {
      suspendDepth = Math.max(0, suspendDepth - 1);
    }
  }

  function isRestoring() {
    return restoring;
  }

  function isRecording() {
    return recording && suspendDepth === 0 && !restoring;
  }

  return {
    record,
    undo,
    redo,
    jumpTo,
    reset,
    initialize,
    onChange,
    withoutRecording,
    isRestoring,
    isRecording,
    flush: flushPending,
    state: getState
  };
}

    function generateDesignCodeCore() {
      const d = new Date();
      const z = (n) => String(n).padStart(2, '0');
      return `${d.getFullYear()}${z(d.getMonth() + 1)}${z(d.getDate())}-${z(d.getHours())}${z(d.getMinutes())}-${Math.random().toString(36).slice(2, 6).toUpperCase()}`;
    }

    function ensureDesignCodeForSnapshot(snapshot) {
      if (!snapshot) {
        return generateDesignCodeCore();
      }
      const storedSnap = safeGetItem(DESIGN_CODE_STORAGE.snapshot);
      const storedCode = safeGetItem(DESIGN_CODE_STORAGE.value);
      if (storedSnap && storedCode && storedSnap === snapshot) {
        return storedCode;
      }
      const generated = generateDesignCodeCore();
      try {
        safeSetItem(DESIGN_CODE_STORAGE.snapshot, snapshot);
        safeSetItem(DESIGN_CODE_STORAGE.value, generated);
      } catch (err) {
        console.warn('Design code cache failed', err);
      }
      return generated;
    }

    function generateOrderId(prefix = 'NH-') {
      const safePrefix = prefix || 'NH-';
      return `${safePrefix}${generateDesignCodeCore()}`;
    }

    window.openIdModal = async function openIdModal(id) {
      const idModal = document.getElementById('id-modal');
      if (!idModal) return; // "why": Fail-safe falls das Modal fehlt

      const input = document.getElementById('id-code-input');
      const feedbackNode = document.getElementById('copy-feedback');

      const code = id || window.__lastDesignId || (typeof generateOrderId === 'function' ? generateOrderId() : 'NH-XXXX');
      window.__lastDesignId = code; // "why": Einheitliche Quelle für Folgeschritte

      if (input) {
        input.value = code;
        input.setAttribute('value', code);
      }

      if (feedbackNode) {
        feedbackNode.classList.remove('is-visible', 'is-error');
        feedbackNode.textContent = '';
      }

      if (copyFeedbackTimer) {
        clearTimeout(copyFeedbackTimer);
        copyFeedbackTimer = null;
      }

      if (releaseIdModalFocusTrap) {
        releaseIdModalFocusTrap();
        releaseIdModalFocusTrap = null;
      }

      idModal.style.display = 'flex';
      requestAnimationFrame(() => {
        idModal.setAttribute('aria-hidden', 'false');
      });

      activateIdModalFocusTrap(idModal);
      requestAnimationFrame(() => focusIdCard());

      if (typeof writeClipboard === 'function') {
        try {
          await writeClipboard(code);
        } catch {
          // Ignorieren – Browser benötigen ggf. Nutzergeste
        }
      }
    };

    (function(){
      function designId(){ return window.__lastDesignId || safeGetItem('NH_LAST_ID') || ''; }
      function addParam(u,k,v){
        try { const url=new URL(u, location.href); url.searchParams.set(k,v); return url.toString(); }
        catch { return u + (u.includes('?')?'&':'?') + encodeURIComponent(k)+'='+encodeURIComponent(v); }
      }
      function patchAnchor(a){
        const id = designId(); if(!id) return;
        const href = a.getAttribute('href'); if(!href) return;
        if(!/netthieraufkleber\.de\/product\//.test(href)) return;
        if(/[?&]design_code=/.test(href)) return;
        a.setAttribute('href', addParam(href,'design_code',id));
      }
      function run(){ document.querySelectorAll('a[href*="netthieraufkleber.de/product/"]').forEach(patchAnchor); }
      document.addEventListener('DOMContentLoaded', run);
      new MutationObserver(run).observe(document.documentElement,{subtree:true,childList:true,attributes:true,attributeFilter:['href']});
    })();

(function(){
      const code = new URLSearchParams(location.search).get('design_code'); if(!code) return;
      const norm = s => (s||'').trim().replace(/\s+/g,' ').toLowerCase();

      // 1) Primär: Label mit Text „Design-ID“
      const labels = Array.from(document.querySelectorAll('label'));
      const target = labels.find(l => ['design-id','design id'].includes(norm(l.textContent)));

      let input = null;
      if (target){
        const forId = target.getAttribute('for');
        if (forId) input = document.getElementById(forId);
        if (!input) input = target.closest('form,div,li,section')?.querySelector('input[type="text"],input:not([type]),textarea');
      }

      // 2) Fallback: productField-Inputs
      if (!input) input = document.querySelector('input[name*="productField"][type="text"], textarea[name*="productField"]');
      if (!input) return;

      input.value = code;
      input.dispatchEvent(new Event('input',{bubbles:true}));
      input.dispatchEvent(new Event('change',{bubbles:true}));
    })();

(function moveFormToggleIntoSidebar(){
        const sidebar = document.querySelector('.sidebar');
        if(!sidebar) return;

        const shapeNav = document.getElementById('shape-toggle');
        if (!shapeNav) return;

        // Alten Button im Text-Panel entfernen (verhindert doppelten Trigger)
        const textPanel = document.getElementById('text');
        if (textPanel) {
          const oldGroup = Array.from(textPanel.querySelectorAll('.button-group'))
            .find(g => /Form wechseln/i.test(g.textContent || ''));
          if (oldGroup) oldGroup.remove();
        }

        // Toast
        function showShapeToast(label){
          const el = document.getElementById('shape-toast'); if (!el) return;
          el.textContent = 'Form: ' + label;
          el.classList.add('show');
          clearTimeout(window.__shapeToastT);
          window.__shapeToastT = setTimeout(()=>el.classList.remove('show'), 1300);
        }

        // Klick → vorhandene toggleShape() nutzen
        shapeNav.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          try{
            const before = (window.isOval === true);
            shapeNav.classList.add('active');
            setTimeout(() => shapeNav.classList.remove('active'), 300);
            if (typeof toggleShape === 'function') toggleShape();
            const after = (window.isOval === true);
            if (after !== before) {
              showShapeToast(after ? 'Oval' : 'Rechteck');
            }
          }catch(e){ console.error(e); }
        });
      })();

(function setupSidebarSwipeHint(){
        const sidebar = document.querySelector('.sidebar');
        if (!sidebar) return;

        const mobileMq = window.matchMedia('(max-width: 1024px)');
        let hintDismissed = false;

        const shouldShowHint = () => mobileMq.matches;

        const hideHint = () => {
          if (!shouldShowHint()) return;
          if (!sidebar.classList.contains('sidebar--scrollable')) return;
          if (hintDismissed) return;
          hintDismissed = true;
          sidebar.classList.add('sidebar--hint-hidden');
        };

        const updateScrollableState = () => {
          const show = shouldShowHint();
          const isScrollable = show && (sidebar.scrollWidth - sidebar.clientWidth > 12);

          sidebar.classList.toggle('sidebar--scrollable', isScrollable);

          if (!show || !isScrollable) {
            sidebar.classList.remove('sidebar--hint-hidden');
            hintDismissed = false;
            return;
          }

          if (!hintDismissed) {
            sidebar.classList.remove('sidebar--hint-hidden');
          }
        };

        updateScrollableState();
        window.addEventListener('resize', () => requestAnimationFrame(updateScrollableState));

        const mqHandler = () => updateScrollableState();
        if (typeof mobileMq.addEventListener === 'function') {
          mobileMq.addEventListener('change', mqHandler);
        } else if (typeof mobileMq.addListener === 'function') {
          mobileMq.addListener(mqHandler);
        }

        sidebar.addEventListener('scroll', () => {
          if (sidebar.scrollLeft > 8) hideHint();
        }, { passive: true });

        ['touchstart', 'mousedown', 'wheel', 'focusin'].forEach(eventName => {
          sidebar.addEventListener(eventName, hideHint, { passive: true });
        });

        if (typeof MutationObserver === 'function') {
          const observer = new MutationObserver(() => requestAnimationFrame(updateScrollableState));
          observer.observe(sidebar, { childList: true, subtree: true });
        }

        setTimeout(() => {
          if (!hintDismissed) hideHint();
        }, 6500);
      })();

(function setupSidebarDesktopMode(){
        const sidebar = document.querySelector('.sidebar');
        if (!sidebar) return;

        const sidebarPrimary   = sidebar.querySelector('.sidebar-primary');
        const sidebarMoreButton = sidebar.querySelector('.sidebar-more');
	        const sidebarSheet     = document.getElementById('sidebar-sheet');
	        const sidebarSheetGrid = sidebarSheet ? sidebarSheet.querySelector('.sidebar-sheet-grid') : null;
	        const orderButton      = document.getElementById('export-action');
	        const loadDesignButton = document.getElementById('nh-load-design-btn');
	        const editorRoot       = document.getElementById('nh-editor');

	        if (!sidebarPrimary || !sidebarMoreButton || !sidebarSheet || !sidebarSheetGrid || !orderButton) return;

        const desktopMq = window.matchMedia('(min-width: 1025px)');
        const navItems = Array.from(sidebar.querySelectorAll('.nav-item'));

        const ensureInitialMeta = () => {
          navItems.forEach(item => {
            if (!item.dataset.initialGroup) {
              const inPrimary = sidebarPrimary.contains(item);
              item.dataset.initialGroup = item.dataset.navGroup || (inPrimary ? 'primary' : 'sheet');
              const siblings = Array.from(inPrimary ? sidebarPrimary.querySelectorAll('.nav-item') : sidebarSheetGrid.querySelectorAll('.nav-item'));
              item.dataset.initialIndex = String(siblings.indexOf(item));
            }
          });
        };

        ensureInitialMeta();

	        const orderButtonOriginalParent = orderButton.parentElement;
	        const orderButtonNextSibling = orderButton.nextElementSibling;
	        const loadDesignOriginalParent = loadDesignButton ? loadDesignButton.parentElement : null;
	        const loadDesignNextSibling = loadDesignButton ? loadDesignButton.nextElementSibling : null;

        const sortByOrder = (a, b) => {
          const orderA = Number(a.dataset.order || 999);
          const orderB = Number(b.dataset.order || 999);
          return orderA - orderB;
        };

        const moveNavItemsToPrimary = () => {
          const items = [...navItems].sort(sortByOrder);
          items.forEach(item => {
            sidebarPrimary.insertBefore(item, sidebarMoreButton);
          });
        };

        const restoreNavItems = () => {
          const primaryItems = navItems
            .filter(item => (item.dataset.initialGroup || 'primary') === 'primary')
            .sort((a, b) => Number(a.dataset.initialIndex || 0) - Number(b.dataset.initialIndex || 0));

          const sheetItems = navItems
            .filter(item => (item.dataset.initialGroup || 'sheet') === 'sheet')
            .sort((a, b) => Number(a.dataset.initialIndex || 0) - Number(b.dataset.initialIndex || 0));

          primaryItems.forEach(item => {
            sidebarPrimary.insertBefore(item, sidebarMoreButton);
          });

          sheetItems.forEach(item => {
            sidebarSheetGrid.appendChild(item);
          });
        };

	        const collapseForMobile = () => {
	          restoreNavItems();
	          sidebar.classList.remove('sidebar--expanded');
	          if (editorRoot) editorRoot.classList.remove('nh-actions-in-toolbar');
	          sidebarMoreButton.hidden = false;
	          sidebarMoreButton.style.display = '';
	          sidebarMoreButton.removeAttribute('aria-hidden');
	          sidebarMoreButton.removeAttribute('tabindex');
	          sidebarMoreButton.setAttribute('aria-expanded', 'false');
	          sidebarSheet.hidden = true;

	          if (loadDesignButton && loadDesignButton.classList.contains('order-button--inline')) {
	            loadDesignButton.classList.remove('order-button--inline');
	            if (loadDesignOriginalParent) {
	              if (orderButtonOriginalParent && orderButtonOriginalParent.contains(orderButton)) {
	                orderButtonOriginalParent.insertBefore(loadDesignButton, orderButton);
	              } else if (loadDesignNextSibling && loadDesignOriginalParent.contains(loadDesignNextSibling)) {
	                loadDesignOriginalParent.insertBefore(loadDesignButton, loadDesignNextSibling);
	              } else {
	                loadDesignOriginalParent.appendChild(loadDesignButton);
	              }
	            }
	          }

	          if (orderButton.classList.contains('order-button--inline')) {
	            orderButton.classList.remove('order-button--inline');
	            if (orderButtonNextSibling) {
	              orderButtonOriginalParent.insertBefore(orderButton, orderButtonNextSibling);
            } else {
              orderButtonOriginalParent.appendChild(orderButton);
            }
          }
        };

	        const expandForDesktop = () => {
	          sidebar.classList.add('sidebar--expanded');
	          moveNavItemsToPrimary();
	          if (editorRoot) editorRoot.classList.add('nh-actions-in-toolbar');
	          sidebarMoreButton.hidden = true;
	          sidebarMoreButton.style.display = 'none';
	          sidebarMoreButton.setAttribute('aria-hidden', 'true');
	          sidebarMoreButton.setAttribute('tabindex', '-1');
	          sidebarMoreButton.setAttribute('aria-expanded', 'true');
	          sidebarSheet.hidden = false;

	          if (loadDesignButton) {
	            sidebar.appendChild(loadDesignButton);
	            loadDesignButton.classList.add('order-button--inline');
	          }

	          sidebar.appendChild(orderButton);
	          orderButton.classList.add('order-button--inline');
	        };

        const apply = () => {
          if (desktopMq.matches) {
            expandForDesktop();
          } else {
            collapseForMobile();
          }
        };

        apply();

        const mqHandler = () => apply();
        if (typeof desktopMq.addEventListener === 'function') desktopMq.addEventListener('change', mqHandler);
        else if (typeof desktopMq.addListener === 'function') desktopMq.addListener(mqHandler);
      })();

(function(){
            // 1) Menü-Texte in <span.nav-label> packen (für den Marker)
            document.querySelectorAll('.sidebar .nav-item').forEach(item=>{
                if(!item.querySelector('.nav-label')){
                    const textNodes = [...item.childNodes].filter(n => n.nodeType===3 && n.nodeValue.trim());
                    if(textNodes.length){
                        const span = document.createElement('span');
                        span.className = 'nav-label';
                        span.textContent = textNodes.map(n => n.nodeValue).join(' ').trim();
                        textNodes.forEach(n => n.remove());
                        item.appendChild(span);
                    }
                }
            });

            // === Sidebar: Layout cleanup =====================================
            (function stabiliseSidebar(){
              const sb      = document.querySelector('.sidebar');
              const wrapper = document.querySelector('.editor-wrapper');
              if (!sb || !wrapper) return;

              const collapseToggle = document.querySelector('.collapse-toggle');
              if (collapseToggle) collapseToggle.remove();
              if (typeof safeRemoveItem === 'function') safeRemoveItem('sb_collapsed');

              const mobileMq = window.matchMedia('(max-width: 768px)');

              function cleanupLegacyArtifacts(){
                sb.classList.remove('collapsed','mobile-left','sidebar-embedded');
                wrapper.classList.remove('has-embedded-sidebar');
                document.querySelectorAll('.mobile-brand').forEach(node => node.remove());
              }

              function apply(){
                cleanupLegacyArtifacts();
              }

              apply();

              const mqHandler = () => apply();
              if (typeof mobileMq.addEventListener === 'function') mobileMq.addEventListener('change', mqHandler);
              else if (typeof mobileMq.addListener === 'function') mobileMq.addListener(mqHandler);
              window.addEventListener('resize', apply);
              window.addEventListener('orientationchange', apply);
              window.addEventListener('load', apply);
            })();

                // Kleine Badges an den Menüeinträgen – deaktiviert (keine Zahlen/Badges)
        (function () {
          // vorhandene Badges sicher entfernen (falls schon erstellt)
          try {
            document.querySelectorAll('.sidebar .nav-item .badge').forEach(b => b.remove());
          } catch (e) {}

          // Kompatible Platzhalter: werden ggf. anderswo aufgerufen, machen aber nichts
          function setBadge(/* panel, value */) { /* no-op */ }

          function updateNavBadges() {
            // nur sicherstellen, dass keine Badges sichtbar sind
            document.querySelectorAll('.sidebar .nav-item .badge').forEach(b => b.remove());
          }

          // Canvas-Events nur binden, wenn canvas existiert – sonst beim Laden einmal aufräumen
          if (window.canvas) {
            ['object:added', 'object:removed', 'object:modified', 'selection:updated']
              .forEach(ev => canvas.on(ev, updateNavBadges));
            updateNavBadges();
          } else {
            window.addEventListener('load', updateNavBadges);
          }
        })();

        })();
  function canvasHasTransparency(canvasEl) {
    try {
      const ctx = canvasEl.getContext('2d', { willReadFrequently: true });
      if (!ctx) return false;
      const { width, height } = canvasEl;
      if (!width || !height) return false;
      const data = ctx.getImageData(0, 0, width, height).data;
      for (let i = 3; i < data.length; i += 4) {
        if (data[i] !== 255) return true;
      }
    } catch (err) {
      console.warn('Transparency check failed', err);
    }
    return false;
  }
